import type { Muban } from '@/types/muban'
import { fontStyle } from 'html2canvas/dist/types/css/property-descriptors/font-style'

export const muban: Muban[] = [
  {
    id: '1',
    imgList: [
      { imgUrl: 'https://static.yipigai.cn/public/muban/1/1.jpeg' },
      { imgUrl: 'https://static.yipigai.cn/public/muban/1/2.jpeg' },
      { imgUrl: 'https://static.yipigai.cn/public/muban/1/3.jpeg' },
      { imgUrl: 'https://static.yipigai.cn/public/muban/1/4.jpeg' }
    ],
    background: {
      type: 'image',
      image:'https://static.yipigai.cn/public/muban/1/bj.jpg',
      imageSize: 'cover'
    },
    slide:{
      shouye:[
          
          {
            type: 'shape',
            width: 476.5,
            height: 476.58,
            left: 261.75,
            top: 42.480000000000004,
            viewBox: [476.5, 476.58],
            path: ' M101.19462703458065,43.37497885549106 C143.19258415879548,13.833983031745095 193.60834703743302,-1.3468545135063514 244.93196188552525,0.093854015098 C244.81886314708268,4.122562311604676 244.7058631848309,8.151171814411247 244.59276444638832,12.179880110917923 C195.87328509200773,10.81227892038991 148.01562800217857,25.222821985937035 108.14866841784144,53.26491979171789z',
            fill: '#bbcccc',
            fixedRatio: false,
            rotate: 252,
            outline: { color: '#000', width: 0, style: 'solid' },
            text: {
              content:
                '<p style="text-align: left;"><span style="font-size: 18px;font-family: 思源黑体 CN;">&nbsp;</span></p>',
              defaultFontName: '思源黑体 CN',
              defaultColor: '#333',
              align: 'middle'
            },
            flipH: false,
            flipV: false,
            special: true
          },
          {
            type: 'shape',
            width: 476.5,
            height: 476.58,
            left: 261.75,
            top: 43.39,
            viewBox: [476.5, 476.58],
            path: ' M101.19462703458065,43.37497885549106 C143.19258415879548,13.833983031745095 193.60834703743302,-1.3468545135063514 244.93196188552525,0.093854015098 C244.81886314708268,4.122562311604676 244.7058631848309,8.151171814411247 244.59276444638832,12.179880110917923 C195.87328509200773,10.81227892038991 148.01562800217857,25.222821985937035 108.14866841784144,53.26491979171789z',
            fill: '#bdcecf',
            fixedRatio: false,
            rotate: 0,
            outline: { color: '#000', width: 0, style: 'solid' },
            text: {
              content:
                '<p style="text-align: left;"><span style="font-size: 18px;font-family: 思源黑体 CN;">&nbsp;</span></p>',
              defaultFontName: '思源黑体 CN',
              defaultColor: '#333',
              align: 'middle'
            },
            flipH: false,
            flipV: false,
            special: true
          },
          {
            type: 'text',
            width: 776.2232763532763,
            height: 129.53125,
            left: 111.88836182336176,
            top: 178.27069325735994,
            rotate: 0,
            defaultFontName: '思源黑体 CN',
            defaultColor: '#333',
            content:
            '<p style="text-align: center;"><strong><span style="font-size: 102px;"> {{title}} </span></strong></p>',
            lineHeight: 1.2,
            outline: { color: '#000', width: 0, style: 'solid' },
            fill: '',
            vertical: false
          },
          {
            type: 'text',
            width: 261.1261443494777,
            height: 41.90625,
            left: 494.9415289648623,
            top: 412.6269230769231,
            rotate: 0,
            defaultFontName: '思源黑体 CN',
            defaultColor: '#333',
            content:
              '<p style=""><strong><span style="font-size: 20.41px;"><span style="font-family: 思源黑体 CN Medium;">演讲时间：{{time}}</span></span></strong></p>',
            lineHeight: 1.2,
            outline: { color: '#000', width: 0, style: 'solid' },
            fill: '',
            vertical: false
          },
          {
            type: 'image',
            src: 'https://static.yipigai.cn/public/muban/1/title-pt.png',
            width: 351.56,
            height: 200,
            left: 0,
            top: 0,
            fixedRatio: true,
            rotate: 0,
            flipH: false,
            flipV: false
          },
          {
            type: 'text',
            width: 214.59243114909785,
            height: 41.90625,
            left: 291.1055745489078,
            top: 412.6269230769231,
            rotate: 0,
            defaultFontName: '思源黑体 CN',
            defaultColor: '#333',
            content:
              '<p ><strong><span style="font-size: 20px;"><span style="font-family: 思源黑体 CN Medium;">演讲人：小鸿</span></span></strong></p>',
            lineHeight: 1.2,
            outline: { color: '#000', width: 0, style: 'solid' },
            fill: '',
            vertical: false
          }
        ],
      mulu:[
        {
          "type": "text",
          "width": 159,
          "height": 88,
          "left": 92.36,
          "top": 262.35,
          "rotate": 0,
          "defaultFontName": "思源黑体 CN",
          "defaultColor": "#333",
          "content": "<p style=\"text-align: left;\"><span style=\"font-size: 57.14px;font-family: 思源宋体 CN;font-weight: bold;\">目录</span></p>",
          "lineHeight": 1,
          "outline": {
            "color": "#000",
            "width": 0,
            "style": "solid"
          },
          "fill": "",
          "vertical": false
        }
        ],
      biaoti:[
          
          {
            type: 'image',
            src: 'https://static.yipigai.cn/public/muban/1/title-pt.png',
            width: 351.56,
            height: 200,
            left: 0,
            top: 0,
            fixedRatio: true,
            rotate: 0,
            flipH: false,
            flipV: false
          },
          {
            type: 'shape',
            width: 476.5,
            height: 476.58,
            left: 261.75,
            top: 42.480000000000004,
            viewBox: [476.5, 476.58],
            path: ' M101.19462703458065,43.37497885549106 C143.19258415879548,13.833983031745095 193.60834703743302,-1.3468545135063514 244.93196188552525,0.093854015098 C244.81886314708268,4.122562311604676 244.7058631848309,8.151171814411247 244.59276444638832,12.179880110917923 C195.87328509200773,10.81227892038991 148.01562800217857,25.222821985937035 108.14866841784144,53.26491979171789z',
            fill: '#bbcccc',
            fixedRatio: false,
            rotate: 252,
            outline: { color: '#000', width: 0, style: 'solid' },
            text: {
              content:
                '<p style="text-align: left;"><span style="font-size: 18px;font-family: 思源黑体 CN;">&nbsp;</span></p>',
              defaultFontName: '思源黑体 CN',
              defaultColor: '#333',
              align: 'middle'
            },
            flipH: false,
            flipV: false,
            special: true
          },
          {
            type: 'shape',
            width: 476.5,
            height: 476.58,
            left: 261.75,
            top: 43.39,
            viewBox: [476.5, 476.58],
            path: ' M101.19462703458065,43.37497885549106 C143.19258415879548,13.833983031745095 193.60834703743302,-1.3468545135063514 244.93196188552525,0.093854015098 C244.81886314708268,4.122562311604676 244.7058631848309,8.151171814411247 244.59276444638832,12.179880110917923 C195.87328509200773,10.81227892038991 148.01562800217857,25.222821985937035 108.14866841784144,53.26491979171789z',
            fill: '#bdcecf',
            fixedRatio: false,
            rotate: 0,
            outline: { color: '#000', width: 0, style: 'solid' },
            text: {
              content:
                '<p style="text-align: left;"><span style="font-size: 18.37px;font-family: 思源黑体 CN;">&nbsp;</span></p>',
              defaultFontName: '思源黑体 CN',
              defaultColor: '#333',
              align: 'middle'
            },
            flipH: false,
            flipV: false,
            special: true
          },
          {
            type: 'text',
            width: 776.2232763532763,
            height: 129.53125,
            left: 111.88836182336176,
            top: 200,
            rotate: 0,
            defaultFontName: '思源黑体 CN',
            defaultColor: '#333',
            content:
              '<p style="text-align: center;"><strong><span style="font-size: 80px;">{{title}}</span></strong></p>',
            lineHeight: 1.2,
            outline: { color: '#000', width: 0, style: 'solid' },
            fill: '',
            vertical: false
          },
        
        ],
      end: [
          {
            type: 'image',
            src: 'https://static.yipigai.cn/public/muban/1/end-pt.png',
            width: 284.02,
            height: 284.02,
            left: 715.98,
            top: 0,
            fixedRatio: true,
            rotate: 0,
            flipH: false,
            flipV: false
          },
          
          {
            type: 'shape',
            width: 476.5,
            height: 476.58,
            left: 261.75,
            top: 42.480000000000004,
            viewBox: [476.5, 476.58],
            path: ' M101.19462703458065,43.37497885549106 C143.19258415879548,13.833983031745095 193.60834703743302,-1.3468545135063514 244.93196188552525,0.093854015098 C244.81886314708268,4.122562311604676 244.7058631848309,8.151171814411247 244.59276444638832,12.179880110917923 C195.87328509200773,10.81227892038991 148.01562800217857,25.222821985937035 108.14866841784144,53.26491979171789z',
            fill: '#bbcccc',
            fixedRatio: false,
            rotate: 252,
            outline: { color: '#000', width: 0, style: 'solid' },
            text: {
              content:
                '<p style="text-align: left;"><span style="font-size: 18.37px;font-family: 思源黑体 CN;">&nbsp;</span></p>',
              defaultFontName: '思源黑体 CN',
              defaultColor: '#333',
              align: 'middle'
            },
            flipH: false,
            flipV: false,
            special: true
          },
          {
            type: 'shape',
            width: 476.5,
            height: 476.58,
            left: 261.75,
            top: 43.39,
            viewBox: [476.5, 476.58],
            path: ' M101.19462703458065,43.37497885549106 C143.19258415879548,13.833983031745095 193.60834703743302,-1.3468545135063514 244.93196188552525,0.093854015098 C244.81886314708268,4.122562311604676 244.7058631848309,8.151171814411247 244.59276444638832,12.179880110917923 C195.87328509200773,10.81227892038991 148.01562800217857,25.222821985937035 108.14866841784144,53.26491979171789z',
            fill: '#bdcecf',
            fixedRatio: false,
            rotate: 0,
            outline: { color: '#000', width: 0, style: 'solid' },
            text: {
              content:
                '<p style="text-align: left;"><span style="font-size: 18.37px;font-family: 思源黑体 CN;">&nbsp;</span></p>',
              defaultFontName: '思源黑体 CN',
              defaultColor: '#333',
              align: 'middle'
            },
            flipH: false,
            flipV: false,
            special: true
          },
          {
            type: 'text',
            width: 499.87,
            height: 244.078125,
            left: 250.06,
            top: 151.68,
            rotate: 0,
            defaultFontName: '思源黑体 CN',
            defaultColor: '#333',
            content:
              '<p style="text-align: center;"><span style="font-size: 102.04px;font-family: 思源宋体 CN;font-weight: bold;">谢谢</span></p><p style="text-align: center;"><span style="font-size: 102.04px;font-family: 思源宋体 CN;font-weight: bold;">观看</span></p>',
            lineHeight: 1.2,
            outline: { color: '#000', width: 0, style: 'solid' },
            fill: '',
            vertical: false
          },
        ],
      neirong:
        [  
          {
            type: 'text',
            width: 400,
            height: 63.8125,
            left: 86.4,
            top: 23.65,
            rotate: 0,
            defaultFontName: '思源黑体 CN',
            defaultColor: '#333',
            content:
              '<p style="text-align: left;"><span style="font-size: 40px;font-family: 思源宋体 CN;font-weight: bold;">{{title}}</span></p>',
            lineHeight: 1.2,
            outline: { color: '#000', width: 0, style: 'solid' },
            fill: '',
            vertical: false
          },
          {
            type: 'image',
            src: 'https://static.yipigai.cn/public/muban/1/conten-title-pt.png',
            width: 57.11,
            height: 57.29,
            left: 17.42,
            top: 24.04,
            fixedRatio: true,
            rotate: 0,
            flipH: true,
            flipV: false
          }]
    },
    theme: {
      backgroundColor: '#F4F1EC',
      themeColor: '#ECBCA6',
      fontColor: '#000',
      fontName: '思源黑体 CN',
      outline: {},
      shadow: { h: 3, v: 3, blur: 2, color: '#808080' }
    }
  },
  {
    id: '2',
    imgList: [
      { imgUrl: 'https://static.yipigai.cn/public/muban/2/1.jpeg' },
      { imgUrl: 'https://static.yipigai.cn/public/muban/2/2.jpeg' },
      { imgUrl: 'https://static.yipigai.cn/public/muban/2/3.jpeg' },
      { imgUrl: 'https://static.yipigai.cn/public/muban/2/4.jpeg' }
    ],
    background: {
      type: 'image',
      image:'https://static.yipigai.cn/public/muban/2/bj.jpeg',
      imageSize: 'cover'
    },
    slide:{
      shouye:[   
        {
          "type": "shape",
          "width": 698.81,
          "height": 4.76,
          "left": 145.17,
          "top": 296.96,
          "viewBox": [
            200,
            200
          ],
          "path": "M 0 0 L 200 0 L 200 200 L 0 200 Z",
          "fill": "#56b3f6",
          "fixedRatio": false,
          "rotate": 0,
          "outline": {
            "color": "#085f9e",
            "width": 0,
            "style": "solid"
          },
          "text": {
            "content": "<p style=\"text-align: center;\"><span style=\"font-size: 18.37px;font-family: 思源黑体 CN;\">&nbsp;</span></p>",
            "defaultFontName": "思源黑体 CN",
            "defaultColor": "#333",
            "align": "middle"
          },
          "flipH": false,
          "flipV": true
        },
        {
          "type": "text",
          "width": 783.33,
          "height": 116.296875,
          "left": 108.33,
          "top": 171.15,
          "rotate": 0,
          "defaultFontName": "思源黑体 CN",
          "defaultColor": "#333",
          "content": "<p style=\"text-align: center;\"><strong><span style=\"font-size: 89.8px;\"><span style=\"font-family: 思源宋体 CN;\">{{title}}</span></span></strong></p>",
          "lineHeight": 1.2,
          "outline": {
            "color": "#000",
            "width": 0,
            "style": "solid"
          },
          "fill": "",
          "vertical": false,
          "name": "文本"
        },
        {
          "type": "shape",
          "width": 141.37,
          "height": 32.82,
          "left": 315.48959728287235,
          "top": 379.88,
          "viewBox": [
            200,
            200
          ],
          "path": "M 0 0 L 200 0 L 200 200 L 0 200 Z",
          "fill": "none",
          "fixedRatio": false,
          "rotate": 0,
          "text": {
            "content": "<p style=\"text-align: center;\"><span style=\"font-size: 18px;\"><span style=\"font-family: 思源宋体 CN;\">演讲人：小鸿</span></span></p>",
            "defaultFontName": "思源黑体 CN",
            "defaultColor": "#333",
            "align": "top"
          },
          "flipH": false,
          "flipV": false
        },
        {
          "type": "text",
          "width": 250,
          "height": 32.82,
          "left": 513.63,
          "top": 379.88,
          "rotate": 0,
          "defaultFontName": "思源黑体 CN",
          "defaultColor": "#333",
          "content": "<p style=\"text-align: center;\"><span style=\"font-size: 18px;\"><span style=\"font-family: 思源宋体 CN;\">时间：{{time}}</span></span></p>",
          "lineHeight": 1.2,
          "fill": "",
          "vertical": false,
        }
      ],
      mulu:[
        {
          "type": "text",
          "width": 156.7483182216391,
          "height": 40,
          "left": 279.44936181270134,
          "top": 117.51375000000002,
          "rotate": 0,
          "defaultFontName": "思源黑体 CN",
          "defaultColor": "#333",
          "content": "<p style=\"\"><span style=\"font-size: 20px;\"><span style=\"font-family: 思源宋体 CN;\"><span style=\"color: #0070C0;\">CONTENT</span></span></span></p>",
          "lineHeight": 1,
          "outline": {
            "color": "#000",
            "width": 0,
            "style": "solid"
          },
          "fill": "",
          "vertical": false
        },
        {
          "type": "text",
          "width": 162.64800865800865,
          "height": 74,
          "left": 170.25448537223102,
          "top": 89.88500721500722,
          "rotate": 0,
          "defaultFontName": "思源黑体 CN",
          "defaultColor": "#333",
          "content": "<p style=\"\"><strong><span style=\"font-size: 48px;\"><span style=\"font-family: 思源宋体 CN;\"><span style=\"color: #0070C0;\">目录</span></span></span></strong></p>",
          "lineHeight": 1,
          "outline": {
            "color": "#000",
            "width": 0,
            "style": "solid"
          },
          "fill": "",
          "vertical": false
        },
        ],
      biaoti:[    
        {
          "type": "text",
          "width": 500,
          "height": 85.71875,
          "left": 149.645,
          "top": 247.98879184861715,
          "rotate": 0,
          "defaultFontName": "思源黑体 CN",
          "defaultColor": "#333",
          "content": "<p style=\"\"><strong><span style=\"font-size: 61.22px;\"><span style=\"font-family: 思源宋体 CN;\"><span style=\"color: rgb(0, 112, 192);\">{{title}}</span></span></span></strong></p>",
          "lineHeight": 1.2,
          "outline": {
            "color": "#000",
            "width": 0,
            "style": "solid"
          },
          "fill": "",
          "vertical": false,
        }
        
        ],
      end: [
        {
          "type": "text",
          "width": 783.33,
          "height": 145.84375,
          "left": 108.33,
          "top": 180.31,
          "rotate": 0,
          "defaultFontName": "思源黑体 CN",
          "defaultColor": "#333",
          "content": "<p style=\"text-align: center;\"><span style=\"font-size: 117.35px;font-family: 思源宋体 CN;font-weight: bold;\">谢谢观看</span></p>",
          "lineHeight": 1.2,
          "outline": {
            "color": "#000",
            "width": 0,
            "style": "solid"
          },
          "fill": "",
          "vertical": false
        },
        {
          "type": "text",
          "width": 512.5,
          "height": 40,
          "left": 243.75,
          "top": 345.24,
          "rotate": 0,
          "defaultFontName": "思源黑体 CN",
          "defaultColor": "#333",
          "content": "<p style=\"text-align: center;\"><span style=\"font-size: 18.37px;font-family: 思源宋体 CN;\">演讲人：小鸿</span></p>",
          "lineHeight": 1.2,
          "outline": {
            "color": "#000",
            "width": 0,
            "style": "solid"
          },
          "fill": "",
          "vertical": false
        }
        ],
      neirong:
        [  
          {
            "type": "shape",
            "left": 26,
            "top": 22,
            "width": 948,
            "height": 518,
            "viewBox": [
              948,
              518
            ],
            "path": "M 64.77438136826783 0 L 883.3090732654052 0 Q 948 0 948 64.77438136826783 L 948 453.4206695778748 Q 948 518 883.3090732654052 518 L 64.77438136826783 518 Q 0 518 0 453.4206695778748 L 0 64.77438136826783 Q 0 0 64.77438136826783 0 Z",
            "fill": "rgba(255,255,255,1)",
            "fixedRatio": false,
            "rotate": 0,
            "pathFormula": "roundRect",
            "keypoints": [
              0.125
            ],
          },
          {
            "type": "text",
            "width": 796,
            "height": 63.8125,
            "left": 76,
            "top": 36,
            "rotate": 0,
            "defaultFontName": "思源黑体 CN",
            "defaultColor": "#333",
            "content": "<p style=\"text-align: center;\"><span style=\"color: #0070C0;font-size: 40.82px;font-family: 思源宋体 CN;font-weight: bold;\">{{title}}</span></p>",
            "lineHeight": 1.2,
            "outline": {
              "color": "#000",
              "width": 0,
              "style": "solid"
            },
            "fill": "",
            "vertical": false
          },
         ]
    },
    theme: {
      backgroundColor: '#DAE8F6',
      themeColor: '#56B3F6',
      fontColor: '#000',
      fontName: '思源黑体 CN',
      outline: {},
      shadow: { h: 3, v: 3, blur: 2, color: '#808080' }
    }
  },
  {
    id: '9',
    imgList: [
      { imgUrl: 'https://static.yipigai.cn/public/muban/9/1.jpeg' },
      { imgUrl: 'https://static.yipigai.cn/public/muban/9/2.jpeg' },
      { imgUrl: 'https://static.yipigai.cn/public/muban/9/3.jpeg' },
      { imgUrl: 'https://static.yipigai.cn/public/muban/9/4.jpeg' }
    ],
    background: {
      type: 'image',
      image:'https://static.yipigai.cn/public/muban/9/bj.jpeg',
      imageSize: 'cover'
    },
    slide:{
      shouye:[
        {
          "type": "image",
          src: 'https://static.yipigai.cn/public/muban/9/dl2.png',
          "width": 1000,
          "height": 317,
          "left": 0,
          "top": 0,
          "fixedRatio": true,
          "rotate": 0,
          "flipH": false,
          "flipV": false
        },
        {
          "type": "image",
          src: 'https://static.yipigai.cn/public/muban/9/jz.png',
          "width": 292.36406937682443,
          "height": 402.72666510185087,
          "left": 577.3706530958435,
          "top": 41.395747430425935,
          "fixedRatio": true,
          "rotate": 0,
          "flipH": false,
          "flipV": false
        },
        {
          "type": "image",
          src: 'https://static.yipigai.cn/public/muban/9/td.png',
          "width": 562.5184374853907,
          "height": 202.16785105756213,
          "left": 409.63984826324173,
          "top": 381.5365594598255,
          "fixedRatio": true,
          "rotate": 0,
          "flipH": false,
          "flipV": false
        },
        {
          "type": "text",
          "width": 511.7696590597933,
          "height": 81.09375,
          "left": 84.7697811437689,
          "top": 193.43564734277837,
          "rotate": 0,
          "defaultFontName": "Microsoft Yahei",
          "defaultColor": "#333",
          "content": "<p style=\"\"><span style=\"font-size: 48px;\"><span style=\"font-family: 思源宋体 CN Heavy;\">{{title}}</span></span></p>",
          "lineHeight": 1.2,
          "outline": {
            "color": "#000",
            "width": 0,
            "style": "solid"
          },
          "fill": "",
          "vertical": false
        },
        {
          "type": "text",
          "width": 154.3960478985928,
          "height": 40,
          "left": 107.8770649088712,
          "top": 297,
          "rotate": 0,
          "defaultFontName": "Microsoft Yahei",
          "defaultColor": "#333",
          "content": "<p style=\"\"><span style=\"font-size: 20px;\"><span style=\"font-family: 思源宋体 CN Heavy;\">演讲人：小鸿</span></span></p>",
          "lineHeight": 1,
          "outline": {
            "color": "#000",
            "width": 0,
            "style": "solid"
          },
          "fill": "",
          "vertical": false
        },
        {
          "type": "image",
          src: 'https://static.yipigai.cn/public/muban/9/hz.png',
          "width": 23.531389002066376,
          "height": 23.72913276581506,
          "left": 73.00408664273571,
          "top": 314,
          "fixedRatio": true,
          "rotate": 0,
          "flipH": false,
          "flipV": false
        },
        {
          "type": "text",
          "width": 272.6742497645809,
          "height": 40,
          "left": 313.1781675382177,
          "top": 297,
          "rotate": 0,
          "defaultFontName": "Microsoft Yahei",
          "defaultColor": "#333",
          "content": "<p style=\"\"><span style=\"font-size: 20px;\"><span style=\"font-family: 思源宋体 CN Heavy;\">演讲时间：{{time}}</span></span></p>",
          "lineHeight": 1,  
          "fill": "",
          "vertical": false
        }
      ],
      mulu:[
        {
          "type": "image",
          "src": "https://static.yipigai.cn/public/muban/9/dl.png",
          "width": 53.63867684478372,
          "height": 287.86089906700596,
          "left": 34.7,
          "top": 0,
          "fixedRatio": true,
          "rotate": 0,
          "flipH": false,
          "flipV": false
        },
        {
          "type": "text",
          "width": 285.82383723288893,
          "height": 68,
          "left": 366.6809042081833,
          "top": 34,
          "rotate": 0,
          "defaultFontName": "Microsoft Yahei",
          "defaultColor": "#333",
          "content": "<p style=\"text-align: center;\"><strong><span style=\"font-size: 48px;\"><span style=\"font-family: 思源宋体 CN;\">目录</span></span></strong></p>",
          "lineHeight": 1,
          "outline": {
            "color": "#000",
            "width": 0,
            "style": "solid"
          },
          "fill": "",
          "vertical": false
        },
      ],
      biaoti:[
        {
          "type": "image",
          src: 'https://static.yipigai.cn/public/muban/9/dl2.png',
          "width": 1000,
          "height": 317,
          "left": 0,
          "top": 0,
          "fixedRatio": true,
          "rotate": 0,
          "flipH": false,
          "flipV": false
        },
        {
          "type": "image",
          src: 'https://static.yipigai.cn/public/muban/9/jz.png',
          "width": 292.36406937682443,
          "height": 402.72666510185087,
          "left": 577.3706530958435,
          "top": 41.395747430425935,
          "fixedRatio": true,
          "rotate": 0,
          "flipH": false,
          "flipV": false
        },
        {
          "type": "image",
          src: 'https://static.yipigai.cn/public/muban/9/td.png',
          "width": 562.5184374853907,
          "height": 202.16785105756213,
          "left": 409.63984826324173,
          "top": 381.5365594598255,
          "fixedRatio": true,
          "rotate": 0,
          "flipH": false,
          "flipV": false
        },
        {
          "type": "text",
          "width": 511.7696590597933,
          "height": 81.09375,
          "left": 80.52889904029138,
          "top": 235.90624999999997,
          "rotate": 0,
          "defaultFontName": "Microsoft Yahei",
          "defaultColor": "#333",
          "content": "<p style=\"\"><span style=\"font-size: 48px;\"><span style=\"font-family: 思源宋体 CN Heavy;\">{{title}}</span></span></p>",
          "lineHeight": 1.2,
          "outline": {
            "color": "#000",
            "width": 0,
            "style": "solid"
          },
          "fill": "",
          "vertical": false
        }
      ],
      end: [
        {
          "type": "image",
          src: 'https://static.yipigai.cn/public/muban/9/xiexie.png',
          "width": 348,
          "height": 298,
          "left": 326,
          "top": 93.6876645858199,
          "fixedRatio": true,
          "rotate": 0,
          "flipH": false,
          "flipV": false
        },
        {
          "type": "text",
          "width": 144.79680116321336,
          "height": 40,
          "left": 436,
          "top": 420.72291338582676,
          "rotate": 0,
          "defaultFontName": "Microsoft Yahei",
          "defaultColor": "#333",
          "content": "<p style=\"\"><span style=\"font-size: 20px;\"><span style=\"font-family: 思源宋体 CN;\">演讲人：小鸿</span></span></p>",
          "lineHeight": 1,
          "outline": {
            "color": "#000",
            "width": 0,
            "style": "solid"
          },
          "fill": "",
          "vertical": false
        }
      ],
      neirong:[
        [
          {
            "type": "image",
            "src": "https://static.yipigai.cn/public/muban/9/yuan.png",
            "width": 149.4396742391934,
            "height": 150.09796520504065,
            "left": 815.8147867776069,
            "top": 16.788723127166357,
            "fixedRatio": true,
            "rotate": 0,
            "flipH": false,
            "flipV": false
          },
          {
            "type": "text",
            "width": 869.9540283418771,
            "height": 60,
            "left": 86,
            "top": 24,
            "rotate": 0,
            "defaultFontName": "Microsoft Yahei",
            "defaultColor": "#333",
            "content": "<p style=\"\"><strong><span style=\"font-size: 40px;\"><span style=\"font-family: 思源宋体 CN;\">{{title}}</span></span></strong></p>",
            "lineHeight": 1,
            "outline": {
              "color": "#000",
              "width": 0,
              "style": "solid"
            },
            "fill": "",
            "vertical": false
          },
          {
            "type": "image",
            "src": "https://static.yipigai.cn/public/muban/9/dl.png",
            "width": 44.09669211195929,
            "height": 236.65224766751487,
            "left": 18.796692111959292,
            "top": 1.204766914274054,
            "fixedRatio": true,
            "rotate": 0,
            "flipH": false,
            "flipV": false
          }
        ],
        [
          {
            "type": "image",
            "src": "https://static.yipigai.cn/public/muban/9/yun.png",
            "width": 728.6535805161759,
            "height": 208.94510053192718,
            "left": 0.7775435322492967,
            "top": 0,
            "fixedRatio": true,
            "rotate": 0,
            "flipH": false,
            "flipV": false
          },
          {
            "type": "text",
            "width": 869.9540283418771,
            "height": 62.5,
            "left": 86,
            "top": 24,
            "rotate": 0,
            "defaultFontName": "Microsoft Yahei",
            "defaultColor": "#333",
            "content": "<p style=\"\"><strong><span style=\"font-size: 40px;\"><span style=\"font-family: 思源宋体 CN;\">{{title}}</span></span></strong></p>",
            "lineHeight": 1,
            "outline": {
              "color": "#000",
              "width": 0,
              "style": "solid"
            },
            "fill": "",
            "vertical": false
          }
        ],
        [{
          "type": "text",
          "width": 869.9540283418771,
          "height": 62.5,
          "left": 86,
          "top": 24,
          "rotate": 0,
          "defaultFontName": "Microsoft Yahei",
          "defaultColor": "#333",
          "content": "<p style=\"\"><strong><span style=\"font-size: 40px;\"><span style=\"font-family: 思源宋体 CN;\">{{title}}</span></span></strong></p>",
          "lineHeight": 1,
          "outline": {
            "color": "#000",
            "width": 0,
            "style": "solid"
          },
          "fill": "",
          "vertical": false
        },
      
        {
          "type": "image",
          "src": "https://static.yipigai.cn/public/muban/9/yezi.png",
          "width": 152.73543307086612,
          "height": 146.6260367454068,
          "left": -2.068766404199475,
          "top": -2.6666666666666665,
          "fixedRatio": true,
          "rotate": 0,
          "flipH": false,
          "flipV": false
        }]
      ]
    },
    theme: {
      backgroundColor: '#D0C3A4',
      themeColor: '#5B9BD5',
      fontColor: '#333',
      fontName: '思源黑体 CN',
      outline: {},
      shadow: { h: 3, v: 3, blur: 2, color: '#808080' }
    }
  },
 
  {
    id: '10',
    imgList: [
      { imgUrl: 'https://static.yipigai.cn/public/muban/10/1.jpeg' },
      { imgUrl: 'https://static.yipigai.cn/public/muban/10/2.jpeg' },
      { imgUrl: 'https://static.yipigai.cn/public/muban/10/3.jpeg' },
      { imgUrl: 'https://static.yipigai.cn/public/muban/10/4.jpeg' }
    ],
    background: {
      type: 'image',
      image:'https://static.yipigai.cn/public/muban/10/bj.jpeg',
      imageSize: 'cover'
    },
    slide:{
      shouye:[
        {
          "type": "image",
          "id": "kPQifTukc3",
          "src": "https://static.yipigai.cn/public/muban/10/title-hh.png",
          "width": 379.39987500126847,
          "height": 569.0999013147722,
          "left": 639.0331097234246,
          "top": 8.627524178120407,
          "fixedRatio": true,
          "rotate": 0,
          "flipH": false,
          "flipV": false
        },
        {
          "type": "text",
          "id": "8czpC5OKbz",
          "width": 630.4037715132936,
          "height": 68,
          "left": 46.187630248509016,
          "top": 217.36090567573547,
          "rotate": 0,
          "defaultFontName": "Microsoft Yahei",
          "defaultColor": "#333",
          "content": "<p style=\"\"><strong><span style=\"font-size: 48px;\"><span style=\"font-family: 思源宋体 CN;\">{{title}}</span></span></strong></p>",
          "lineHeight": 1,
          "outline": {
            "color": "#000",
            "width": 0,
            "style": "solid"
          },
          "fill": "",
          "vertical": false
        },
        {
          "type": "text",
          "id": "qn7uehqmWg",
          "width": 154.2937185523565,
          "height": 40,
          "left": 46.187630248509016,
          "top": 328.9940439952776,
          "rotate": 0,
          "defaultFontName": "Microsoft Yahei",
          "defaultColor": "#333",
          "content": "<p style=\"text-align: center;\"><span style=\"font-size: 20px;\"><span style=\"font-family: 思源黑体 Medium;\"><span style=\"color: rgb(51, 51, 51);\">演讲人：小鸿</span></span></span></p>",
          "lineHeight": 1,
          "outline": {
            "color": "#000",
            "width": 0,
            "style": "solid"
          },
          "fill": "",
          "vertical": false
        },
        {
          "type": "text",
          "id": "aBqtCz3S0K",
          "width": 279.5693758890826,
          "height": 40,
          "left": 236.00103143595544,
          "top": 328.9940439952776,
          "rotate": 0,
          "defaultFontName": "Microsoft Yahei",
          "defaultColor": "#333",
          "content": "<p style=\"\"><span style=\"font-size: 20px;\"><span style=\"font-family: 思源黑体 Medium;\"><span style=\"color: rgb(51, 51, 51);\">演讲时间：{{time}}</span></span></span></p>",
          "lineHeight": 1,
          "outline": {
            "color": "#000",
            "width": 0,
            "style": "solid"
          },
          "fill": "",
          "vertical": false
        }
      ],
      mulu:[
        {
          "type": "text",
          "id": "Bi9UtomuW1",
          "width": 205.53396046793358,
          "height": 68,
          "left": 21.6732090497389,
          "top": 85.4503771796329,
          "rotate": 0,
          "defaultFontName": "Microsoft Yahei",
          "defaultColor": "#333",
          "content": "<p style=\"text-align: center;\"><strong><span style=\"font-size: 48px;\"><span style=\"font-family: 思源宋体 CN;\">目录</span></span></strong></p>",
          "lineHeight": 1,
          "outline": {
            "color": "#000",
            "width": 0,
            "style": "solid"
          },
          "fill": "",
          "vertical": false
        },
        {
          "type": "image",
          "id": "oRow4AB_1G",
         src:'https://static.yipigai.cn/public/muban/10/ml-hh.png',
          "width": 260.1101123181296,
          "height": 390.16520654449187,
          "left": -0.712906091045383,
          "top": 172.33479345550813,
          "fixedRatio": true,
          "rotate": 0,
          "flipH": false,
          "flipV": false
        }
       
      ],
      biaoti:[
        {
          "type": "image",
          "id": "QGkdrLMyMk",
          "src": "https://static.yipigai.cn/public/muban/10/title-hh.png",
          "width": 379.39987500126847,
          "height": 569.0999013147722,
          "left": 639.0331097234246,
          "top": 8.627524178120407,
          "fixedRatio": true,
          "rotate": 0,
          "flipH": false,
          "flipV": false
        },
        {
          "type": "text",
          "id": "xn7e_J5RI6",
          "width": 622.9822278322079,
          "height": 68,
          "left": 44.06718919677026,
          "top": 245.49999999999997,
          "rotate": 0,
          "defaultFontName": "Microsoft Yahei",
          "defaultColor": "#333",
          "content": "<p style=\"\"><strong><span style=\"font-size: 48px;\"><span style=\"font-family: 思源宋体 CN;\">{{title}}</span></span></strong></p>",
          "lineHeight": 1,
          "outline": {
            "color": "#000",
            "width": 0,
            "style": "solid"
          },
          "fill": "",
          "vertical": false
        }
      ],
      end: [
        {
          "type": "image",
          "id": "L6saWfqRH4",
          src: 'https://static.yipigai.cn/public/muban/10/nr-4.png',
          "width": 128.90078205873118,
          "height": 214.61760663225337,
          "left": 0,
          "top": 0,
          "fixedRatio": true,
          "rotate": 0,
          "flipH": false,
          "flipV": false
        },
        {
          "type": "image",
          "id": "L6saWfqRH4",
          src: 'https://static.yipigai.cn/public/muban/10/nr-2.png',
          "width": 279.4925748066853,
          "height": 273.23077593859136,
          "left": 0,
          "top": 289.26922406140864,
          "fixedRatio": true,
          "rotate": 0,
          "flipH": true,
          "flipV": false
        },
        {
          "type": "image",
          "id": "oZcGQ61iDc",
          src: 'https://static.yipigai.cn/public/muban/10/nr-5.png',
          "width": 333.10062843626355,
          "height": 668.4219575039174,
          "left": 666.8993715637364,
          "top": -105.92195750391735,
          "fixedRatio": true,
          "rotate": 0,
          "flipH": false,
          "flipV": false
        },
        {
          "type": "text",
          "id": "-FVE7AfnJZ",
          "width": 397.65016010852264,
          "height": 84.5,
          "left": 102.34983989147736,
          "top": 209.98882342024402,
          "rotate": 0,
          "defaultFontName": "Microsoft Yahei",
          "defaultColor": "#333",
          "content": "<p style=\"\"><strong><span style=\"font-size: 60px;\"><span style=\"font-family: 思源宋体 CN;\">感谢您的观看</span></span></strong></p>",
          "lineHeight": 1,
          "outline": {
            "color": "#000",
            "width": 0,
            "style": "solid"
          },
          "fill": "",
          "vertical": false
        },
        {
          "type": "text",
          "id": "B3L2JiKvp-",
          "width": 151.05069106146192,
          "height": 40,
          "left": 102.34983989147736,
          "top": 312.511176579756,
          "rotate": 0,
          "defaultFontName": "Microsoft Yahei",
          "defaultColor": "#333",
          "content": "<p style=\"\"><span style=\"font-size: 20px;\"><span style=\"font-family: 思源黑体 Medium;\"><span style=\"color: rgb(51, 51, 51);\"><span style=\"background-color: rgba(0, 0, 0, 0);\">演讲人：小鸿</span></span></span></span></p>",
          "lineHeight": 1,
          "outline": {
            "color": "#000",
            "width": 0,
            "style": "solid"
          },
          "fill": "",
          "vertical": false
        }
      ],
      neirong:[
        [{
          "type": "image",
          "id": "SFPuJFNeFn",
          src: 'https://static.yipigai.cn/public/muban/10/nr-1.png',
          "width": 138.24936386768445,
          "height": 163.45630229944894,
          "left": 0,
          "top": 0,
          "fixedRatio": true,
          "rotate": 0,
          "flipH": false,
          "flipV": false
        },
        {
          "type": "text",
          "id": "LgjUxEmtvD",
          "width": 871.921704531502,
          "height": 62.5,
          "left": 86,
          "top": 24,
          "rotate": 0,
          "defaultFontName": "Microsoft Yahei",
          "defaultColor": "#333",
          "content": "<p style=\"\"><strong><span style=\"font-size: 40px;\"><span style=\"font-family: 思源宋体 CN;\">{{title}}</span></span></strong></p>",
          "lineHeight": 1,
          "outline": {
            "color": "#000",
            "width": 0,
            "style": "solid"
          },
          "fill": "",
          "vertical": false
        },
        {
          "type": "image",
          "id": "P_r8vknWqL",
          src: 'https://static.yipigai.cn/public/muban/10/nr-2.png',
          "width": 306.8026398990202,
          "height": 270.89682635845367,
          "left": 693.1973601009797,
          "top": 291.60317364154633,
          "fixedRatio": true,
          "rotate": 0,
          "flipH": false,
          "flipV": false
        }],
        [{
          "type": "image",
          "id": "SFPuJFNeFn",
          src: 'https://static.yipigai.cn/public/muban/10/nr-1.png',
          "width": 138.24936386768445,
          "height": 163.45630229944894,
          "left": 0,
          "top": 0,
          "fixedRatio": true,
          "rotate": 0,
          "flipH": false,
          "flipV": false
        },
        {
          "type": "text",
          "id": "LgjUxEmtvD",
          "width": 871.921704531502,
          "height": 62.5,
          "left": 86,
          "top": 24,
          "rotate": 0,
          "defaultFontName": "Microsoft Yahei",
          "defaultColor": "#333",
          "content": "<p style=\"\"><strong><span style=\"font-size: 40px;\"><span style=\"font-family: 思源宋体 CN;\">{{title}}</span></span></strong></p>",
          "lineHeight": 1,
          "outline": {
            "color": "#000",
            "width": 0,
            "style": "solid"
          },
          "fill": "",
          "vertical": false
        },
        {
          "type": "image",
          "id": "P_r8vknWqL",
          src: 'https://static.yipigai.cn/public/muban/10/nr-3.png',
          "width": 242,
          "height": 242,
          "left": 757,
          "top": 320,
          "fixedRatio": true,
          "rotate": 0,
          "flipH": false,
          "flipV": false
        }]
      ]
    },
    theme: {
      backgroundColor: '#E9E1DA',
      themeColor: '#B2B17A',
      fontColor: '#000',
      fontName: '思源黑体 CN',
      outline: {},
      shadow: { h: 3, v: 3, blur: 2, color: '#808080' }
    }
  },
  {
    id: '6',
    imgList: [
      { imgUrl: 'https://static.yipigai.cn/public/muban/6/1.jpeg' },
      { imgUrl: 'https://static.yipigai.cn/public/muban/6/2.jpeg' },
      { imgUrl: 'https://static.yipigai.cn/public/muban/6/3.jpeg' },
      { imgUrl: 'https://static.yipigai.cn/public/muban/6/4.jpeg' }
    ],
    background: {
      type: 'image',
      image:'https://static.yipigai.cn/public/muban/6/bj.jpeg',
      imageSize: 'cover'
    },
    slide:{
      shouye:[
        {
          "type": "image",
          "src": "https://static.yipigai.cn/public/muban/6/yuan.png",
          "width": 215.63,
          "height": 311.56,
          "left": 785.52,
          "top": 251.88,
          "fixedRatio": true,
          "rotate": 0,
          "flipH": false,
          "flipV": false
        },
        {
          "type": "shape",
          "width": 159.38,
          "height": 101.56,
          "left": 716.93,
          "top": 461.25,
          "viewBox": [
            200,
            200
          ],
          "path": "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
          "fill": "#de1a37",
          "fixedRatio": false,
          "rotate": 0,
          "flipH": true,
          "flipV": true
        },
        {
          "type": "image",
          "src": "https://static.yipigai.cn/public/muban/6/yuan.png",
          "width": 232.03,
          "height": 222.76,
          "left": -1.09,
          "top": -0.83,
          "fixedRatio": true,
          "rotate": 0,
          "flipH": false,
          "flipV": false
        },
        {
          "type": "shape",
          "width": 68.85,
          "height": 68.85,
          "left": 19.9,
          "top": 170.68,
          "viewBox": [
            200,
            200
          ],
          "path": "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
          "fill": "#de1a37",
          "fixedRatio": false,
          "rotate": 0,
          "flipH": true,
          "flipV": true
        },
        {
          "type": "shape",
          "width": 121.15,
          "height": 121.15,
          "left": 622.19,
          "top": 62.6,
          "viewBox": [
            200,
            200
          ],
          "path": "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
          "fill": "#fbdfe3",
          "fixedRatio": false,
          "rotate": 0,
          "flipH": true,
          "flipV": true
        },
        {
          "type": "shape",
          "width": 74.17,
          "height": 74.17,
          "left": 230.94,
          "top": 386.09,
          "viewBox": [
            200,
            200
          ],
          "path": "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
          "fill": "#fbdfe3",
          "fixedRatio": false,
          "rotate": 0,
          "flipH": true,
          "flipV": true
        },
        {
          "type": "shape",
          "width": 51.04,
          "height": 51.04,
          "left": 721.41,
          "top": 119.64,
          "viewBox": [
            200,
            200
          ],
          "path": "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
          "fill": "#de1a37",
          "fixedRatio": false,
          "rotate": 0,
          "flipH": true,
          "flipV": true
        },
       
        {
          "type": "shape",
          "width": 184.15,
          "height": 31.75,
          "left": 412.23,
          "top": 388.77,
          "viewBox": [
            184.15,
            31.75
          ],
          "path": "M 3.96875 0 L 180.18125 0 Q 184.15 0 184.15 3.96875 L 184.15 27.78125 Q 184.15 31.75 180.18125 31.75 L 3.96875 31.75 Q 0 31.75 0 27.78125 L 0 3.96875 Q 0 0 3.96875 0 Z",
          "fill": "#f49fac",
          "fixedRatio": false,
          "rotate": 0,
          "flipH": false,
          "flipV": false,
          "pathFormula": "roundRect",
          "keypoints": [
            0.125
          ]
        },
        {
          "type": "text",
          "width": 607.03,
          "height": 75.09375,
          "left": 196.48,
          "top": 192.29,
          "rotate": 0,
          "defaultFontName": "思源黑体 CN",
          "defaultColor": "#333",
          "content": "<p style=\"text-align: center;\"><span style=\"font-size: 55.1px;\"><span style=\"font-family: 思源黑体 CN;\">{{title}}</span></span></p>",
          "lineHeight": 1,
          "outline": {
            "color": "#000",
            "width": 0,
            "style": "solid"
          },
          "fill": "",
          "vertical": false
        },
        {
          "type": "shape",
          "width": 19.05,
          "height": 19.05,
          "left": 424.93,
          "top": 395.12,
          "viewBox": [
            19.05,
            19.05
          ],
          "path": " M0.012444232629572404,0.018123114686010182 L0.014184613652490694,0.018123114686010182 L0.014199122362107297,0.018123114686010182 L0.014233044133886959,0.018123114686010182 L0.014262163727131547,0.018123114686010182 L0.01427667243674815,0.018123114686010182 L0.014281525702288914,0.018123114686010182 L0.016021906725207206,0.018123114686010182 C0.01660363445902499,0.018123114686010182 0.0168848173383552,0.01859179746667462 0.016574565952786096,0.019142571117320532 C0.016438827778661753,0.019374465077988703 0.015231692921159296,0.02193519034023079 0.015231692921159296,0.02193519034023079 L0.015425619194767122,0.026017808948564272 C0.01623034170843163,0.02455868197573201 0.017529535350191548,0.021539012663363662 0.01823249254851707,0.01984314785865314 C0.01823249254851707,0.01984314785865314 0.01823249254851707,0.01984314785865314 0.018237345814057837,0.01984314785865314 C0.018382739432258016,0.019432438568155748 0.018775445245014434,0.019137727246110445 0.019240796779865246,0.019137727246110445 C0.01936687950991375,0.019137727246110445 0.01948320462187503,0.019157051742832793 0.01959472755530124,0.019195700736277486 C0.019599529733836312,0.019195700736277486 0.019599529733836312,0.019195700736277486 0.019604382999377078,0.019200544607487574 C0.019793456007444137,0.01925851809765462 0.023754078297748133,0.020993031895809835 0.02649310810793876,0.022379704752962793 C0.027719553853592892,0.022998139636195923 0.028461286089238844,0.023776014364417924 0.028461286089238844,0.02458769421487453 L0.028461286089238844,0.031003937007874013 L0.014291232233370445,0.031003937007874013 L0.01427667243674815,0.031003937007874013 L0.014271870258213078,0.031003937007874013 L0.014262163727131547,0.031003937007874013 L0.014252457196050018,0.031003937007874013 L0.014233044133886959,0.031003937007874013 L0.014208828893188826,0.031003937007874013 L0.014199122362107297,0.031003937007874013 L0.014194269096566531,0.031003937007874013 L0.014189415831025766,0.031003937007874013 L0.014184613652490694,0.031003937007874013 L0.014170053855868399,0.031003937007874013 L0,0.031003937007874013 L0,0.02458769421487453 C0,0.023776014364417924 0.0007417322356459518,0.022998139636195923 0.0019730312468408504,0.022379704752962793 C0.004707207791490712,0.020993031895809835 0.008667830081794706,0.01925851809765462 0.008861756355402534,0.019200544607487574 C0.008861756355402534,0.019195700736277486 0.008861756355402534,0.019195700736277486 0.008866558533937606,0.019195700736277486 C0.008978081467363813,0.019157051742832793 0.009094406579325094,0.019137727246110445 0.009220489309373596,0.019137727246110445 C0.009685840844224412,0.019137727246110445 0.01007854665698083,0.019432438568155748 0.010228793540721771,0.01984314785865314 C0.010936604004588062,0.021539012663363662 0.012230944380807211,0.02455868197573201 0.013035666894471722,0.026017808948564272 L0.013229593168079548,0.02193519034023079 C0.013229593168079548,0.02193519034023079 0.01202245831057709,0.019374465077988703 0.01188672013645275,0.019142571117320532 C0.011576468750883643,0.01859179746667462 0.011857651630213854,0.018123114686010182 0.012444232629572404,0.018123114686010182 M0.014112785322487375,0 C0.014137051650191199,0 0.01416126689088933,0 0.014185533218593154,0 C0.01419038648413392,0 0.01419038648413392,0 0.014195188662668992,0 C0.014195188662668992,0 0.014195188662668992,0 0.014200041928209757,0 C0.014224308255913582,0 0.014248523496611714,0 0.014272789824315539,0 C0.019693376563292998,0 0.02071154058673978,0.0038554665426393914 0.020566095881533908,0.005348398637706261 C0.0204545729481077,0.006546619410727827 0.02016368353769596,0.008107161750263913 0.02016368353769596,0.008107161750263913 C0.02016368353769596,0.008107161750263913 0.020735806914443603,0.008368067950074609 0.020735806914443603,0.009421278515501565 C0.02053702737529501,0.012059250776515044 0.01948003722752211,0.010919054481778523 0.01926184462621046,0.012078575273237392 C0.018903060585233705,0.014001490167406 0.017196396986072306,0.015392955907651044 0.016129751394223568,0.015871275442617655 C0.01550914644907397,0.016151506139150697 0.014869128441761312,0.01629162148741722 0.014200041928209757,0.016301258241719394 L0.014200041928209757,0.01630610211292948 C0.014195188662668992,0.01630610211292948 0.014195188662668992,0.01630610211292948 0.014195188662668992,0.01630610211292948 C0.01419038648413392,0.01630610211292948 0.01419038648413392,0.01630610211292948 0.014185533218593154,0.01630610211292948 L0.014185533218593154,0.016301258241719394 C0.0135164467050416,0.01629162148741722 0.012876428697728941,0.016151506139150697 0.012255823752579343,0.015871275442617655 C0.011189178160730605,0.015392955907651044 0.009482514561569209,0.014001490167406 0.009123730520592453,0.012078575273237392 C0.008905537919280802,0.010919054481778523 0.007848547771507902,0.012059250776515044 0.00764976823235931,0.009421278515501565 C0.00764976823235931,0.008368067950074609 0.008226744874647716,0.008107161750263913 0.008226744874647716,0.008107161750263913 C0.008226744874647716,0.008107161750263913 0.007931002198695213,0.006546619410727827 0.007819479265269004,0.005348398637706261 C0.0076740345600631345,0.0038554665426393914 0.008692198583509916,0 0.014112785322487375,0zz",
          "fill": "#ffffff",
          "fixedRatio": false,
          "rotate": 0,
          "flipH": false,
          "flipV": false,
          "special": true
        },
        {
          "type": "text",
          "width": 158.75,
          "height": 50,
          "left": 424.93,
          "top": 370,
          "rotate": 0,
          "content": "<p style=\"text-align: center;\"><span style=\"font-size: 18px;\"><span style=\"font-family: 思源黑体 CN;\"><span style=\"color: rgb(255, 255, 255);\">授课教师：小鸿</span></span></span></p>",
          "defaultFontName": "思源黑体 CN",
          "defaultColor": "#333"
        }
       
      ],
      mulu:[
        {
          "type": "text",
          "width": 351.86000000000007,
          "height": 64,
          "left": 322.83000000000004,
          "top": 33.65,
          "rotate": 0,
          "defaultFontName": "思源黑体 CN",
          "defaultColor": "#333",
          "content": "<p style=\"text-align: center;\"><span style=\"font-size: 44px;\"><span style=\"font-family: 汉仪中黑简;\">目录</span></span></p>",
          "lineHeight": 1,
          "outline": {
            "color": "#000",
            "width": 0,
            "style": "solid"
          },
          "fill": "",
          "vertical": false
        },
        {
          "type": "text",
          "width": 351.8600000000001,
          "height": 48,
          "left": 322.83000000000004,
          "top": 95.47,
          "rotate": 0,
          "defaultFontName": "思源黑体 CN",
          "defaultColor": "#333",
          "content": "<p style=\"text-align: center;\"><span style=\"font-size: 28px;\"><span style=\"font-family: 汉仪中黑简;\">CONTENTS</span></span></p>",
          "lineHeight": 1,
          "outline": {
            "color": "#000",
            "width": 0,
            "style": "solid"
          },
          "fill": "",
          "vertical": false
        },
      ],
      biaoti:[
        {
          "type": "shape",
          "width": 133,
          "height": 119,
          "left": 431.8,
          "top": 125.08,
          "viewBox": [
            200,
            200
          ],
          "path": "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
          "fill": "#de1a37",
          "fixedRatio": false,
          "rotate": 0,
          "outline": {
            "color": "#16468d",
            "width": 0,
            "style": "solid"
          },
          "text": {
            "content": "<p style=\"text-align: center;\"><span style=\"font-size: 18.37px;font-family: Arial;\">&nbsp;</span></p>",
            "defaultFontName": "思源黑体 CN",
            "defaultColor": "#333",
            "align": "middle"
          },
          "flipH": false,
          "flipV": false
        },
        {
          "type": "text",
          "width": 133,
          "height": 86,
          "left": 431.8,
          "top": 139.04,
          "rotate": 0,
          "defaultFontName": "思源黑体 CN",
          "defaultColor": "#333",
          "content": "<p style=\"text-align: center;\"><strong><span style=\"font-size: 66px;\"><span style=\"font-family: 思源黑体 CN;\"><span style=\"color: rgb(255, 255, 255);\">{{index}}</span></span></span></strong></p>",
          "lineHeight": 1,
          "outline": {
            "color": "#000",
            "width": 0,
            "style": "solid"
          },
          "fill": "",
          "vertical": false
        },
        {
          "type": "text",
          "width": 853.9164942159566,
          "height": 55.703125,
          "left": 71.31520448296948,
          "top": 281.25,
          "rotate": 0,
          "defaultFontName": "思源黑体 CN",
          "defaultColor": "#333",
          "content": "<p style=\"text-align: center;\"><span style=\"font-size: 35.71px;\"><span style=\"font-family: 汉仪中黑简;\">{{title}}</span></span></p>",
          "lineHeight": 1,
          "outline": {
            "color": "#000",
            "width": 0,
            "style": "solid"
          },
          "fill": "",
          "vertical": false
        },
        {
          "type": "image",
         src:'https://static.yipigai.cn/public/muban/6/xian.png',
          "width": 927.2328548644339,
          "height": 163.76089663760897,
          "left": 51.83413078149914,
          "top": 383.77944003845226,
          "fixedRatio": true,
          "rotate": 0
        }
      ],
      end: [
         {
        "type": "image",
        "src": "https://static.yipigai.cn/public/muban/6/yuan.png",
        "width": 286.25761672483867,
        "height": 223.19157218051475,
        "left": 760.2096337216667,
        "top": 300.5676985012948,
        "fixedRatio": true,
        "rotate": -56.06195833514698,
        "flipH": false,
        "flipV": false
      },
      {
        "type": "shape",
        "width": 159.38,
        "height": 101.56,
        "left": 716.93,
        "top": 461.25,
        "viewBox": [
          200,
          200
        ],
        "path": "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
        "fill": "#de1a37",
        "fixedRatio": false,
        "rotate": 0,
        "flipH": true,
        "flipV": true
      },
      {
        "type": "image",
        "src": "https://static.yipigai.cn/public/muban/6/yuan.png",
        "width": 232.03,
        "height": 222.76,
        "left": -1.09,
        "top": -0.83,
        "fixedRatio": true,
        "rotate": 0,
        "flipH": false,
        "flipV": false
      },
      {
        "type": "shape",
        "width": 68.85,
        "height": 68.85,
        "left": 19.9,
        "top": 170.68,
        "viewBox": [
          200,
          200
        ],
        "path": "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
        "fill": "#de1a37",
        "fixedRatio": false,
        "rotate": 0,
        "flipH": true,
        "flipV": true
      },
      {
        "type": "shape",
        "width": 121.15,
        "height": 121.15,
        "left": 622.19,
        "top": 62.6,
        "viewBox": [
          200,
          200
        ],
        "path": "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
        "fill": "#fbdfe3",
        "fixedRatio": false,
        "rotate": 0,
        "flipH": true,
        "flipV": true
      },
      {
        "type": "shape",
        "width": 74.17,
        "height": 74.17,
        "left": 230.94,
        "top": 386.09,
        "viewBox": [
          200,
          200
        ],
        "path": "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
        "fill": "#fbdfe3",
        "fixedRatio": false,
        "rotate": 0,
        "flipH": true,
        "flipV": true
      },
      {
        "type": "shape",
        "width": 51.04,
        "height": 51.04,
        "left": 721.41,
        "top": 119.64,
        "viewBox": [
          200,
          200
        ],
        "path": "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
        "fill": "#de1a37",
        "fixedRatio": false,
        "rotate": 0,
        "flipH": true,
        "flipV": true
      },
      {
        "type": "shape",
        "width": 184.15,
        "height": 31.75,
        "left": 412.23,
        "top": 388.77,
        "viewBox": [
          184.15,
          31.75
        ],
        "path": "M 3.96875 0 L 180.18125 0 Q 184.15 0 184.15 3.96875 L 184.15 27.78125 Q 184.15 31.75 180.18125 31.75 L 3.96875 31.75 Q 0 31.75 0 27.78125 L 0 3.96875 Q 0 0 3.96875 0 Z",
        "fill": "#f49fac",
        "fixedRatio": false,
        "rotate": 0,
        "flipH": false,
        "flipV": false,
        "pathFormula": "roundRect",
        "keypoints": [
          0.125
        ]
      },
      {
        "type": "text",
        "width": 158.75,
        "height": 50,
        "left": 424.93,
        "top": 370,
        "rotate": 0,
        "content": "<p style=\"text-align: center;\"><span style=\"font-size: 18px;\"><span style=\"font-family: 思源黑体 CN;\"><span style=\"color: rgb(255, 255, 255);\">授课教师：小鸿</span></span></span></p>",
        "defaultFontName": "思源黑体 CN",
        "defaultColor": "#333"
      },
      {
        "type": "shape",
        "width": 19.05,
        "height": 19.05,
        "left": 424.93,
        "top": 395.12,
        "viewBox": [
          19.05,
          19.05
        ],
        "path": " M0.012444232629572404,0.018123114686010182 L0.014184613652490694,0.018123114686010182 L0.014199122362107297,0.018123114686010182 L0.014233044133886959,0.018123114686010182 L0.014262163727131547,0.018123114686010182 L0.01427667243674815,0.018123114686010182 L0.014281525702288914,0.018123114686010182 L0.016021906725207206,0.018123114686010182 C0.01660363445902499,0.018123114686010182 0.0168848173383552,0.01859179746667462 0.016574565952786096,0.019142571117320532 C0.016438827778661753,0.019374465077988703 0.015231692921159296,0.02193519034023079 0.015231692921159296,0.02193519034023079 L0.015425619194767122,0.026017808948564272 C0.01623034170843163,0.02455868197573201 0.017529535350191548,0.021539012663363662 0.01823249254851707,0.01984314785865314 C0.01823249254851707,0.01984314785865314 0.01823249254851707,0.01984314785865314 0.018237345814057837,0.01984314785865314 C0.018382739432258016,0.019432438568155748 0.018775445245014434,0.019137727246110445 0.019240796779865246,0.019137727246110445 C0.01936687950991375,0.019137727246110445 0.01948320462187503,0.019157051742832793 0.01959472755530124,0.019195700736277486 C0.019599529733836312,0.019195700736277486 0.019599529733836312,0.019195700736277486 0.019604382999377078,0.019200544607487574 C0.019793456007444137,0.01925851809765462 0.023754078297748133,0.020993031895809835 0.02649310810793876,0.022379704752962793 C0.027719553853592892,0.022998139636195923 0.028461286089238844,0.023776014364417924 0.028461286089238844,0.02458769421487453 L0.028461286089238844,0.031003937007874013 L0.014291232233370445,0.031003937007874013 L0.01427667243674815,0.031003937007874013 L0.014271870258213078,0.031003937007874013 L0.014262163727131547,0.031003937007874013 L0.014252457196050018,0.031003937007874013 L0.014233044133886959,0.031003937007874013 L0.014208828893188826,0.031003937007874013 L0.014199122362107297,0.031003937007874013 L0.014194269096566531,0.031003937007874013 L0.014189415831025766,0.031003937007874013 L0.014184613652490694,0.031003937007874013 L0.014170053855868399,0.031003937007874013 L0,0.031003937007874013 L0,0.02458769421487453 C0,0.023776014364417924 0.0007417322356459518,0.022998139636195923 0.0019730312468408504,0.022379704752962793 C0.004707207791490712,0.020993031895809835 0.008667830081794706,0.01925851809765462 0.008861756355402534,0.019200544607487574 C0.008861756355402534,0.019195700736277486 0.008861756355402534,0.019195700736277486 0.008866558533937606,0.019195700736277486 C0.008978081467363813,0.019157051742832793 0.009094406579325094,0.019137727246110445 0.009220489309373596,0.019137727246110445 C0.009685840844224412,0.019137727246110445 0.01007854665698083,0.019432438568155748 0.010228793540721771,0.01984314785865314 C0.010936604004588062,0.021539012663363662 0.012230944380807211,0.02455868197573201 0.013035666894471722,0.026017808948564272 L0.013229593168079548,0.02193519034023079 C0.013229593168079548,0.02193519034023079 0.01202245831057709,0.019374465077988703 0.01188672013645275,0.019142571117320532 C0.011576468750883643,0.01859179746667462 0.011857651630213854,0.018123114686010182 0.012444232629572404,0.018123114686010182 M0.014112785322487375,0 C0.014137051650191199,0 0.01416126689088933,0 0.014185533218593154,0 C0.01419038648413392,0 0.01419038648413392,0 0.014195188662668992,0 C0.014195188662668992,0 0.014195188662668992,0 0.014200041928209757,0 C0.014224308255913582,0 0.014248523496611714,0 0.014272789824315539,0 C0.019693376563292998,0 0.02071154058673978,0.0038554665426393914 0.020566095881533908,0.005348398637706261 C0.0204545729481077,0.006546619410727827 0.02016368353769596,0.008107161750263913 0.02016368353769596,0.008107161750263913 C0.02016368353769596,0.008107161750263913 0.020735806914443603,0.008368067950074609 0.020735806914443603,0.009421278515501565 C0.02053702737529501,0.012059250776515044 0.01948003722752211,0.010919054481778523 0.01926184462621046,0.012078575273237392 C0.018903060585233705,0.014001490167406 0.017196396986072306,0.015392955907651044 0.016129751394223568,0.015871275442617655 C0.01550914644907397,0.016151506139150697 0.014869128441761312,0.01629162148741722 0.014200041928209757,0.016301258241719394 L0.014200041928209757,0.01630610211292948 C0.014195188662668992,0.01630610211292948 0.014195188662668992,0.01630610211292948 0.014195188662668992,0.01630610211292948 C0.01419038648413392,0.01630610211292948 0.01419038648413392,0.01630610211292948 0.014185533218593154,0.01630610211292948 L0.014185533218593154,0.016301258241719394 C0.0135164467050416,0.01629162148741722 0.012876428697728941,0.016151506139150697 0.012255823752579343,0.015871275442617655 C0.011189178160730605,0.015392955907651044 0.009482514561569209,0.014001490167406 0.009123730520592453,0.012078575273237392 C0.008905537919280802,0.010919054481778523 0.007848547771507902,0.012059250776515044 0.00764976823235931,0.009421278515501565 C0.00764976823235931,0.008368067950074609 0.008226744874647716,0.008107161750263913 0.008226744874647716,0.008107161750263913 C0.008226744874647716,0.008107161750263913 0.007931002198695213,0.006546619410727827 0.007819479265269004,0.005348398637706261 C0.0076740345600631345,0.0038554665426393914 0.008692198583509916,0 0.014112785322487375,0zz",
        "fill": "#ffffff",
        "fixedRatio": false,
        "rotate": 0,
        "flipH": false,
        "flipV": false,
        "special": true
      },
      {
        "type": "text",
        "width": 581.15,
        "height": 74,
        "left": 209.48,
        "top": 193.91,
        "rotate": 0,
        "defaultFontName": "思源黑体 CN",
        "defaultColor": "#333",
        "content": "<p style=\"text-align: justify;\"><span style=\"font-size: 54px;\"><span style=\"font-family: 思源黑体 CN;\">谢谢您的观看</span></span></p>",
        "lineHeight": 1,
        "outline": {
          "color": "#000",
          "width": 0,
          "style": "solid"
        },
        "fill": "",
        "vertical": false
      }],
      neirong:[
        {
          "type": "text",
          "width": 923,
          "height": 42,
          "left": 36.41,
          "top": 8,
          "rotate": 0,
          "defaultFontName": "思源黑体 CN",
          "defaultColor": "#333",
          "content": "<p style=\"text-align: justify;\"><strong><span style=\"font-size: 22px;\"><span style=\"color: #354359;\">{{title}}</span></span></strong></p>",
          "lineHeight": 1,
          "outline": {
            "color": "#000",
            "width": 0,
            "style": "solid"
          },
          "fill": "",
          "vertical": false
        },
        {
          "type": "shape",
          "width": 30.36,
          "height": 58.33,
          "left": -0.05,
          "top": -0.73,
          "viewBox": [
            200,
            200
          ],
          "path": "M 0 0 L 200 0 L 200 200 L 0 200 Z",
          "fill": "#de1a37",
          "fixedRatio": false,
          "rotate": 180,
          "flipH": false,
          "flipV": false
        }
      ]
    },
    theme: {
      backgroundColor: '#fff',
      themeColor: '#DE1A37',
      fontColor: '#333333',
      fontName: '思源黑体 CN',
      outline: {},
      shadow: { h: 3, v: 3, blur: 2, color: '#808080' }
    }
  },
  {
    id: '3',
    imgList: [
      { imgUrl: 'https://static.yipigai.cn/public/muban/3/1.jpeg' },
      { imgUrl: 'https://static.yipigai.cn/public/muban/3/2.jpeg' },
      { imgUrl: 'https://static.yipigai.cn/public/muban/3/3.jpeg' },
      { imgUrl: 'https://static.yipigai.cn/public/muban/3/4.jpeg' }
    ],
    background: {
      "type": "solid",
      "color": "#f2f2f2"
    },
    slide:{
      shouye:[   
        {
          "type": "shape",
          "width": 1001.51,
          "height": 565.31,
          "left": 0,
          "top": -1.41,
          "viewBox": [
            1001.51,
            565.31
          ],
          "path": " M0,0 L464.1145833333333,1.0416666666666667 L780.8333333333333,334.1666666666667 L1001.5104166666666,565.3125 L685.4687499999999,563.2291666666667 L0,563.90625 L0,0z",
          "fill": "#427092",
          "fixedRatio": false,
          "rotate": 0,
          "outline": {
            "color": "#16468d",
            "width": 0,
            "style": "solid"
          },
          "text": {
            "content": "<p style=\"text-align: center;\"><span style=\"font-size: 18.37px;font-family: Arial;\">&nbsp;</span></p>",
            "defaultFontName": "思源黑体 CN",
            "defaultColor": "#333",
            "align": "middle"
          },
          "flipH": false,
          "flipV": false,
          "special": true
        },
        {
          "type": "shape",
          "width": 351.41,
          "height": 555.21,
          "left": 650.05,
          "top": -1.41,
          "viewBox": [
            351.41,
            555.21
          ],
          "path": " M178.04930916172106,0.31285217881292265 L349.8421272255193,0 L351.40625,555.2083333333334 L0,186.19918842349114 L178.04930916172106,0.31285217881292265z",
          "fill": "#f1cb8f",
          "fixedRatio": false,
          "rotate": 0,
          "outline": {
            "color": "#16468d",
            "width": 0,
            "style": "solid"
          },
          "text": {
            "content": "<p style=\"text-align: center;\"><span style=\"font-size: 18.37px;font-family: Arial;\">&nbsp;</span></p>",
            "defaultFontName": "思源黑体 CN",
            "defaultColor": "#333",
            "align": "middle"
          },
          "flipH": false,
          "flipV": false,
          "special": true
        },
        {
          "type": "text",
          "width": 638.1965372168283,
          "height": 71,
          "left": 32.08,
          "top": 208.75,
          "rotate": 0,
          "defaultFontName": "思源黑体 CN",
          "defaultColor": "#333",
          "content": "<p style=\"\"><span style=\"font-size: 51px;\"><span style=\"color: rgb(255, 255, 255);\">{{title}}</span></span></p>",
          "lineHeight": 1,
          "outline": {
            "color": "#000",
            "width": 0,
            "style": "solid"
          },
          "fill": "",
          "vertical": false
        },
        {
          "type": "shape",
          "width": 49.9,
          "height": 49.9,
          "left": 40.94,
          "top": 139.32,
          "viewBox": [
            200,
            200
          ],
          "path": "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
          "fill": "#f1cb8f",
          "fixedRatio": false,
          "rotate": 0,
          "outline": {
            "color": "#16468d",
            "width": 0,
            "style": "solid"
          },
          "text": {
            "content": "<p style=\"text-align: center;\"><span style=\"font-size: 18.37px;font-family: Arial;\">&nbsp;</span></p>",
            "defaultFontName": "思源黑体 CN",
            "defaultColor": "#333",
            "align": "middle"
          },
          "flipH": false,
          "flipV": false
        },
        {
          "type": "shape",
          "width": 49.9,
          "height": 49.9,
          "left": 78.33,
          "top": 139.32,
          "viewBox": [
            200,
            200
          ],
          "path": "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
          "fill": "#f2f2f2",
          "fixedRatio": false,
          "rotate": 0,
          "outline": {
            "color": "#16468d",
            "width": 0,
            "style": "solid"
          },
          "text": {
            "content": "<p style=\"text-align: center;\"><span style=\"font-size: 18.37px;font-family: Arial;\">&nbsp;</span></p>",
            "defaultFontName": "思源黑体 CN",
            "defaultColor": "#333",
            "align": "middle"
          },
          "flipH": false,
          "flipV": false
        },
        {
          "type": "shape",
          "width": 158.46473684210525,
          "height": 36.961722488038276,
          "left": 40.94,
          "top": 399.01,
          "viewBox": [
            158.46473684210525,
            36.961722488038276
          ],
          "path": "M 4.6202153110047846 0 L 153.84452153110047 0 Q 158.46473684210525 0 158.46473684210525 4.6202153110047846 L 158.46473684210525 32.34150717703349 Q 158.46473684210525 36.961722488038276 153.84452153110047 36.961722488038276 L 4.6202153110047846 36.961722488038276 Q 0 36.961722488038276 0 32.34150717703349 L 0 4.6202153110047846 Q 0 0 4.6202153110047846 0 Z",
          "fill": "#f1cb8f",
          "fixedRatio": false,
          "rotate": 0,
          "outline": {
            "color": "#16468d",
            "width": 0,
            "style": "solid"
          },
          "text": {
            "content": "<p style=\"text-align: center;\"><span style=\"font-size: 18.37px;font-family: Arial;\">&nbsp;</span></p>",
            "defaultFontName": "思源黑体 CN",
            "defaultColor": "#333",
            "align": "middle"
          },
          "flipH": false,
          "flipV": false,
          "pathFormula": "roundRect",
          "keypoints": [
            0.125
          ]
        },
        {
          "type": "text",
          "width": 158,
          "height": 40,
          "left": 48.75,
          "top": 388,
          "rotate": 0,
          "defaultFontName": "思源黑体 CN",
          "defaultColor": "#333",
          "content": "<p style=\"\"><span style=\"font-size: 14.29px;text-align: center;\"><span style=\"color: rgb(66, 112, 146);\">汇报人：小鸿</span></span></p>",
          "lineHeight": 1,
          "outline": {
            "color": "#000",
            "width": 0,
            "style": "solid"
          },
          "fill": "",
          "vertical": false
        },
        {
          "type": "shape",
          "width": 181.06581066760862,
          "height": 36.961722488038276,
          "left": 248.0876510067114,
          "top": 399.01,
          "viewBox": [
            181.06581066760862,
            36.961722488038276
          ],
          "path": "M 4.6202153110047846 0 L 176.44559535660383 0 Q 181.06581066760862 0 181.06581066760862 4.6202153110047846 L 181.06581066760862 32.34150717703349 Q 181.06581066760862 36.961722488038276 176.44559535660383 36.961722488038276 L 4.6202153110047846 36.961722488038276 Q 0 36.961722488038276 0 32.34150717703349 L 0 4.6202153110047846 Q 0 0 4.6202153110047846 0 Z",
          "fill": "#f1cb8f",
          "fixedRatio": false,
          "rotate": 0,
          "outline": {
            "color": "#16468d",
            "width": 0,
            "style": "solid"
          },
          "text": {
            "content": "<p style=\"text-align: center;\"><span style=\"font-size: 18.37px;font-family: Arial;\">&nbsp;</span></p>",
            "defaultFontName": "思源黑体 CN",
            "defaultColor": "#333",
            "align": "middle"
          },
          "flipH": false,
          "flipV": false,
          "pathFormula": "roundRect",
          "keypoints": [
            0.125
          ]
        },
        {
          "type": "text",
          "width": 181.06581066760864,
          "height": 40,
          "left": 248.0876510067114,
          "top": 388,
          "rotate": 0,
          "defaultFontName": "思源黑体 CN",
          "defaultColor": "#333",
          "content": "<p style=\"\"><span style=\"font-size: 14.29px;\"><span style=\"color: rgb(66, 112, 146);\">汇报时间：{{time}}</span></span></p>",
          "lineHeight": 1,
          "outline": {
            "color": "#000",
            "width": 0,
            "style": "solid"
          },
          "fill": "",
          "vertical": false
        }
      ],
      mulu:[
        {
          "type": "shape",
          "width": 1001.51,
          "height": 565.31,
          "left": 0,
          "top": -1.41,
          "viewBox": [
            1001.51,
            565.31
          ],
          "path": " M0,0 L464.1145833333333,1.0416666666666667 L780.8333333333333,334.1666666666667 L1001.5104166666666,565.3125 L685.4687499999999,563.2291666666667 L0,563.90625 L0,0z",
          "fill": "#427092",
          "fixedRatio": false,
          "rotate": 0,
          "outline": {
            "color": "#16468d",
            "width": 0,
            "style": "solid"
          },
          "text": {
            "content": "<p style=\"text-align: center;\"><span style=\"font-size: 14px;\"><span style=\"font-family: Arial;\">&nbsp;</span></span></p>",
            "defaultFontName": "思源黑体 CN",
            "defaultColor": "#333",
            "align": "middle"
          },
          "flipH": false,
          "flipV": false,
          "special": true
        },
        {
          "type": "text",
          "width": 200.26714513556618,
          "height": 71,
          "left": 807.24,
          "top": 76.15,
          "rotate": 0,
          "defaultFontName": "思源黑体 CN",
          "defaultColor": "#333",
          "content": "<p style=\"\"><span style=\"font-size: 51px;\"><span style=\"color: rgb(66, 112, 146);\">目录</span></span></p>",
          "lineHeight": 1,
          "outline": {
            "color": "#000",
            "width": 0,
            "style": "solid"
          },
          "fill": "",
          "vertical": false
        },
        {
          "type": "text",
          "width": 163.3055980861244,
          "height": 40,
          "left": 808.8,
          "top": 151.77,
          "rotate": 0,
          "defaultFontName": "思源黑体 CN",
          "defaultColor": "#333",
          "content": "<p style=\"\"><span style=\"font-size: 16px;\"><span style=\"color: rgb(66, 112, 146);\">CONTENTS</span></span></p>",
          "lineHeight": 1,
          "outline": {
            "color": "#000",
            "width": 0,
            "style": "solid"
          },
          "fill": "",
          "vertical": false
        }
        ],
      biaoti:[    
        {
          "type": "shape",
          "width": 1001.51,
          "height": 565.31,
          "left": 0,
          "top": -1.41,
          "viewBox": [
            1001.51,
            565.31
          ],
          "path": " M0,0 L464.1145833333333,1.0416666666666667 L780.8333333333333,334.1666666666667 L1001.5104166666666,565.3125 L685.4687499999999,563.2291666666667 L0,563.90625 L0,0z",
          "fill": "#427092",
          "fixedRatio": false,
          "rotate": 0,
          "outline": {
            "color": "#16468d",
            "width": 0,
            "style": "solid"
          },
          "text": {
            "content": "<p style=\"text-align: center;\"><span style=\"font-size: 18.37px;font-family: Arial;\">&nbsp;</span></p>",
            "defaultFontName": "思源黑体 CN",
            "defaultColor": "#333",
            "align": "middle"
          },
          "flipH": false,
          "flipV": false,
          "special": true
        },
        {
          "type": "shape",
          "width": 351.41,
          "height": 555.21,
          "left": 650.05,
          "top": -1.41,
          "viewBox": [
            351.41,
            555.21
          ],
          "path": " M178.04930916172106,0.31285217881292265 L349.8421272255193,0 L351.40625,555.2083333333334 L0,186.19918842349114 L178.04930916172106,0.31285217881292265z",
          "fill": "#f1cb8f",
          "fixedRatio": false,
          "rotate": 0,
          "outline": {
            "color": "#16468d",
            "width": 0,
            "style": "solid"
          },
          "text": {
            "content": "<p style=\"text-align: center;\"><span style=\"font-size: 18.37px;font-family: Arial;\">&nbsp;</span></p>",
            "defaultFontName": "思源黑体 CN",
            "defaultColor": "#333",
            "align": "middle"
          },
          "flipH": false,
          "flipV": false,
          "special": true
        },
        {
          "type": "shape",
          "width": 966.41,
          "height": 533.49,
          "left": 16.8,
          "top": 14.51,
          "viewBox": [
            200,
            200
          ],
          "path": "M 0 0 L 200 0 L 200 200 L 0 200 Z",
          "fill": "#ffffff",
          "fixedRatio": false,
          "rotate": 0,
          "outline": {
            "color": "#16468d",
            "width": 0,
            "style": "solid"
          },
          "text": {
            "content": "<p style=\"text-align: center;\"><span style=\"font-size: 18.37px;font-family: Arial;\">&nbsp;</span></p>",
            "defaultFontName": "思源黑体 CN",
            "defaultColor": "#333",
            "align": "middle"
          },
          "flipH": false,
          "flipV": false
        },
        {
          "type": "text",
          "width": 476.996644295302,
          "height": 69,
          "left": 278.24167785234897,
          "top": 227.9698657718121,
          "rotate": 0,
          "defaultFontName": "思源黑体 CN",
          "defaultColor": "#333",
          "content": "<p style=\"text-align: center;\"><span style=\"font-size: 49px;\"><span style=\"font-family: 思源黑体 CN;\"><span style=\"color: rgb(66, 112, 146);\">{{title}}</span></span></span></p>",
          "lineHeight": 1,
          "outline": {
            "color": "#000",
            "width": 0,
            "style": "solid"
          },
          "fill": "",
          "vertical": false
        },
        {
          "type": "shape",
          "width": 31.98,
          "height": 31.98,
          "left": 442.58,
          "top": 331.6863758389262,
          "viewBox": [
            200,
            200
          ],
          "path": "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
          "fill": "#f1cb8f",
          "fixedRatio": false,
          "rotate": 0,
          "outline": {
            "color": "#16468d",
            "width": 0,
            "style": "solid"
          },
          "text": {
            "content": "<p style=\"text-align: center;\" class=\"\"><span style=\"font-size: 18.37px;\"><span style=\"font-family: Arial;\">&nbsp;</span></span></p>",
            "defaultFontName": "思源黑体 CN",
            "defaultColor": "#333",
            "align": "middle"
          },
          "flipH": false,
          "flipV": false
        },
        {
          "type": "shape",
          "width": 31.98,
          "height": 31.98,
          "left": 484.76,
          "top": 331.6863758389262,
          "viewBox": [
            200,
            200
          ],
          "path": "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
          "fill": "#427092",
          "fixedRatio": false,
          "rotate": 0,
          "outline": {
            "color": "#16468d",
            "width": 0,
            "style": "solid"
          },
          "text": {
            "content": "<p style=\"text-align: center;\" class=\"ProseMirror-selectednode\" draggable=\"true\"><span style=\"font-size: 18.37px;\"><span style=\"font-family: Arial;\">&nbsp;</span></span></p>",
            "defaultFontName": "思源黑体 CN",
            "defaultColor": "#333",
            "align": "middle"
          },
          "flipH": false,
          "flipV": false
        },
        {
          "type": "shape",
          "width": 31.98,
          "height": 31.98,
          "left": 526.95,
          "top": 331.6863758389262,
          "viewBox": [
            200,
            200
          ],
          "path": "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
          "fill": "#f1cb8f",
          "fixedRatio": false,
          "rotate": 0,
          "outline": {
            "color": "#16468d",
            "width": 0,
            "style": "solid"
          },
          "text": {
            "content": "<p style=\"text-align: center;\"><span style=\"font-size: 18.37px;font-family: Arial;\">&nbsp;</span></p>",
            "defaultFontName": "思源黑体 CN",
            "defaultColor": "#333",
            "align": "middle"
          },
          "flipH": false,
          "flipV": false
        },
        {
          "type": "shape",
          "width": 38.04523489932886,
          "height": 42.07255033557047,
          "left": 481.73238255033556,
          "top": 161.19926174496644,
          "viewBox": [
            26.51,
            28.44
          ],
          "path": " M4.3002548603993915,23.3341158835332 L3.171468834435852,22.20622287807382 L4.463274286468524,18.43375250804909 L8.070696586074101,22.043010125519107 C8.070696586074101,22.043010125519107 4.3002548603993915,23.3341158835332 4.3002548603993915,23.3341158835332 M19.853790102177086,2.389806238626289 L20.904771402062174,3.443390999020111 L6.587466807975403,17.758343637721058 L5.536485508090314,16.707412743222434 C5.536485508090314,16.707412743222434 19.853790102177086,2.389806238626289 19.853790102177086,2.389806238626289 M9.799690498928538,20.9695213709113 L8.747474203391409,19.918590476412675 L23.067248788782262,5.606291703606924 L24.116995093015312,6.655895665157949 C24.116995093015312,6.655895665157949 9.799690498928538,20.9695213709113 9.799690498928538,20.9695213709113 M10.30603871626448,23.266442303205636 L26.22019268843753,7.355189328542766 C26.6067463275257,6.9677249078437775 26.6067463275257,6.34273948952452 26.22019268843753,5.953948135877934 L20.555267632535173,0.2892713825766413 C20.3687832890773,0.1048277028603425 20.116844176061367,0 19.853790102177086,0 C19.590736028292802,0 19.34003191092891,0.1048277028603425 19.15354756747104,0.2892713825766413 L3.2393935952979906,16.20185129018711 C3.133183969222647,16.308005925995054 3.0504392605360415,16.43804535485978 3.002274430106525,16.581354113200504 L0.051869817385633094,25.19314894311978 C-0.06915975651417745,25.551420838971584 0.024699913040777663,25.949500723251365 0.29022397822913754,26.21488731277122 C0.47794331733904777,26.40198485838272 0.72988243035498,26.502831762400263 0.9867615259790676,26.502831762400263 C1.0188714129320786,26.56387067798983 1.0658012477095562,26.619601861788997 1.1361959998757725,26.66737144790257 C1.6450142085157924,27.022989477859177 2.1785323301965898,27.298991530959825 2.7219304170936987,27.539166394475295 C5.254906499425448,28.661751668144277 8.102806473027112,28.625924478559096 10.853141790117705,28.011554523820635 C12.93781445075934,27.54580105921329 14.910102507065437,26.716467966963744 16.939200363365323,26.0715785544305 C19.704355628280382,25.19314894311978 22.7128050366471,24.77251119873081 25.586639918941582,24.434143297092998 C26.22019268843753,24.35850811907984 26.116453053666262,23.37392387196118 25.481665288518276,23.448232117026738 C21.574139045467252,23.908677849843684 17.740712541538556,24.690241355979655 14.035725585421908,26.01584737063133 C10.922301546631884,27.129144113667117 7.344519142675239,28.01686225561103 4.153290377806764,27.048201203863563 C3.4728077735333396,26.842526596985675 2.8083801127364203,26.549274415566238 2.1735923475884342,26.156502263076852 L9.925660055436504,23.50396330082591 C10.067684555420977,23.453539848817133 10.198594094537098,23.37392387196118 10.30603871626448,23.266442303205636 C10.30603871626448,23.266442303205636 10.30603871626448,23.266442303205636 10.30603871626448,23.266442303205636zzzz",
          "fill": "#ffffff",
          "fixedRatio": false,
          "rotate": 0,
          "outline": {
            "color": "#000",
            "width": 1,
            "style": "solid"
          },
          "text": {
            "content": "<p style=\"text-align: left;\"><span style=\"font-size: 18.37px;font-family: Arial;\">&nbsp;</span></p>",
            "defaultFontName": "思源黑体 CN",
            "defaultColor": "#333",
            "align": "middle"
          },
          "flipH": false,
          "flipV": false,
          "special": true
        }
        
        ],
      end: [
        {
          "type": "shape",
          "width": 1001.51,
          "height": 565.31,
          "left": 0,
          "top": -1.41,
          "viewBox": [
            1001.51,
            565.31
          ],
          "path": " M0,0 L464.1145833333333,1.0416666666666667 L780.8333333333333,334.1666666666667 L1001.5104166666666,565.3125 L685.4687499999999,563.2291666666667 L0,563.90625 L0,0z",
          "fill": "#427092",
          "fixedRatio": false,
          "rotate": 0,
          "outline": {
            "color": "#16468d",
            "width": 0,
            "style": "solid"
          },
          "text": {
            "content": "<p style=\"text-align: center;\"><span style=\"font-size: 18.37px;font-family: Arial;\">&nbsp;</span></p>",
            "defaultFontName": "思源黑体 CN",
            "defaultColor": "#333",
            "align": "middle"
          },
          "flipH": false,
          "flipV": false,
          "special": true
        },
        {
          "type": "shape",
          "width": 351.41,
          "height": 555.21,
          "left": 650.05,
          "top": -1.41,
          "viewBox": [
            351.41,
            555.21
          ],
          "path": " M178.04930916172106,0.31285217881292265 L349.8421272255193,0 L351.40625,555.2083333333334 L0,186.19918842349114 L178.04930916172106,0.31285217881292265z",
          "fill": "#f1cb8f",
          "fixedRatio": false,
          "rotate": 0,
          "outline": {
            "color": "#16468d",
            "width": 0,
            "style": "solid"
          },
          "text": {
            "content": "<p style=\"text-align: center;\"><span style=\"font-size: 18.37px;font-family: Arial;\">&nbsp;</span></p>",
            "defaultFontName": "思源黑体 CN",
            "defaultColor": "#333",
            "align": "middle"
          },
          "flipH": false,
          "flipV": false,
          "special": true
        },
        {
          "type": "text",
          "width": 352.5,
          "height": 75.09375,
          "left": 78.33,
          "top": 281.24499999999995,
          "rotate": 0,
          "defaultFontName": "思源黑体 CN",
          "defaultColor": "#333",
          "content": "<p style=\"\"><span style=\"font-size: 55.1px;\"><span style=\"color: #ffffff;\">谢谢大家观看</span></span></p>",
          "lineHeight": 1,
          "outline": {
            "color": "#000",
            "width": 0,
            "style": "solid"
          },
          "fill": "",
          "vertical": false
        },
        {
          "type": "shape",
          "width": 49.9,
          "height": 49.9,
          "left": 40.94,
          "top": 139.32,
          "viewBox": [
            200,
            200
          ],
          "path": "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
          "fill": "#f1cb8f",
          "fixedRatio": false,
          "rotate": 0,
          "outline": {
            "color": "#16468d",
            "width": 0,
            "style": "solid"
          },
          "text": {
            "content": "<p style=\"text-align: center;\"><span style=\"font-size: 18.37px;font-family: Arial;\">&nbsp;</span></p>",
            "defaultFontName": "思源黑体 CN",
            "defaultColor": "#333",
            "align": "middle"
          },
          "flipH": false,
          "flipV": false
        },
        {
          "type": "shape",
          "width": 49.9,
          "height": 49.9,
          "left": 78.33,
          "top": 139.32,
          "viewBox": [
            200,
            200
          ],
          "path": "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
          "fill": "#f2f2f2",
          "fixedRatio": false,
          "rotate": 0,
          "outline": {
            "color": "#16468d",
            "width": 0,
            "style": "solid"
          },
          "text": {
            "content": "<p style=\"text-align: center;\"><span style=\"font-size: 18.37px;font-family: Arial;\">&nbsp;</span></p>",
            "defaultFontName": "思源黑体 CN",
            "defaultColor": "#333",
            "align": "middle"
          },
          "flipH": false,
          "flipV": false
        }
        ],
      neirong:
        [ 
          [
            {
              "type": "shape",
              "width": 1001.51,
              "height": 565.31,
              "left": 0,
              "top": -1.41,
              "viewBox": [
                1001.51,
                565.31
              ],
              "path": " M0,0 L464.1145833333333,1.0416666666666667 L780.8333333333333,334.1666666666667 L1001.5104166666666,565.3125 L685.4687499999999,563.2291666666667 L0,563.90625 L0,0z",
              "fill": "#427092",
              "fixedRatio": false,
              "rotate": 0,
              "outline": {
                "color": "#16468d",
                "width": 0,
                "style": "solid"
              },
              "text": {
                "content": "<p style=\"text-align: center;\"><span style=\"font-size: 18.37px;font-family: Arial;\">&nbsp;</span></p>",
                "defaultFontName": "思源黑体 CN",
                "defaultColor": "#333",
                "align": "middle"
              },
              "flipH": false,
              "flipV": false,
              "special": true
            },
            {
              "type": "shape",
              "width": 351.41,
              "height": 555.21,
              "left": 650.05,
              "top": -1.41,
              "viewBox": [
                351.41,
                555.21
              ],
              "path": " M178.04930916172106,0.31285217881292265 L349.8421272255193,0 L351.40625,555.2083333333334 L0,186.19918842349114 L178.04930916172106,0.31285217881292265z",
              "fill": "#f1cb8f",
              "fixedRatio": false,
              "rotate": 0,
              "outline": {
                "color": "#16468d",
                "width": 0,
                "style": "solid"
              },
              "text": {
                "content": "<p style=\"text-align: center;\"><span style=\"font-size: 18.37px;font-family: Arial;\">&nbsp;</span></p>",
                "defaultFontName": "思源黑体 CN",
                "defaultColor": "#333",
                "align": "middle"
              },
              "flipH": false,
              "flipV": false,
              "special": true
            },
            {
              "type": "shape",
              "width": 966,
              "height": 533,
              "left": 16,
              "top": 14,
              "viewBox": [
                200,
                200
              ],
              "path": "M 0 0 L 200 0 L 200 200 L 0 200 Z",
              "fill": "#ffffff",
              "fixedRatio": false,
              "rotate": 0,
              "outline": {
                "color": "#16468d",
                "width": 0,
                "style": "solid"
              },
              "text": {
                "content": "<p style=\"text-align: center;\"><span style=\"font-size: 18.37px;font-family: Arial;\">&nbsp;</span></p>",
                "defaultFontName": "思源黑体 CN",
                "defaultColor": "#333",
                "align": "middle"
              },
              "flipH": false,
              "flipV": false
            },
            {
              "type": "image",
              "id": "2EvI3pSehb",
             src:'https://static.yipigai.cn/public/muban/3/nr-2.png',
              "width": 966,
              "height": 304.3,
              "left": 16,
              "top": 342,
              "fixedRatio": true,
              "rotate": 0
            },
            
            {
              "type": "shape",
              "width": 17.34,
              "height": 17.34,
              "left": 33.7,
              "top": 44.84,
              "viewBox": [
                200,
                200
              ],
              "path": "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
              "fill": "#427092",
              "fixedRatio": false,
              "rotate": 0,
              "outline": {
                "color": "#16468d",
                "width": 0,
                "style": "solid"
              },
              "text": {
                "content": "<p style=\"text-align: center;\"><span style=\"font-size: 18.37px;font-family: Arial;\">&nbsp;</span></p>",
                "defaultFontName": "思源黑体 CN",
                "defaultColor": "#333",
                "align": "middle"
              },
              "flipH": false,
              "flipV": false
            },
            {
              "type": "text",
              "width": 373.28999999999996,
              "height": 44.484375,
              "left": 58.85,
              "top": 26,
              "rotate": 0,
              "defaultFontName": "思源黑体 CN",
              "defaultColor": "#333",
              "content": "<p style=\"\"><strong><span style=\"font-size: 24.49px;\"><span style=\"color: rgb(66, 112, 146);\">{{title}}</span></span></strong></p>",
              "lineHeight": 1,
              "outline": {
                "color": "#000",
                "width": 0,
                "style": "solid"
              },
              "fill": "",
              "vertical": false
            }
          ] ,
          [
            {
              "type": "shape",
              "width": 1001.51,
              "height": 565.31,
              "left": 0,
              "top": -1.41,
              "viewBox": [
                1001.51,
                565.31
              ],
              "path": " M0,0 L464.1145833333333,1.0416666666666667 L780.8333333333333,334.1666666666667 L1001.5104166666666,565.3125 L685.4687499999999,563.2291666666667 L0,563.90625 L0,0z",
              "fill": "#427092",
              "fixedRatio": false,
              "rotate": 0,
              "outline": {
                "color": "#16468d",
                "width": 0,
                "style": "solid"
              },
              "text": {
                "content": "<p style=\"text-align: center;\"><span style=\"font-size: 18.37px;font-family: Arial;\">&nbsp;</span></p>",
                "defaultFontName": "思源黑体 CN",
                "defaultColor": "#333",
                "align": "middle"
              },
              "flipH": false,
              "flipV": false,
              "special": true
            },
            {
              "type": "shape",
              "width": 351.41,
              "height": 555.21,
              "left": 650.05,
              "top": -1.41,
              "viewBox": [
                351.41,
                555.21
              ],
              "path": " M178.04930916172106,0.31285217881292265 L349.8421272255193,0 L351.40625,555.2083333333334 L0,186.19918842349114 L178.04930916172106,0.31285217881292265z",
              "fill": "#f1cb8f",
              "fixedRatio": false,
              "rotate": 0,
              "outline": {
                "color": "#16468d",
                "width": 0,
                "style": "solid"
              },
              "text": {
                "content": "<p style=\"text-align: center;\"><span style=\"font-size: 18.37px;font-family: Arial;\">&nbsp;</span></p>",
                "defaultFontName": "思源黑体 CN",
                "defaultColor": "#333",
                "align": "middle"
              },
              "flipH": false,
              "flipV": false,
              "special": true
            },
            {
              "type": "shape",
              "width": 966,
              "height": 533,
              "left": 16,
              "top": 14,
              "viewBox": [
                200,
                200
              ],
              "path": "M 0 0 L 200 0 L 200 200 L 0 200 Z",
              "fill": "#ffffff",
              "fixedRatio": false,
              "rotate": 0,
              "outline": {
                "color": "#16468d",
                "width": 0,
                "style": "solid"
              },
              "text": {
                "content": "<p style=\"text-align: center;\"><span style=\"font-size: 18.37px;font-family: Arial;\">&nbsp;</span></p>",
                "defaultFontName": "思源黑体 CN",
                "defaultColor": "#333",
                "align": "middle"
              },
              "flipH": false,
              "flipV": false
            },
            {
              "type": "image",
              "id": "2EvI3pSehb",
             src:'https://static.yipigai.cn/public/muban/3/nr-1.png',
              "width": 966,
              "height": 243.5,
              "left": 16,
              "top": 304,
              "fixedRatio": true,
              "rotate": 0
            },
            {
              "type": "shape",
              "width": 17.34,
              "height": 17.34,
              "left": 33.7,
              "top": 44.84,
              "viewBox": [
                200,
                200
              ],
              "path": "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
              "fill": "#427092",
              "fixedRatio": false,
              "rotate": 0,
              "outline": {
                "color": "#16468d",
                "width": 0,
                "style": "solid"
              },
              "text": {
                "content": "<p style=\"text-align: center;\"><span style=\"font-size: 18.37px;font-family: Arial;\">&nbsp;</span></p>",
                "defaultFontName": "思源黑体 CN",
                "defaultColor": "#333",
                "align": "middle"
              },
              "flipH": false,
              "flipV": false
            },
            {
              "type": "text",
              "width": 373.28999999999996,
              "height": 44.484375,
              "left": 58.85,
              "top": 26,
              "rotate": 0,
              "defaultFontName": "思源黑体 CN",
              "defaultColor": "#333",
              "content": "<p style=\"\"><strong><span style=\"font-size: 24.49px;\"><span style=\"color: rgb(66, 112, 146);\">{{title}}</span></span></strong></p>",
              "lineHeight": 1,
              "outline": {
                "color": "#000",
                "width": 0,
                "style": "solid"
              },
              "fill": "",
              "vertical": false
            }
          ] 
         
         ]
    },
    theme: {
      backgroundColor: '#f2f2f2',
      themeColor: '#5B9BD5',
      fontColor: '#000',
      fontName: '思源黑体 CN',
      outline: {},
      shadow: { h: 3, v: 3, blur: 2, color: '#808080' }
    }
  },
  {
    id: '7',
    imgList: [
      { imgUrl: 'https://static.yipigai.cn/public/muban/7/1.jpeg' },
      { imgUrl: 'https://static.yipigai.cn/public/muban/7/2.jpeg' },
      { imgUrl: 'https://static.yipigai.cn/public/muban/7/3.jpeg' },
      { imgUrl: 'https://static.yipigai.cn/public/muban/7/4.jpeg' }
    ],
    background: {
      type: 'image',
      image:'https://static.yipigai.cn/public/muban/7/bj.jpeg',
      imageSize: 'cover'
    },
    slide:{
      shouye:[ {
        "type": "text",
        "width": 757.6,
        "height": 64.890625,
        "left": 139.7,
        "top": 216.3,
        "rotate": 0,
        "defaultFontName": "思源黑体 CN",
        "defaultColor": "#333",
        "content": "<p style=\"text-align: center;\"><span style=\"font-size: 44.9px;font-family: 思源黑体 CN;\">{{title}}</span></p>",
        "lineHeight": 1,
        "outline": {
          "color": "#000",
          "width": 0,
          "style": "solid"
        },
        "fill": "",
        "vertical": false
      },
      {
        "type": "text",
        "width": 203.75,
        "height": 40,
        "left": 398.13,
        "top": 403.24,
        "rotate": 0,
        "defaultFontName": "思源黑体 CN",
        "defaultColor": "#333",
        "content": "<p style=\"text-align: center;\"><span style=\"font-size: 16.33px;font-family: 思源黑体 CN;\">授课教师：小鸿</span></p>",
        "lineHeight": 1,
        "outline": {
          "color": "#000",
          "width": 0,
          "style": "solid"
        },
        "fill": "",
        "vertical": false
      }],
      mulu:[
        {
          "type": "text",
          "width": 589.6671284271284,
          "height": 56.71875,
          "left": 166.69,
          "top": 130.63,
          "rotate": 0,
          "defaultFontName": "思源黑体 CN",
          "defaultColor": "#333",
          "content": "<p style=\"text-align: center;\"><span style=\"font-size: 36.73px;font-family: 思源黑体 CN;\">目录</span><span style=\"font-size: 36.73px;font-family: 思源黑体 CN;\">-CONTENTS</span></p>",
          "lineHeight": 1,
          "outline": {
            "color": "#000",
            "width": 0,
            "style": "solid"
          },
          "fill": "",
          "vertical": false
        }
      ],
      biaoti:[
        {
          "type": "shape",
          "width": 153.11,
          "height": 25.4,
          "left": 423.45000000000005,
          "top": 171.39,
          "viewBox": [
            200,
            200
          ],
          "path": "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
          "fill": "#7d9f64",
          "fixedRatio": false,
          "rotate": 0,
          "flipH": false,
          "flipV": false
        },
        {
          "type": "text",
          "width": 109.33827751196172,
          "height": 68,
          "left": 445.33586124401916,
          "top": 128.79,
          "rotate": 0,
          "defaultFontName": "思源黑体 CN",
          "defaultColor": "#333",
          "content": "<p style=\"text-align: center;\"><em><strong><span style=\"font-size: 48px;\"><span style=\"color: rgb(119, 148, 99);\">{{index}}</span></span></strong></em></p>",
          "lineHeight": 1,
          "fill": "",
          "vertical": false
        },
        {
          "type": "text",
          "width": 867.6888888888889,
          "height": 72.03125,
          "left": 65.47777777777782,
          "top": 223.7,
          "rotate": 0,
          "content": "<p style=\"text-align: center;\"><span style=\"font-size: 34.69px;\"><span style=\"font-family: 思源黑体 CN;\">{{title}}</span></span></p>",
          "defaultFontName": "思源黑体 CN",
          "defaultColor": "#000"
        }
      ],
      end: [
        {
          "type": "text",
          "width": 717.5,
          "height": 64.890625,
          "left": 141.25,
          "top": 216.99,
          "rotate": 0,
          "defaultFontName": "思源黑体 CN",
          "defaultColor": "#333",
          "content": "<p style=\"text-align: center;\"><span style=\"font-size: 44.9px;font-family: +mn-ea;\">讲解完毕，谢谢大家</span></p>",
          "lineHeight": 1,
          "outline": {
            "color": "#000",
            "width": 0,
            "style": "solid"
          },
          "fill": "",
          "vertical": false
        },
        {
          "type": "text",
          "width": 203.75,
          "height": 40,
          "left": 398.13,
          "top": 403.24,
          "rotate": 0,
          "defaultFontName": "思源黑体 CN",
          "defaultColor": "#333",
          "content": "<p style=\"text-align: center;\"><span style=\"font-size: 16.33px;\"><span style=\"font-family: +mn-ea;\">授课老师：小鸿</span></span></p>",
          "lineHeight": 1,
          "outline": {
            "color": "#000",
            "width": 0,
            "style": "solid"
          },
          "fill": "",
          "vertical": false
        }
      ],
      neirong:[
        [
          {
            "type": "image",
            "id": "BlSNzwrdiO",
            src:'https://static.yipigai.cn/public/muban/7/nr-2.png',
            "width": 195.27735368956743,
            "height": 109.60420096791897,
            "left": 746,
            "top": 0,
            "fixedRatio": true,
            "rotate": 0
          },
         
          {
            "type": "shape",
            "width": 42.39,
            "height": 42.39,
            "left": 41.37,
            "top": 34.07,
            "viewBox": [
              200,
              200
            ],
            "path": "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
            "fill": "rgb(234, 201, 177)",
            "fixedRatio": false,
            "rotate": 0,
            "flipH": false,
            "flipV": false
          },
          {
            "type": "text",
            "width": 881.1663203463204,
            "height": 56,
            "left": 91,
            "top": 24,
            "rotate": 0,
            "content": "<p style=\"\"><strong><span style=\"font-size: 30px;\">{{title}}</span></strong></p>",
            "defaultFontName": "思源黑体 CN",
            "defaultColor": "#333"
          }
        ],
        [
          {
            "type": "image",
            "id": "Z8XkF-eykI",
           src:'https://static.yipigai.cn/public/muban/7/nr-1.png',
            "width": 232.14890016920475,
            "height": 343,
            "left": 0,
            "top": 222,
            "fixedRatio": true,
            "rotate": 0
          },
          {
            "type": "shape",
            "width": 42.39,
            "height": 42.39,
            "left": 41.37,
            "top": 34.07,
            "viewBox": [
              200,
              200
            ],
            "path": "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
            "fill": "rgb(234, 201, 177)",
            "fixedRatio": false,
            "rotate": 0,
            "flipH": false,
            "flipV": false
          },
          {
            "type": "text",
            "width": 881.1663203463204,
            "height": 56,
            "left": 91,
            "top": 24,
            "rotate": 0,
            "content": "<p style=\"\"><strong><span style=\"font-size: 30px;\">{{title}}</span></strong></p>",
            "defaultFontName": "思源黑体 CN",
            "defaultColor": "#333"
          }
        ]

       
      ]
    },
    theme: {
      backgroundColor: '#fff',
      themeColor: '#7D9F64',
      fontColor: '#333333',
      fontName: '思源黑体 CN',
      outline: {},
      shadow: { h: 3, v: 3, blur: 2, color: '#808080' }
    }

  },
  {
    id: '8',
    imgList: [
      { imgUrl: 'https://static.yipigai.cn/public/muban/8/1.jpeg' },
      { imgUrl: 'https://static.yipigai.cn/public/muban/8/2.jpeg' },
      { imgUrl: 'https://static.yipigai.cn/public/muban/8/3.jpeg' },
      { imgUrl: 'https://static.yipigai.cn/public/muban/8/4.jpeg' }
    ],
    background: {
      type: 'image',
      image:'https://static.yipigai.cn/public/muban/8/bj.jpeg',
      imageSize: 'cover'
    },
    slide:{
      shouye:[
        {
          "type": "shape",
          "left": 279.4124054515669,
          "top": 64.37327767730038,
          "width": 441.17518909686635,
          "height": 422.3215485371712,
          "viewBox": [
            200,
            200
          ],
          "path": "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
          "fill": "rgba(197,227,255,1)",
          "fixedRatio": false,
          "rotate": 0,
          "gradient": {
            "type": "linear",
            "rotate": 90,
            "color": [
              'rgba(197,227,255,1)',
              "#fff"
            ]
          }
        },
        {
          "type": "text",
          "left": 39.009036331964694,
          "top": 183.09134375650024,
          "width": 918.1453323379504,
          "height": 141.5,
          "content": "<p style=\"text-align: center;\"><strong><span style=\"font-size: 80px;\"><span style=\"font-family: Arial;\">{{title}}</span></span></strong></p>",
          "rotate": 0,
          "defaultFontName": "思源黑体 CN",
          "defaultColor": "#333",
          "vertical": false
        },
        {
          "type": "text",
          "left": 414.52301853925593,
          "top": 336.5,
          "width": 170.95396292148808,
          "height": 50,
          "content": "<p style=\"text-align: center;\"><strong><span style=\"font-size: 20px;\"><span style=\"font-family: Arial;\">授课老师：小鸿</span></span></strong></p>",
          "rotate": 0,
          "defaultFontName": "思源黑体 CN",
          "defaultColor": "#333",
          "vertical": false
        },
        {
          "type": "shape",
          "left": 925.910123304729,
          "top": 38.21166304881313,
          "width": 13.532914769205899,
          "height": 13.532914769205899,
          "viewBox": [
            200,
            200
          ],
          "path": "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
          "fill": "rgba(197,227,255,1)",
          "fixedRatio": false,
          "rotate": 0
        },
        {
          "type": "shape",
          "left": 943.6214539007092,
          "top": 38.21166304881313,
          "width": 13.532914769205899,
          "height": 13.532914769205899,
          "viewBox": [
            200,
            200
          ],
          "path": "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
          "fill": "#5b9bd5",
          "fixedRatio": false,
          "rotate": 0
        },
        {
          "type": "shape",
          "left": 925.910123304729,
          "top": 57.606820292697435,
          "width": 13.532914769205899,
          "height": 13.532914769205899,
          "viewBox": [
            200,
            200
          ],
          "path": "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
          "fill": "#5b9bd5",
          "fixedRatio": false,
          "rotate": 0
        },
        {
          "type": "shape",
          "left": 943.6214539007092,
          "top": 57.606820292697435,
          "width": 13.532914769205899,
          "height": 13.532914769205899,
          "viewBox": [
            200,
            200
          ],
          "path": "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
          "fill": "rgba(197,227,255,1)",
          "fixedRatio": false,
          "rotate": 0
        },
        {
          "type": "shape",
          "left": 925.910123304729,
          "top": 76.16006421262963,
          "width": 13.532914769205899,
          "height": 13.532914769205899,
          "viewBox": [
            200,
            200
          ],
          "path": "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
          "fill": "rgba(197,227,255,1)",
          "fixedRatio": false,
          "rotate": 0
        },
        {
          "type": "shape",
          "left": 943.6214539007092,
          "top": 76.16006421262963,
          "width": 13.532914769205899,
          "height": 13.532914769205899,
          "viewBox": [
            200,
            200
          ],
          "path": "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
          "fill": "#5b9bd5",
          "fixedRatio": false,
          "rotate": 0
        },
        {
          "type": "shape",
          "left": 39.00903633196466,
          "top": 31.445205664210178,
          "width": 13.532914769205899,
          "height": 13.532914769205899,
          "viewBox": [
            200,
            200
          ],
          "path": "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
          "fill": "rgba(197,227,255,1)",
          "fixedRatio": false,
          "rotate": 0
        },
        {
          "type": "shape",
          "left": 56.72036692794478,
          "top": 31.445205664210178,
          "width": 13.532914769205899,
          "height": 13.532914769205899,
          "viewBox": [
            200,
            200
          ],
          "path": "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
          "fill": "#5b9bd5",
          "fixedRatio": false,
          "rotate": 0
        },
        {
          "type": "shape",
          "left": 39.00903633196466,
          "top": 50.840362908094484,
          "width": 13.532914769205899,
          "height": 13.532914769205899,
          "viewBox": [
            200,
            200
          ],
          "path": "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
          "fill": "#5b9bd5",
          "fixedRatio": false,
          "rotate": 0
        },
        {
          "type": "shape",
          "left": 56.72036692794478,
          "top": 50.840362908094484,
          "width": 13.532914769205899,
          "height": 13.532914769205899,
          "viewBox": [
            200,
            200
          ],
          "path": "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
          "fill": "rgba(197,227,255,1)",
          "fixedRatio": false,
          "rotate": 0
        },
        {
          "type": "shape",
          "left": 39.00903633196466,
          "top": 69.39360682802669,
          "width": 13.532914769205899,
          "height": 13.532914769205899,
          "viewBox": [
            200,
            200
          ],
          "path": "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
          "fill": "rgba(197,227,255,1)",
          "fixedRatio": false,
          "rotate": 0
        },
        {
          "type": "shape",
          "left": 56.72036692794478,
          "top": 69.39360682802669,
          "width": 13.532914769205899,
          "height": 13.532914769205899,
          "viewBox": [
            200,
            200
          ],
          "path": "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
          "fill": "#5b9bd5",
          "fixedRatio": false,
          "rotate": 0
        },
        {
          "type": "line",
          "left": 47.7,
          "top": 525.253178424802,
          "start": [
            0,
            0
          ],
          "end": [
            904.636923852177,
            0.04682157519800967
          ],
          "points": [
            "",
            ""
          ],
          "color": "rgba(197,227,255,1)",
          "style": "solid",
          "width": 1
        },
        {
          "type": "shape",
          "left": 39.00903633196466,
          "top": 514.7202636555961,
          "width": 13.532914769205899,
          "height": 13.532914769205899,
          "viewBox": [
            200,
            200
          ],
          "path": "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
          "fill": "rgba(121,188,250,1)",
          "fixedRatio": false,
          "rotate": 0
        },
        {
          "type": "shape",
          "left": 943.6214539007092,
          "top": 514.7202636555961,
          "width": 13.532914769205899,
          "height": 13.532914769205899,
          "viewBox": [
            200,
            200
          ],
          "path": "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
          "fill": "rgba(121,188,250,1)",
          "fixedRatio": false,
          "rotate": 0
        }
      ],
      mulu:[
        {
          "type": "shape",
          "left": 39.00903633196466,
          "top": 31.445205664210178,
          "width": 13.532914769205899,
          "height": 13.532914769205899,
          "viewBox": [
            200,
            200
          ],
          "path": "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
          "fill": "rgba(197,227,255,1)",
          "fixedRatio": false,
          "rotate": 0
        },
        {
          "type": "shape",
          "left": 56.7,
          "top": 31.4,
          "width": 13.532914769205899,
          "height": 13.532914769205899,
          "viewBox": [
            200,
            200
          ],
          "path": "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
          "fill": "#5b9bd5",
          "fixedRatio": false,
          "rotate": 0
        },
        {
          "type": "shape",
          "left": 39.00903633196466,
          "top": 50.840362908094484,
          "width": 13.532914769205899,
          "height": 13.532914769205899,
          "viewBox": [
            200,
            200
          ],
          "path": "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
          "fill": "#5b9bd5",
          "fixedRatio": false,
          "rotate": 0
        },
        {
          "type": "shape",
          "left": 56.72036692794478,
          "top": 50.840362908094484,
          "width": 13.532914769205899,
          "height": 13.532914769205899,
          "viewBox": [
            200,
            200
          ],
          "path": "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
          "fill": "rgba(197,227,255,1)",
          "fixedRatio": false,
          "rotate": 0
        },
        {
          "type": "text",
          "left": 83,
          "top": 0,
          "width": 836,
          "height": 177,
          "content": "<p style=\"text-align: center;\"><strong><span style=\"font-size: 104px;\"><span style=\"font-family: Arial;\"><span style=\"color: rgba(232,234,238,0.47);\">CONTENTS</span></span></span></strong></p>",
          "rotate": 0,
          "defaultFontName": "思源黑体 CN",
          "defaultColor": "#333",
          "vertical": false
        },
        {
          "type": "text",
          "left": 281,
          "top": 24,
          "width": 436,
          "height": 129.5,
          "content": "<p style=\"text-align: center;\"><strong><span style=\"font-size: 72px;\"><span style=\"font-family: Arial;\">目录</span></span></strong></p>",
          "rotate": 0,
          "defaultFontName": "思源黑体 CN",
          "defaultColor": "#333",
          "vertical": false
        },
        {
          "type": "line",
          "left": 47.7,
          "top": 525.253178424802,
          "start": [
            0,
            0
          ],
          "end": [
            904.636923852177,
            0.04682157519800967
          ],
          "points": [
            "",
            ""
          ],
          "color": "rgba(197,227,255,1)",
          "style": "solid",
          "width": 1
        },
        {
          "type": "shape",
          "left": 39.00903633196466,
          "top": 514.7202636555961,
          "width": 13.532914769205899,
          "height": 13.532914769205899,
          "viewBox": [
            200,
            200
          ],
          "path": "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
          "fill": "rgba(121,188,250,1)",
          "fixedRatio": false,
          "rotate": 0
        },
        {
          "type": "shape",
          "left": 943.6214539007092,
          "top": 514.7202636555961,
          "width": 13.532914769205899,
          "height": 13.532914769205899,
          "viewBox": [
            200,
            200
          ],
          "path": "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
          "fill": "rgba(121,188,250,1)",
          "fixedRatio": false,
          "rotate": 0
        }
      ],
      biaoti:[ {
        "type": "shape",
        "left": 279.4124054515669,
        "top": 71.13973506190334,
        "width": 441.17518909686635,
        "height": 422.3215485371712,
        "viewBox": [
          200,
          200
        ],
        "path": "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
        "fill": "rgba(197,227,255,1)",
        "fixedRatio": false,
        "rotate": 0,
        "gradient": {
          "type": "linear",
          "rotate": 90,
          "color": [
            "rgba(197,227,255,1)",
            "#fff"
          ]
        }
      },
      {
        "type": "text",
        "left": 40.92733383102482,
        "top": 185.21471352349405,
        "width": 918.1453323379504,
        "height": 93.5,
        "content": "<p style=\"text-align: center;\"><strong><span style=\"font-size: 72px;\"><span style=\"font-family: Arial;\">{{index}}</span></span></strong></p>",
        "rotate": 0,
        "defaultFontName": "思源黑体 CN",
        "defaultColor": "#333",
        "vertical": false,
        "lineHeight": 1
      },
      {
        "type": "text",
        "left": 40.927333831024825,
        "top": 278.7147135234941,
        "width": 918.1453323379504,
        "height": 68.5,
        "content": "<p style=\"text-align: center;\"><strong><span style=\"font-size: 32px;\"><span style=\"font-family: Arial;\">{{title}}</span></span></strong></p>",
        "rotate": 0,
        "defaultFontName": "思源黑体 CN",
        "defaultColor": "#333",
        "vertical": false
      },
      {
        "type": "shape",
        "left": 925.910123304729,
        "top": 38.21166304881313,
        "width": 13.532914769205899,
        "height": 13.532914769205899,
        "viewBox": [
          200,
          200
        ],
        "path": "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
        "fill": "rgba(197,227,255,1)",
        "fixedRatio": false,
        "rotate": 0
      },
      {
        "type": "shape",
        "left": 943.6214539007092,
        "top": 38.21166304881313,
        "width": 13.532914769205899,
        "height": 13.532914769205899,
        "viewBox": [
          200,
          200
        ],
        "path": "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
        "fill": "#5b9bd5",
        "fixedRatio": false,
        "rotate": 0
      },
      {
        "type": "shape",
        "left": 925.910123304729,
        "top": 57.606820292697435,
        "width": 13.532914769205899,
        "height": 13.532914769205899,
        "viewBox": [
          200,
          200
        ],
        "path": "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
        "fill": "#5b9bd5",
        "fixedRatio": false,
        "rotate": 0
      },
      {
        "type": "shape",
        "left": 943.6214539007092,
        "top": 57.606820292697435,
        "width": 13.532914769205899,
        "height": 13.532914769205899,
        "viewBox": [
          200,
          200
        ],
        "path": "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
        "fill": "rgba(197,227,255,1)",
        "fixedRatio": false,
        "rotate": 0
      },
      {
        "type": "shape",
        "left": 925.910123304729,
        "top": 76.16006421262963,
        "width": 13.532914769205899,
        "height": 13.532914769205899,
        "viewBox": [
          200,
          200
        ],
        "path": "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
        "fill": "rgba(197,227,255,1)",
        "fixedRatio": false,
        "rotate": 0
      },
      {
        "type": "shape",
        "left": 943.6214539007092,
        "top": 76.16006421262963,
        "width": 13.532914769205899,
        "height": 13.532914769205899,
        "viewBox": [
          200,
          200
        ],
        "path": "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
        "fill": "#5b9bd5",
        "fixedRatio": false,
        "rotate": 0
      },
      {
        "type": "shape",
        "left": 39.00903633196466,
        "top": 31.445205664210178,
        "width": 13.532914769205899,
        "height": 13.532914769205899,
        "viewBox": [
          200,
          200
        ],
        "path": "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
        "fill": "rgba(197,227,255,1)",
        "fixedRatio": false,
        "rotate": 0
      },
      {
        "type": "shape",
        "left": 56.72036692794478,
        "top": 31.445205664210178,
        "width": 13.532914769205899,
        "height": 13.532914769205899,
        "viewBox": [
          200,
          200
        ],
        "path": "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
        "fill": "#5b9bd5",
        "fixedRatio": false,
        "rotate": 0
      },
      {
        "type": "shape",
        "left": 39.00903633196466,
        "top": 50.840362908094484,
        "width": 13.532914769205899,
        "height": 13.532914769205899,
        "viewBox": [
          200,
          200
        ],
        "path": "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
        "fill": "#5b9bd5",
        "fixedRatio": false,
        "rotate": 0
      },
      {
        "type": "shape",
        "left": 56.72036692794478,
        "top": 50.840362908094484,
        "width": 13.532914769205899,
        "height": 13.532914769205899,
        "viewBox": [
          200,
          200
        ],
        "path": "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
        "fill": "rgba(197,227,255,1)",
        "fixedRatio": false,
        "rotate": 0
      },
      {
        "type": "shape",
        "left": 39.00903633196466,
        "top": 69.39360682802669,
        "width": 13.532914769205899,
        "height": 13.532914769205899,
        "viewBox": [
          200,
          200
        ],
        "path": "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
        "fill": "rgba(197,227,255,1)",
        "fixedRatio": false,
        "rotate": 0
      },
      {
        "type": "shape",
        "left": 56.72036692794478,
        "top": 69.39360682802669,
        "width": 13.532914769205899,
        "height": 13.532914769205899,
        "viewBox": [
          200,
          200
        ],
        "path": "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
        "fill": "#5b9bd5",
        "fixedRatio": false,
        "rotate": 0
      },
      {
        "type": "line",
        "left": 47.7,
        "top": 525.253178424802,
        "start": [
          0,
          0
        ],
        "end": [
          904.636923852177,
          0.04682157519800967
        ],
        "points": [
          "",
          ""
        ],
        "color": "rgba(197,227,255,1)",
        "style": "solid",
        "width": 1
      },
      {
        "type": "shape",
        "left": 39.00903633196466,
        "top": 514.7202636555961,
        "width": 13.532914769205899,
        "height": 13.532914769205899,
        "viewBox": [
          200,
          200
        ],
        "path": "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
        "fill": "rgba(121,188,250,1)",
        "fixedRatio": false,
        "rotate": 0
      },
      {
        "type": "shape",
        "left": 943.6214539007092,
        "top": 514.7202636555961,
        "width": 13.532914769205899,
        "height": 13.532914769205899,
        "viewBox": [
          200,
          200
        ],
        "path": "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
        "fill": "rgba(121,188,250,1)",
        "fixedRatio": false,
        "rotate": 0
      }],
      end: [
        {
          "type": "shape",
          "left": 279.4124054515669,
          "top": 64.37327767730038,
          "width": 441.17518909686635,
          "height": 422.3215485371712,
          "viewBox": [
            200,
            200
          ],
          "path": "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
          "fill": "rgba(197,227,255,1)",
          "fixedRatio": false,
          "rotate": 0,
          "gradient": {
            "type": "linear",
            "rotate": 90,
            "color": [
              "rgba(197,227,255,1)",
              "#fff"
            ]
          }
        },
        {
          "type": "text",
          "left": 39.009036331964694,
          "top": 183.09134375650024,
          "width": 918.1453323379504,
          "height": 141.5,
          "content": "<p style=\"text-align: center;\"><strong><span style=\"font-size: 80px;\"><span style=\"font-family: Arial;\">谢谢观看</span></span></strong></p>",
          "rotate": 0,
          "defaultFontName": "思源黑体 CN",
          "defaultColor": "#333",
          "vertical": false
        },
        {
          "type": "text",
          "left": 414.52301853925593,
          "top": 336.5,
          "width": 170.95396292148808,
          "height": 50,
          "content": "<p style=\"text-align: center;\"><strong><span style=\"font-size: 20px;\"><span style=\"font-family: Arial;\">授课老师：小鸿</span></span></strong></p>",
          "rotate": 0,
          "defaultFontName": "思源黑体 CN",
          "defaultColor": "#333",
          "vertical": false
        },
        {
          "type": "shape",
          "left": 925.910123304729,
          "top": 38.21166304881313,
          "width": 13.532914769205899,
          "height": 13.532914769205899,
          "viewBox": [
            200,
            200
          ],
          "path": "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
          "fill": "rgba(197,227,255,1)",
          "fixedRatio": false,
          "rotate": 0
        },
        {
          "type": "shape",
          "left": 943.6214539007092,
          "top": 38.21166304881313,
          "width": 13.532914769205899,
          "height": 13.532914769205899,
          "viewBox": [
            200,
            200
          ],
          "path": "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
          "fill": "#5b9bd5",
          "fixedRatio": false,
          "rotate": 0
        },
        {
          "type": "shape",
          "left": 925.910123304729,
          "top": 57.606820292697435,
          "width": 13.532914769205899,
          "height": 13.532914769205899,
          "viewBox": [
            200,
            200
          ],
          "path": "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
          "fill": "#5b9bd5",
          "fixedRatio": false,
          "rotate": 0
        },
        {
          "type": "shape",
          "left": 943.6214539007092,
          "top": 57.606820292697435,
          "width": 13.532914769205899,
          "height": 13.532914769205899,
          "viewBox": [
            200,
            200
          ],
          "path": "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
          "fill": "rgba(197,227,255,1)",
          "fixedRatio": false,
          "rotate": 0
        },
        {
          "type": "shape",
          "left": 925.910123304729,
          "top": 76.16006421262963,
          "width": 13.532914769205899,
          "height": 13.532914769205899,
          "viewBox": [
            200,
            200
          ],
          "path": "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
          "fill": "rgba(197,227,255,1)",
          "fixedRatio": false,
          "rotate": 0
        },
        {
          "type": "shape",
          "left": 943.6214539007092,
          "top": 76.16006421262963,
          "width": 13.532914769205899,
          "height": 13.532914769205899,
          "viewBox": [
            200,
            200
          ],
          "path": "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
          "fill": "#5b9bd5",
          "fixedRatio": false,
          "rotate": 0
        },
        {
          "type": "shape",
          "left": 39.00903633196466,
          "top": 31.445205664210178,
          "width": 13.532914769205899,
          "height": 13.532914769205899,
          "viewBox": [
            200,
            200
          ],
          "path": "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
          "fill": "rgba(197,227,255,1)",
          "fixedRatio": false,
          "rotate": 0
        },
        {
          "type": "shape",
          "left": 56.72036692794478,
          "top": 31.445205664210178,
          "width": 13.532914769205899,
          "height": 13.532914769205899,
          "viewBox": [
            200,
            200
          ],
          "path": "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
          "fill": "#5b9bd5",
          "fixedRatio": false,
          "rotate": 0
        },
        {
          "type": "shape",
          "left": 39.00903633196466,
          "top": 50.840362908094484,
          "width": 13.532914769205899,
          "height": 13.532914769205899,
          "viewBox": [
            200,
            200
          ],
          "path": "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
          "fill": "#5b9bd5",
          "fixedRatio": false,
          "rotate": 0
        },
        {
          "type": "shape",
          "left": 56.72036692794478,
          "top": 50.840362908094484,
          "width": 13.532914769205899,
          "height": 13.532914769205899,
          "viewBox": [
            200,
            200
          ],
          "path": "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
          "fill": "rgba(197,227,255,1)",
          "fixedRatio": false,
          "rotate": 0
        },
        {
          "type": "shape",
          "left": 39.00903633196466,
          "top": 69.39360682802669,
          "width": 13.532914769205899,
          "height": 13.532914769205899,
          "viewBox": [
            200,
            200
          ],
          "path": "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
          "fill": "rgba(197,227,255,1)",
          "fixedRatio": false,
          "rotate": 0
        },
        {
          "type": "shape",
          "left": 56.72036692794478,
          "top": 69.39360682802669,
          "width": 13.532914769205899,
          "height": 13.532914769205899,
          "viewBox": [
            200,
            200
          ],
          "path": "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
          "fill": "#5b9bd5",
          "fixedRatio": false,
          "rotate": 0
        },
        {
          "type": "line",
          "left": 47.7,
          "top": 525.253178424802,
          "start": [
            0,
            0
          ],
          "end": [
            904.636923852177,
            0.04682157519800967
          ],
          "points": [
            "",
            ""
          ],
          "color": "rgba(197,227,255,1)",
          "style": "solid",
          "width": 1
        },
        {
          "type": "shape",
          "left": 39.00903633196466,
          "top": 514.7202636555961,
          "width": 13.532914769205899,
          "height": 13.532914769205899,
          "viewBox": [
            200,
            200
          ],
          "path": "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
          "fill": "rgba(121,188,250,1)",
          "fixedRatio": false,
          "rotate": 0
        },
        {
          "type": "shape",
          "left": 943.6214539007092,
          "top": 514.7202636555961,
          "width": 13.532914769205899,
          "height": 13.532914769205899,
          "viewBox": [
            200,
            200
          ],
          "path": "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
          "fill": "rgba(121,188,250,1)",
          "fixedRatio": false,
          "rotate": 0
        }
      ],
      neirong:[
        {
          "type": "line",
          "left": 47.7,
          "top": 525.253178424802,
          "start": [
            0,
            0
          ],
          "end": [
            904.636923852177,
            0.04682157519800967
          ],
          "points": [
            "",
            ""
          ],
          "color": "rgba(197,227,255,1)",
          "style": "solid",
          "width": 1
        },
        {
          "type": "shape",
          "left": 39.00903633196466,
          "top": 514.7202636555961,
          "width": 13.532914769205899,
          "height": 13.532914769205899,
          "viewBox": [
            200,
            200
          ],
          "path": "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
          "fill": "rgba(121,188,250,1)",
          "fixedRatio": false,
          "rotate": 0
        },
        {
          "type": "shape",
          "left": 943.6214539007092,
          "top": 514.7202636555961,
          "width": 13.532914769205899,
          "height": 13.532914769205899,
          "viewBox": [
            200,
            200
          ],
          "path": "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
          "fill": "rgba(121,188,250,1)",
          "fixedRatio": false,
          "rotate": 0
        },
        {
          "type": "shape",
          "left": 39.00903633196466,
          "top": 31.445205664210178,
          "width": 13.532914769205899,
          "height": 13.532914769205899,
          "viewBox": [
            200,
            200
          ],
          "path": "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
          "fill": "rgba(197,227,255,1)",
          "fixedRatio": false,
          "rotate": 0
        },
        {
          "type": "shape",
          "left": 56.72036692794478,
          "top": 31.445205664210178,
          "width": 13.532914769205899,
          "height": 13.532914769205899,
          "viewBox": [
            200,
            200
          ],
          "path": "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
          "fill": "#5b9bd5",
          "fixedRatio": false,
          "rotate": 0
        },
        {
          "type": "shape",
          "left": 39.00903633196466,
          "top": 50.840362908094484,
          "width": 13.532914769205899,
          "height": 13.532914769205899,
          "viewBox": [
            200,
            200
          ],
          "path": "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
          "fill": "#5b9bd5",
          "fixedRatio": false,
          "rotate": 0
        },
        {
          "type": "shape",
          "left": 56.72036692794478,
          "top": 50.840362908094484,
          "width": 13.532914769205899,
          "height": 13.532914769205899,
          "viewBox": [
            200,
            200
          ],
          "path": "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
          "fill": "rgba(197,227,255,1)",
          "fixedRatio": false,
          "rotate": 0
        },
        {
          "type": "text",
          "left": 83.97510871378834,
          "top": 15,
          "width": 881.0376139325222,
          "height": 62.5,
          "content": "<p style=\"\"><strong><span style=\"font-size: 28px;\"><span style=\"font-family: Arial;\">{{title}}</span></span></strong></p>",
          "rotate": 0,
          "defaultFontName": "思源黑体 CN",
          "defaultColor": "#333",
          "vertical": false
        }
      ]
    },
    theme: {
      backgroundColor: '#fff',
      themeColor: '#5B9BD5',
      fontColor: '#333333',
      fontName: 'Arial',
      outline: {},
      shadow: { h: 3, v: 3, blur: 2, color: '#808080' }
    }

  },
 
  {
    id: '5',
    imgList: [
      { imgUrl: 'https://static.yipigai.cn/public/muban/5/1.jpeg' },
      { imgUrl: 'https://static.yipigai.cn/public/muban/5/2.jpeg' },
      { imgUrl: 'https://static.yipigai.cn/public/muban/5/3.jpeg' },
      { imgUrl: 'https://static.yipigai.cn/public/muban/5/4.jpeg' }
    ],
    background: {
      type: 'image',
      image:'https://static.yipigai.cn/public/muban/5/bj.jpeg',
      imageSize: 'cover'
    },
    slide:{
      shouye:[
        {
          "type": "text",
          "width": 583.3537214776727,
          "height": 64,
          "left": 202.7952232854865,
          "top": 178.75,
          "rotate": 0,
          "defaultFontName": "思源黑体 CN",
          "defaultColor": "#333",
          "content": "<p style=\"text-align: center;\"><span style=\"font-size: 44px;\"><span style=\"font-family: 思源黑体 CN;\">{{title}}</span></span></p>",
          "lineHeight": 1,
          "outline": {
            "color": "#000",
            "width": 0,
            "style": "solid"
          },
          "fill": "",
          "vertical": false
        },
        {
          "type": "text",
          "width": 188.41055463423623,
          "height": 40,
          "left": 318.96,
          "top": 298.39,
          "rotate": 0,
          "defaultFontName": "思源黑体 CN",
          "defaultColor": "#333",
          "content": "<p style=\"text-align: left;\"><span style=\"font-size: 14.29px;font-family: 思源黑体 CN;\">授课教师：小鸿</span></p>",
          "lineHeight": 1,
          "outline": {
            "color": "#000",
            "width": 0,
            "style": "solid"
          },
          "fill": "",
          "vertical": false
        },
        {
          "type": "text",
          "width": 194.7471451355662,
          "height": 40,
          "left": 570.16,
          "top": 298.39,
          "rotate": 0,
          "defaultFontName": "思源黑体 CN",
          "defaultColor": "#333",
          "content": "<p style=\"\"><span style=\"font-size: 14.29px;\"><span style=\"font-family: 思源黑体 CN;\">授课时间：{{time}}</span></span></p>",
          "lineHeight": 1,
          "outline": {
            "color": "#000",
            "width": 0,
            "style": "solid"
          },
          "fill": "",
          "vertical": false
        }
      ],
      mulu:[ {
        "type": "image",
        "src": "https://static.yipigai.cn/public/muban/5/bj1.jpeg",
        "width": 790,
        "height": 400,
        "left": 100,
        "top": 84,
        "fixedRatio": true,
        "rotate": 0
      },
      {
        "type": "text",
        "width": 738.7197844112768,
        "height": 52.640625,
        "left": 125.61773908236603,
        "top": 105.06,
        "rotate": 0,
        "defaultFontName": "思源黑体 CN",
        "defaultColor": "#333",
        "content": "<p style=\"text-align: center;\"><span style=\"font-size: 32.65px;\"><span style=\"font-family: 思源黑体 CN;\">目录/CONTENT</span></span></p>",
        "lineHeight": 1,
        "outline": {
          "color": "#000",
          "width": 0,
          "style": "solid"
        },
        "fill": "",
        "vertical": false
      }],
      biaoti:[
        {
          "type": "text",
          "width": 586.750398724083,
          "height": 64,
          "left": 200.1455342902711,
          "top": 205.0727591706539,
          "rotate": 0,
          "defaultFontName": "思源黑体 CN",
          "defaultColor": "#333",
          "content": "<p style=\"text-align: center;\"><span style=\"font-size: 44px;\"><span style=\"font-family: 思源黑体 CN;\">{{title}}</span></span></p>",
          "lineHeight": 1,
          "outline": {
            "color": "#000",
            "width": 0,
            "style": "solid"
          },
          "fill": "",
          "vertical": false
        }
      ],
      end: [
        {
          "type": "text",
          "width": 578.0872969901511,
          "height": 68,
          "left": 207.8680670720472,
          "top": 178.75,
          "rotate": 0,
          "defaultFontName": "思源黑体 CN",
          "defaultColor": "#333",
          "content": "<p style=\"text-align: center;\"><span style=\"font-size: 48px;\"><span style=\"font-family: 方正楷体_GBK;\">谢谢同学们的观看</span></span></p>",
          "lineHeight": 1,
          "outline": {
            "color": "#000",
            "width": 0,
            "style": "solid"
          },
          "fill": "",
          "vertical": false
        },
        {
          "type": "text",
          "width": 131.8085326953748,
          "height": 40,
          "left": 308.75070954568656,
          "top": 298.39,
          "rotate": 0,
          "defaultFontName": "思源黑体 CN",
          "defaultColor": "#333",
          "content": "<p style=\"\"><span style=\"font-size: 14.29px;\"><span style=\"font-family: 方正楷体_GBK;\">授课教师：小鸿</span></span></p>",
          "lineHeight": 1,
          "outline": {
            "color": "#000",
            "width": 0,
            "style": "solid"
          },
          "fill": "",
          "vertical": false
        }
      ],
      neirong:[
        {
          "type": "image",
          "src": "https://static.yipigai.cn/public/muban/5/bj1.jpeg",
          "width": 982,
          "height": 542,
          "left": 9,
          "top": 10,
          "fixedRatio": true,
          "rotate": 0
        },
        {
          "type": "text",
          "width": 938,
          "height": 48,
          "left": 30,
          "top": 38,
          "rotate": 0,
          "defaultFontName": "思源黑体 CN",
          "defaultColor": "#333",
          "content": "<p style=\"text-align: center;\"><strong><span style=\"font-size: 28px;\"><span style=\"font-family: 思源黑体 CN;\">{{title}}</span></span></strong></p>",
          "lineHeight": 1,
          "outline": {
            "color": "#000",
            "width": 0,
            "style": "solid"
          },
          "fill": "",
          "vertical": false
        }
      ]
    },
    theme: {
      backgroundColor: '#9AD9FD',
      themeColor: '#E8A812',
      fontColor: '#333333',
      fontName: '思源黑体 CN',
      outline: {},
      shadow: { h: 3, v: 3, blur: 2, color: '#808080' }
    }
  },
  {
    id: '4',
    imgList: [
      { imgUrl: 'https://static.yipigai.cn/public/muban/4/1.jpeg' },
      { imgUrl: 'https://static.yipigai.cn/public/muban/4/2.jpeg' },
      { imgUrl: 'https://static.yipigai.cn/public/muban/4/3.jpeg' },
      { imgUrl: 'https://static.yipigai.cn/public/muban/4/4.jpeg' }
    ],
    background: {
      "type": "solid",
      "color": "#1e497b"
    },
    slide:{
      shouye:[
        {
          "type": "shape",
          "left": 10,
          "top": 10,
          "width": 980,
          "height": 542,
          "viewBox": [
            200,
            200
          ],
          "path": "M 0 0 L 200 0 L 200 200 L 0 200 Z",
          "fill": "rgba(255,255,255,1)",
          "fixedRatio": false,
          "rotate": 0
        },
        {
          "type": "image",
          "id": "2EvI3pSehb",
         src:'https://static.yipigai.cn/public/muban/4/nr-bj.jpeg',
         "left": 10,
         "top": 10,
         "width": 980,
         "height": 542,
          "fixedRatio": true,
          "rotate": 0
        },
        {
          "type": "text",
          "width": 655.21,
          "height": 81.21875,
          "left": 176.98,
          "top": 193.28,
          "rotate": 0,
          "defaultFontName": "思源黑体 CN",
          "defaultColor": "#333",
          "content": "<p style=\"text-align: center;\"><strong><span style=\"font-size: 61.22px;\"><span style=\"font-family: 思源黑体 CN;\"><span style=\"color: rgb(0, 32, 96);\">{{title}}</span></span></span></strong></p>",
          "lineHeight": 1,
          "outline": {
            "color": "#000",
            "width": 0,
            "style": "solid"
          },
          "fill": "",
          "vertical": false
        },
        
      
       
        {
          "type": "line",
          "left": 266.2480063795853,
          "top": 324.4118789356481,
          "start": [
            0,
            0
          ],
          "end": [
            467.5039872408293,
            0
          ],
          "points": [
            "",
            ""
          ],
          "color": "rgb(59, 59, 59)",
          "style": "solid",
          "width": 1
        },
      
        {
          "type": "image",
          src:'https://static.yipigai.cn/public/muban/man.png',
          "width": 25.696296296296275,
          "height": 34.68999999999997,
          "left": 280.71370370370374,
          "top": 358.31000000000006,
          "fixedRatio": true,
          "rotate": 0
        },
        {
          "type": "text",
          "width": 164.67,
          "height": 40,
          "left": 306.41,
          "top": 346,
          "rotate": 0,
          "defaultFontName": "思源黑体 CN",
          "defaultColor": "#333",
          "content": "<p style=\"\"><strong><span style=\"font-size: 16.33px;\"><span style=\"font-family: 思源黑体 CN;\"><span style=\"color: rgb(0, 32, 96);\">汇报人：小鸿</span></span></span></strong></p>",
          "lineHeight": 1,
          "outline": {
            "color": "#000",
            "width": 0,
            "style": "solid"
          },
          "fill": "",
          "vertical": false
        },
        {
          "type": "image",
          src:'https://static.yipigai.cn/public/muban/man.png',
          "width": 25.696296296296275,
          "height": 34.68999999999997,
          "left": 541.7537037037038,
          "top": 358.31,
          "fixedRatio": true,
          "rotate": 0
        },
        {
          "type": "text",
          "width": 209.95,
          "height": 40,
          "left": 567.45,
          "top": 346,
          "rotate": 0,
          "defaultFontName": "思源黑体 CN",
          "defaultColor": "#333",
          "content": "<p style=\"\"><strong><span style=\"font-size: 16.33px;\"><span style=\"font-family: 思源黑体 CN;\"><span style=\"color: rgb(0, 32, 96);\">汇报时间：{{time}}</span></span></span></strong></p>",
          "lineHeight": 1,
          "outline": {
            "color": "#000",
            "width": 0,
            "style": "solid"
          },
          "fill": "",
          "vertical": false
        },
        
        {
          "type": "line",
          "left": 30,
          "top": 531.7,
          "start": [
            0,
            0
          ],
          "end": [
            362.8389154704944,
            0.996810207336523
          ],
          "points": [
            "",
            ""
          ],
          "color": "rgba(30,73,123,1)",
          "style": "solid",
          "width": 2
        },
        {
          "type": "line",
          "left": 607.2,
          "top": 529.7866795736065,
          "start": [
            0,
            0
          ],
          "end": [
            362.8389154704944,
            0.996810207336523
          ],
          "points": [
            "",
            ""
          ],
          "color": "rgba(30,73,123,1)",
          "style": "solid",
          "width": 2
        }
      ],
      mulu:[
        {
          "type": "shape",
          "left": 10,
          "top": 10,
          "width": 980,
          "height": 542,
          "viewBox": [
            200,
            200
          ],
          "path": "M 0 0 L 200 0 L 200 200 L 0 200 Z",
          "fill": "rgba(255,255,255,1)",
          "fixedRatio": false,
          "rotate": 0
        },
        {
          "type": "image",
          "id": "2EvI3pSehb",
         src:'https://static.yipigai.cn/public/muban/4/nr-bj.jpeg',
         "left": 10,
         "top": 10,
         "width": 980,
         "height": 542,
          "fixedRatio": true,
          "rotate": 0
        },
        {
          "type": "text",
          "width": 314.56072833599154,
          "height": 62.859375,
          "left": 316.771128199286,
          "top": 42.040625,
          "rotate": 0,
          "defaultFontName": "思源黑体 CN",
          "defaultColor": "#333",
          "content": "<p style=\"text-align: center;\"><strong><span style=\"font-size: 42.86px;\"><span style=\"font-family: 汉仪大黑简;\"><span style=\"color: rgb(0, 32, 96);\">目录</span></span></span></strong></p>",
          "lineHeight": 1,
          "outline": {
            "color": "#000",
            "width": 0,
            "style": "solid"
          },
          "fill": "",
          "vertical": false
        },
        {
          "type": "text",
          "width": 213.44,
          "height": 52.640625,
          "left": 393.28,
          "top": 104.9,
          "rotate": 0,
          "defaultFontName": "思源黑体 CN",
          "defaultColor": "#333",
          "content": "<p style=\"text-align: justify;\"><span style=\"color: #002060;font-size: 32.65px;font-family: 汉仪大黑简;\">CONTENTS</span></p>",
          "lineHeight": 1,
          "outline": {
            "color": "#000",
            "width": 0,
            "style": "solid"
          },
          "fill": "",
          "vertical": false
        },
       
        {
          "type": "line",
          "left": 30,
          "top": 531.7,
          "start": [
            0,
            0
          ],
          "end": [
            362.8389154704944,
            0.996810207336523
          ],
          "points": [
            "",
            ""
          ],
          "color": "rgba(30,73,123,1)",
          "style": "solid",
          "width": 2
        },
        {
          "type": "line",
          "left": 607.2,
          "top": 529.7866795736065,
          "start": [
            0,
            0
          ],
          "end": [
            362.8389154704944,
            0.996810207336523
          ],
          "points": [
            "",
            ""
          ],
          "color": "rgba(30,73,123,1)",
          "style": "solid",
          "width": 2
        }
      ],
      biaoti:[
        {
          "type": "shape",
          "left": 10,
          "top": 10,
          "width": 980,
          "height": 542,
          "viewBox": [
            200,
            200
          ],
          "path": "M 0 0 L 200 0 L 200 200 L 0 200 Z",
          "fill": "rgba(255,255,255,1)",
          "fixedRatio": false,
          "rotate": 0
        },
        {
          "type": "image",
          "id": "2EvI3pSehb",
         src:'https://static.yipigai.cn/public/muban/4/nr-bj.jpeg',
         "left": 10,
         "top": 10,
         "width": 980,
         "height": 542,
          "fixedRatio": true,
          "rotate": 0
        },
        {
          "type": "shape",
          "left": 468.135,
          "top": 134.43,
          "width": 75.03000000000003,
          "height": 75.03000000000003,
          "viewBox": [
            200,
            200
          ],
          "path": "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
          "fill": "rgba(0,32,97,1)",
          "fixedRatio": false,
          "rotate": 0
        },      
        {
          "type": "text",
          "width": 86.29999999999995,
          "height": 62.859375,
          "left": 462.5,
          "top": 140.5,
          "rotate": 0,
          "defaultFontName": "思源黑体 CN",
          "defaultColor": "#333",
          "content": "<p style=\"text-align: center;\"><span style=\"font-size: 42.86px;\"><span style=\"font-family: 思源黑体 CN;\"><span style=\"color: rgb(255, 255, 255);\">{{index}}</span></span></span></p>",
          "lineHeight": 1,
          "outline": {
            "color": "#000",
            "width": 0,
            "style": "solid"
          },
          "fill": "",
          "vertical": false
        },
        {
          "type": "text",
          "width": 346.96999999999997,
          "height": 52.640625,
          "left": 332.165,
          "top": 243.24362041467305,
          "rotate": 0,
          "defaultFontName": "思源黑体 CN",
          "defaultColor": "#333",
          "content": "<p style=\"text-align: center;\"><strong><span style=\"font-size: 32.65px;\"><span style=\"font-family: 思源黑体 CN;\"><span style=\"color: rgb(0, 32, 96);\">{{title}}</span></span></span></strong></p>",
          "lineHeight": 1,
          "outline": {
            "color": "#000",
            "width": 0,
            "style": "solid"
          },
          "fill": "",
          "vertical": false
        },      
        {
          "type": "line",
          "left": 30,
          "top": 531.7,
          "start": [
            0,
            0
          ],
          "end": [
            362.8389154704944,
            0.996810207336523
          ],
          "points": [
            "",
            ""
          ],
          "color": "rgba(30,73,123,1)",
          "style": "solid",
          "width": 2
        },
        {
          "type": "line",
          "left": 607.2,
          "top": 529.7866795736065,
          "start": [
            0,
            0
          ],
          "end": [
            362.8389154704944,
            0.996810207336523
          ],
          "points": [
            "",
            ""
          ],
          "color": "rgba(30,73,123,1)",
          "style": "solid",
          "width": 2
        },
        {
          "type": "line",
          "left": 321.12256778309404,
          "top": 304.9,
          "start": [
            0,
            0
          ],
          "end": [
            357.8548644338118,
            0
          ],
          "points": [
            "",
            ""
          ],
          "color": "#1e497b",
          "style": "solid",
          "width": 5
        }
      ],
      end: [
        {
          "type": "shape",
          "left": 10,
          "top": 10,
          "width": 980,
          "height": 542,
          "viewBox": [
            200,
            200
          ],
          "path": "M 0 0 L 200 0 L 200 200 L 0 200 Z",
          "fill": "rgba(255,255,255,1)",
          "fixedRatio": false,
          "rotate": 0
        },
        {
          "type": "image",
          "id": "2EvI3pSehb",
         src:'https://static.yipigai.cn/public/muban/4/nr-bj.jpeg',
         "left": 10,
         "top": 10,
         "width": 980,
         "height": 542,
          "fixedRatio": true,
          "rotate": 0
        },
        {
          "type": "text",
          "width": 518.48,
          "height": 68.96875,
          "left": 240.76,
          "top": 195.23,
          "rotate": 0,
          "defaultFontName": "思源黑体 CN",
          "defaultColor": "#333",
          "content": "<p style=\"text-align: center;\"><span style=\"font-size: 48.98px;\"><span style=\"font-family: 思源黑体 CN;\"><span style=\"color: rgb(0, 32, 96);\">&nbsp;</span></span></span><strong><span style=\"font-size: 48.98px;\"><span style=\"font-family: 思源黑体 CN;\"><span style=\"color: rgb(0, 32, 96);\">谢谢观看</span></span></span></strong></p>",
          "lineHeight": 1,
          "outline": {
            "color": "#000",
            "width": 0,
            "style": "solid"
          },
          "fill": "",
          "vertical": false
        },
        {
          "type": "text",
          "width": 482.97,
          "height": 40,
          "left": 258.54,
          "top": 279.95,
          "rotate": 0,
          "defaultFontName": "思源黑体 CN",
          "defaultColor": "#333",
          "content": "<p style=\"text-align: center;\"><span style=\"font-size: 18.37px;\"><span style=\"font-family: 思源黑体 CN;\"><span style=\"color: #000000;\">That’s&nbsp;All,&nbsp;Thank&nbsp;You!</span></span></span></p>",
          "lineHeight": 1,
          "outline": {
            "color": "#000",
            "width": 0,
            "style": "solid"
          },
          "fill": "",
          "vertical": false
        },
        
        {
          "type": "line",
          "left": 30,
          "top": 531.7,
          "start": [
            0,
            0
          ],
          "end": [
            362.8389154704944,
            0.996810207336523
          ],
          "points": [
            "",
            ""
          ],
          "color": "rgba(30,73,123,1)",
          "style": "solid",
          "width": 2
        },
        {
          "type": "line",
          "left": 607.2,
          "top": 529.7866795736065,
          "start": [
            0,
            0
          ],
          "end": [
            362.8389154704944,
            0.996810207336523
          ],
          "points": [
            "",
            ""
          ],
          "color": "rgba(30,73,123,1)",
          "style": "solid",
          "width": 2
        },
        {
          "type": "line",
          "left": 266.2480063795853,
          "top": 324.4118789356481,
          "start": [
            0,
            0
          ],
          "end": [
            467.5039872408293,
            0
          ],
          "points": [
            "",
            ""
          ],
          "color": "rgb(59, 59, 59)",
          "style": "solid",
          "width": 1
        }
        ],
      neirong:[  {
        "type": "shape",
        "left": 10,
        "top": 10,
        "width": 980,
        "height": 542,
        "viewBox": [
          200,
          200
        ],
        "path": "M 0 0 L 200 0 L 200 200 L 0 200 Z",
        "fill": "rgba(255,255,255,1)",
        "fixedRatio": false,
        "rotate": 0
      },
      {
        "type": "image",
        "id": "2EvI3pSehb",
       src:'https://static.yipigai.cn/public/muban/4/nr-bj.jpeg',
       "left": 10,
       "top": 10,
       "width": 980,
       "height": 542,
        "fixedRatio": true,
        "rotate": 0
      },
      {
        "type": "text",
        "width": 500,
        "height": 42.4375,
        "left": 81.67,
        "top": 21,
        "rotate": 0,
        "defaultFontName": "思源黑体 CN",
        "defaultColor": "#333",
        "content": "<p style=\"text-align: justify;\"><strong><span style=\"font-size: 22.45px;\"><span style=\"font-family: 思源黑体 CN;\"><span style=\"color: rgb(0, 32, 96);\">{{title}}</span></span></span></strong></p>",
        "lineHeight": 1,
        "outline": {
          "color": "#000",
          "width": 0,
          "style": "solid"
        },
        "fill": "",
        "vertical": false
      },
      {
        "type": "image",
        src:'https://static.yipigai.cn/public/muban/jiaobiao.png',
        "width": 32.33666666666663,
        "height": 23.301421568627422,
        "left": 58.317384370015986,
        "top": 37.328039215686296,
        "fixedRatio": true,
        "rotate": 0
      }]
    },
    theme: {
      backgroundColor: '#1e497b',
      themeColor: '#002060',
      fontColor: '#002060',
      fontName: '思源黑体 CN',
      outline: {},
      shadow: { h: 3, v: 3, blur: 2, color: '#808080' }
    }
  }
 
 
]

export const muluItem={
'1':{
  manyLenght:[3,3,3],
  'few': [
    {
      "type": "shape",
      "width": 51.24,
      "height": 51.24,
      "left": 350.19,
      "top": 145.35,
      "viewBox": [
        200,
        200
      ],
      "path": "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
      "fill": "#557c7b",
      "fixedRatio": false,
      "rotate": 90,
      "flipH": true,
      "flipV": false
    },
    {
      "type": "text",
      "width": 55.43,
      "height": 40,
      "left": 346,
      "top": 145,
      "rotate": 0,
      "defaultFontName": "思源黑体 CN",
      "defaultColor": "#333",
      "content": "<p style=\"text-align: center;\"><span style=\"font-size: 20px;\"><span style=\"font-family: 思源宋体 CN Heavy;\"><span style=\"color: rgba(255,255,255,1);\">01</span></span></span></p>",
      "lineHeight": 1,
      "fill": "",
      "vertical": false
    },
    {
      "type": "text",
      "width": 261,
      "height": 62.84375,
      "left": 413.12999999999994,
      "top": 145,
      "rotate": 0,
      "content": "<p style=\"\"><strong><span style=\"font-size: 28.57px;\"><span style=\"font-family: 思源宋体 CN Heavy;\">{{title}}</span></span></strong></p>",
      "defaultFontName": "思源黑体 CN",
      "defaultColor": "#333"
    }
    ,
    {
      "type": "shape",
      "width": 51.2,
      "height": 51.2,
      "left": 413.12999999999994,
      "top": 236.1393929944912,
      "viewBox": [
        200,
        200
      ],
      "path": "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
      "fill": "#ecbca6",
      "fixedRatio": false,
      "rotate": 90,
      "flipH": true,
      "flipV": false
    },
    {
      "type": "text",
      "width": 51,
      "height": 40,
      "left": 413.12999999999994,
      "top": 236,
      "rotate": 0,
      "defaultFontName": "思源黑体 CN",
      "defaultColor": "#333",
      "content": "<p style=\"text-align: center;\"><span style=\"font-size: 20px;\"><span style=\"font-family: 思源宋体 CN Heavy;\">02</span></span></p>",
      "lineHeight": 1,
      "fill": "",
      "vertical": false
    },
    {
      "type": "text",
      "width": 261,
      "height": 62.84375,
      "left": 467.12999999999994,
      "top": 236,
      "rotate": 0,
      "content": "<p style=\"\"><strong><span style=\"font-size: 28.57px;\"><span style=\"font-family: 思源宋体 CN Heavy;\">{{title}}</span></span></strong></p>",
      "defaultFontName": "思源黑体 CN",
      "defaultColor": "#333"
    },
    {
      "type": "shape",
      "width": 51.24,
      "height": 51.24,
      "left": 493.3325,
      "top": 317.49530714062985,
      "viewBox": [
        200,
        200
      ],
      "path": "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
      "fill": "#557c7b",
      "fixedRatio": false,
      "rotate": 90,
      "flipH": true,
      "flipV": false
    },
    {
      "type": "text",
      "width": 51,
      "height": 40,
      "left": 490.98749999999995,
      "top": 317,
      "rotate": 0,
      "defaultFontName": "思源黑体 CN",
      "defaultColor": "#333",
      "content": "<p style=\"text-align: center;\"><span style=\"font-size: 20px;\"><span style=\"font-family: 思源宋体 CN Heavy;\"><span style=\"color: rgb(255, 255, 255);\">03</span></span></span></p>",
      "lineHeight": 1,
      "fill": "",
      "vertical": false
    },
    {
      "type": "text",
      "width": 261,
      "height": 62.84375,
      "left": 556.2724999999999,
      "top": 317,
      "rotate": 0,
      "content": "<p style=\"\"><strong><span style=\"font-size: 28.57px;\"><span style=\"font-family: 思源宋体 CN Heavy;\">{{title}}</span></span></strong></p>",
      "defaultFontName": "思源黑体 CN",
      "defaultColor": "#333"
    },
    {
      "type": "shape",
      "width": 51.2,
      "height": 51.2,
      "left": 563.2724999999999,
      "top": 408.28470013512106,
      "viewBox": [
        200,
        200
      ],
      "path": "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
      "fill": "#ecbca6",
      "fixedRatio": false,
      "rotate": 90,
      "flipH": true,
      "flipV": false
    },
    {
      "type": "text",
      "width": 51,
      "height": 40,
      "left": 564.1642466324341,
      "top": 408,
      "rotate": 0,
      "defaultFontName": "思源黑体 CN",
      "defaultColor": "#333",
      "content": "<p style=\"text-align: center;\"><span style=\"font-size: 20px;\"><span style=\"font-family: 思源宋体 CN Heavy;\">04</span></span></p>",
      "lineHeight": 1,
      "outline": {
        "color": "#000",
        "width": 0,
        "style": "solid"
      },
      "fill": "",
      "vertical": false
    },
    {
      "type": "text",
      "width": 261,
      "height": 62.84375,
      "left": 617.2724999999999,
      "top": 408,
      "rotate": 0,
      "content": "<p style=\"\"><strong><span style=\"font-size: 28.57px;\"><span style=\"font-family: 思源宋体 CN Heavy;\">{{title}}</span></span></strong></p>",
      "defaultFontName": "思源黑体 CN",
      "defaultColor": "#333"
    }
  ],
  'many':[
    {
      "type": "shape",
      "width": 51.24,
      "height": 51.24,
      "left": 274.4736324186674,
      "top": 163.0196809063507,
      "viewBox": [
        200,
        200
      ],
      "path": "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
      "fill": "#557c7b",
      "fixedRatio": false,
      "rotate": 90,
      "flipH": true,
      "flipV": false
    },
    {
      "type": "text",
      "width": 51,
      "height": 40,
      "left": 272.37863241866745,
      "top": 163,
      "rotate": 0,
      "defaultFontName": "思源黑体 CN",
      "defaultColor": "#333",
      "content": "<p style=\"text-align: center;\"><span style=\"font-size: 20px;\"><span style=\"font-family: 思源宋体 CN Heavy;\"><span style=\"color: rgba(255,255,255,1);\">01</span></span></span></p>",
      "lineHeight": 1,
      "fill": "",
      "vertical": false
    },
    {
      "type": "text",
      "width": 261,
      "height": 62.84375,
      "left": 340.4327782974742,
      "top": 163,
      "rotate": 0,
      "content": "<p style=\"\"><strong><span style=\"font-size: 28.57px;\"><span style=\"font-family: 思源宋体 CN Heavy;\">{{title}}</span></span></strong></p>",
      "defaultFontName": "思源黑体 CN",
      "defaultColor": "#333"
    },
    {
      "type": "shape",
      "width": 51.2,
      "height": 51.2,
      "left": 273.43613241866746,
      "top": 256.71968090635073,
      "viewBox": [
        200,
        200
      ],
      "path": "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
      "fill": "#ecbca6",
      "fixedRatio": false,
      "rotate": 90,
      "flipH": true,
      "flipV": false
    },
    {
      "type": "text",
      "width": 50.99999999999996,
      "height": 40,
      "left": 273.5361324186675,
      "top": 256,
      "rotate": 0,
      "defaultFontName": "思源黑体 CN",
      "defaultColor": "#333",
      "content": "<p style=\"text-align: center;\"><span style=\"font-size: 20px;\"><span style=\"font-family: 思源宋体 CN Heavy;\">02</span></span></p>",
      "lineHeight": 1,
      "outline": {
        "color": "#000",
        "width": 0,
        "style": "solid"
      },
      "fill": "",
      "vertical": false
    },
    {
      "type": "text",
      "width": 261,
      "height": 62.84375,
      "left": 340.4327782974742,
      "top": 256,
      "rotate": 0,
      "content": "<p style=\"\"><strong><span style=\"font-size: 28.57px;\"><span style=\"font-family: 思源宋体 CN Heavy;\">{{title}}</span></span></strong></p>",
      "defaultFontName": "思源黑体 CN",
      "defaultColor": "#333"
    },
    {
      "type": "shape",
      "width": 51.24,
      "height": 51.24,
      "left": 274.4736324186674,
      "top": 343.93093090635057,
      "viewBox": [
        200,
        200
      ],
      "path": "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
      "fill": "#557c7b",
      "fixedRatio": false,
      "rotate": 90,
      "flipH": true,
      "flipV": false
    },
    {
      "type": "text",
      "width": 55.43,
      "height": 40,
      "left": 272.37863241866745,
      "top": 343,
      "rotate": 0,
      "defaultFontName": "思源黑体 CN",
      "defaultColor": "#333",
      "content": "<p style=\"text-align: center;\"><span style=\"font-size: 20px;\"><span style=\"font-family: 思源宋体 CN Heavy;\"><span style=\"color: rgb(255, 255, 255);\">03</span></span></span></p>",
      "lineHeight": 1,
      "fill": "",
      "vertical": false
    },
    {
      "type": "text",
      "width": 261,
      "height": 62.84375,
      "left": 340.4327782974742,
      "top": 343,
      "rotate": 0,
      "content": "<p style=\"\"><strong><span style=\"font-size: 28.57px;\"><span style=\"font-family: 思源宋体 CN Heavy;\">{{title}}</span></span></strong></p>",
      "defaultFontName": "思源黑体 CN",
      "defaultColor": "#333"
    },
    {
      "type": "shape",
      "width": 51.2,
      "height": 51.2,
      "left": 274.0148824186674,
      "top": 440.50588296434864,
      "viewBox": [
        200,
        200
      ],
      "path": "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
      "fill": "#ecbca6",
      "fixedRatio": false,
      "rotate": 90,
      "flipH": true,
      "flipV": false
    },
    {
      "type": "text",
      "width": 49.842499999999944,
      "height": 40,
      "left": 274.69363241866745,
      "top": 440,
      "rotate": 0,
      "defaultFontName": "思源黑体 CN",
      "defaultColor": "#333",
      "content": "<p style=\"text-align: center;\"><span style=\"font-size: 20px;\"><span style=\"font-family: 思源宋体 CN Heavy;\">04</span></span></p>",
      "lineHeight": 1,
      "outline": {
        "color": "#000",
        "width": 0,
        "style": "solid"
      },
      "fill": "",
      "vertical": false
    },
    {
      "type": "text",
      "width": 261,
      "height": 62.84375,
      "left": 340.4327782974742,
      "top": 440,
      "rotate": 0,
      "content": "<p style=\"\"><strong><span style=\"font-size: 28.57px;\"><span style=\"font-family: 思源宋体 CN Heavy;\">{{title}}</span></span></strong></p>",
      "defaultFontName": "思源黑体 CN",
      "defaultColor": "#333"
    },
    {
      "type": "shape",
      "width": 51.24,
      "height": 51.24,
      "left": 625.3945346117865,
      "top": 163.0196809063507,
      "viewBox": [
        200,
        200
      ],
      "path": "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
      "fill": "#557c7b",
      "fixedRatio": false,
      "rotate": 90,
      "flipH": true,
      "flipV": false
    },
    {
      "type": "text",
      "width": 55.43,
      "height": 40,
      "left": 623.2995346117865,
      "top": 163,
      "rotate": 0,
      "defaultFontName": "思源黑体 CN",
      "defaultColor": "#333",
      "content": "<p style=\"text-align: center;\"><span style=\"font-size: 20px;\"><span style=\"font-family: 思源宋体 CN Heavy;\"><span style=\"color: rgb(255, 255, 255);\">05</span></span></span></p>",
      "lineHeight": 1,
      "fill": "",
      "vertical": false
    },
    {
      "type": "text",

      "width": 261,
      "height": 62.84375,
      "left": 691.3536804905934,
      "top": 163,
      "rotate": 0,
      "content": "<p style=\"\"><strong><span style=\"font-size: 28.57px;\"><span style=\"font-family: 思源宋体 CN Heavy;\">{{title}}</span></span></strong></p>",
      "defaultFontName": "思源黑体 CN",
      "defaultColor": "#333"
    },
    {
      "type": "shape",
      "width": 51.2,
      "height": 51.2,
      "left": 625.4145346117865,
      "top": 256.71968090635073,
      "viewBox": [
        200,
        200
      ],
      "path": "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
      "fill": "#ecbca6",
      "fixedRatio": false,
      "rotate": 90,
      "flipH": true,
      "flipV": false
    },
    {
      "type": "text",
      "width": 55.42999999999993,
      "height": 40,
      "left": 623.2995346117866,
      "top": 256,
      "rotate": 0,
      "defaultFontName": "思源黑体 CN",
      "defaultColor": "#333",
      "content": "<p style=\"text-align: center;\"><span style=\"font-size: 20px;\"><span style=\"font-family: 思源宋体 CN Heavy;\">06</span></span></p>",
      "lineHeight": 1,
      "outline": {
        "color": "#000",
        "width": 0,
        "style": "solid"
      },
      "fill": "",
      "vertical": false
    },
    {
      "type": "text",
      "width": 261,
      "height": 62.84375,
      "left": 691.3536804905934,
      "top": 256,
      "rotate": 0,
      "content": "<p style=\"\"><strong><span style=\"font-size: 28.57px;\"><span style=\"font-family: 思源宋体 CN Heavy;\">{{title}}</span></span></strong></p>",
      "defaultFontName": "思源黑体 CN",
      "defaultColor": "#333"
    },
    {
      "type": "shape",
      "width": 51.24,
      "height": 51.24,
      "left": 625.3945346117865,
      "top": 343.93093090635057,
      "viewBox": [
        200,
        200
      ],
      "path": "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
      "fill": "#557c7b",
      "fixedRatio": false,
      "rotate": 90,
      "flipH": true,
      "flipV": false
    },
    {
      "type": "text",
      "width": 55.43,
      "height": 40,
      "left": 623.2995346117865,
      "top": 343,
      "rotate": 0,
      "defaultFontName": "思源黑体 CN",
      "defaultColor": "#333",
      "content": "<p style=\"text-align: center;\"><span style=\"font-size: 20px;\"><span style=\"font-family: 思源宋体 CN Heavy;\"><span style=\"color: rgb(255, 255, 255);\">07</span></span></span></p>",
      "lineHeight": 1,
      "fill": "",
      "vertical": false
    },
    {
      "type": "text",
      "width": 261,
      "height": 62.84375,
      "left": 691.3536804905934,
      "top": 343,
      "rotate": 0,
      "content": "<p style=\"\"><strong><span style=\"font-size: 28.57px;\"><span style=\"font-family: 思源宋体 CN Heavy;\">{{title}}</span></span></strong></p>",
      "defaultFontName": "思源黑体 CN",
      "defaultColor": "#333"
    },
    {
      "type": "shape",
      "width": 51.2,
      "height": 51.2,
      "left": 625.4145346117864,
      "top": 440.50588296434864,
      "viewBox": [
        200,
        200
      ],
      "path": "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
      "fill": "#ecbca6",
      "fixedRatio": false,
      "rotate": 90,
      "flipH": true,
      "flipV": false
    },
    {
      "type": "text",
      "width": 55.42999999999985,
      "height": 40,
      "left": 623.2995346117865,
      "top": 440,
      "rotate": 0,
      "defaultFontName": "思源黑体 CN",
      "defaultColor": "#333",
      "content": "<p style=\"text-align: center;\"><span style=\"font-size: 20px;\"><span style=\"font-family: 思源宋体 CN Heavy;\">08</span></span></p>",
      "lineHeight": 1,
      "outline": {
        "color": "#000",
        "width": 0,
        "style": "solid"
      },
      "fill": "",
      "vertical": false
    },
    {
      "type": "text",
      "width": 261,
      "height": 62.84375,
      "left": 691.3536804905934,
      "top": 440,
      "rotate": 0,
      "content": "<p style=\"\"><strong><span style=\"font-size: 28.57px;\"><span style=\"font-family: 思源宋体 CN Heavy;\">{{title}}</span></span></strong></p>",
      "defaultFontName": "思源黑体 CN",
      "defaultColor": "#333"
    }
  ],
  'max':[
    {
      "type": "shape",
      "width": 51.24,
      "height": 51.24,
      "left": 273.4261324186674,
      "top": 46.54242802203511,
      "viewBox": [
        200,
        200
      ],
      "path": "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
      "fill": "#557c7b",
      "fixedRatio": false,
      "rotate": 90,
      "flipH": true,
      "flipV": false
    },
    {
      "type": "text",
      "width": 51,
      "height": 40,
      "left": 273.5461324186674,
      "top": 46,
      "rotate": 0,
      "defaultFontName": "思源黑体 CN",
      "defaultColor": "#333",
      "content": "<p style=\"text-align: center;\"><span style=\"font-size: 20px;\"><span style=\"font-family: 思源宋体 CN Heavy;\"><span style=\"color: rgba(255,255,255,1);\">01</span></span></span></p>",
      "lineHeight": 1,
      "fill": "",
      "vertical": false
    },
    {
      "type": "text",
      "width": 261,
      "height": 62.84375,
      "left": 341.4721712919654,
      "top": 46,
      "rotate": 0,
      "content": "<p style=\"\"><strong><span style=\"font-size: 28.57px;\"><span style=\"font-family: 思源宋体 CN Heavy;\">{{title}}</span></span></strong></p>",
      "defaultFontName": "思源黑体 CN",
      "defaultColor": "#333"
    },
    {
      "type": "shape",
      "width": 51.2,
      "height": 51.2,
      "left": 276.97400789938666,
      "top": 131.79018667498198,
      "viewBox": [
        200,
        200
      ],
      "path": "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
      "fill": "#ecbca6",
      "fixedRatio": false,
      "rotate": 90,
      "flipH": true,
      "flipV": false
    },
    {
      "type": "text",
      "width": 51,
      "height": 40,
      "left": 277.0740078993867,
      "top": 131,
      "rotate": 0,
      "defaultFontName": "思源黑体 CN",
      "defaultColor": "#333",
      "content": "<p style=\"text-align: center;\"><span style=\"font-size: 20px;\"><span style=\"font-family: 思源宋体 CN Heavy;\">02</span></span></p>",
      "lineHeight": 1,
      "outline": {
        "color": "#000",
        "width": 0,
        "style": "solid"
      },
      "fill": "",
      "vertical": false
    },
    {
      "type": "text",
      "width": 261,
      "height": 62.84375,
      "left": 341.4721712919654,
      "top": 131,
      "rotate": 0,
      "content": "<p style=\"\"><strong><span style=\"font-size: 28.57px;\"><span style=\"font-family: 思源宋体 CN Heavy;\">{{title}}</span></span></strong></p>",
      "defaultFontName": "思源黑体 CN",
      "defaultColor": "#333"
    },
    {
      "type": "shape",
      "width": 51.24,
      "height": 51.24,
      "left": 273.4261324186674,
      "top": 216.99794532792868,
      "viewBox": [
        200,
        200
      ],
      "path": "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
      "fill": "#557c7b",
      "fixedRatio": false,
      "rotate": 90,
      "flipH": true,
      "flipV": false
    },
    {
      "type": "text",
      "width": 51,
      "height": 40,
      "left": 273.5461324186674,
      "top": 216,
      "rotate": 0,
      "defaultFontName": "思源黑体 CN",
      "defaultColor": "#333",
      "content": "<p style=\"text-align: center;\"><span style=\"font-size: 20px;\"><span style=\"font-family: 思源宋体 CN Heavy;\"><span style=\"color: rgb(255, 255, 255);\">03</span></span></span></p>",
      "lineHeight": 1,
      "fill": "",
      "vertical": false
    },
    {
      "type": "text",
      "width": 261,
      "height": 62.84375,
      "left": 341.4721712919654,
      "top": 216,
      "rotate": 0,
      "content": "<p style=\"\"><strong><span style=\"font-size: 28.57px;\"><span style=\"font-family: 思源宋体 CN Heavy;\">{{title}}</span></span></strong></p>",
      "defaultFontName": "思源黑体 CN",
      "defaultColor": "#333"
    },
    {
      "type": "shape",
      "width": 51.2,
      "height": 51.2,
      "left": 276.97400789938666,
      "top": 302.24570398087536,
      "viewBox": [
        200,
        200
      ],
      "path": "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
      "fill": "#ecbca6",
      "fixedRatio": false,
      "rotate": 90,
      "flipH": true,
      "flipV": false
    },
    {
      "type": "text",
      "width": 51,
      "height": 40,
      "left": 277.0740078993867,
      "top": 302,
      "rotate": 0,
      "defaultFontName": "思源黑体 CN",
      "defaultColor": "#333",
      "content": "<p style=\"text-align: center;\"><span style=\"font-size: 20px;\"><span style=\"font-family: 思源宋体 CN Heavy;\">04</span></span></p>",
      "lineHeight": 1,
      "outline": {
        "color": "#000",
        "width": 0,
        "style": "solid"
      },
      "fill": "",
      "vertical": false
    },
    {
      "type": "text",
      "width": 261,
      "height": 62.84375,
      "left": 341.4721712919654,
      "top": 302,
      "rotate": 0,
      "content": "<p style=\"\"><strong><span style=\"font-size: 28.57px;\"><span style=\"font-family: 思源宋体 CN Heavy;\">{{title}}</span></span></strong></p>",
      "defaultFontName": "思源黑体 CN",
      "defaultColor": "#333"
    },
    {
      "type": "shape",
      "width": 51.24,
      "height": 51.24,
      "left": 275.52113241866743,
      "top": 387.4534626338221,
      "viewBox": [
        200,
        200
      ],
      "path": "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
      "fill": "#557c7b",
      "fixedRatio": false,
      "rotate": 90,
      "flipH": true,
      "flipV": false
    },
    {
      "type": "text",
      "width": 51,
      "height": 40,
      "left": 275.64113241866744,
      "top": 387,
      "rotate": 0,
      "defaultFontName": "思源黑体 CN",
      "defaultColor": "#333",
      "content": "<p style=\"text-align: center;\"><span style=\"font-size: 20px;\"><span style=\"font-family: 思源宋体 CN Heavy;\"><span style=\"color: rgb(255, 255, 255);\">05</span></span></span></p>",
      "lineHeight": 1,
      "fill": "",
      "vertical": false
    },
    {
      "type": "text",
      "width": 261,
      "height": 62.84375,
      "left": 343.5671712919654,
      "top": 387,
      "rotate": 0,
      "content": "<p style=\"\"><strong><span style=\"font-size: 28.57px;\"><span style=\"font-family: 思源宋体 CN Heavy;\">{{title}}</span></span></strong></p>",
      "defaultFontName": "思源黑体 CN",
      "defaultColor": "#333"
    },
    {
      "type": "shape",
      "width": 51.2,
      "height": 51.2,
      "left": 282.13475886082523,
      "top": 472.7012212867684,
      "viewBox": [
        200,
        200
      ],
      "path": "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
      "fill": "#ecbca6",
      "fixedRatio": false,
      "rotate": 90,
      "flipH": true,
      "flipV": false
    },
    {
      "type": "text",
      "width": 51,
      "height": 40,
      "left": 282.23475886082525,
      "top": 472,
      "rotate": 0,
      "defaultFontName": "思源黑体 CN",
      "defaultColor": "#333",
      "content": "<p style=\"text-align: center;\"><span style=\"font-size: 20px;\"><span style=\"font-family: 思源宋体 CN Heavy;\">06</span></span></p>",
      "lineHeight": 1,
      "outline": {
        "color": "#000",
        "width": 0,
        "style": "solid"
      },
      "fill": "",
      "vertical": false
    },
    {
      "type": "text",
      "width": 261,
      "height": 62.84375,
      "left": 343.5671712919654,
      "top": 472,
      "rotate": 0,
      "content": "<p style=\"\"><strong><span style=\"font-size: 28.57px;\"><span style=\"font-family: 思源宋体 CN Heavy;\">{{title}}</span></span></strong></p>",
      "defaultFontName": "思源黑体 CN",
      "defaultColor": "#333"
    },
    {
      "type": "shape",
      "width": 51.24,
      "height": 51.24,
      "left": 624.3470346117866,
      "top": 46.742428022035085,
      "viewBox": [
        200,
        200
      ],
      "path": "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
      "fill": "#557c7b",
      "fixedRatio": false,
      "rotate": 90,
      "flipH": true,
      "flipV": false
    },
    {
      "type": "text",
      "width": 51,
      "height": 40,
      "left": 624.4670346117866,
      "top": 46,
      "rotate": 0,
      "defaultFontName": "思源黑体 CN",
      "defaultColor": "#333",
      "content": "<p style=\"text-align: center;\"><span style=\"font-size: 20px;\"><span style=\"font-family: 思源宋体 CN Heavy;\"><span style=\"color: rgb(255, 255, 255);\">07</span></span></span></p>",
      "lineHeight": 1,
      "fill": "",
      "vertical": false
    },
    {
      "type": "text",
    
      "width": 261,
      "height": 62.84375,
      "left": 692.3930734850846,
      "top": 46,
      "rotate": 0,
      "content": "<p style=\"\"><strong><span style=\"font-size: 28.57px;\"><span style=\"font-family: 思源宋体 CN Heavy;\">{{title}}</span></span></strong></p>",
      "defaultFontName": "思源黑体 CN",
      "defaultColor": "#333"
    },
    {
      "type": "shape",
      "width": 51.2,
      "height": 51.2,
      "left": 627.8949100925059,
      "top": 131.99018667498197,
      "viewBox": [
        200,
        200
      ],
      "path": "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
      "fill": "#ecbca6",
      "fixedRatio": false,
      "rotate": 90,
      "flipH": true,
      "flipV": false
    },
    {
      "type": "text",
      "width": 51,
      "height": 40,
      "left": 627.994910092506,
      "top": 131,
      "rotate": 0,
      "defaultFontName": "思源黑体 CN",
      "defaultColor": "#333",
      "content": "<p style=\"text-align: center;\"><span style=\"font-size: 20px;\"><span style=\"font-family: 思源宋体 CN Heavy;\">08</span></span></p>",
      "lineHeight": 1,
      "outline": {
        "color": "#000",
        "width": 0,
        "style": "solid"
      },
      "fill": "",
      "vertical": false
    },
    {
      "type": "text",
      "width": 261,
      "height": 62.84375,
      "left": 692.3930734850846,
      "top": 131,
      "rotate": 0,
      "content": "<p style=\"\"><strong><span style=\"font-size: 28.57px;\"><span style=\"font-family: 思源宋体 CN Heavy;\">{{title}}</span></span></strong></p>",
      "defaultFontName": "思源黑体 CN",
      "defaultColor": "#333"
    },
    {
      "type": "shape",
      "width": 51.24,
      "height": 51.24,
      "left": 624.3470346117866,
      "top": 217.19794532792866,
      "viewBox": [
        200,
        200
      ],
      "path": "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
      "fill": "#557c7b",
      "fixedRatio": false,
      "rotate": 90,
      "flipH": true,
      "flipV": false
    },
    {
      "type": "text",
      "width": 51,
      "height": 40,
      "left": 624.4670346117866,
      "top": 217,
      "rotate": 0,
      "defaultFontName": "思源黑体 CN",
      "defaultColor": "#333",
      "content": "<p style=\"text-align: center;\"><span style=\"font-size: 20px;\"><span style=\"font-family: 思源宋体 CN Heavy;\"><span style=\"color: rgb(255, 255, 255);\">09</span></span></span></p>",
      "lineHeight": 1,
      "fill": "",
      "vertical": false
    },
    {
      "type": "text",
      "width": 261,
      "height": 62.84375,
      "left": 692.3930734850846,
      "top": 217,
      "rotate": 0,
      "content": "<p style=\"\"><strong><span style=\"font-size: 28.57px;\"><span style=\"font-family: 思源宋体 CN Heavy;\">{{title}}</span></span></strong></p>",
      "defaultFontName": "思源黑体 CN",
      "defaultColor": "#333"
    },
    {
      "type": "shape",
      "width": 51.2,
      "height": 51.2,
      "left": 627.8949100925059,
      "top": 302.44570398087535,
      "viewBox": [
        200,
        200
      ],
      "path": "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
      "fill": "#ecbca6",
      "fixedRatio": false,
      "rotate": 90,
      "flipH": true,
      "flipV": false
    },
    {
      "type": "text",
      "width": 51,
      "height": 40,
      "left": 627.994910092506,
      "top": 302,
      "rotate": 0,
      "defaultFontName": "思源黑体 CN",
      "defaultColor": "#333",
      "content": "<p style=\"text-align: center;\"><span style=\"font-size: 20px;\"><span style=\"font-family: 思源宋体 CN Heavy;\">10</span></span></p>",
      "lineHeight": 1,
      "outline": {
        "color": "#000",
        "width": 0,
        "style": "solid"
      },
      "fill": "",
      "vertical": false
    },
    {
      "type": "text",
      "width": 261,
      "height": 62.84375,
      "left": 692.3930734850846,
      "top": 302,
      "rotate": 0,
      "content": "<p style=\"\"><strong><span style=\"font-size: 28.57px;\"><span style=\"font-family: 思源宋体 CN Heavy;\">{{title}}</span></span></strong></p>",
      "defaultFontName": "思源黑体 CN",
      "defaultColor": "#333"
    },
    {
      "type": "shape",
      "width": 51.24,
      "height": 51.24,
      "left": 626.4420346117867,
      "top": 387.6534626338221,
      "viewBox": [
        200,
        200
      ],
      "path": "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
      "fill": "#557c7b",
      "fixedRatio": false,
      "rotate": 90,
      "flipH": true,
      "flipV": false
    },
    {
      "type": "text",
      "width": 51,
      "height": 40,
      "left": 626.5620346117867,
      "top": 387,
      "rotate": 0,
      "defaultFontName": "思源黑体 CN",
      "defaultColor": "#333",
      "content": "<p style=\"text-align: center;\"><span style=\"font-size: 20px;\"><span style=\"font-family: 思源宋体 CN Heavy;\"><span style=\"color: rgb(255, 255, 255);\">11</span></span></span></p>",
      "lineHeight": 1,
      "fill": "",
      "vertical": false
    },
    {
      "type": "text",
      "width": 261,
      "height": 62.84375,
      "left": 694.4880734850847,
      "top": 387,
      "rotate": 0,
      "content": "<p style=\"\"><strong><span style=\"font-size: 28.57px;\"><span style=\"font-family: 思源宋体 CN Heavy;\">{{title}}</span></span></strong></p>",
      "defaultFontName": "思源黑体 CN",
      "defaultColor": "#333"
    },
    {
      "type": "shape",
      "width": 51.2,
      "height": 51.2,
      "left": 633.0556610539444,
      "top": 472.9012212867684,
      "viewBox": [
        200,
        200
      ],
      "path": "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
      "fill": "#ecbca6",
      "fixedRatio": false,
      "rotate": 90,
      "flipH": true,
      "flipV": false
    },
    {
      "type": "text",
      "width": 51,
      "height": 40,
      "left": 633.1556610539444,
      "top": 472,
      "rotate": 0,
      "defaultFontName": "思源黑体 CN",
      "defaultColor": "#333",
      "content": "<p style=\"text-align: center;\"><span style=\"font-size: 20px;\"><span style=\"font-family: 思源宋体 CN Heavy;\">12</span></span></p>",
      "lineHeight": 1,
      "outline": {
        "color": "#000",
        "width": 0,
        "style": "solid"
      },
      "fill": "",
      "vertical": false
    },
    {
      "type": "text",
      "width": 261,
      "height": 62.84375,
      "left": 694.4880734850847,
      "top": 472,
      "rotate": 0,
      "content": "<p style=\"\"><strong><span style=\"font-size: 28.57px;\"><span style=\"font-family: 思源宋体 CN Heavy;\">{{title}}</span></span></strong></p>",
      "defaultFontName": "思源黑体 CN",
      "defaultColor": "#333"
    }
  ]

} ,
'2':{
  manyLenght:[2,2,2],
 'few': [
  {
    "type": "text",
    "width": 300,
    "height": 52,
    "left": 170,
    "top": 254,
    "rotate": 0,
    "defaultFontName": "思源黑体 CN",
    "defaultColor": "#333",
    "content": "<p style=\"text-align: center;\"><strong><span style=\"font-size: 32px;\"><span style=\"font-family: 思源宋体 CN;\"><span style=\"color: rgb(0, 0, 0);\">{{title}}</span></span></span></strong></p>",
    "lineHeight": 1,
    "outline": {
      "color": "#000",
      "width": 0,
      "style": "solid"
    },
    "fill": "",
    "vertical": false
  },
  {
    "type": "shape",
    "width": 60.1,
    "height": 60.1,
    "left": 291.3084824862281,
    "top": 188.11939299449122,
    "viewBox": [
      200,
      200
    ],
    "path": "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
    "fill": "#56b3f6",
    "fixedRatio": false,
    "rotate": 0,
    "outline": {
      "color": "#085f9e",
      "width": 0,
      "style": "solid"
    },
    "flipH": false,
    "flipV": false,
    "text": {
      "content": "<p style=\"text-align: center;\"><span style=\"font-size: 28px;\"><span style=\"font-family: Songti SC;\">01</span></span></p>",
      "defaultFontName": "思源黑体 CN",
      "defaultColor": "#000",
      "align": "middle"
    }
  },
  {
    "type": "text",
    "width": 300,
    "height": 52,
    "left": 526,
    "top": 254.00000000000003,
    "rotate": 0,
    "defaultFontName": "思源黑体 CN",
    "defaultColor": "#333",
    "content": "<p style=\"text-align: center;\"><strong><span style=\"font-size: 32px;\"><span style=\"font-family: 思源宋体 CN;\"><span style=\"color: rgb(0, 0, 0);\">{{title}}</span></span></span></strong></p>",
    "lineHeight": 1,
    "outline": {
      "color": "#000",
      "width": 0,
      "style": "solid"
    },
    "fill": "",
    "vertical": false
  },
  {
    "type": "shape",
    "width": 60.1,
    "height": 60.1,
    "left": 642.6084824862282,
    "top": 188.11939299449122,
    "viewBox": [
      200,
      200
    ],
    "path": "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
    "fill": "#56b3f6",
    "fixedRatio": false,
    "rotate": 0,
    "outline": {
      "color": "#085f9e",
      "width": 0,
      "style": "solid"
    },
    "flipH": false,
    "flipV": false,
    "text": {
      "content": "<p style=\"text-align: center;\"><span style=\"font-size: 28px;\"><span style=\"font-family: Songti SC;\">02</span></span></p>",
      "defaultFontName": "思源黑体 CN",
      "defaultColor": "#000",
      "align": "middle"
    }
  },
  {
    "type": "text",
    "width": 300,
    "height": 52,
    "left": 170,
    "top": 399.88926826733166,
    "rotate": 0,
    "defaultFontName": "思源黑体 CN",
    "defaultColor": "#333",
    "content": "<p style=\"text-align: center;\"><strong><span style=\"font-size: 32px;\"><span style=\"font-family: 思源宋体 CN;\"><span style=\"color: rgb(0, 0, 0);\">{{title}}</span></span></span></strong></p>",
    "lineHeight": 1,
    "outline": {
      "color": "#000",
      "width": 0,
      "style": "solid"
    },
    "fill": "",
    "vertical": false
  },
  {
    "type": "shape",
    "width": 60.1,
    "height": 60.1,
    "left": 291.3084824862281,
    "top": 335.31926826733184,
    "viewBox": [
      200,
      200
    ],
    "path": "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
    "fill": "#56b3f6",
    "fixedRatio": false,
    "rotate": 0,
    "outline": {
      "color": "#085f9e",
      "width": 0,
      "style": "solid"
    },
    "flipH": false,
    "flipV": false,
    "text": {
      "content": "<p style=\"text-align: center;\"><span style=\"font-size: 28px;\"><span style=\"font-family: Songti SC;\">03</span></span></p>",
      "defaultFontName": "思源黑体 CN",
      "defaultColor": "#000",
      "align": "middle"
    }
  },
  {
    "type": "text",
    "width": 300,
    "height": 52,
    "left": 524,
    "top": 399.88926826733166,
    "rotate": 0,
    "defaultFontName": "思源黑体 CN",
    "defaultColor": "#333",
    "content": "<p style=\"text-align: center;\"><strong><span style=\"font-size: 32px;\"><span style=\"font-family: 思源宋体 CN;\"><span style=\"color: rgb(0, 0, 0);\">{{title}}</span></span></span></strong></p>",
    "lineHeight": 1,
    "outline": {
      "color": "#000",
      "width": 0,
      "style": "solid"
    },
    "fill": "",
    "vertical": false
  },
  {
    "type": "shape",
    "width": 60.1,
    "height": 60.1,
    "left": 642.6084824862282,
    "top": 335.31926826733184,
    "viewBox": [
      200,
      200
    ],
    "path": "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
    "fill": "#56b3f6",
    "fixedRatio": false,
    "rotate": 0,
    "outline": {
      "color": "#085f9e",
      "width": 0,
      "style": "solid"
    },
    "flipH": false,
    "flipV": false,
    "text": {
      "content": "<p style=\"text-align: center;\"><span style=\"font-size: 28px;\"><span style=\"font-family: Songti SC;\">04</span></span></p>",
      "defaultFontName": "思源黑体 CN",
      "defaultColor": "#000",
      "align": "middle"
    }
  }
 ],
  'many':[
    {
      "type": "text",
      "width": 199.2900000000002,
      "height": 40,
      "left": 110.60999999999979,
      "top": 252.18485604407027,
      "rotate": 0,
      "defaultFontName": "思源黑体 CN",
      "defaultColor": "#333",
      "content": "<p style=\"text-align: center;\"><span style=\"font-size: 20px;\"><strong>{{title}}</strong></span></p>",
      "lineHeight": 1,
      "outline": {
        "color": "#000",
        "width": 0,
        "style": "solid"
      },
      "fill": "",
      "vertical": false
    },
    {
      "type": "shape",
      "width": 60.1,
      "height": 60.1,
      "left": 173.55999999999977,
      "top": 183.96182101652636,
      "viewBox": [
        200,
        200
      ],
      "path": "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
      "fill": "#56b3f6",
      "fixedRatio": false,
      "rotate": 0,
      "outline": {
        "color": "#085f9e",
        "width": 0,
        "style": "solid"
      },
      "flipH": false,
      "flipV": false,
      "text": {
        "content": "<p style=\"text-align: center;\"><span style=\"font-size: 20px;\"><span style=\"font-family: Songti SC;\">01</span></span></p>",
        "defaultFontName": "思源黑体 CN",
        "defaultColor": "#000",
        "align": "middle"
      }
    },
    {
      "type": "text",
      "width": 191.92666666666682,
      "height": 40,
      "left": 309.5366666666666,
      "top": 252.18485604407027,
      "rotate": 0,
      "defaultFontName": "思源黑体 CN",
      "defaultColor": "#333",
      "content": "<p style=\"text-align: center;\"><span style=\"font-size: 20px;\"><strong>{{title}}</strong></span></p>",
      "lineHeight": 1,
      "outline": {
        "color": "#000",
        "width": 0,
        "style": "solid"
      },
      "fill": "",
      "vertical": false
    },
    {
      "type": "shape",
      "width": 60.1,
      "height": 60.1,
      "left": 372.48666666666657,
      "top": 183.96182101652636,
      "viewBox": [
        200,
        200
      ],
      "path": "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
      "fill": "#56b3f6",
      "fixedRatio": false,
      "rotate": 0,
      "outline": {
        "color": "#085f9e",
        "width": 0,
        "style": "solid"
      },
      "flipH": false,
      "flipV": false,
      "text": {
        "content": "<p style=\"text-align: center;\"><span style=\"font-size: 20px;\"><span style=\"font-family: Songti SC;\">02</span></span></p>",
        "defaultFontName": "思源黑体 CN",
        "defaultColor": "#000",
        "align": "middle"
      }
    },
    {
      "type": "text",
      "width": 198.98701298701297,
      "height": 40,
      "left": 504.46333333333337,
      "top": 252.18485604407027,
      "rotate": 0,
      "defaultFontName": "思源黑体 CN",
      "defaultColor": "#333",
      "content": "<p style=\"text-align: center;\"><span style=\"font-size: 20px;\"><strong>{{title}}</strong></span></p>",
      "lineHeight": 1,
      "outline": {
        "color": "#000",
        "width": 0,
        "style": "solid"
      },
      "fill": "",
      "vertical": false
    },
    {
      "type": "shape",
      "width": 60.1,
      "height": 60.1,
      "left": 567.4133333333333,
      "top": 183.96182101652636,
      "viewBox": [
        200,
        200
      ],
      "path": "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
      "fill": "#56b3f6",
      "fixedRatio": false,
      "rotate": 0,
      "outline": {
        "color": "#085f9e",
        "width": 0,
        "style": "solid"
      },
      "flipH": false,
      "flipV": false,
      "text": {
        "content": "<p style=\"text-align: center;\"><span style=\"font-size: 20px;\"><span style=\"font-family: Songti SC;\">03</span></span></p>",
        "defaultFontName": "思源黑体 CN",
        "defaultColor": "#000",
        "align": "middle"
      }
    },
    {
      "type": "text",
      "width": 204.75901875901877,
      "height": 40,
      "left": 707.3900000000001,
      "top": 252.1848560440703,
      "rotate": 0,
      "defaultFontName": "思源黑体 CN",
      "defaultColor": "#333",
      "content": "<p style=\"text-align: center;\"><span style=\"font-size: 20px;\"><strong>{{title}}</strong></span></p>",
      "lineHeight": 1,
      "outline": {
        "color": "#000",
        "width": 0,
        "style": "solid"
      },
      "fill": "",
      "vertical": false
    },
    {
      "type": "shape",
      "width": 60.1,
      "height": 60.1,
      "left": 770.34,
      "top": 183.9618210165264,
      "viewBox": [
        200,
        200
      ],
      "path": "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
      "fill": "#56b3f6",
      "fixedRatio": false,
      "rotate": 0,
      "outline": {
        "color": "#085f9e",
        "width": 0,
        "style": "solid"
      },
      "flipH": false,
      "flipV": false,
      "text": {
        "content": "<p style=\"text-align: center;\"><span style=\"font-size: 20px;\"><span style=\"font-family: Songti SC;\">04</span></span></p>",
        "defaultFontName": "思源黑体 CN",
        "defaultColor": "#000",
        "align": "middle"
      }
    },
    {
      "type": "text",
      "width": 193.2150072150072,
      "height": 40,
      "left": 110.60999999999979,
      "top": 384.83322939403376,
      "rotate": 0,
      "defaultFontName": "思源黑体 CN",
      "defaultColor": "#333",
      "content": "<p style=\"text-align: center;\"><span style=\"font-size: 20px;\"><strong>{{title}}</strong></span></p>",
      "lineHeight": 1,
      "outline": {
        "color": "#000",
        "width": 0,
        "style": "solid"
      },
      "fill": "",
      "vertical": false
    },
    {
      "type": "shape",
      "width": 60.1,
      "height": 60.1,
      "left": 173.55999999999977,
      "top": 316.61019436648996,
      "viewBox": [
        200,
        200
      ],
      "path": "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
      "fill": "#56b3f6",
      "fixedRatio": false,
      "rotate": 0,
      "outline": {
        "color": "#085f9e",
        "width": 0,
        "style": "solid"
      },
      "flipH": false,
      "flipV": false,
      "text": {
        "content": "<p style=\"text-align: center;\"><span style=\"font-size: 20px;\"><span style=\"font-family: Songti SC;\">05</span></span></p>",
        "defaultFontName": "思源黑体 CN",
        "defaultColor": "#000",
        "align": "middle"
      }
    },
    {
      "type": "text",
      "width": 191.9266666666668,
      "height": 40,
      "left": 309.5366666666666,
      "top": 384.83322939403376,
      "rotate": 0,
      "defaultFontName": "思源黑体 CN",
      "defaultColor": "#333",
      "content": "<p style=\"text-align: center;\"><span style=\"font-size: 20px;\"><strong>{{title}}</strong></span></p>",
      "lineHeight": 1,
      "outline": {
        "color": "#000",
        "width": 0,
        "style": "solid"
      },
      "fill": "",
      "vertical": false
    },
    {
      "type": "shape",
      "width": 60.1,
      "height": 60.1,
      "left": 372.48666666666657,
      "top": 316.61019436648996,
      "viewBox": [
        200,
        200
      ],
      "path": "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
      "fill": "#56b3f6",
      "fixedRatio": false,
      "rotate": 0,
      "outline": {
        "color": "#085f9e",
        "width": 0,
        "style": "solid"
      },
      "flipH": false,
      "flipV": false,
      "text": {
        "content": "<p style=\"text-align: center;\"><span style=\"font-size: 20px;\"><span style=\"font-family: Songti SC;\">06</span></span></p>",
        "defaultFontName": "思源黑体 CN",
        "defaultColor": "#000",
        "align": "middle"
      }
    },
    {
      "type": "text",
      "width": 198.987012987013,
      "height": 40,
      "left": 504.46333333333337,
      "top": 384.83322939403376,
      "rotate": 0,
      "defaultFontName": "思源黑体 CN",
      "defaultColor": "#333",
      "content": "<p style=\"text-align: center;\"><span style=\"font-size: 20px;\"><strong>{{title}}</strong></span></p>",
      "lineHeight": 1,
      "outline": {
        "color": "#000",
        "width": 0,
        "style": "solid"
      },
      "fill": "",
      "vertical": false
    },
    {
      "type": "shape",
      "width": 60.1,
      "height": 60.1,
      "left": 567.4133333333333,
      "top": 316.61019436648996,
      "viewBox": [
        200,
        200
      ],
      "path": "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
      "fill": "#56b3f6",
      "fixedRatio": false,
      "rotate": 0,
      "outline": {
        "color": "#085f9e",
        "width": 0,
        "style": "solid"
      },
      "flipH": false,
      "flipV": false,
      "text": {
        "content": "<p style=\"text-align: center;\"><span style=\"font-size: 20px;\"><span style=\"font-family: Songti SC;\">07</span></span></p>",
        "defaultFontName": "思源黑体 CN",
        "defaultColor": "#000",
        "align": "middle"
      }
    },
    {
      "type": "text",
      "width": 197.54401154401154,
      "height": 40,
      "left": 707.3900000000001,
      "top": 384.8332293940339,
      "rotate": 0,
      "defaultFontName": "思源黑体 CN",
      "defaultColor": "#333",
      "content": "<p style=\"text-align: center;\"><span style=\"font-size: 20px;\"><strong>{{title}}</strong></span></p>",
      "lineHeight": 1,
      "outline": {
        "color": "#000",
        "width": 0,
        "style": "solid"
      },
      "fill": "",
      "vertical": false
    },
    {
      "type": "shape",
      "width": 60.1,
      "height": 60.1,
      "left": 770.34,
      "top": 316.61019436648996,
      "viewBox": [
        200,
        200
      ],
      "path": "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
      "fill": "#56b3f6",
      "fixedRatio": false,
      "rotate": 0,
      "outline": {
        "color": "#085f9e",
        "width": 0,
        "style": "solid"
      },
      "flipH": false,
      "flipV": false,
      "text": {
        "content": "<p style=\"text-align: center;\"><span style=\"font-size: 20px;\"><span style=\"font-family: Songti SC;\">08</span></span></p>",
        "defaultFontName": "思源黑体 CN",
        "defaultColor": "#000",
        "align": "middle"
      }
    }
  ],
  'max':[
    {
      "type": "text",
      "width": 201.73534247999157,
      "height": 40,
      "left": 183.43145515019228,
      "top": 190.1436420330527,
      "rotate": 0,
      "defaultFontName": "思源黑体 CN",
      "defaultColor": "#333",
      "content": "<p style=\"\"><strong><span style=\"font-size: 20px;\"><span style=\"font-family: 思源宋体 CN;\"><span style=\"color: rgb(0, 0, 0);\">{{title}}</span></span></span></strong></p>",
      "lineHeight": 1,
      "outline": {
        "color": "#000",
        "width": 0,
        "style": "solid"
      },
      "fill": "",
      "vertical": false
    },
    {
      "type": "shape",
      "width": 60.1,
      "height": 60.1,
      "left": 114.37854484980772,
      "top": 180.8436420330527,
      "viewBox": [
        200,
        200
      ],
      "path": "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
      "fill": "#56b3f6",
      "fixedRatio": false,
      "rotate": 0,
      "outline": {
        "color": "#085f9e",
        "width": 0,
        "style": "solid"
      },
      "flipH": false,
      "flipV": false,
      "text": {
        "content": "<p style=\"text-align: center;\"><span style=\"font-size: 20px;\"><span style=\"font-family: Songti SC;\">01</span></span></p>",
        "defaultFontName": "思源黑体 CN",
        "defaultColor": "#000",
        "align": "middle"
      }
    },
    {
      "type": "text",
      "width": 201.73534247999154,
      "height": 40,
      "left": 183.43145515019228,
      "top": 267.0112580119877,
      "rotate": 0,
      "defaultFontName": "思源黑体 CN",
      "defaultColor": "#333",
      "content": "<p style=\"\"><strong><span style=\"font-size: 20px;\"><span style=\"font-family: 思源宋体 CN;\"><span style=\"color: rgb(0, 0, 0);\">{{title}}</span></span></span></strong></p>",
      "lineHeight": 1,
      "outline": {
        "color": "#000",
        "width": 0,
        "style": "solid"
      },
      "fill": "",
      "vertical": false
    },
    {
      "type": "shape",
      "width": 60.1,
      "height": 60.1,
      "left": 114.37854484980772,
      "top": 257.71125801198764,
      "viewBox": [
        200,
        200
      ],
      "path": "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
      "fill": "#56b3f6",
      "fixedRatio": false,
      "rotate": 0,
      "outline": {
        "color": "#085f9e",
        "width": 0,
        "style": "solid"
      },
      "flipH": false,
      "flipV": false,
      "text": {
        "content": "<p style=\"text-align: center;\"><span style=\"font-size: 20px;\"><span style=\"font-family: Songti SC;\">02</span></span></p>",
        "defaultFontName": "思源黑体 CN",
        "defaultColor": "#000",
        "align": "middle"
      }
    },
    {
      "type": "text",
      "width": 201.73534247999157,
      "height": 40,
      "left": 183.43145515019228,
      "top": 343.87887399092267,
      "rotate": 0,
      "defaultFontName": "思源黑体 CN",
      "defaultColor": "#333",
      "content": "<p style=\"\"><strong><span style=\"font-size: 20px;\"><span style=\"font-family: 思源宋体 CN;\"><span style=\"color: rgb(0, 0, 0);\">{{title}}</span></span></span></strong></p>",
      "lineHeight": 1,
      "outline": {
        "color": "#000",
        "width": 0,
        "style": "solid"
      },
      "fill": "",
      "vertical": false
    },
    {
      "type": "shape",
      "width": 60.1,
      "height": 60.1,
      "left": 114.37854484980772,
      "top": 334.5788739909226,
      "viewBox": [
        200,
        200
      ],
      "path": "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
      "fill": "#56b3f6",
      "fixedRatio": false,
      "rotate": 0,
      "outline": {
        "color": "#085f9e",
        "width": 0,
        "style": "solid"
      },
      "flipH": false,
      "flipV": false,
      "text": {
        "content": "<p style=\"text-align: center;\"><span style=\"font-size: 20px;\"><span style=\"font-family: Songti SC;\">03</span></span></p>",
        "defaultFontName": "思源黑体 CN",
        "defaultColor": "#000",
        "align": "middle"
      }
    },
    {
      "type": "text",
      "width": 201.73534247999157,
      "height": 40,
      "left": 183.43145515019228,
      "top": 420.74648996985763,
      "rotate": 0,
      "defaultFontName": "思源黑体 CN",
      "defaultColor": "#333",
      "content": "<p style=\"\"><strong><span style=\"font-size: 20px;\"><span style=\"font-family: 思源宋体 CN;\"><span style=\"color: rgb(0, 0, 0);\">{{title}}</span></span></span></strong></p>",
      "lineHeight": 1,
      "outline": {
        "color": "#000",
        "width": 0,
        "style": "solid"
      },
      "fill": "",
      "vertical": false
    },
    {
      "type": "shape",
      "width": 60.1,
      "height": 60.1,
      "left": 114.37854484980772,
      "top": 411.44648996985757,
      "viewBox": [
        200,
        200
      ],
      "path": "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
      "fill": "#56b3f6",
      "fixedRatio": false,
      "rotate": 0,
      "outline": {
        "color": "#085f9e",
        "width": 0,
        "style": "solid"
      },
      "flipH": false,
      "flipV": false,
      "text": {
        "content": "<p style=\"text-align: center;\"><span style=\"font-size: 20px;\"><span style=\"font-family: Songti SC;\">04</span></span></p>",
        "defaultFontName": "思源黑体 CN",
        "defaultColor": "#000",
        "align": "middle"
      }
    },
    {
      "type": "text",
      "width": 201.73534247999154,
      "height": 40,
      "left": 454.21970793056846,
      "top": 190.14364203305274,
      "rotate": 0,
      "defaultFontName": "思源黑体 CN",
      "defaultColor": "#333",
      "content": "<p style=\"\"><strong><span style=\"font-size: 20px;\"><span style=\"font-family: 思源宋体 CN;\"><span style=\"color: rgb(0, 0, 0);\">{{title}}</span></span></span></strong></p>",
      "lineHeight": 1,
      "outline": {
        "color": "#000",
        "width": 0,
        "style": "solid"
      },
      "fill": "",
      "vertical": false
    },
    {
      "type": "shape",
      "width": 60.1,
      "height": 60.1,
      "left": 385.16679763018385,
      "top": 180.84364203305273,
      "viewBox": [
        200,
        200
      ],
      "path": "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
      "fill": "#56b3f6",
      "fixedRatio": false,
      "rotate": 0,
      "outline": {
        "color": "#085f9e",
        "width": 0,
        "style": "solid"
      },
      "flipH": false,
      "flipV": false,
      "text": {
        "content": "<p style=\"text-align: center;\"><span style=\"font-size: 20px;\"><span style=\"font-family: Songti SC;\">05</span></span></p>",
        "defaultFontName": "思源黑体 CN",
        "defaultColor": "#000",
        "align": "middle"
      }
    },
    {
      "type": "text",
      "width": 201.73534247999157,
      "height": 40,
      "left": 454.21970793056846,
      "top": 267.0112580119877,
      "rotate": 0,
      "defaultFontName": "思源黑体 CN",
      "defaultColor": "#333",
      "content": "<p style=\"\"><strong><span style=\"font-size: 20px;\"><span style=\"font-family: 思源宋体 CN;\"><span style=\"color: rgb(0, 0, 0);\">{{title}}</span></span></span></strong></p>",
      "lineHeight": 1,
      "outline": {
        "color": "#000",
        "width": 0,
        "style": "solid"
      },
      "fill": "",
      "vertical": false
    },
    {
      "type": "shape",
      "width": 60.1,
      "height": 60.1,
      "left": 385.16679763018385,
      "top": 257.7112580119877,
      "viewBox": [
        200,
        200
      ],
      "path": "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
      "fill": "#56b3f6",
      "fixedRatio": false,
      "rotate": 0,
      "outline": {
        "color": "#085f9e",
        "width": 0,
        "style": "solid"
      },
      "flipH": false,
      "flipV": false,
      "text": {
        "content": "<p style=\"text-align: center;\"><span style=\"font-size: 20px;\"><span style=\"font-family: Songti SC;\">06</span></span></p>",
        "defaultFontName": "思源黑体 CN",
        "defaultColor": "#000",
        "align": "middle"
      }
    },
    {
      "type": "text",
      "width": 201.73534247999154,
      "height": 40,
      "left": 454.21970793056846,
      "top": 343.8788739909227,
      "rotate": 0,
      "defaultFontName": "思源黑体 CN",
      "defaultColor": "#333",
      "content": "<p style=\"\"><strong><span style=\"font-size: 20px;\"><span style=\"font-family: 思源宋体 CN;\"><span style=\"color: rgb(0, 0, 0);\">{{title}}</span></span></span></strong></p>",
      "lineHeight": 1,
      "outline": {
        "color": "#000",
        "width": 0,
        "style": "solid"
      },
      "fill": "",
      "vertical": false
    },
    {
      "type": "shape",
      "width": 60.1,
      "height": 60.1,
      "left": 385.16679763018385,
      "top": 334.5788739909227,
      "viewBox": [
        200,
        200
      ],
      "path": "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
      "fill": "#56b3f6",
      "fixedRatio": false,
      "rotate": 0,
      "outline": {
        "color": "#085f9e",
        "width": 0,
        "style": "solid"
      },
      "flipH": false,
      "flipV": false,
      "text": {
        "content": "<p style=\"text-align: center;\"><span style=\"font-size: 20px;\"><span style=\"font-family: Songti SC;\">07</span></span></p>",
        "defaultFontName": "思源黑体 CN",
        "defaultColor": "#000",
        "align": "middle"
      }
    },
    {
      "type": "text",
      "width": 201.73534247999154,
      "height": 40,
      "left": 454.21970793056846,
      "top": 420.7464899698577,
      "rotate": 0,
      "defaultFontName": "思源黑体 CN",
      "defaultColor": "#333",
      "content": "<p style=\"\"><strong><span style=\"font-size: 20px;\"><span style=\"font-family: 思源宋体 CN;\"><span style=\"color: rgb(0, 0, 0);\">{{title}}</span></span></span></strong></p>",
      "lineHeight": 1,
      "outline": {
        "color": "#000",
        "width": 0,
        "style": "solid"
      },
      "fill": "",
      "vertical": false
    },
    {
      "type": "shape",
      "width": 60.1,
      "height": 60.1,
      "left": 385.16679763018385,
      "top": 411.4464899698577,
      "viewBox": [
        200,
        200
      ],
      "path": "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
      "fill": "#56b3f6",
      "fixedRatio": false,
      "rotate": 0,
      "outline": {
        "color": "#085f9e",
        "width": 0,
        "style": "solid"
      },
      "flipH": false,
      "flipV": false,
      "text": {
        "content": "<p style=\"text-align: center;\"><span style=\"font-size: 20px;\"><span style=\"font-family: Songti SC;\">08</span></span></p>",
        "defaultFontName": "思源黑体 CN",
        "defaultColor": "#000",
        "align": "middle"
      }
    },
    {
      "type": "text",
      "width": 193.2150072150072,
      "height": 40,
      "left": 725.0079607109446,
      "top": 190.1436420330527,
      "rotate": 0,
      "defaultFontName": "思源黑体 CN",
      "defaultColor": "#333",
      "content": "<p style=\"\"><strong><span style=\"font-size: 20px;\"><span style=\"font-family: 思源宋体 CN;\"><span style=\"color: rgb(0, 0, 0);\">{{title}}</span></span></span></strong></p>",
      "lineHeight": 1,
      "outline": {
        "color": "#000",
        "width": 0,
        "style": "solid"
      },
      "fill": "",
      "vertical": false
    },
    {
      "type": "shape",
      "width": 60.1,
      "height": 60.1,
      "left": 655.95505041056,
      "top": 180.8436420330527,
      "viewBox": [
        200,
        200
      ],
      "path": "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
      "fill": "#56b3f6",
      "fixedRatio": false,
      "rotate": 0,
      "outline": {
        "color": "#085f9e",
        "width": 0,
        "style": "solid"
      },
      "flipH": false,
      "flipV": false,
      "text": {
        "content": "<p style=\"text-align: center;\"><span style=\"font-size: 20px;\"><span style=\"font-family: Songti SC;\">09</span></span></p>",
        "defaultFontName": "思源黑体 CN",
        "defaultColor": "#000",
        "align": "middle"
      }
    },
    {
      "type": "text",
      "width": 193.21500721500723,
      "height": 40,
      "left": 725.0079607109446,
      "top": 267.0112580119877,
      "rotate": 0,
      "defaultFontName": "思源黑体 CN",
      "defaultColor": "#333",
      "content": "<p style=\"\"><strong><span style=\"font-size: 20px;\"><span style=\"font-family: 思源宋体 CN;\"><span style=\"color: rgb(0, 0, 0);\">{{title}}</span></span></span></strong></p>",
      "lineHeight": 1,
      "outline": {
        "color": "#000",
        "width": 0,
        "style": "solid"
      },
      "fill": "",
      "vertical": false
    },
    {
      "type": "shape",
      "width": 60.1,
      "height": 60.1,
      "left": 655.95505041056,
      "top": 257.71125801198764,
      "viewBox": [
        200,
        200
      ],
      "path": "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
      "fill": "#56b3f6",
      "fixedRatio": false,
      "rotate": 0,
      "outline": {
        "color": "#085f9e",
        "width": 0,
        "style": "solid"
      },
      "flipH": false,
      "flipV": false,
      "text": {
        "content": "<p style=\"text-align: center;\"><span style=\"font-size: 20px;\"><span style=\"font-family: Songti SC;\">10</span></span></p>",
        "defaultFontName": "思源黑体 CN",
        "defaultColor": "#000",
        "align": "middle"
      }
    },
    {
      "type": "text",
      "width": 193.21500721500723,
      "height": 40,
      "left": 725.0079607109446,
      "top": 343.87887399092267,
      "rotate": 0,
      "defaultFontName": "思源黑体 CN",
      "defaultColor": "#333",
      "content": "<p style=\"\"><strong><span style=\"font-size: 20px;\"><span style=\"font-family: 思源宋体 CN;\"><span style=\"color: rgb(0, 0, 0);\">{{title}}</span></span></span></strong></p>",
      "lineHeight": 1,
      "outline": {
        "color": "#000",
        "width": 0,
        "style": "solid"
      },
      "fill": "",
      "vertical": false
    },
    {
      "type": "shape",
      "width": 60.1,
      "height": 60.1,
      "left": 655.95505041056,
      "top": 334.5788739909226,
      "viewBox": [
        200,
        200
      ],
      "path": "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
      "fill": "#56b3f6",
      "fixedRatio": false,
      "rotate": 0,
      "outline": {
        "color": "#085f9e",
        "width": 0,
        "style": "solid"
      },
      "flipH": false,
      "flipV": false,
      "text": {
        "content": "<p style=\"text-align: center;\"><span style=\"font-size: 20px;\"><span style=\"font-family: Songti SC;\">11</span></span></p>",
        "defaultFontName": "思源黑体 CN",
        "defaultColor": "#000",
        "align": "middle"
      }
    },
    {
      "type": "text",
      "width": 193.2150072150072,
      "height": 40,
      "left": 725.0079607109446,
      "top": 420.74648996985763,
      "rotate": 0,
      "defaultFontName": "思源黑体 CN",
      "defaultColor": "#333",
      "content": "<p style=\"\"><strong><span style=\"font-size: 20px;\"><span style=\"font-family: 思源宋体 CN;\"><span style=\"color: rgb(0, 0, 0);\">{{title}}</span></span></span></strong></p>",
      "lineHeight": 1,
      "outline": {
        "color": "#000",
        "width": 0,
        "style": "solid"
      },
      "fill": "",
      "vertical": false
    },
    {
      "type": "shape",
      "width": 60.1,
      "height": 60.1,
      "left": 655.95505041056,
      "top": 411.44648996985757,
      "viewBox": [
        200,
        200
      ],
      "path": "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
      "fill": "#56b3f6",
      "fixedRatio": false,
      "rotate": 0,
      "outline": {
        "color": "#085f9e",
        "width": 0,
        "style": "solid"
      },
      "flipH": false,
      "flipV": false,
      "text": {
        "content": "<p style=\"text-align: center;\"><span style=\"font-size: 20px;\"><span style=\"font-family: Songti SC;\">12</span></span></p>",
        "defaultFontName": "思源黑体 CN",
        "defaultColor": "#000",
        "align": "middle"
      }
    }
  ]
},
'3':{
  manyLenght:[3,3,3],

  'few':[
    {
      "type": "shape",
      "width": 49.95,
      "height": 49.95,
      "left": 74.69,
      "top": 219.73,
      "viewBox": [
        200,
        200
      ],
      "path": "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
      "fill": "#f1cb8f",
      "fixedRatio": false,
      "rotate": 0,
      "outline": {
        "color": "#16468d",
        "width": 0,
        "style": "solid"
      },
      "text": {
        "content": "<p style=\"text-align: center;\"><span style=\"font-size: 14px;\"><span style=\"font-family: Arial;\">&nbsp;</span></span></p>",
        "defaultFontName": "思源黑体 CN",
        "defaultColor": "#333",
        "align": "middle"
      },
      "flipH": false,
      "flipV": false
    },
    {
      "type": "text",
      "width": 49.95000000000001,
      "height": 40,
      "left": 78.66129186602872,
      "top": 219,
      "rotate": 0,
      "defaultFontName": "思源黑体 CN",
      "defaultColor": "#333",
      "content": "<p style=\"\" class=\"ProseMirror-selectednode\" draggable=\"true\"><span style=\"font-size: 20px;\"><span style=\"color: rgb(66, 112, 146);\">01</span></span></p>",
      "lineHeight": 1,
      "outline": {
        "color": "#000",
        "width": 0,
        "style": "solid"
      },
      "fill": "",
      "vertical": false
    },
    {
      "type": "text",
      "width": 221.80426875608794,
      "height": 44,
      "left": 142.68,
      "top": 219,
      "rotate": 0,
      "defaultFontName": "思源黑体 CN",
      "defaultColor": "#333",
      "content": "<p style=\"\"><span style=\"font-size: 24px;\"><span style=\"color: rgb(255, 255, 255);\">{{title}}</span></span></p>",
      "lineHeight": 1,
      "outline": {
        "color": "#000",
        "width": 0,
        "style": "solid"
      },
      "fill": "",
      "vertical": false
    },

    {
      "type": "shape",
      "width": 49.95,
      "height": 49.95,
      "left": 74.69,
      "top": 295.21,
      "viewBox": [
        200,
        200
      ],
      "path": "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
      "fill": "#f1cb8f",
      "fixedRatio": false,
      "rotate": 0,
      "outline": {
        "color": "#16468d",
        "width": 0,
        "style": "solid"
      },
      "text": {
        "content": "<p style=\"text-align: center;\"><span style=\"font-size: 14px;\"><span style=\"font-family: Arial;\">&nbsp;</span></span></p>",
        "defaultFontName": "思源黑体 CN",
        "defaultColor": "#333",
        "align": "middle"
      },
      "flipH": false,
      "flipV": false
    },
    {
      "type": "text",
      "width": 49.949999999999996,
      "height": 40,
      "left": 77.69,
      "top": 295,
      "rotate": 0,
      "defaultFontName": "思源黑体 CN",
      "defaultColor": "#333",
      "content": "<p style=\"\"><span style=\"font-size: 20px;\"><span style=\"color: rgb(66, 112, 146);\">02</span></span></p>",
      "lineHeight": 1,
      "outline": {
        "color": "#000",
        "width": 0,
        "style": "solid"
      },
      "fill": "",
      "vertical": false
    },
    {
      "type": "text",
      "width": 213.41500701112147,
      "height": 44,
      "left": 142.68,
      "top": 295,
      "rotate": 0,
      "defaultFontName": "思源黑体 CN",
      "defaultColor": "#333",
      "content": "<p style=\"\"><span style=\"font-size: 24px;\"><span style=\"color: rgb(255, 255, 255);\">{{title}}</span></span></p>",
      "lineHeight": 1,
      "outline": {
        "color": "#000",
        "width": 0,
        "style": "solid"
      },
      "fill": "",
      "vertical": false
    },

    {
      "type": "shape",
      "width": 49.95,
      "height": 49.95,
      "left": 76.2,
      "top": 369.69,
      "viewBox": [
        200,
        200
      ],
      "path": "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
      "fill": "#f1cb8f",
      "fixedRatio": false,
      "rotate": 0,
      "outline": {
        "color": "#16468d",
        "width": 0,
        "style": "solid"
      },
      "text": {
        "content": "<p style=\"text-align: center;\"><span style=\"font-size: 14px;\"><span style=\"font-family: Arial;\">&nbsp;</span></span></p>",
        "defaultFontName": "思源黑体 CN",
        "defaultColor": "#333",
        "align": "middle"
      },
      "flipH": false,
      "flipV": false
    },
    {
      "type": "text",
      "width": 46.94999999999999,
      "height": 40,
      "left": 77.69,
      "top": 369,
      "rotate": 0,
      "defaultFontName": "思源黑体 CN",
      "defaultColor": "#333",
      "content": "<p style=\"\"><span style=\"font-size: 20px;\"><span style=\"color: rgb(66, 112, 146);\">03</span></span></p>",
      "lineHeight": 1,
      "outline": {
        "color": "#000",
        "width": 0,
        "style": "solid"
      },
      "fill": "",
      "vertical": false
    },
    {
      "type": "text",
      "width": 213.41500701112147,
      "height": 44,
      "left": 142.68,
      "top": 369,
      "rotate": 0,
      "defaultFontName": "思源黑体 CN",
      "defaultColor": "#333",
      "content": "<p style=\"\"><span style=\"font-size: 24px;\"><span style=\"color: rgb(255, 255, 255);\">{{title}}</span></span></p>",
      "lineHeight": 1,
      "outline": {
        "color": "#000",
        "width": 0,
        "style": "solid"
      },
      "fill": "",
      "vertical": false
    },
    {
      "type": "shape",
      "width": 49.95,
      "height": 49.95,
      "left": 76.2,
      "top": 444.17,
      "viewBox": [
        200,
        200
      ],
      "path": "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
      "fill": "#f1cb8f",
      "fixedRatio": false,
      "rotate": 0,
      "outline": {
        "color": "#16468d",
        "width": 0,
        "style": "solid"
      },
      "text": {
        "content": "<p style=\"text-align: center;\"><span style=\"font-size: 14px;\"><span style=\"font-family: Arial;\">&nbsp;</span></span></p>",
        "defaultFontName": "思源黑体 CN",
        "defaultColor": "#333",
        "align": "middle"
      },
      "flipH": false,
      "flipV": false
    },
    {
      "type": "text",
      "width": 58.92129186602872,
      "height": 40,
      "left": 77.69,
      "top": 444,
      "rotate": 0,
      "defaultFontName": "思源黑体 CN",
      "defaultColor": "#333",
      "content": "<p style=\"\"><span style=\"font-size: 20px;\"><span style=\"color: rgb(66, 112, 146);\">04</span></span></p>",
      "lineHeight": 1,
      "outline": {
        "color": "#000",
        "width": 0,
        "style": "solid"
      },
      "fill": "",
      "vertical": false
    },
    {
      "type": "text",
      "width": 213.41500701112147,
      "height": 44,
      "left": 142.68,
      "top": 444,
      "rotate": 0,
      "defaultFontName": "思源黑体 CN",
      "defaultColor": "#333",
      "content": "<p style=\"\"><span style=\"font-size: 24px;\"><span style=\"color: rgb(255, 255, 255);\">{{title}}</span></span></p>",
      "lineHeight": 1,
      "outline": {
        "color": "#000",
        "width": 0,
        "style": "solid"
      },
      "fill": "",
      "vertical": false
    },
    
  ],
   'many':[
    {
      "type": "shape",
      "width": 49.95,
      "height": 49.95,
      "left": 74.69,
      "top": 219.73,
      "viewBox": [
        200,
        200
      ],
      "path": "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
      "fill": "#f1cb8f",
      "fixedRatio": false,
      "rotate": 0,
      "outline": {
        "color": "#16468d",
        "width": 0,
        "style": "solid"
      },
      "text": {
        "content": "<p style=\"text-align: center;\"><span style=\"font-size: 14px;\"><span style=\"font-family: Arial;\">&nbsp;</span></span></p>",
        "defaultFontName": "思源黑体 CN",
        "defaultColor": "#333",
        "align": "middle"
      },
      "flipH": false,
      "flipV": false
    },
    {
      "type": "text",
      "width": 49.95000000000001,
      "height": 40,
      "left": 78.66129186602872,
      "top": 219,
      "rotate": 0,
      "defaultFontName": "思源黑体 CN",
      "defaultColor": "#333",
      "content": "<p style=\"\" class=\"ProseMirror-selectednode\" draggable=\"true\"><span style=\"font-size: 20px;\"><span style=\"color: rgb(66, 112, 146);\">01</span></span></p>",
      "lineHeight": 1,
      "outline": {
        "color": "#000",
        "width": 0,
        "style": "solid"
      },
      "fill": "",
      "vertical": false
    },
    {
      "type": "text",
      "width": 212.3663492930007,
      "height": 44,
      "left": 142.68,
      "top": 219,
      "rotate": 0,
      "defaultFontName": "思源黑体 CN",
      "defaultColor": "#333",
      "content": "<p style=\"\"><span style=\"font-size: 24px;\"><span style=\"color: rgb(255, 255, 255);\">{{title}}</span></span></p>",
      "lineHeight": 1,
      "outline": {
        "color": "#000",
        "width": 0,
        "style": "solid"
      },
      "fill": "",
      "vertical": false
    },
    {
      "type": "shape",
      "width": 49.95,
      "height": 49.95,
      "left": 360.1195302013423,
      "top": 219.73000000000008,
      "viewBox": [
        200,
        200
      ],
      "path": "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
      "fill": "#f1cb8f",
      "fixedRatio": false,
      "rotate": 0,
      "outline": {
        "color": "#16468d",
        "width": 0,
        "style": "solid"
      },
      "text": {
        "content": "<p style=\"text-align: center;\"><span style=\"font-size: 14px;\"><span style=\"font-family: Arial;\">&nbsp;</span></span></p>",
        "defaultFontName": "思源黑体 CN",
        "defaultColor": "#333",
        "align": "middle"
      },
      "flipH": false,
      "flipV": false
    },
    {
      "type": "text",
      "width": 49.95000000000001,
      "height": 40,
      "left": 364.09082206737105,
      "top": 219,
      "rotate": 0,
      "defaultFontName": "思源黑体 CN",
      "defaultColor": "#333",
      "content": "<p style=\"\"><span style=\"font-size: 20px;\"><span style=\"color: rgb(66, 112, 146);\">02</span></span></p>",
      "lineHeight": 1,
      "outline": {
        "color": "#000",
        "width": 0,
        "style": "solid"
      },
      "fill": "",
      "vertical": false
    },
    {
      "type": "text",
      "width": 224.95024191045033,
      "height": 44,
      "left": 428.1095302013423,
      "top": 219,
      "rotate": 0,
      "defaultFontName": "思源黑体 CN",
      "defaultColor": "#333",
      "content": "<p style=\"\"><span style=\"font-size: 24px;\"><span style=\"color: rgb(255, 255, 255);\">{{title}}</span></span></p>",
      "lineHeight": 1,
      "outline": {
        "color": "#000",
        "width": 0,
        "style": "solid"
      },
      "fill": "",
      "vertical": false
    },
    {
      "type": "shape",
      "width": 49.95,
      "height": 49.95,
      "left": 74.69,
      "top": 295.21,
      "viewBox": [
        200,
        200
      ],
      "path": "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
      "fill": "#f1cb8f",
      "fixedRatio": false,
      "rotate": 0,
      "outline": {
        "color": "#16468d",
        "width": 0,
        "style": "solid"
      },
      "text": {
        "content": "<p style=\"text-align: center;\"><span style=\"font-size: 14px;\"><span style=\"font-family: Arial;\">&nbsp;</span></span></p>",
        "defaultFontName": "思源黑体 CN",
        "defaultColor": "#333",
        "align": "middle"
      },
      "flipH": false,
      "flipV": false
    },
    {
      "type": "text",
      "width": 49.949999999999996,
      "height": 40,
      "left": 77.69,
      "top": 295,
      "rotate": 0,
      "defaultFontName": "思源黑体 CN",
      "defaultColor": "#333",
      "content": "<p style=\"\"><span style=\"font-size: 20px;\"><span style=\"color: rgb(66, 112, 146);\">03</span></span></p>",
      "lineHeight": 1,
      "outline": {
        "color": "#000",
        "width": 0,
        "style": "solid"
      },
      "fill": "",
      "vertical": false
    },
    {
      "type": "text",
      "width": 212.36634929300072,
      "height": 44,
      "left": 142.68,
      "top": 295,
      "rotate": 0,
      "defaultFontName": "思源黑体 CN",
      "defaultColor": "#333",
      "content": "<p style=\"\"><span style=\"font-size: 24px;\"><span style=\"color: rgb(255, 255, 255);\">{{title}}</span></span></p>",
      "lineHeight": 1,
      "outline": {
        "color": "#000",
        "width": 0,
        "style": "solid"
      },
      "fill": "",
      "vertical": false
    },
    {
      "type": "shape",
      "width": 49.95,
      "height": 49.95,
      "left": 360.1195302013423,
      "top": 295.21,
      "viewBox": [
        200,
        200
      ],
      "path": "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
      "fill": "#f1cb8f",
      "fixedRatio": false,
      "rotate": 0,
      "outline": {
        "color": "#16468d",
        "width": 0,
        "style": "solid"
      },
      "text": {
        "content": "<p style=\"text-align: center;\"><span style=\"font-size: 14px;\"><span style=\"font-family: Arial;\">&nbsp;</span></span></p>",
        "defaultFontName": "思源黑体 CN",
        "defaultColor": "#333",
        "align": "middle"
      },
      "flipH": false,
      "flipV": false
    },
    {
      "type": "text",
      "width": 49.949999999999996,
      "height": 40,
      "left": 363.1195302013423,
      "top": 295,
      "rotate": 0,
      "defaultFontName": "思源黑体 CN",
      "defaultColor": "#333",
      "content": "<p style=\"\"><span style=\"font-size: 20px;\"><span style=\"color: rgb(66, 112, 146);\">04</span></span></p>",
      "lineHeight": 1,
      "outline": {
        "color": "#000",
        "width": 0,
        "style": "solid"
      },
      "fill": "",
      "vertical": false
    },
    {
      "type": "text",
      "width": 224.95024191045033,
      "height": 44,
      "left": 428.1095302013423,
      "top": 295,
      "rotate": 0,
      "defaultFontName": "思源黑体 CN",
      "defaultColor": "#333",
      "content": "<p style=\"\"><span style=\"font-size: 24px;\"><span style=\"color: rgb(255, 255, 255);\">{{title}}</span></span></p>",
      "lineHeight": 1,
      "outline": {
        "color": "#000",
        "width": 0,
        "style": "solid"
      },
      "fill": "",
      "vertical": false
    },
    {
      "type": "shape",
      "width": 49.95,
      "height": 49.95,
      "left": 76.2,
      "top": 369.69,
      "viewBox": [
        200,
        200
      ],
      "path": "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
      "fill": "#f1cb8f",
      "fixedRatio": false,
      "rotate": 0,
      "outline": {
        "color": "#16468d",
        "width": 0,
        "style": "solid"
      },
      "text": {
        "content": "<p style=\"text-align: center;\"><span style=\"font-size: 14px;\"><span style=\"font-family: Arial;\">&nbsp;</span></span></p>",
        "defaultFontName": "思源黑体 CN",
        "defaultColor": "#333",
        "align": "middle"
      },
      "flipH": false,
      "flipV": false
    },
    {
      "type": "text",
      "width": 46.94999999999999,
      "height": 40,
      "left": 77.69,
      "top": 369,
      "rotate": 0,
      "defaultFontName": "思源黑体 CN",
      "defaultColor": "#333",
      "content": "<p style=\"\"><span style=\"font-size: 20px;\"><span style=\"color: rgb(66, 112, 146);\">05</span></span></p>",
      "lineHeight": 1,
      "outline": {
        "color": "#000",
        "width": 0,
        "style": "solid"
      },
      "fill": "",
      "vertical": false
    },
    {
      "type": "text",
      "width": 212.36634929300072,
      "height": 44,
      "left": 142.68,
      "top": 369,
      "rotate": 0,
      "defaultFontName": "思源黑体 CN",
      "defaultColor": "#333",
      "content": "<p style=\"\"><span style=\"font-size: 24px;\"><span style=\"color: rgb(255, 255, 255);\">{{title}}</span></span></p>",
      "lineHeight": 1,
      "outline": {
        "color": "#000",
        "width": 0,
        "style": "solid"
      },
      "fill": "",
      "vertical": false
    },
    {
      "type": "shape",
      "width": 49.95,
      "height": 49.95,
      "left": 361.6295302013423,
      "top": 369.69,
      "viewBox": [
        200,
        200
      ],
      "path": "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
      "fill": "#f1cb8f",
      "fixedRatio": false,
      "rotate": 0,
      "outline": {
        "color": "#16468d",
        "width": 0,
        "style": "solid"
      },
      "text": {
        "content": "<p style=\"text-align: center;\"><span style=\"font-size: 14px;\"><span style=\"font-family: Arial;\">&nbsp;</span></span></p>",
        "defaultFontName": "思源黑体 CN",
        "defaultColor": "#333",
        "align": "middle"
      },
      "flipH": false,
      "flipV": false
    },
    {
      "type": "text",
      "width": 46.94999999999999,
      "height": 40,
      "left": 363.1195302013423,
      "top": 369,
      "rotate": 0,
      "defaultFontName": "思源黑体 CN",
      "defaultColor": "#333",
      "content": "<p style=\"\"><span style=\"font-size: 20px;\"><span style=\"color: rgb(66, 112, 146);\">06</span></span></p>",
      "lineHeight": 1,
      "outline": {
        "color": "#000",
        "width": 0,
        "style": "solid"
      },
      "fill": "",
      "vertical": false
    },
    {
      "type": "text",
      "width": 224.95024191045044,
      "height": 44,
      "left": 428.1095302013423,
      "top": 369,
      "rotate": 0,
      "defaultFontName": "思源黑体 CN",
      "defaultColor": "#333",
      "content": "<p style=\"\"><span style=\"font-size: 24px;\"><span style=\"color: rgb(255, 255, 255);\">{{title}}</span></span></p>",
      "lineHeight": 1,
      "outline": {
        "color": "#000",
        "width": 0,
        "style": "solid"
      },
      "fill": "",
      "vertical": false
    },
    {
      "type": "shape",
      "width": 49.95,
      "height": 49.95,
      "left": 76.2,
      "top": 444.17,
      "viewBox": [
        200,
        200
      ],
      "path": "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
      "fill": "#f1cb8f",
      "fixedRatio": false,
      "rotate": 0,
      "outline": {
        "color": "#16468d",
        "width": 0,
        "style": "solid"
      },
      "text": {
        "content": "<p style=\"text-align: center;\"><span style=\"font-size: 14px;\"><span style=\"font-family: Arial;\">&nbsp;</span></span></p>",
        "defaultFontName": "思源黑体 CN",
        "defaultColor": "#333",
        "align": "middle"
      },
      "flipH": false,
      "flipV": false
    },
    {
      "type": "text",
      "width": 58.92129186602872,
      "height": 40,
      "left": 77.69,
      "top": 444,
      "rotate": 0,
      "defaultFontName": "思源黑体 CN",
      "defaultColor": "#333",
      "content": "<p style=\"\"><span style=\"font-size: 20px;\"><span style=\"color: rgb(66, 112, 146);\">07</span></span></p>",
      "lineHeight": 1,
      "outline": {
        "color": "#000",
        "width": 0,
        "style": "solid"
      },
      "fill": "",
      "vertical": false
    },
    {
      "type": "text",
      "width": 212.36634929300072,
      "height": 44,
      "left": 142.68,
      "top": 444,
      "rotate": 0,
      "defaultFontName": "思源黑体 CN",
      "defaultColor": "#333",
      "content": "<p style=\"\"><span style=\"font-size: 24px;\"><span style=\"color: rgb(255, 255, 255);\">{{title}}</span></span></p>",
      "lineHeight": 1,
      "outline": {
        "color": "#000",
        "width": 0,
        "style": "solid"
      },
      "fill": "",
      "vertical": false
    },
    {
      "type": "shape",
      "width": 49.95,
      "height": 49.95,
      "left": 361.6295302013423,
      "top": 444.17,
      "viewBox": [
        200,
        200
      ],
      "path": "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
      "fill": "#f1cb8f",
      "fixedRatio": false,
      "rotate": 0,
      "outline": {
        "color": "#16468d",
        "width": 0,
        "style": "solid"
      },
      "text": {
        "content": "<p style=\"text-align: center;\"><span style=\"font-size: 14px;\"><span style=\"font-family: Arial;\">&nbsp;</span></span></p>",
        "defaultFontName": "思源黑体 CN",
        "defaultColor": "#333",
        "align": "middle"
      },
      "flipH": false,
      "flipV": false
    },
    {
      "type": "text",
      "width": 58.92129186602872,
      "height": 40,
      "left": 363.1195302013423,
      "top": 444,
      "rotate": 0,
      "defaultFontName": "思源黑体 CN",
      "defaultColor": "#333",
      "content": "<p style=\"\"><span style=\"font-size: 20px;\"><span style=\"color: rgb(66, 112, 146);\">08</span></span></p>",
      "lineHeight": 1,
      "outline": {
        "color": "#000",
        "width": 0,
        "style": "solid"
      },
      "fill": "",
      "vertical": false
    },
    {
      "type": "text",
      "width": 224.95024191045044,
      "height": 44,
      "left": 428.1095302013423,
      "top": 444,
      "rotate": 0,
      "defaultFontName": "思源黑体 CN",
      "defaultColor": "#333",
      "content": "<p style=\"\"><span style=\"font-size: 24px;\"><span style=\"color: rgb(255, 255, 255);\">{{title}}</span></span></p>",
      "lineHeight": 1,
      "outline": {
        "color": "#000",
        "width": 0,
        "style": "solid"
      },
      "fill": "",
      "vertical": false
    }

   ],
   'max':[
    {
      "type": "shape",
      "width": 49.95,
      "height": 49.95,
      "left": 35.8896644295302,
      "top": 83.40449664429528,
      "viewBox": [
        200,
        200
      ],
      "path": "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
      "fill": "#f1cb8f",
      "fixedRatio": false,
      "rotate": 0,
      "outline": {
        "color": "#16468d",
        "width": 0,
        "style": "solid"
      },
      "text": {
        "content": "<p style=\"text-align: center;\"><span style=\"font-size: 14px;\"><span style=\"font-family: Arial;\">&nbsp;</span></span></p>",
        "defaultFontName": "思源黑体 CN",
        "defaultColor": "#333",
        "align": "middle"
      },
      "flipH": false,
      "flipV": false
    },
    {
      "type": "text",
      "width": 49.95000000000001,
      "height": 40,
      "left": 39.86095629555892,
      "top": 83,
      "rotate": 0,
      "defaultFontName": "思源黑体 CN",
      "defaultColor": "#333",
      "content": "<p style=\"\" class=\"ProseMirror-selectednode\" draggable=\"true\"><span style=\"font-size: 20px;\"><span style=\"color: rgb(66, 112, 146);\">01</span></span></p>",
      "lineHeight": 1,
      "outline": {
        "color": "#000",
        "width": 0,
        "style": "solid"
      },
      "fill": "",
      "vertical": false
    },
    {
      "type": "text",
      "width": 212.2717449664429,
      "height": 44,
      "left": 103.87966442953021,
      "top": 83,
      "rotate": 0,
      "defaultFontName": "思源黑体 CN",
      "defaultColor": "#333",
      "content": "<p style=\"\"><span style=\"font-size: 24px;\"><span style=\"color: rgb(255, 255, 255);\">{{title}}</span></span></p>",
      "lineHeight": 1,
      "outline": {
        "color": "#000",
        "width": 0,
        "style": "solid"
      },
      "fill": "",
      "vertical": false
    },
    {
      "type": "shape",
      "width": 49.95,
      "height": 49.95,
      "left": 316.15140939597313,
      "top": 83.40449664429528,
      "viewBox": [
        200,
        200
      ],
      "path": "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
      "fill": "#f1cb8f",
      "fixedRatio": false,
      "rotate": 0,
      "outline": {
        "color": "#16468d",
        "width": 0,
        "style": "solid"
      },
      "text": {
        "content": "<p style=\"text-align: center;\"><span style=\"font-size: 14px;\"><span style=\"font-family: Arial;\">&nbsp;</span></span></p>",
        "defaultFontName": "思源黑体 CN",
        "defaultColor": "#333",
        "align": "middle"
      },
      "flipH": false,
      "flipV": false
    },
    {
      "type": "text",
      "width": 49.95000000000001,
      "height": 40,
      "left": 320.1227012620019,
      "top": 83,
      "rotate": 0,
      "defaultFontName": "思源黑体 CN",
      "defaultColor": "#333",
      "content": "<p style=\"\"><span style=\"font-size: 20px;\"><span style=\"color: rgb(66, 112, 146);\">02</span></span></p>",
      "lineHeight": 1,
      "outline": {
        "color": "#000",
        "width": 0,
        "style": "solid"
      },
      "fill": "",
      "vertical": false
    },
    {
      "type": "text",
      "width": 221.38307235029725,
      "height": 44,
      "left": 384.1414093959732,
      "top": 83,
      "rotate": 0,
      "defaultFontName": "思源黑体 CN",
      "defaultColor": "#333",
      "content": "<p style=\"\"><span style=\"font-size: 24px;\"><span style=\"color: rgb(255, 255, 255);\">{{title}}</span></span></p>",
      "lineHeight": 1,
      "outline": {
        "color": "#000",
        "width": 0,
        "style": "solid"
      },
      "fill": "",
      "vertical": false
    },
    {
      "type": "shape",
      "width": 49.95,
      "height": 49.95,
      "left": 35.8896644295302,
      "top": 158.8844966442952,
      "viewBox": [
        200,
        200
      ],
      "path": "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
      "fill": "#f1cb8f",
      "fixedRatio": false,
      "rotate": 0,
      "outline": {
        "color": "#16468d",
        "width": 0,
        "style": "solid"
      },
      "text": {
        "content": "<p style=\"text-align: center;\"><span style=\"font-size: 14px;\"><span style=\"font-family: Arial;\">&nbsp;</span></span></p>",
        "defaultFontName": "思源黑体 CN",
        "defaultColor": "#333",
        "align": "middle"
      },
      "flipH": false,
      "flipV": false
    },
    {
      "type": "text",
      "width": 49.949999999999996,
      "height": 40,
      "left": 38.8896644295302,
      "top": 158,
      "rotate": 0,
      "defaultFontName": "思源黑体 CN",
      "defaultColor": "#333",
      "content": "<p style=\"\"><span style=\"font-size: 20px;\"><span style=\"color: rgb(66, 112, 146);\">03</span></span></p>",
      "lineHeight": 1,
      "outline": {
        "color": "#000",
        "width": 0,
        "style": "solid"
      },
      "fill": "",
      "vertical": false
    },
    {
      "type": "text",
      "width": 212.2717449664429,
      "height": 44,
      "left": 103.87966442953021,
      "top": 158,
      "rotate": 0,
      "defaultFontName": "思源黑体 CN",
      "defaultColor": "#333",
      "content": "<p style=\"\"><span style=\"font-size: 24px;\"><span style=\"color: rgb(255, 255, 255);\">{{title}}</span></span></p>",
      "lineHeight": 1,
      "outline": {
        "color": "#000",
        "width": 0,
        "style": "solid"
      },
      "fill": "",
      "vertical": false
    },

    {
      "type": "shape",
      "width": 49.95,
      "height": 49.95,
      "left": 316.15140939597313,
      "top": 158.8844966442952,
      "viewBox": [
        200,
        200
      ],
      "path": "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
      "fill": "#f1cb8f",
      "fixedRatio": false,
      "rotate": 0,
      "outline": {
        "color": "#16468d",
        "width": 0,
        "style": "solid"
      },
      "text": {
        "content": "<p style=\"text-align: center;\"><span style=\"font-size: 14px;\"><span style=\"font-family: Arial;\">&nbsp;</span></span></p>",
        "defaultFontName": "思源黑体 CN",
        "defaultColor": "#333",
        "align": "middle"
      },
      "flipH": false,
      "flipV": false
    },
    {
      "type": "text",
      "width": 49.949999999999996,
      "height": 40,
      "left": 319.1514093959732,
      "top": 158,
      "rotate": 0,
      "defaultFontName": "思源黑体 CN",
      "defaultColor": "#333",
      "content": "<p style=\"\"><span style=\"font-size: 20px;\"><span style=\"color: rgb(66, 112, 146);\">04</span></span></p>",
      "lineHeight": 1,
      "outline": {
        "color": "#000",
        "width": 0,
        "style": "solid"
      },
      "fill": "",
      "vertical": false
    },
    {
      "type": "text",
      "width": 221.3830723502972,
      "height": 44,
      "left": 384.1414093959732,
      "top": 158,
      "rotate": 0,
      "defaultFontName": "思源黑体 CN",
      "defaultColor": "#333",
      "content": "<p style=\"\"><span style=\"font-size: 24px;\"><span style=\"color: rgb(255, 255, 255);\">{{title}}</span></span></p>",
      "lineHeight": 1,
      "outline": {
        "color": "#000",
        "width": 0,
        "style": "solid"
      },
      "fill": "",
      "vertical": false
    },
    {
      "type": "shape",
      "width": 49.95,
      "height": 49.95,
      "left": 37.399664429530205,
      "top": 233.36449664429523,
      "viewBox": [
        200,
        200
      ],
      "path": "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
      "fill": "#f1cb8f",
      "fixedRatio": false,
      "rotate": 0,
      "outline": {
        "color": "#16468d",
        "width": 0,
        "style": "solid"
      },
      "text": {
        "content": "<p style=\"text-align: center;\"><span style=\"font-size: 14px;\"><span style=\"font-family: Arial;\">&nbsp;</span></span></p>",
        "defaultFontName": "思源黑体 CN",
        "defaultColor": "#333",
        "align": "middle"
      },
      "flipH": false,
      "flipV": false
    },
    {
      "type": "text",
      "width": 46.94999999999999,
      "height": 40,
      "left": 38.8896644295302,
      "top": 233,
      "rotate": 0,
      "defaultFontName": "思源黑体 CN",
      "defaultColor": "#333",
      "content": "<p style=\"\"><span style=\"font-size: 20px;\"><span style=\"color: rgb(66, 112, 146);\">05</span></span></p>",
      "lineHeight": 1,
      "outline": {
        "color": "#000",
        "width": 0,
        "style": "solid"
      },
      "fill": "",
      "vertical": false
    },
    {
      "type": "text",
      "width": 212.2717449664429,
      "height": 44,
      "left": 103.87966442953021,
      "top": 233,
      "rotate": 0,
      "defaultFontName": "思源黑体 CN",
      "defaultColor": "#333",
      "content": "<p style=\"\"><span style=\"font-size: 24px;\"><span style=\"color: rgb(255, 255, 255);\">{{title}}</span></span></p>",
      "lineHeight": 1,
      "outline": {
        "color": "#000",
        "width": 0,
        "style": "solid"
      },
      "fill": "",
      "vertical": false
    },
    {
      "type": "shape",
      "width": 49.95,
      "height": 49.95,
      "left": 317.6614093959732,
      "top": 233.36449664429523,
      "viewBox": [
        200,
        200
      ],
      "path": "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
      "fill": "#f1cb8f",
      "fixedRatio": false,
      "rotate": 0,
      "outline": {
        "color": "#16468d",
        "width": 0,
        "style": "solid"
      },
      "text": {
        "content": "<p style=\"text-align: center;\"><span style=\"font-size: 14px;\"><span style=\"font-family: Arial;\">&nbsp;</span></span></p>",
        "defaultFontName": "思源黑体 CN",
        "defaultColor": "#333",
        "align": "middle"
      },
      "flipH": false,
      "flipV": false
    },
    {
      "type": "text",
      "width": 46.94999999999999,
      "height": 40,
      "left": 319.1514093959732,
      "top": 233,
      "rotate": 0,
      "defaultFontName": "思源黑体 CN",
      "defaultColor": "#333",
      "content": "<p style=\"\"><span style=\"font-size: 20px;\"><span style=\"color: rgb(66, 112, 146);\">06</span></span></p>",
      "lineHeight": 1,
      "outline": {
        "color": "#000",
        "width": 0,
        "style": "solid"
      },
      "fill": "",
      "vertical": false
    },
    {
      "type": "text",
      "width": 221.38307235029717,
      "height": 44,
      "left": 384.1414093959732,
      "top": 233,
      "rotate": 0,
      "defaultFontName": "思源黑体 CN",
      "defaultColor": "#333",
      "content": "<p style=\"\"><span style=\"font-size: 24px;\"><span style=\"color: rgb(255, 255, 255);\">{{title}}</span></span></p>",
      "lineHeight": 1,
      "outline": {
        "color": "#000",
        "width": 0,
        "style": "solid"
      },
      "fill": "",
      "vertical": false
    },

    {
      "type": "shape",
      "width": 49.95,
      "height": 49.95,
      "left": 37.399664429530205,
      "top": 307.8444966442952,
      "viewBox": [
        200,
        200
      ],
      "path": "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
      "fill": "#f1cb8f",
      "fixedRatio": false,
      "rotate": 0,
      "outline": {
        "color": "#16468d",
        "width": 0,
        "style": "solid"
      },
      "text": {
        "content": "<p style=\"text-align: center;\"><span style=\"font-size: 14px;\"><span style=\"font-family: Arial;\">&nbsp;</span></span></p>",
        "defaultFontName": "思源黑体 CN",
        "defaultColor": "#333",
        "align": "middle"
      },
      "flipH": false,
      "flipV": false
    },
    {
      "type": "text",
      "width": 58.92129186602872,
      "height": 40,
      "left": 38.8896644295302,
      "top": 307,
      "rotate": 0,
      "defaultFontName": "思源黑体 CN",
      "defaultColor": "#333",
      "content": "<p style=\"\"><span style=\"font-size: 20px;\"><span style=\"color: rgb(66, 112, 146);\">07</span></span></p>",
      "lineHeight": 1,
      "outline": {
        "color": "#000",
        "width": 0,
        "style": "solid"
      },
      "fill": "",
      "vertical": false
    },
    {
      "type": "text",
      "width": 212.27174496644295,
      "height": 44,
      "left": 103.87966442953021,
      "top": 307,
      "rotate": 0,
      "defaultFontName": "思源黑体 CN",
      "defaultColor": "#333",
      "content": "<p style=\"\"><span style=\"font-size: 24px;\"><span style=\"color: rgb(255, 255, 255);\">{{title}}</span></span></p>",
      "lineHeight": 1,
      "outline": {
        "color": "#000",
        "width": 0,
        "style": "solid"
      },
      "fill": "",
      "vertical": false
    },
    {
      "type": "shape",
      "width": 49.95,
      "height": 49.95,
      "left": 317.6614093959732,
      "top": 307.8444966442952,
      "viewBox": [
        200,
        200
      ],
      "path": "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
      "fill": "#f1cb8f",
      "fixedRatio": false,
      "rotate": 0,
      "outline": {
        "color": "#16468d",
        "width": 0,
        "style": "solid"
      },
      "text": {
        "content": "<p style=\"text-align: center;\"><span style=\"font-size: 14px;\"><span style=\"font-family: Arial;\">&nbsp;</span></span></p>",
        "defaultFontName": "思源黑体 CN",
        "defaultColor": "#333",
        "align": "middle"
      },
      "flipH": false,
      "flipV": false
    },
    {
      "type": "text",
      "width": 58.92129186602872,
      "height": 40,
      "left": 319.1514093959732,
      "top": 307,
      "rotate": 0,
      "defaultFontName": "思源黑体 CN",
      "defaultColor": "#333",
      "content": "<p style=\"\"><span style=\"font-size: 20px;\"><span style=\"color: rgb(66, 112, 146);\">08</span></span></p>",
      "lineHeight": 1,
      "outline": {
        "color": "#000",
        "width": 0,
        "style": "solid"
      },
      "fill": "",
      "vertical": false
    },
    {
      "type": "text",
      "width": 221.38307235029717,
      "height": 44,
      "left": 384.1414093959732,
      "top": 307,
      "rotate": 0,
      "defaultFontName": "思源黑体 CN",
      "defaultColor": "#333",
      "content": "<p style=\"\"><span style=\"font-size: 24px;\"><span style=\"color: rgb(255, 255, 255);\">{{title}}</span></span></p>",
      "lineHeight": 1,
      "outline": {
        "color": "#000",
        "width": 0,
        "style": "solid"
      },
      "fill": "",
      "vertical": false
    },
    {
      "type": "shape",
      "width": 49.95,
      "height": 49.95,
      "left": 35.889664429530185,
      "top": 380.7386577181207,
      "viewBox": [
        200,
        200
      ],
      "path": "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
      "fill": "#f1cb8f",
      "fixedRatio": false,
      "rotate": 0,
      "outline": {
        "color": "#16468d",
        "width": 0,
        "style": "solid"
      },
      "text": {
        "content": "<p style=\"text-align: center;\"><span style=\"font-size: 14px;\"><span style=\"font-family: Arial;\">&nbsp;</span></span></p>",
        "defaultFontName": "思源黑体 CN",
        "defaultColor": "#333",
        "align": "middle"
      },
      "flipH": false,
      "flipV": false
    },
    {
      "type": "text",
      "width": 46.94999999999999,
      "height": 40,
      "left": 37.37966442953018,
      "top": 380,
      "rotate": 0,
      "defaultFontName": "思源黑体 CN",
      "defaultColor": "#333",
      "content": "<p style=\"\"><span style=\"font-size: 20px;\"><span style=\"color: rgb(66, 112, 146);\">09</span></span></p>",
      "lineHeight": 1,
      "outline": {
        "color": "#000",
        "width": 0,
        "style": "solid"
      },
      "fill": "",
      "vertical": false
    },
    {
      "type": "text",
      "width": 213.781744966443,
      "height": 44,
      "left": 102.36966442953019,
      "top": 380,
      "rotate": 0,
      "defaultFontName": "思源黑体 CN",
      "defaultColor": "#333",
      "content": "<p style=\"\"><span style=\"font-size: 24px;\"><span style=\"color: rgb(255, 255, 255);\">{{title}}</span></span></p>",
      "lineHeight": 1,
      "outline": {
        "color": "#000",
        "width": 0,
        "style": "solid"
      },
      "fill": "",
      "vertical": false
    },
    {
      "type": "shape",
      "width": 49.95,
      "height": 49.95,
      "left": 316.15140939597313,
      "top": 380,
      "viewBox": [
        200,
        200
      ],
      "path": "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
      "fill": "#f1cb8f",
      "fixedRatio": false,
      "rotate": 0,
      "outline": {
        "color": "#16468d",
        "width": 0,
        "style": "solid"
      },
      "text": {
        "content": "<p style=\"text-align: center;\"><span style=\"font-size: 14px;\"><span style=\"font-family: Arial;\">&nbsp;</span></span></p>",
        "defaultFontName": "思源黑体 CN",
        "defaultColor": "#333",
        "align": "middle"
      },
      "flipH": false,
      "flipV": false
    },
    {
      "type": "text",
      "width": 46.94999999999999,
      "height": 40,
      "left": 317.64140939597314,
      "top": 380,
      "rotate": 0,
      "defaultFontName": "思源黑体 CN",
      "defaultColor": "#333",
      "content": "<p style=\"text-align: center;\"><span style=\"font-size: 20px;\"><span style=\"color: rgb(66, 112, 146);\">10</span></span></p>",
      "lineHeight": 1,
      "outline": {
        "color": "#000",
        "width": 0,
        "style": "solid"
      },
      "fill": "",
      "vertical": false
    },
    {
      "type": "text",
      "width": 222.8930723502973,
      "height": 44,
      "left": 382.63140939597315,
      "top": 380,
      "rotate": 0,
      "defaultFontName": "思源黑体 CN",
      "defaultColor": "#333",
      "content": "<p style=\"\"><span style=\"font-size: 24px;\"><span style=\"color: rgb(255, 255, 255);\">{{title}}</span></span></p>",
      "lineHeight": 1,
      "outline": {
        "color": "#000",
        "width": 0,
        "style": "solid"
      },
      "fill": "",
      "vertical": false
    },
    {
      "type": "shape",
      "width": 49.95,
      "height": 49.95,
      "left": 35.889664429530185,
      "top": 455.21865771812065,
      "viewBox": [
        200,
        200
      ],
      "path": "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
      "fill": "#f1cb8f",
      "fixedRatio": false,
      "rotate": 0,
      "outline": {
        "color": "#16468d",
        "width": 0,
        "style": "solid"
      },
      "text": {
        "content": "<p style=\"text-align: center;\"><span style=\"font-size: 14px;\"><span style=\"font-family: Arial;\">&nbsp;</span></span></p>",
        "defaultFontName": "思源黑体 CN",
        "defaultColor": "#333",
        "align": "middle"
      },
      "flipH": false,
      "flipV": false
    },
    {
      "type": "text",
      "width": 49.949999999999996,
      "height": 40,
      "left": 35.889664429530185,
      "top": 455,
      "rotate": 0,
      "defaultFontName": "思源黑体 CN",
      "defaultColor": "#333",
      "content": "<p style=\"text-align: center;\"><span style=\"font-size: 20px;\"><span style=\"color: rgb(66, 112, 146);\">11</span></span></p>",
      "lineHeight": 1,
      "outline": {
        "color": "#000",
        "width": 0,
        "style": "solid"
      },
      "fill": "",
      "vertical": false
    },
    {
      "type": "text",
      "width": 213.781744966443,
      "height": 44,
      "left": 102.36966442953019,
      "top": 455,
      "rotate": 0,
      "defaultFontName": "思源黑体 CN",
      "defaultColor": "#333",
      "content": "<p style=\"\"><span style=\"font-size: 24px;\"><span style=\"color: rgb(255, 255, 255);\">{{title}}</span></span></p>",
      "lineHeight": 1,
      "outline": {
        "color": "#000",
        "width": 0,
        "style": "solid"
      },
      "fill": "",
      "vertical": false
    },
    {
      "type": "shape",
      "width": 49.95,
      "height": 49.95,
      "left": 316.15140939597313,
      "top": 455,
      "viewBox": [
        200,
        200
      ],
      "path": "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
      "fill": "#f1cb8f",
      "fixedRatio": false,
      "rotate": 0,
      "outline": {
        "color": "#16468d",
        "width": 0,
        "style": "solid"
      },
      "text": {
        "content": "<p style=\"text-align: center;\"><span style=\"font-size: 14px;\"><span style=\"font-family: Arial;\">&nbsp;</span></span></p>",
        "defaultFontName": "思源黑体 CN",
        "defaultColor": "#333",
        "align": "middle"
      },
      "flipH": false,
      "flipV": false
    },
    {
      "type": "text",
      "width": 48.45999999999999,
      "height": 40,
      "left": 317.64140939597314,
      "top": 455,
      "rotate": 0,
      "defaultFontName": "思源黑体 CN",
      "defaultColor": "#333",
      "content": "<p style=\"text-align: center;\"><span style=\"font-size: 20px;\"><span style=\"color: rgb(66, 112, 146);\">12</span></span></p>",
      "lineHeight": 1,
      "outline": {
        "color": "#000",
        "width": 0,
        "style": "solid"
      },
      "fill": "",
      "vertical": false
    },
    {
      "type": "text",
      "width": 222.8930723502973,
      "height": 44,
      "left": 382.63140939597315,
      "top": 455,
      "rotate": 0,
      "defaultFontName": "思源黑体 CN",
      "defaultColor": "#333",
      "content": "<p style=\"\"><span style=\"font-size: 24px;\"><span style=\"color: rgb(255, 255, 255);\">{{title}}</span></span></p>",
      "lineHeight": 1,
      "outline": {
        "color": "#000",
        "width": 0,
        "style": "solid"
      },
      "fill": "",
      "vertical": false
    }


   ]
   
 },
 '4':{
  manyLenght:[1,1,1],
  'few':[ {
    "type": "text",
    "width": 285.73,
    "height": 44,
    "left": 199.34,
    "top": 203.18,
    "rotate": 0,
    "defaultFontName": "思源黑体 CN",
    "defaultColor": "#333",
    "content": "<p style=\"\" class=\"ProseMirror-selectednode\" draggable=\"true\"><strong><span style=\"font-size: 24px;\"><span style=\"font-family: 思源黑体 CN;\"><span style=\"color: rgb(0, 32, 96);\">1.{{title}}</span></span></span></strong></p>",
    "lineHeight": 1,
    "outline": {
      "color": "#000",
      "width": 0,
      "style": "solid"
    },
    "fill": "",
    "vertical": false
  },
  {
    "type": "text",
    "width": 285.78,
    "height": 44,
    "left": 567,
    "top": 203.18,
    "rotate": 0,
    "defaultFontName": "思源黑体 CN",
    "defaultColor": "#333",
    "content": "<p style=\"\" class=\"ProseMirror-selectednode\" draggable=\"true\"><strong><span style=\"font-size: 24px;\"><span style=\"font-family: 思源黑体 CN;\"><span style=\"color: rgb(0, 32, 96);\">2.{{title}}</span></span></span></strong></p>",
    "lineHeight": 1,
    "outline": {
      "color": "#000",
      "width": 0,
      "style": "solid"
    },
    "fill": "",
    "vertical": false
  },
  {
    "type": "text",
    "width": 285.68,
    "height": 44,
    "left": 199.34,
    "top": 312.46759170653905,
    "rotate": 0,
    "defaultFontName": "思源黑体 CN",
    "defaultColor": "#333",
    "content": "<p style=\"\" class=\"ProseMirror-selectednode\" draggable=\"true\"><strong><span style=\"font-size: 24px;\"><span style=\"font-family: 思源黑体 CN;\"><span style=\"color: rgb(0, 32, 96);\">3.{{title}}</span></span></span></strong></p>",
    "lineHeight": 1,
    "outline": {
      "color": "#000",
      "width": 0,
      "style": "solid"
    },
    "fill": "",
    "vertical": false
  },
  
  {
    "type": "text",
    "width": 285.73,
    "height": 44,
    "left": 567,
    "top": 312.46759170653905,
    "rotate": 0,
    "defaultFontName": "思源黑体 CN",
    "defaultColor": "#333",
    "content": "<p style=\"\" class=\"ProseMirror-selectednode\" draggable=\"true\"><strong><span style=\"font-size: 24px;\"><span style=\"font-family: 思源黑体 CN;\"><span style=\"color: rgb(0, 32, 96);\">4.{{title}}</span></span></span></strong></p>",
    "lineHeight": 1,
    "outline": {
      "color": "#000",
      "width": 0,
      "style": "solid"
    },
    "fill": "",
    "vertical": false
  }],
  'many':[
    {
      "type": "text",
      "width": 277.24,
      "height": 44,
      "left": 176.74551834130776,
      "top": 205.36,
      "rotate": 0,
      "defaultFontName": "思源黑体 CN",
      "defaultColor": "#333",
      "content": "<p style=\"\"><strong><span style=\"font-size: 24px;\"><span style=\"font-family: 思源黑体 CN;\"><span style=\"color: rgb(0, 32, 96);\">1.{{title}}</span></span></span></strong></p>",
      "lineHeight": 1,
      "outline": {
        "color": "#000",
        "width": 0,
        "style": "solid"
      },
      "fill": "",
      "vertical": false
    },
    {
      "type": "text",
      "width": 279.9,
      "height": 44,
      "left": 544.4055183413077,
      "top": 205.36,
      "rotate": 0,
      "defaultFontName": "思源黑体 CN",
      "defaultColor": "#333",
      "content": "<p style=\"\" class=\"ProseMirror-selectednode\" draggable=\"true\"><strong><span style=\"font-size: 24px;\"><span style=\"font-family: 思源黑体 CN;\"><span style=\"color: rgb(0, 32, 96);\">2.{{title}}</span></span></span></strong></p>",
      "lineHeight": 1,
      "outline": {
        "color": "#000",
        "width": 0,
        "style": "solid"
      },
      "fill": "",
      "vertical": false
    },
    {
      "type": "text",
      "width": 277.19,
      "height": 44,
      "left": 176.74551834130776,
      "top": 255.05,
      "rotate": 0,
      "defaultFontName": "思源黑体 CN",
      "defaultColor": "#333",
      "content": "<p style=\"\" class=\"ProseMirror-selectednode\" draggable=\"true\"><strong><span style=\"font-size: 24px;\"><span style=\"font-family: 思源黑体 CN;\"><span style=\"color: rgb(0, 32, 96);\">3.{{title}}</span></span></span></strong></p>",
      "lineHeight": 1,
      "outline": {
        "color": "#000",
        "width": 0,
        "style": "solid"
      },
      "fill": "",
      "vertical": false
    },
   
    {
      "type": "text",
      "width": 279.9,
      "height": 44,
      "left": 544.4055183413077,
      "top": 255.05,
      "rotate": 0,
      "defaultFontName": "思源黑体 CN",
      "defaultColor": "#333",
      "content": "<p style=\"\" class=\"ProseMirror-selectednode\" draggable=\"true\"><strong><span style=\"font-size: 24px;\"><span style=\"font-family: 思源黑体 CN;\"><span style=\"color: rgb(0, 32, 96);\">4.{{title}}</span></span></span></strong></p>",
      "lineHeight": 1,
      "outline": {
        "color": "#000",
        "width": 0,
        "style": "solid"
      },
      "fill": "",
      "vertical": false
    },
    {
      "type": "text",
      "width": 273.8,
      "height": 44,
      "left": 177.31551834130775,
      "top": 308.13,
      "rotate": 0,
      "defaultFontName": "思源黑体 CN",
      "defaultColor": "#333",
      "content": "<p style=\"\"><strong><span style=\"font-size: 24px;\"><span style=\"font-family: 思源黑体 CN;\"><span style=\"color: rgb(0, 32, 96);\">5.{{title}}</span></span></span></strong></p>",
      "lineHeight": 1,
      "outline": {
        "color": "#000",
        "width": 0,
        "style": "solid"
      },
      "fill": "",
      "vertical": false
    },
    {
      "type": "text",
      "width": 274.01,
      "height": 44,
      "left": 544.9755183413077,
      "top": 308.13,
      "rotate": 0,
      "defaultFontName": "思源黑体 CN",
      "defaultColor": "#333",
      "content": "<p style=\"\" class=\"ProseMirror-selectednode\" draggable=\"true\"><strong><span style=\"font-size: 24px;\"><span style=\"font-family: 思源黑体 CN;\"><span style=\"color: rgb(0, 32, 96);\">6.{{title}}</span></span></span></strong></p>",
      "lineHeight": 1,
      "outline": {
        "color": "#000",
        "width": 0,
        "style": "solid"
      },
      "fill": "",
      "vertical": false
    },
    {
      "type": "text",
      "width": 277.24,
      "height": 44,
      "left": 175.74551834130776,
      "top": 361.2,
      "rotate": 0,
      "defaultFontName": "思源黑体 CN",
      "defaultColor": "#333",
      "content": "<p style=\"\" class=\"ProseMirror-selectednode\" draggable=\"true\"><strong><span style=\"font-size: 24px;\"><span style=\"font-family: 思源黑体 CN;\"><span style=\"color: rgb(0, 32, 96);\">7.{{title}}</span></span></span></strong></p>",
      "lineHeight": 1,
      "outline": {
        "color": "#000",
        "width": 0,
        "style": "solid"
      },
      "fill": "",
      "vertical": false
    },
    {
      "type": "text",
      "width": 279.9,
      "height": 44,
      "left": 543.4055183413077,
      "top": 361.2,
      "rotate": 0,
      "defaultFontName": "思源黑体 CN",
      "defaultColor": "#333",
      "content": "<p style=\"\" class=\"\"><strong><span style=\"font-size: 24px;\"><span style=\"font-family: 思源黑体 CN;\"><span style=\"color: rgb(0, 32, 96);\">8.{{title}}</span></span></span></strong></p>",
      "lineHeight": 1,
      "outline": {
        "color": "#000",
        "width": 0,
        "style": "solid"
      },
      "fill": "",
      "vertical": false
    }
  ],
  'max':[
    {
      "type": "text",
      "width": 295.36,
      "height": 42,
      "left": 174.11,
      "top": 179.64,
      "rotate": 0,
      "defaultFontName": "思源黑体 CN",
      "defaultColor": "#333",
      "content": "<p style=\"\"><strong><span style=\"font-size: 22px;\"><span style=\"font-family: 思源黑体 CN;\"><span style=\"color: rgb(0, 32, 96);\">01.{{title}}</span></span></span></strong></p>",
      "lineHeight": 1,
      "outline": {
        "color": "#000",
        "width": 0,
        "style": "solid"
      },
      "fill": "",
      "vertical": false
    },
    {
      "type": "text",
      "width": 315.57,
      "height": 42,
      "left": 541.77,
      "top": 179.64,
      "rotate": 0,
      "defaultFontName": "思源黑体 CN",
      "defaultColor": "#333",
      "content": "<p style=\"\"><strong><span style=\"font-size: 22px;\"><span style=\"font-family: 思源黑体 CN;\"><span style=\"color: rgb(0, 32, 96);\">02.{{title}}</span></span></span></strong></p>",
      "lineHeight": 1,
      "outline": {
        "color": "#000",
        "width": 0,
        "style": "solid"
      },
      "fill": "",
      "vertical": false
    },
    {
      "type": "text",
      "width": 295.31,
      "height": 42,
      "left": 174.11,
      "top": 230.99,
      "rotate": 0,
      "defaultFontName": "思源黑体 CN",
      "defaultColor": "#333",
      "content": "<p style=\"\"><strong><span style=\"font-size: 22px;\"><span style=\"font-family: 汉仪大黑简;\"><span style=\"color: rgb(0, 32, 96);\">03.{{title}}</span></span></span></strong></p>",
      "lineHeight": 1,
      "outline": {
        "color": "#000",
        "width": 0,
        "style": "solid"
      },
      "fill": "",
      "vertical": false
    },
   
    {
      "type": "text",
      "width": 315.63,
      "height": 42,
      "left": 541.77,
      "top": 230.99,
      "rotate": 0,
      "defaultFontName": "思源黑体 CN",
      "defaultColor": "#333",
      "content": "<p style=\"\"><strong><span style=\"font-size: 22px;\"><span style=\"font-family: 思源黑体 CN;\"><span style=\"color: rgb(0, 32, 96);\">04.{{title}}</span></span></span></strong></p>",
      "lineHeight": 1,
      "outline": {
        "color": "#000",
        "width": 0,
        "style": "solid"
      },
      "fill": "",
      "vertical": false
    },
    {
      "type": "text",
      "width": 294.79,
      "height": 42,
      "left": 174.69,
      "top": 284.06,
      "rotate": 0,
      "defaultFontName": "思源黑体 CN",
      "defaultColor": "#333",
      "content": "<p style=\"\"><strong><span style=\"font-size: 22px;\"><span style=\"font-family: 思源黑体 CN;\"><span style=\"color: rgb(0, 32, 96);\">05.{{title}}</span></span></span></strong></p>",
      "lineHeight": 1,
      "outline": {
        "color": "#000",
        "width": 0,
        "style": "solid"
      },
      "fill": "",
      "vertical": false
    },
    {
      "type": "text",
      "width": 315,
      "height": 42,
      "left": 542.34,
      "top": 284.06,
      "rotate": 0,
      "defaultFontName": "思源黑体 CN",
      "defaultColor": "#333",
      "content": "<p style=\"\"><strong><span style=\"font-size: 22px;\"><span style=\"font-family: 思源黑体 CN;\"><span style=\"color: rgb(0, 32, 96);\">06.{{title}}</span></span></span></strong></p>",
      "lineHeight": 1,
      "outline": {
        "color": "#000",
        "width": 0,
        "style": "solid"
      },
      "fill": "",
      "vertical": false
    },
    {
      "type": "text",
      "width": 295.31,
      "height": 42,
      "left": 174.11,
      "top": 337.14,
      "rotate": 0,
      "defaultFontName": "思源黑体 CN",
      "defaultColor": "#333",
      "content": "<p style=\"\"><strong><span style=\"font-size: 22px;\"><span style=\"font-family: 思源黑体 CN;\"><span style=\"color: rgb(0, 32, 96);\">07.{{title}}</span></span></span></strong></p>",
      "lineHeight": 1,
      "outline": {
        "color": "#000",
        "width": 0,
        "style": "solid"
      },
      "fill": "",
      "vertical": false
    },
    {
      "type": "text",
      "width": 315.57,
      "height": 42,
      "left": 541.77,
      "top": 337.14,
      "rotate": 0,
      "defaultFontName": "思源黑体 CN",
      "defaultColor": "#333",
      "content": "<p style=\"\"><strong><span style=\"font-size: 22px;\"><span style=\"font-family: 思源黑体 CN;\"><span style=\"color: rgb(0, 32, 96);\">08.{{title}}</span></span></span></strong></p>",
      "lineHeight": 1,
      "outline": {
        "color": "#000",
        "width": 0,
        "style": "solid"
      },
      "fill": "",
      "vertical": false
    },
    {
      "type": "text",
      "width": 295.83,
      "height": 42,
      "left": 173.65,
      "top": 387.6,
      "rotate": 0,
      "defaultFontName": "思源黑体 CN",
      "defaultColor": "#333",
      "content": "<p style=\"\"><strong><span style=\"font-size: 22px;\"><span style=\"font-family: 思源黑体 CN;\"><span style=\"color: rgb(0, 32, 96);\">09.{{title}}</span></span></span></strong></p>",
      "lineHeight": 1,
      "outline": {
        "color": "#000",
        "width": 0,
        "style": "solid"
      },
      "fill": "",
      "vertical": false
    },
    {
      "type": "text",
      "width": 316.09,
      "height": 42,
      "left": 541.3,
      "top": 387.6,
      "rotate": 0,
      "defaultFontName": "思源黑体 CN",
      "defaultColor": "#333",
      "content": "<p style=\"\"><strong><span style=\"font-size: 22px;\"><span style=\"font-family: 思源黑体 CN;\"><span style=\"color: rgb(0, 32, 96);\">10.{{title}}</span></span></span></strong></p>",
      "lineHeight": 1,
      "outline": {
        "color": "#000",
        "width": 0,
        "style": "solid"
      },
      "fill": "",
      "vertical": false
    },
    {
      "type": "text",
      "width": 313.65,
      "height": 42,
      "left": 171.7,
      "top": 434.9,
      "rotate": 0,
      "defaultFontName": "思源黑体 CN",
      "defaultColor": "#333",
      "content": "<p style=\"\"><strong><span style=\"font-size: 22px;\"><span style=\"font-family: 思源黑体 CN;\"><span style=\"color: rgb(0, 32, 96);\">11.{{title}}</span></span></span></strong></p>",
      "lineHeight": 1,
      "outline": {
        "color": "#000",
        "width": 0,
        "style": "solid"
      },
      "fill": "",
      "vertical": false
    },
    {
      "type": "text",
      "width": 315.99,
      "height": 42,
      "left": 541.35,
      "top": 434.9,
      "rotate": 0,
      "defaultFontName": "思源黑体 CN",
      "defaultColor": "#333",
      "content": "<p style=\"\"><strong><span style=\"font-size: 22px;\"><span style=\"font-family: 思源黑体 CN;\"><span style=\"color: rgb(0, 32, 96);\">12.{{title}}</span></span></span></strong></p>",
      "lineHeight": 1,
      "outline": {
        "color": "#000",
        "width": 0,
        "style": "solid"
      },
      "fill": "",
      "vertical": false
    }
  ]
 },
 '5':{
  manyLenght:[2,2,2],
  'few':[
   
    {
      "type": "shape",
      "width": 40.1,
      "height": 40.1,
      "left": 206.83,
      "top": 194.62437500000001,
      "viewBox": [
        200,
        200
      ],
      "path": "M 100 0 A 100 100 102 1 0 200 100 L 200 0 L 100 0 Z",
      "fill": "#eb7630",
      "fixedRatio": false,
      "rotate": 0,
      "outline": {
        "color": "#EB7630",
        "width": 0,
        "style": "solid"
      },
      "text": {
        "content": "<p style=\"text-align: center;\"><span style=\"font-size: 18.37px;\"><span style=\"font-family: 思源黑体 CN;\"><span style=\"color: rgb(255, 255, 255);\">1</span></span></span></p>",
        "defaultFontName": "思源黑体 CN",
        "defaultColor": "#333",
        "align": "middle"
      },
      "flipH": false,
      "flipV": false
    },
    {
      "type": "text",
      "width": 271.72,
      "height": 44.484375,
      "left": 246.93,
      "top": 189.24,
      "rotate": 0,
      "defaultFontName": "思源黑体 CN",
      "defaultColor": "#333",
      "content": "<p style=\"\"><span style=\"font-size: 24.49px;\"><span style=\"font-family: 思源黑体 CN;\">{{title}}</span></span></p>",
      "lineHeight": 1,
      "outline": {
        "color": "#000",
        "width": 0,
        "style": "solid"
      },
      "fill": "",
      "vertical": false
    },
   
    {
      "type": "shape",
      "width": 40.1,
      "height": 40.1,
      "left": 532.4,
      "top": 194.62437500000001,
      "viewBox": [
        200,
        200
      ],
      "path": "M 100 0 A 100 100 102 1 0 200 100 L 200 0 L 100 0 Z",
      "fill": "#75a3f8",
      "fixedRatio": false,
      "rotate": 0,
      "outline": {
        "color": "#1f4e79",
        "width": 0,
        "style": "solid"
      },
      "text": {
        "content": "<p style=\"text-align: center;\" class=\"ProseMirror-selectednode\" draggable=\"true\"><span style=\"font-size: 18.37px;\"><span style=\"font-family: 思源黑体 CN;\"><span style=\"color: rgb(255, 255, 255);\">2</span></span></span></p>",
        "defaultFontName": "思源黑体 CN",
        "defaultColor": "#333",
        "align": "middle"
      },
      "flipH": false,
      "flipV": false
    },
    {
      "type": "text",
      "width": 267.08,
      "height": 44.484375,
      "left": 572.5,
      "top": 189.76,
      "rotate": 0,
      "defaultFontName": "思源黑体 CN",
      "defaultColor": "#333",
      "content": "<p style=\"\"><span style=\"font-size: 24.49px;\"><span style=\"font-family: 思源黑体 CN;\">{{title}}</span></span></p>",
      "lineHeight": 1,
      "outline": {
        "color": "#000",
        "width": 0,
        "style": "solid"
      },
      "fill": "",
      "vertical": false
    },
   
    {
      "type": "shape",
      "width": 40.1,
      "height": 40.1,
      "left": 206.83,
      "top": 313.064375,
      "viewBox": [
        200,
        200
      ],
      "path": "M 100 0 A 100 100 102 1 0 200 100 L 200 0 L 100 0 Z",
      "fill": "#e8a812",
      "fixedRatio": false,
      "rotate": 0,
      "outline": {
        "color": "#1f4e79",
        "width": 0,
        "style": "solid"
      },
      "text": {
        "content": "<p style=\"text-align: center;\" class=\"ProseMirror-selectednode\" draggable=\"true\"><span style=\"font-size: 18.37px;\"><span style=\"font-family: 方正楷体_GBK;\"><span style=\"color: #ffffff;\">3</span></span></span></p>",
        "defaultFontName": "思源黑体 CN",
        "defaultColor": "#333",
        "align": "middle"
      },
      "flipH": false,
      "flipV": false
    },
    {
      "type": "text",
      "width": 271.56,
      "height": 44.484375,
      "left": 247.03,
      "top": 307.68,
      "rotate": 0,
      "defaultFontName": "思源黑体 CN",
      "defaultColor": "#333",
      "content": "<p style=\"\"><span style=\"font-size: 24.49px;\"><span style=\"font-family: 思源黑体 CN;\">{{title}}</span></span></p>",
      "lineHeight": 1,
      "outline": {
        "color": "#000",
        "width": 0,
        "style": "solid"
      },
      "fill": "",
      "vertical": false
    },
   
    {
      "type": "shape",
      "width": 40.1,
      "height": 40.1,
      "left": 532.4,
      "top": 313.064375,
      "viewBox": [
        200,
        200
      ],
      "path": "M 100 0 A 100 100 102 1 0 200 100 L 200 0 L 100 0 Z",
      "fill": "rgb(214, 169, 137)",
      "fixedRatio": false,
      "rotate": 0,
      "outline": {
        "color": "#1f4e79",
        "width": 0,
        "style": "solid"
      },
      "text": {
        "content": "<p style=\"text-align: center;\" class=\"\"><span style=\"font-size: 18.37px;\"><span style=\"font-family: 方正楷体_GBK;\"><span style=\"color: #ffffff;\">4</span></span></span></p>",
        "defaultFontName": "思源黑体 CN",
        "defaultColor": "#333",
        "align": "middle"
      },
      "flipH": false,
      "flipV": false
    },
    {
      "type": "text",
      "width": 267.07999999999987,
      "height": 44.484375,
      "left": 572.5,
      "top": 307.68,
      "rotate": 0,
      "defaultFontName": "思源黑体 CN",
      "defaultColor": "#333",
      "content": "<p style=\"\"><span style=\"font-size: 24.49px;\"><span style=\"font-family: 思源黑体 CN;\">{{title}}</span></span></p>",
      "lineHeight": 1,
      "outline": {
        "color": "#000",
        "width": 0,
        "style": "solid"
      },
      "fill": "",
      "vertical": false
    },
  ],
    'many':[
     
      {
        "type": "shape",
        "width": 30.13189792663477,
        "height": 31.128708133971294,
        "left": 215.95810207336524,
        "top": 198.59566686602872,
        "viewBox": [
          200,
          200
        ],
        "path": "M 100 0 A 100 100 102 1 0 200 100 L 200 0 L 100 0 Z",
        "fill": "#e8a812",
        "fixedRatio": false,
        "rotate": 0,
        "outline": {
          "color": "#1f4e79",
          "width": 0,
          "style": "solid"
        },
        "text": {
          "content": "<p style=\"text-align: center;\"><span style=\"font-size: 18.37px;\"><span style=\"font-family: 方正楷体_GBK;\"><span style=\"color: rgb(255, 255, 255);\">1</span></span></span></p>",
          "defaultFontName": "思源黑体 CN",
          "defaultColor": "#333",
          "align": "middle"
        },
        "flipH": false,
        "flipV": false
      },
      {
        "type": "text",
        "width": 271.72,
        "height": 42,
        "left": 246.09,
        "top": 187.24,
        "rotate": 0,
        "defaultFontName": "思源黑体 CN",
        "defaultColor": "#333",
        "content": "<p style=\"\"><span style=\"font-size: 22px;\"><span style=\"font-family: 思源黑体 CN;\">{{title}}</span></span></p>",
        "lineHeight": 1,
        "outline": {
          "color": "#000",
          "width": 0,
          "style": "solid"
        },
        "fill": "",
        "vertical": false
      },
      
      {
        "type": "shape",
        "width": 30.13189792663477,
        "height": 31.128708133971294,
        "left": 542.5381020733652,
        "top": 198.59566686602872,
        "viewBox": [
          200,
          200
        ],
        "path": "M 100 0 A 100 100 102 1 0 200 100 L 200 0 L 100 0 Z",
        "fill": "#e8a812",
        "fixedRatio": false,
        "rotate": 0,
        "outline": {
          "color": "#1f4e79",
          "width": 0,
          "style": "solid"
        },
        "text": {
          "content": "<p style=\"text-align: center;\"><span style=\"font-size: 18.37px;\"><span style=\"font-family: 方正楷体_GBK;\"><span style=\"color: rgb(255, 255, 255);\">2</span></span></span></p>",
          "defaultFontName": "思源黑体 CN",
          "defaultColor": "#333",
          "align": "middle"
        },
        "flipH": false,
        "flipV": false
      },
      {
        "type": "text",
        "width": 267.08,
        "height": 42,
        "left": 571.67,
        "top": 187.76,
        "rotate": 0,
        "defaultFontName": "思源黑体 CN",
        "defaultColor": "#333",
        "content": "<p style=\"\"><span style=\"font-size: 22px;\"><span style=\"font-family: 思源黑体 CN;\">{{title}}</span></span></p>",
        "lineHeight": 1,
        "outline": {
          "color": "#000",
          "width": 0,
          "style": "solid"
        },
        "fill": "",
        "vertical": false
      },
     
      {
        "type": "shape",
        "width": 30.13189792663477,
        "height": 31.128708133971294,
        "left": 215.95810207336524,
        "top": 248.1212918660287,
        "viewBox": [
          200,
          200
        ],
        "path": "M 100 0 A 100 100 102 1 0 200 100 L 200 0 L 100 0 Z",
        "fill": "#e8a812",
        "fixedRatio": false,
        "rotate": 0,
        "outline": {
          "color": "#1f4e79",
          "width": 0,
          "style": "solid"
        },
        "text": {
          "content": "<p style=\"text-align: center;\" class=\"ProseMirror-selectednode\" draggable=\"true\"><span style=\"font-size: 18.37px;\"><span style=\"font-family: 方正楷体_GBK;\"><span style=\"color: rgb(255, 255, 255);\">3</span></span></span></p>",
          "defaultFontName": "思源黑体 CN",
          "defaultColor": "#333",
          "align": "middle"
        },
        "flipH": false,
        "flipV": false
      },
      {
        "type": "text",
        "width": 271.72,
        "height": 42,
        "left": 245.68,
        "top": 239.32,
        "rotate": 0,
        "defaultFontName": "思源黑体 CN",
        "defaultColor": "#333",
        "content": "<p style=\"\"><span style=\"font-size: 22px;\"><span style=\"font-family: 思源黑体 CN;\">{{title}}</span></span></p>",
        "lineHeight": 1,
        "outline": {
          "color": "#000",
          "width": 0,
          "style": "solid"
        },
        "fill": "",
        "vertical": false
      },
     
      {
        "type": "shape",
        "width": 30.13189792663477,
        "height": 31.128708133971294,
        "left": 542.5381020733652,
        "top": 248.1212918660287,
        "viewBox": [
          200,
          200
        ],
        "path": "M 100 0 A 100 100 102 1 0 200 100 L 200 0 L 100 0 Z",
        "fill": "#e8a812",
        "fixedRatio": false,
        "rotate": 0,
        "outline": {
          "color": "#1f4e79",
          "width": 0,
          "style": "solid"
        },
        "text": {
          "content": "<p style=\"text-align: center;\"><span style=\"font-size: 18.37px;\"><span style=\"font-family: 方正楷体_GBK;\"><span style=\"color: rgb(255, 255, 255);\">4</span></span></span></p>",
          "defaultFontName": "思源黑体 CN",
          "defaultColor": "#333",
          "align": "middle"
        },
        "flipH": false,
        "flipV": false
      },
      {
        "type": "text",
        "width": 267.08,
        "height": 42,
        "left": 571.25,
        "top": 239.84,
        "rotate": 0,
        "defaultFontName": "思源黑体 CN",
        "defaultColor": "#333",
        "content": "<p style=\"\"><span style=\"font-size: 22px;\"><span style=\"font-family: 思源黑体 CN;\">{{title}}</span></span></p>",
        "lineHeight": 1,
        "outline": {
          "color": "#000",
          "width": 0,
          "style": "solid"
        },
        "fill": "",
        "vertical": false
      },
      
      {
        "type": "shape",
        "width": 30.13189792663477,
        "height": 31.128708133971294,
        "left": 215.95810207336524,
        "top": 298.43566686602867,
        "viewBox": [
          200,
          200
        ],
        "path": "M 100 0 A 100 100 102 1 0 200 100 L 200 0 L 100 0 Z",
        "fill": "#e8a812",
        "fixedRatio": false,
        "rotate": 0,
        "outline": {
          "color": "#1f4e79",
          "width": 0,
          "style": "solid"
        },
        "text": {
          "content": "<p style=\"text-align: center;\"><span style=\"font-size: 18.37px;\"><span style=\"font-family: 方正楷体_GBK;\"><span style=\"color: rgb(255, 255, 255);\">5</span></span></span></p>",
          "defaultFontName": "思源黑体 CN",
          "defaultColor": "#333",
          "align": "middle"
        },
        "flipH": false,
        "flipV": false
      },
      {
        "type": "text",
        "width": 271.72,
        "height": 42,
        "left": 246.09,
        "top": 287.08,
        "rotate": 0,
        "defaultFontName": "思源黑体 CN",
        "defaultColor": "#333",
        "content": "<p style=\"\"><span style=\"font-size: 22px;\"><span style=\"font-family: 思源黑体 CN;\">{{title}}</span></span></p>",
        "lineHeight": 1,
        "outline": {
          "color": "#000",
          "width": 0,
          "style": "solid"
        },
        "fill": "",
        "vertical": false
      },
     
      {
        "type": "shape",
        "width": 30.13189792663477,
        "height": 31.128708133971294,
        "left": 541.5381020733652,
        "top": 301.3221875,
        "viewBox": [
          200,
          200
        ],
        "path": "M 100 0 A 100 100 102 1 0 200 100 L 200 0 L 100 0 Z",
        "fill": "#e8a812",
        "fixedRatio": false,
        "rotate": 0,
        "outline": {
          "color": "#1f4e79",
          "width": 0,
          "style": "solid"
        },
        "text": {
          "content": "<p style=\"text-align: center;\"><span style=\"font-size: 18.37px;\"><span style=\"font-family: 方正楷体_GBK;\"><span style=\"color: rgb(255, 255, 255);\">6</span></span></span></p>",
          "defaultFontName": "思源黑体 CN",
          "defaultColor": "#333",
          "align": "middle"
        },
        "flipH": false,
        "flipV": false
      },
      {
        "type": "text",
        "width": 267.08,
        "height": 42,
        "left": 571.67,
        "top": 287.6,
        "rotate": 0,
        "defaultFontName": "思源黑体 CN",
        "defaultColor": "#333",
        "content": "<p style=\"\"><span style=\"font-size: 22px;\"><span style=\"font-family: 思源黑体 CN;\">{{title}}</span></span></p>",
        "lineHeight": 1,
        "outline": {
          "color": "#000",
          "width": 0,
          "style": "solid"
        },
        "fill": "",
        "vertical": false
      },
      
      {
        "type": "shape",
        "width": 30.13189792663477,
        "height": 31.128708133971294,
        "left": 215.95810207336524,
        "top": 347.81566686602866,
        "viewBox": [
          200,
          200
        ],
        "path": "M 100 0 A 100 100 102 1 0 200 100 L 200 0 L 100 0 Z",
        "fill": "#e8a812",
        "fixedRatio": false,
        "rotate": 0,
        "outline": {
          "color": "#1f4e79",
          "width": 0,
          "style": "solid"
        },
        "text": {
          "content": "<p style=\"text-align: center;\"><span style=\"font-size: 18.37px;\"><span style=\"font-family: 方正楷体_GBK;\"><span style=\"color: rgb(255, 255, 255);\">7</span></span></span></p>",
          "defaultFontName": "思源黑体 CN",
          "defaultColor": "#333",
          "align": "middle"
        },
        "flipH": false,
        "flipV": false
      },
      {
        "type": "text",
        "width": 271.72,
        "height": 42,
        "left": 246.09,
        "top": 336.46,
        "rotate": 0,
        "defaultFontName": "思源黑体 CN",
        "defaultColor": "#333",
        "content": "<p style=\"\"><span style=\"font-size: 22px;\"><span style=\"font-family: 思源黑体 CN;\">{{title}}</span></span></p>",
        "lineHeight": 1,
        "outline": {
          "color": "#000",
          "width": 0,
          "style": "solid"
        },
        "fill": "",
        "vertical": false
      },
     
      {
        "type": "shape",
        "width": 30.13189792663477,
        "height": 31.128708133971294,
        "left": 541.5381020733652,
        "top": 348.81566686602866,
        "viewBox": [
          200,
          200
        ],
        "path": "M 100 0 A 100 100 102 1 0 200 100 L 200 0 L 100 0 Z",
        "fill": "#e8a812",
        "fixedRatio": false,
        "rotate": 0,
        "outline": {
          "color": "#1f4e79",
          "width": 0,
          "style": "solid"
        },
        "text": {
          "content": "<p style=\"text-align: center;\"><span style=\"font-size: 18.37px;\"><span style=\"font-family: 方正楷体_GBK;\"><span style=\"color: rgb(255, 255, 255);\">8</span></span></span></p>",
          "defaultFontName": "思源黑体 CN",
          "defaultColor": "#333",
          "align": "middle"
        },
        "flipH": false,
        "flipV": false
      },
      {
        "type": "text",
        "width": 267.08,
        "height": 42,
        "left": 571.67,
        "top": 336.98,
        "rotate": 0,
        "defaultFontName": "思源黑体 CN",
        "defaultColor": "#333",
        "content": "<p style=\"\"><span style=\"font-size: 22px;\"><span style=\"font-family: 思源黑体 CN;\">{{title}}</span></span></p>",
        "lineHeight": 1,
        "outline": {
          "color": "#000",
          "width": 0,
          "style": "solid"
        },
        "fill": "",
        "vertical": false
      },
    ],
    'max':[
     
      {
        "type": "shape",
        "width": 37.12551834130782,
        "height": 22.57709230462519,
        "left": 214.96129186602872,
        "top": 177.06915769537483,
        "viewBox": [
          200,
          200
        ],
        "path": "M 100 0 A 100 100 102 1 0 200 100 L 200 0 L 100 0 Z",
        "fill": "#e8a812",
        "fixedRatio": false,
        "rotate": 0,
        "outline": {
          "color": "#1f4e79",
          "width": 0,
          "style": "solid"
        },
        "text": {
          "content": "<p style=\"text-align: center;\"><span style=\"font-size: 14px;\"><span style=\"font-family: 思源黑体 CN;\"><span style=\"color: rgb(255, 255, 255);\">01</span></span></span></p>",
          "defaultFontName": "思源黑体 CN",
          "defaultColor": "#333",
          "align": "middle"
        },
        "flipH": false,
        "flipV": false
      },
      {
        "type": "text",
        "width": 271.72,
        "height": 40,
        "left": 246.09,
        "top": 159,
        "rotate": 0,
        "defaultFontName": "思源黑体 CN",
        "defaultColor": "#333",
        "content": "<p style=\"\"><span style=\"font-size: 20px;\"><span style=\"font-family: 思源黑体 CN;\">{{title}}</span></span></p>",
        "lineHeight": 1,
        "outline": {
          "color": "#000",
          "width": 0,
          "style": "solid"
        },
        "fill": "",
        "vertical": false
      },
      
      {
        "type": "shape",
        "width": 37.12551834130782,
        "height": 22.57709230462519,
        "left": 540.9501275917065,
        "top": 179.06915769537483,
        "viewBox": [
          200,
          200
        ],
        "path": "M 100 0 A 100 100 102 1 0 200 100 L 200 0 L 100 0 Z",
        "fill": "#e8a812",
        "fixedRatio": false,
        "rotate": 0,
        "outline": {
          "color": "#1f4e79",
          "width": 0,
          "style": "solid"
        },
        "text": {
          "content": "<p style=\"text-align: center;\"><span style=\"font-size: 14px;\"><span style=\"font-family: 思源黑体 CN;\"><span style=\"color: rgb(255, 255, 255);\">02</span></span></span></p>",
          "defaultFontName": "思源黑体 CN",
          "defaultColor": "#333",
          "align": "middle"
        },
        "flipH": false,
        "flipV": false
      },
      {
        "type": "text",
        "width": 267.08,
        "height": 40,
        "left": 571.67,
        "top": 159,
        "rotate": 0,
        "defaultFontName": "思源黑体 CN",
        "defaultColor": "#333",
        "content": "<p style=\"\"><span style=\"font-size: 20px;\"><span style=\"font-family: 思源黑体 CN;\">{{title}}</span></span></p>",
        "lineHeight": 1,
        "outline": {
          "color": "#000",
          "width": 0,
          "style": "solid"
        },
        "fill": "",
        "vertical": false
      },
      
      {
        "type": "shape",
        "width": 37.12551834130782,
        "height": 22.57709230462519,
        "left": 214.96129186602872,
        "top": 226.2345788476874,
        "viewBox": [
          200,
          200
        ],
        "path": "M 100 0 A 100 100 102 1 0 200 100 L 200 0 L 100 0 Z",
        "fill": "#e8a812",
        "fixedRatio": false,
        "rotate": 0,
        "outline": {
          "color": "#1f4e79",
          "width": 0,
          "style": "solid"
        },
        "text": {
          "content": "<p style=\"text-align: center;\"><span style=\"font-size: 14px;\"><span style=\"font-family: 思源黑体 CN;\"><span style=\"color: rgb(255, 255, 255);\">03</span></span></span></p>",
          "defaultFontName": "思源黑体 CN",
          "defaultColor": "#333",
          "align": "middle"
        },
        "flipH": false,
        "flipV": false
      },
      {
        "type": "text",
        "width": 271.72,
        "height": 40,
        "left": 245.68,
        "top": 209,
        "rotate": 0,
        "defaultFontName": "思源黑体 CN",
        "defaultColor": "#333",
        "content": "<p style=\"\"><span style=\"font-size: 20px;\"><span style=\"font-family: 思源黑体 CN;\">{{title}}</span></span></p>",
        "lineHeight": 1,
        "outline": {
          "color": "#000",
          "width": 0,
          "style": "solid"
        },
        "fill": "",
        "vertical": false
      },
     
      {
        "type": "shape",
        "width": 37.12551834130782,
        "height": 22.57709230462519,
        "left": 540.9501275917065,
        "top": 229.14915769537478,
        "viewBox": [
          200,
          200
        ],
        "path": "M 100 0 A 100 100 102 1 0 200 100 L 200 0 L 100 0 Z",
        "fill": "#e8a812",
        "fixedRatio": false,
        "rotate": 0,
        "outline": {
          "color": "#1f4e79",
          "width": 0,
          "style": "solid"
        },
        "text": {
          "content": "<p style=\"text-align: center;\"><span style=\"font-size: 14px;\"><span style=\"font-family: 思源黑体 CN;\"><span style=\"color: rgb(255, 255, 255);\">04</span></span></span></p>",
          "defaultFontName": "思源黑体 CN",
          "defaultColor": "#333",
          "align": "middle"
        },
        "flipH": false,
        "flipV": false
      },
      {
        "type": "text",
        "width": 267.08,
        "height": 40,
        "left": 571.25,
        "top": 209,
        "rotate": 0,
        "defaultFontName": "思源黑体 CN",
        "defaultColor": "#333",
        "content": "<p style=\"\"><span style=\"font-size: 20px;\"><span style=\"font-family: 思源黑体 CN;\">{{title}}</span></span></p>",
        "lineHeight": 1,
        "outline": {
          "color": "#000",
          "width": 0,
          "style": "solid"
        },
        "fill": "",
        "vertical": false
      },
    
      {
        "type": "shape",
        "width": 37.12551834130782,
        "height": 22.57709230462519,
        "left": 214.96129186602872,
        "top": 276.9091576953748,
        "viewBox": [
          200,
          200
        ],
        "path": "M 100 0 A 100 100 102 1 0 200 100 L 200 0 L 100 0 Z",
        "fill": "#e8a812",
        "fixedRatio": false,
        "rotate": 0,
        "outline": {
          "color": "#1f4e79",
          "width": 0,
          "style": "solid"
        },
        "text": {
          "content": "<p style=\"text-align: center;\"><span style=\"font-size: 14px;\"><span style=\"font-family: 思源黑体 CN;\"><span style=\"color: rgb(255, 255, 255);\">05</span></span></span></p>",
          "defaultFontName": "思源黑体 CN",
          "defaultColor": "#333",
          "align": "middle"
        },
        "flipH": false,
        "flipV": false
      },
      {
        "type": "text",
        "width": 271.72,
        "height": 40,
        "left": 246.09,
        "top": 257,
        "rotate": 0,
        "defaultFontName": "思源黑体 CN",
        "defaultColor": "#333",
        "content": "<p style=\"\"><span style=\"font-size: 20px;\"><span style=\"font-family: 思源黑体 CN;\">{{title}}</span></span></p>",
        "lineHeight": 1,
        "outline": {
          "color": "#000",
          "width": 0,
          "style": "solid"
        },
        "fill": "",
        "vertical": false
      },
     
      {
        "type": "shape",
        "width": 37.12551834130782,
        "height": 22.57709230462519,
        "left": 540.9501275917065,
        "top": 279.283125,
        "viewBox": [
          200,
          200
        ],
        "path": "M 100 0 A 100 100 102 1 0 200 100 L 200 0 L 100 0 Z",
        "fill": "#e8a812",
        "fixedRatio": false,
        "rotate": 0,
        "outline": {
          "color": "#1f4e79",
          "width": 0,
          "style": "solid"
        },
        "text": {
          "content": "<p style=\"text-align: center;\"><span style=\"font-size: 14px;\"><span style=\"font-family: 思源黑体 CN;\"><span style=\"color: rgb(255, 255, 255);\">06</span></span></span></p>",
          "defaultFontName": "思源黑体 CN",
          "defaultColor": "#333",
          "align": "middle"
        },
        "flipH": false,
        "flipV": false
      },
      {
        "type": "text",
        "width": 267.08,
        "height": 40,
        "left": 571.67,
        "top": 257,
        "rotate": 0,
        "defaultFontName": "思源黑体 CN",
        "defaultColor": "#333",
        "content": "<p style=\"\"><span style=\"font-size: 20px;\"><span style=\"font-family: 思源黑体 CN;\">{{title}}</span></span></p>",
        "lineHeight": 1,
        "outline": {
          "color": "#000",
          "width": 0,
          "style": "solid"
        },
        "fill": "",
        "vertical": false
      },
      
      {
        "type": "shape",
        "width": 37.12551834130782,
        "height": 22.57709230462519,
        "left": 214.96129186602872,
        "top": 327.2891576953748,
        "viewBox": [
          200,
          200
        ],
        "path": "M 100 0 A 100 100 102 1 0 200 100 L 200 0 L 100 0 Z",
        "fill": "#e8a812",
        "fixedRatio": false,
        "rotate": 0,
        "outline": {
          "color": "#1f4e79",
          "width": 0,
          "style": "solid"
        },
        "text": {
          "content": "<p style=\"text-align: center;\"><span style=\"font-size: 14px;\"><span style=\"font-family: 思源黑体 CN;\"><span style=\"color: rgb(255, 255, 255);\">07</span></span></span></p>",
          "defaultFontName": "思源黑体 CN",
          "defaultColor": "#333",
          "align": "middle"
        },
        "flipH": false,
        "flipV": false
      },
      {
        "type": "text",
        "width": 271.72,
        "height": 40,
        "left": 246.09,
        "top": 306,
        "rotate": 0,
        "defaultFontName": "思源黑体 CN",
        "defaultColor": "#333",
        "content": "<p style=\"\"><span style=\"font-size: 20px;\"><span style=\"font-family: 思源黑体 CN;\">{{title}}</span></span></p>",
        "lineHeight": 1,
        "outline": {
          "color": "#000",
          "width": 0,
          "style": "solid"
        },
        "fill": "",
        "vertical": false
      },
      
      {
        "type": "shape",
        "width": 37.12551834130782,
        "height": 22.57709230462519,
        "left": 540.9501275917065,
        "top": 328.663125,
        "viewBox": [
          200,
          200
        ],
        "path": "M 100 0 A 100 100 102 1 0 200 100 L 200 0 L 100 0 Z",
        "fill": "#e8a812",
        "fixedRatio": false,
        "rotate": 0,
        "outline": {
          "color": "#1f4e79",
          "width": 0,
          "style": "solid"
        },
        "text": {
          "content": "<p style=\"text-align: center;\"><span style=\"font-size: 14px;\"><span style=\"font-family: 思源黑体 CN;\"><span style=\"color: rgb(255, 255, 255);\">08</span></span></span></p>",
          "defaultFontName": "思源黑体 CN",
          "defaultColor": "#333",
          "align": "middle"
        },
        "flipH": false,
        "flipV": false
      },
      {
        "type": "text",
        "width": 267.08,
        "height": 40,
        "left": 571.67,
        "top": 306,
        "rotate": 0,
        "defaultFontName": "思源黑体 CN",
        "defaultColor": "#333",
        "content": "<p style=\"\"><span style=\"font-size: 20px;\"><span style=\"font-family: 思源黑体 CN;\">{{title}}</span></span></p>",
        "lineHeight": 1,
        "outline": {
          "color": "#000",
          "width": 0,
          "style": "solid"
        },
        "fill": "",
        "vertical": false
      },
      
      {
        "type": "shape",
        "width": 37.12551834130782,
        "height": 22.57709230462519,
        "left": 214.96129186602872,
        "top": 377.4791576953748,
        "viewBox": [
          200,
          200
        ],
        "path": "M 100 0 A 100 100 102 1 0 200 100 L 200 0 L 100 0 Z",
        "fill": "#e8a812",
        "fixedRatio": false,
        "rotate": 0,
        "outline": {
          "color": "#1f4e79",
          "width": 0,
          "style": "solid"
        },
        "text": {
          "content": "<p style=\"text-align: center;\"><span style=\"font-size: 14px;\"><span style=\"font-family: 思源黑体 CN;\"><span style=\"color: rgb(255, 255, 255);\">09</span></span></span></p>",
          "defaultFontName": "思源黑体 CN",
          "defaultColor": "#333",
          "align": "middle"
        },
        "flipH": false,
        "flipV": false
      },
      {
        "type": "text",
        "width": 271.72,
        "height": 40,
        "left": 246.09,
        "top": 358,
        "rotate": 0,
        "defaultFontName": "思源黑体 CN",
        "defaultColor": "#333",
        "content": "<p style=\"\"><span style=\"font-size: 20px;\"><span style=\"font-family: 思源黑体 CN;\">{{title}}</span></span></p>",
        "lineHeight": 1,
        "outline": {
          "color": "#000",
          "width": 0,
          "style": "solid"
        },
        "fill": "",
        "vertical": false
      },
     
      {
        "type": "shape",
        "width": 37.12551834130782,
        "height": 22.57709230462519,
        "left": 540.9501275917065,
        "top": 378.4791576953748,
        "viewBox": [
          200,
          200
        ],
        "path": "M 100 0 A 100 100 102 1 0 200 100 L 200 0 L 100 0 Z",
        "fill": "#e8a812",
        "fixedRatio": false,
        "rotate": 0,
        "outline": {
          "color": "#1f4e79",
          "width": 0,
          "style": "solid"
        },
        "text": {
          "content": "<p style=\"text-align: center;\"><span style=\"font-size: 14px;\"><span style=\"font-family: 思源黑体 CN;\"><span style=\"color: rgb(255, 255, 255);\">10</span></span></span></p>",
          "defaultFontName": "思源黑体 CN",
          "defaultColor": "#333",
          "align": "middle"
        },
        "flipH": false,
        "flipV": false
      },
      {
        "type": "text",
        "width": 267.08,
        "height": 40,
        "left": 571.67,
        "top": 358,
        "rotate": 0,
        "defaultFontName": "思源黑体 CN",
        "defaultColor": "#333",
        "content": "<p style=\"\"><span style=\"font-size: 20px;\"><span style=\"font-family: 思源黑体 CN;\">{{title}}</span></span></p>",
        "lineHeight": 1,
        "outline": {
          "color": "#000",
          "width": 0,
          "style": "solid"
        },
        "fill": "",
        "vertical": false
      },
     
      {
        "type": "shape",
        "width": 37.12551834130782,
        "height": 22.57709230462519,
        "left": 214.96129186602872,
        "top": 429.18915769537483,
        "viewBox": [
          200,
          200
        ],
        "path": "M 100 0 A 100 100 102 1 0 200 100 L 200 0 L 100 0 Z",
        "fill": "#e8a812",
        "fixedRatio": false,
        "rotate": 0,
        "outline": {
          "color": "#1f4e79",
          "width": 0,
          "style": "solid"
        },
        "text": {
          "content": "<p style=\"text-align: center;\"><span style=\"font-size: 14px;\"><span style=\"font-family: 思源黑体 CN;\"><span style=\"color: rgb(255, 255, 255);\">11</span></span></span></p>",
          "defaultFontName": "思源黑体 CN",
          "defaultColor": "#333",
          "align": "middle"
        },
        "flipH": false,
        "flipV": false
      },
      {
        "type": "text",
        "width": 271.72,
        "height": 40,
        "left": 246.09,
        "top": 410,
        "rotate": 0,
        "defaultFontName": "思源黑体 CN",
        "defaultColor": "#333",
        "content": "<p style=\"\"><span style=\"font-size: 20px;\"><span style=\"font-family: 思源黑体 CN;\">{{title}}</span></span></p>",
        "lineHeight": 1,
        "outline": {
          "color": "#000",
          "width": 0,
          "style": "solid"
        },
        "fill": "",
        "vertical": false
      },
      
      {
        "type": "shape",
        "width": 37.12551834130782,
        "height": 22.57709230462519,
        "left": 540.9501275917065,
        "top": 430.18915769537483,
        "viewBox": [
          200,
          200
        ],
        "path": "M 100 0 A 100 100 102 1 0 200 100 L 200 0 L 100 0 Z",
        "fill": "#e8a812",
        "fixedRatio": false,
        "rotate": 0,
        "outline": {
          "color": "#1f4e79",
          "width": 0,
          "style": "solid"
        },
        "text": {
          "content": "<p style=\"text-align: center;\"><span style=\"font-size: 14px;\"><span style=\"font-family: 思源黑体 CN;\"><span style=\"color: rgb(255, 255, 255);\">12</span></span></span></p>",
          "defaultFontName": "思源黑体 CN",
          "defaultColor": "#333",
          "align": "middle"
        },
        "flipH": false,
        "flipV": false
      },
      {
        "type": "text",
        "width": 267.08,
        "height": 40,
        "left": 571.67,
        "top": 410,
        "rotate": 0,
        "defaultFontName": "思源黑体 CN",
        "defaultColor": "#333",
        "content": "<p style=\"\"><span style=\"font-size: 20px;\"><span style=\"font-family: 思源黑体 CN;\">{{title}}</span></span></p>",
        "lineHeight": 1,
        "outline": {
          "color": "#000",
          "width": 0,
          "style": "solid"
        },
        "fill": "",
        "vertical": false
      },
    ]
 },
 '6':{
  manyLenght:[4,2,2],
  'few':[
    {
      "type": "shape",
      "width": 292.81,
      "height": 155.68,
      "left": 145.68,
      "top": 163.13,
      "viewBox": [
        200,
        200
      ],
      "path": "M 0 0 L 200 0 L 200 200 L 0 200 Z",
      "fill": "#ffffff",
      "fixedRatio": false,
      "rotate": 0,
      "outline": {
        "color": "#FFFFFF",
        "width": 1,
        "style": "solid"
      },
      "flipH": false,
      "flipV": false,
      "shadow": {
        "h": -4.42,
        "v": 4.42,
        "blur": 18.75,
        "color": "#00000045"
      }
    },
    {
      "type": "shape",
      "width": 61.53,
      "height": 86.49,
      "left": 261.3,
      "top": 163.14,
      "viewBox": [
        61.53,
        86.49
      ],
      "path": "M 0 74.184 L 0 0 L 49.224000000000004 0 L 61.53 12.306000000000001 L 61.53 86.49 L 12.306000000000001 86.49 Z",
      "fill": "#de1a37",
      "fixedRatio": false,
      "rotate": 0,
      "outline": {
        "color": "#16468d",
        "width": 1.5,
        "style": "solid"
      },
      "flipH": false,
      "flipV": false,
      "pathFormula": "cutRectDiagonal",
      "keypoints": [
        0.2
      ]
    },
    {
      "type": "text",
      "width": 64.84,
      "height": 52,
      "left": 257.97,
      "top": 174.95,
      "rotate": 0,
      "defaultFontName": "思源黑体 CN",
      "defaultColor": "#333",
      "content": "<p style=\"text-align: center;\"><span style=\"font-size: 32px;\"><span style=\"font-family: 思源黑体 CN;\"><span style=\"color: rgb(255, 255, 255);\">01</span></span></span></p>",
      "lineHeight": 1,
      "outline": {
        "color": "#000",
        "width": 0,
        "style": "solid"
      },
      "fill": "",
      "vertical": false
    },
    {
      "type": "text",
      "width": 275.16,
      "height": 44,
      "left": 154.53,
      "top": 269.43,
      "rotate": 0,
      "defaultFontName": "思源黑体 CN",
      "defaultColor": "#333",
      "content": "<p style=\"text-align: center;\"><span style=\"font-size: 24px;\">{{title}}</span></p>",
      "lineHeight": 1,
      "outline": {
        "color": "#000",
        "width": 0,
        "style": "solid"
      },
      "fill": "",
      "vertical": false
    },
    {
      "type": "shape",
      "width": 292.81,
      "height": 155.68,
      "left": 559.06,
      "top": 163.13,
      "viewBox": [
        200,
        200
      ],
      "path": "M 0 0 L 200 0 L 200 200 L 0 200 Z",
      "fill": "#ffffff",
      "fixedRatio": false,
      "rotate": 0,
      "outline": {
        "color": "#FFFFFF",
        "width": 1,
        "style": "solid"
      },
      "flipH": false,
      "flipV": false,
      "shadow": {
        "h": -4.42,
        "v": 4.42,
        "blur": 18.75,
        "color": "#00000045"
      }
    },
    {
      "type": "shape",
      "width": 61.53,
      "height": 86.49,
      "left": 674.69,
      "top": 163.14,
      "viewBox": [
        61.53,
        86.49
      ],
      "path": "M 0 74.184 L 0 0 L 49.224000000000004 0 L 61.53 12.306000000000001 L 61.53 86.49 L 12.306000000000001 86.49 Z",
      "fill": "#de1a37",
      "fixedRatio": false,
      "rotate": 0,
      "outline": {
        "color": "#16468d",
        "width": 1.5,
        "style": "solid"
      },
      "flipH": false,
      "flipV": false,
      "pathFormula": "cutRectDiagonal",
      "keypoints": [
        0.2
      ]
    },
    {
      "type": "text",
      "width": 64.84,
      "height": 52,
      "left": 671.35,
      "top": 174.95,
      "rotate": 0,
      "defaultFontName": "思源黑体 CN",
      "defaultColor": "#333",
      "content": "<p style=\"text-align: center;\"><span style=\"font-size: 32px;\"><span style=\"font-family: 思源黑体 CN;\"><span style=\"color: rgb(255, 255, 255);\">02</span></span></span></p>",
      "lineHeight": 1,
      "outline": {
        "color": "#000",
        "width": 0,
        "style": "solid"
      },
      "fill": "",
      "vertical": false
    },
    {
      "type": "text",
      "width": 275.16,
      "height": 44,
      "left": 567.92,
      "top": 269.43,
      "rotate": 0,
      "defaultFontName": "思源黑体 CN",
      "defaultColor": "#333",
      "content": "<p style=\"text-align: center;\"><span style=\"font-size: 24px;\">{{title}}</span></p>",
      "lineHeight": 1,
      "outline": {
        "color": "#000",
        "width": 0,
        "style": "solid"
      },
      "fill": "",
      "vertical": false
    },
    {
      "type": "shape",
      "width": 292.81,
      "height": 155.68,
      "left": 145.68,
      "top": 363.91,
      "viewBox": [
        200,
        200
      ],
      "path": "M 0 0 L 200 0 L 200 200 L 0 200 Z",
      "fill": "#ffffff",
      "fixedRatio": false,
      "rotate": 0,
      "outline": {
        "color": "#FFFFFF",
        "width": 1,
        "style": "solid"
      },
      "flipH": false,
      "flipV": false,
      "shadow": {
        "h": -4.42,
        "v": 4.42,
        "blur": 18.75,
        "color": "#00000045"
      }
    },
    {
      "type": "shape",
      "width": 61.53,
      "height": 86.49,
      "left": 261.3,
      "top": 363.92,
      "viewBox": [
        61.53,
        86.49
      ],
      "path": "M 0 74.184 L 0 0 L 49.224000000000004 0 L 61.53 12.306000000000001 L 61.53 86.49 L 12.306000000000001 86.49 Z",
      "fill": "#de1a37",
      "fixedRatio": false,
      "rotate": 0,
      "outline": {
        "color": "#16468d",
        "width": 1.5,
        "style": "solid"
      },
      "flipH": false,
      "flipV": false,
      "pathFormula": "cutRectDiagonal",
      "keypoints": [
        0.2
      ]
    },
    {
      "type": "text",
      "width": 64.84,
      "height": 52,
      "left": 257.97,
      "top": 375.73,
      "rotate": 0,
      "defaultFontName": "思源黑体 CN",
      "defaultColor": "#333",
      "content": "<p style=\"text-align: center;\"><span style=\"font-size: 32px;\"><span ><span style=\"color: rgb(255, 255, 255);\">03</span></span></span></p>",
      "lineHeight": 1,
      "fill": "",
      "vertical": false
    },
    {
      "type": "text",
      "width": 275.16,
      "height": 44.484375,
      "left": 154.53,
      "top": 470.21,
      "rotate": 0,
      "defaultFontName": "思源黑体 CN",
      "defaultColor": "#333",
      "content": "<p style=\"text-align: center;\"><span style=\"font-size: 24px;\">{{title}}</span></p>",
      "lineHeight": 1,
      "outline": {
        "color": "#000",
        "width": 0,
        "style": "solid"
      },
      "fill": "",
      "vertical": false
    },
    {
      "type": "shape",
      "width": 292.81,
      "height": 155.68,
      "left": 559.06,
      "top": 363.91,
      "viewBox": [
        200,
        200
      ],
      "path": "M 0 0 L 200 0 L 200 200 L 0 200 Z",
      "fill": "#ffffff",
      "fixedRatio": false,
      "rotate": 0,
      "outline": {
        "color": "#FFFFFF",
        "width": 1,
        "style": "solid"
      },
      "flipH": false,
      "flipV": false,
      "shadow": {
        "h": -4.42,
        "v": 4.42,
        "blur": 18.75,
        "color": "#00000045"
      }
    },
    {
      "type": "shape",
      "width": 61.53,
      "height": 86.49,
      "left": 674.69,
      "top": 363.92,
      "viewBox": [
        61.53,
        86.49
      ],
      "path": "M 0 74.184 L 0 0 L 49.224000000000004 0 L 61.53 12.306000000000001 L 61.53 86.49 L 12.306000000000001 86.49 Z",
      "fill": "#de1a37",
      "fixedRatio": false,
      "rotate": 0,
      "outline": {
        "color": "#16468d",
        "width": 1.5,
        "style": "solid"
      },
      "flipH": false,
      "flipV": false,
      "pathFormula": "cutRectDiagonal",
      "keypoints": [
        0.2
      ]
    },
    {
      "type": "text",
      "width": 64.84,
      "height": 52,
      "left": 671.35,
      "top": 375.73,
      "rotate": 0,
      "defaultFontName": "思源黑体 CN",
      "defaultColor": "#333",
      "content": "<p style=\"text-align: center;\"><span style=\"font-size: 32px;\"><span style=\"font-family: 思源黑体 CN;\"><span style=\"color: rgb(255, 255, 255);\">04</span></span></span></p>",
      "lineHeight": 1,
      "outline": {
        "color": "#000",
        "width": 0,
        "style": "solid"
      },
      "fill": "",
      "vertical": false
    },
    {
      "type": "text",
      "width": 275.16,
      "height": 44.484375,
      "left": 567.92,
      "top": 470.21,
      "rotate": 0,
      "defaultFontName": "思源黑体 CN",
      "defaultColor": "#333",
      "content": "<p style=\"text-align: center;\"><span style=\"font-size: 24px;\">{{title}}</span></p>",
      "lineHeight": 1,
      "outline": {
        "color": "#000",
        "width": 0,
        "style": "solid"
      },
      "fill": "",
      "vertical": false
    }
  ],
  'many':[
    
    {
      "type": "shape",
      "width": 28.366379585326953,
      "height": 45.3714673046252,
      "left": 230.27362041467305,
      "top": 171.3485326953748,
      "viewBox": [
        28.366379585326953,
        45.3714673046252
      ],
      "path": "M 0 39.69819138755981 L 0 0 L 22.693103668261564 0 L 28.366379585326953 5.673275917065391 L 28.366379585326953 45.3714673046252 L 5.673275917065391 45.3714673046252 Z",
      "fill": "#de1a37",
      "fixedRatio": false,
      "rotate": 0,
      "flipH": false,
      "flipV": false,
      "shadow": {
        "h": 2.21,
        "v": 2.21,
        "blur": 4.17,
        "color": "#00000066"
      },
      "text": {
        "content": "<p style=\"text-align: center;\" class=\"\"><span style=\"font-size: 18px;\"><span style=\"font-family: 思源黑体 CN;\"><span style=\"color: rgb(255, 255, 255);\">1</span></span></span></p>",
        "defaultFontName": "思源黑体 CN",
        "defaultColor": "#333",
        "align": "top"
      },
      "pathFormula": "cutRectDiagonal",
      "keypoints": [
        0.2
      ]
    },
    {
      "type": "text",
      "width": 256.98,
      "height": 50,
      "left": 268.96,
      "top": 169.69,
      "rotate": 0,
      "content": "<p style=\"\" class=\"ProseMirror-selectednode\" draggable=\"true\"><span style=\"font-size: 20px;\">{{title}}</span></p>",
      "defaultFontName": "思源黑体 CN",
      "defaultColor": "#333"
    },
   
    {
      "type": "shape",
      "width": 28.366379585326953,
      "height": 45.3714673046252,
      "left": 547.465,
      "top": 174.6285326953748,
      "viewBox": [
        28.366379585326953,
        45.3714673046252
      ],
      "path": "M 0 39.69819138755981 L 0 0 L 22.693103668261564 0 L 28.366379585326953 5.673275917065391 L 28.366379585326953 45.3714673046252 L 5.673275917065391 45.3714673046252 Z",
      "fill": "#de1a37",
      "fixedRatio": false,
      "rotate": 0,
      "outline": {
        "color": "#16468d",
        "width": 0,
        "style": "solid"
      },
      "text": {
        "content": "<p style=\"text-align: center;\"><span style=\"font-size: 18px;\"><span style=\"font-family: 思源黑体 CN;\"><span style=\"color: rgb(255, 255, 255);\">2</span></span></span></p>",
        "defaultFontName": "思源黑体 CN",
        "defaultColor": "#333",
        "align": "middle"
      },
      "flipH": false,
      "flipV": false,
      "shadow": {
        "h": 2.21,
        "v": 2.21,
        "blur": 4.17,
        "color": "#00000066"
      },
      "pathFormula": "cutRectDiagonal",
      "keypoints": [
        0.2
      ]
    },
    {
      "type": "text",
      "width": 256.98,
      "height": 50,
      "left": 586.151379585327,
      "top": 172.97,
      "rotate": 0,
      "content": "<p style=\"\" class=\"ProseMirror-selectednode\" draggable=\"true\"><span style=\"font-size: 20px;\">{{title}}</span></p>",
      "defaultFontName": "思源黑体 CN",
      "defaultColor": "#333"
    },
   
    {
      "type": "shape",
      "width": 28.366379585326953,
      "height": 45.3714673046252,
      "left": 230.27362041467305,
      "top": 253.17000000000002,
      "viewBox": [
        28.366379585326953,
        45.3714673046252
      ],
      "path": "M 0 39.69819138755981 L 0 0 L 22.693103668261564 0 L 28.366379585326953 5.673275917065391 L 28.366379585326953 45.3714673046252 L 5.673275917065391 45.3714673046252 Z",
      "fill": "#de1a37",
      "fixedRatio": false,
      "rotate": 0,
      "outline": {
        "color": "#16468d",
        "width": 0,
        "style": "solid"
      },
      "text": {
        "content": "<p style=\"text-align: center;\" class=\"\"><span style=\"font-size: 18px;\"><span style=\"font-family: 思源黑体 CN;\"><span style=\"color: rgb(255, 255, 255);\">3</span></span></span></p>",
        "defaultFontName": "思源黑体 CN",
        "defaultColor": "#333",
        "align": "middle"
      },
      "flipH": false,
      "flipV": false,
      "shadow": {
        "h": 2.21,
        "v": 2.21,
        "blur": 4.17,
        "color": "#00000066"
      },
      "pathFormula": "cutRectDiagonal",
      "keypoints": [
        0.2
      ]
    },
    {
      "type": "text",
      "width": 256.98,
      "height": 50,
      "left": 268.96,
      "top": 251.17000000000002,
      "rotate": 0,
      "content": "<p style=\"\" class=\"ProseMirror-selectednode\" draggable=\"true\"><span style=\"font-size: 20px;\">{{title}}</span></p>",
      "defaultFontName": "思源黑体 CN",
      "defaultColor": "#333"
    },
   
    {
      "type": "shape",
      "width": 28.366379585326953,
      "height": 45.3714673046252,
      "left": 547.465,
      "top": 256.45000000000005,
      "viewBox": [
        28.366379585326953,
        45.3714673046252
      ],
      "path": "M 0 39.69819138755981 L 0 0 L 22.693103668261564 0 L 28.366379585326953 5.673275917065391 L 28.366379585326953 45.3714673046252 L 5.673275917065391 45.3714673046252 Z",
      "fill": "#de1a37",
      "fixedRatio": false,
      "rotate": 0,
      "outline": {
        "color": "#16468d",
        "width": 0,
        "style": "solid"
      },
      "text": {
        "content": "<p style=\"text-align: center;\"><span style=\"font-size: 18px;\"><span style=\"font-family: 思源黑体 CN;\"><span style=\"color: rgb(255, 255, 255);\">4</span></span></span></p>",
        "defaultFontName": "思源黑体 CN",
        "defaultColor": "#333",
        "align": "middle"
      },
      "flipH": false,
      "flipV": false,
      "shadow": {
        "h": 2.21,
        "v": 2.21,
        "blur": 4.17,
        "color": "#00000066"
      },
      "pathFormula": "cutRectDiagonal",
      "keypoints": [
        0.2
      ]
    },
    {
      "type": "text",
      "width": 256.98,
      "height": 50,
      "left": 586.151379585327,
      "top": 254.45000000000002,
      "rotate": 0,
      "content": "<p style=\"\" class=\"ProseMirror-selectednode\" draggable=\"true\"><span style=\"font-size: 20px;\">{{title}}</span></p>",
      "defaultFontName": "思源黑体 CN",
      "defaultColor": "#333"
    },

    
    {
      "type": "shape",
      "width": 28.366379585326953,
      "height": 45.3714673046252,
      "left": 230.27362041467305,
      "top": 337.275,
      "viewBox": [
        28.366379585326953,
        45.3714673046252
      ],
      "path": "M 0 39.69819138755981 L 0 0 L 22.693103668261564 0 L 28.366379585326953 5.673275917065391 L 28.366379585326953 45.3714673046252 L 5.673275917065391 45.3714673046252 Z",
      "fill": "#de1a37",
      "fixedRatio": false,
      "rotate": 0,
      "outline": {
        "color": "#16468d",
        "width": 0,
        "style": "solid"
      },
      "text": {
        "content": "<p style=\"text-align: center;\" class=\"\"><span style=\"font-size: 18px;\"><span style=\"font-family: 思源黑体 CN;\"><span style=\"color: rgb(255, 255, 255);\">5</span></span></span></p>",
        "defaultFontName": "思源黑体 CN",
        "defaultColor": "#333",
        "align": "middle"
      },
      "flipH": false,
      "flipV": false,
      "shadow": {
        "h": 2.21,
        "v": 2.21,
        "blur": 4.17,
        "color": "#00000066"
      },
      "pathFormula": "cutRectDiagonal",
      "keypoints": [
        0.2
      ]
    },
    {
      "type": "text",
      "width": 256.98,
      "height": 50,
      "left": 268.96,
      "top": 338.51,
      "rotate": 0,
      "content": "<p ><span style=\"font-size: 20px;\">{{title}}</span></p>",
      "defaultFontName": "思源黑体 CN",
      "defaultColor": "#333"
    },
   
    {
      "type": "shape",
      "width": 28.366379585326953,
      "height": 45.3714673046252,
      "left": 547.465,
      "top": 340.55499999999995,
      "viewBox": [
        28.366379585326953,
        45.3714673046252
      ],
      "path": "M 0 39.69819138755981 L 0 0 L 22.693103668261564 0 L 28.366379585326953 5.673275917065391 L 28.366379585326953 45.3714673046252 L 5.673275917065391 45.3714673046252 Z",
      "fill": "#de1a37",
      "fixedRatio": false,
      "rotate": 0,
      "outline": {
        "color": "#16468d",
        "width": 0,
        "style": "solid"
      },
      "text": {
        "content": "<p style=\"text-align: center;\"><span style=\"font-size: 18px;\"><span style=\"font-family: 思源黑体 CN;\"><span style=\"color: rgb(255, 255, 255);\">6</span></span></span></p>",
        "defaultFontName": "思源黑体 CN",
        "defaultColor": "#333",
        "align": "middle"
      },
      "flipH": false,
      "flipV": false,
      "shadow": {
        "h": 2.21,
        "v": 2.21,
        "blur": 4.17,
        "color": "#00000066"
      },
      "pathFormula": "cutRectDiagonal",
      "keypoints": [
        0.2
      ]
    },
    {
      "type": "text",
      "width": 256.98,
      "height": 50,
      "left": 586.151379585327,
      "top": 341.78999999999996,
      "rotate": 0,
      "content": "<p style=\"\" class=\"ProseMirror-selectednode\" draggable=\"true\"><span style=\"font-size: 20px;\">{{title}}</span></p>",
      "defaultFontName": "思源黑体 CN",
      "defaultColor": "#333"
    },
    
    {
      "type": "shape",
      "width": 28.366379585326953,
      "height": 45.3714673046252,
      "left": 230.27362041467305,
      "top": 426.33,
      "viewBox": [
        28.366379585326953,
        45.3714673046252
      ],
      "path": "M 0 39.69819138755981 L 0 0 L 22.693103668261564 0 L 28.366379585326953 5.673275917065391 L 28.366379585326953 45.3714673046252 L 5.673275917065391 45.3714673046252 Z",
      "fill": "#de1a37",
      "fixedRatio": false,
      "rotate": 0,
      "outline": {
        "color": "#16468d",
        "width": 0,
        "style": "solid"
      },
      "text": {
        "content": "<p style=\"text-align: center;\" class=\"\"><span style=\"font-size: 18px;\"><span style=\"font-family: 思源黑体 CN;\"><span style=\"color: rgb(255, 255, 255);\">7</span></span></span></p>",
        "defaultFontName": "思源黑体 CN",
        "defaultColor": "#333",
        "align": "middle"
      },
      "flipH": false,
      "flipV": false,
      "shadow": {
        "h": 2.21,
        "v": 2.21,
        "blur": 4.17,
        "color": "#00000066"
      },
      "pathFormula": "cutRectDiagonal",
      "keypoints": [
        0.2
      ]
    },
    {
      "type": "text",
      "width": 256.98,
      "height": 50,
      "left": 269.38,
      "top": 422.33,
      "rotate": 0,
      "content": "<p style=\"\" class=\"ProseMirror-selectednode\" draggable=\"true\"><span style=\"font-size: 20px;\">{{title}}</span></p>",
      "defaultFontName": "思源黑体 CN",
      "defaultColor": "#333"
    },
    
    {
      "type": "shape",
      "width": 28.366379585326953,
      "height": 45.3714673046252,
      "left": 547.465,
      "top": 429.61,
      "viewBox": [
        28.366379585326953,
        45.3714673046252
      ],
      "path": "M 0 39.69819138755981 L 0 0 L 22.693103668261564 0 L 28.366379585326953 5.673275917065391 L 28.366379585326953 45.3714673046252 L 5.673275917065391 45.3714673046252 Z",
      "fill": "#de1a37",
      "fixedRatio": false,
      "rotate": 0,
      "outline": {
        "color": "#16468d",
        "width": 0,
        "style": "solid"
      },
      "text": {
        "content": "<p style=\"text-align: center;\"><span style=\"font-size: 18px;\"><span style=\"font-family: 思源黑体 CN;\"><span style=\"color: rgb(255, 255, 255);\">8</span></span></span></p>",
        "defaultFontName": "思源黑体 CN",
        "defaultColor": "#333",
        "align": "middle"
      },
      "flipH": false,
      "flipV": false,
      "shadow": {
        "h": 2.21,
        "v": 2.21,
        "blur": 4.17,
        "color": "#00000066"
      },
      "pathFormula": "cutRectDiagonal",
      "keypoints": [
        0.2
      ]
    },
    {
      "type": "text",
      "width": 256.98,
      "height": 50,
      "left": 586.5713795853271,
      "top": 425.61,
      "rotate": 0,
      "content": "<p style=\"\" class=\"ProseMirror-selectednode\" draggable=\"true\"><span style=\"font-size: 20px;\">{{title}}</span></p>",
      "defaultFontName": "思源黑体 CN",
      "defaultColor": "#333"
    },

  ],
  'max':[
   
    {
      "type": "shape",
      "width": 50.42,
      "height": 36.77,
      "left": 85.31,
      "top": 172.92,
      "viewBox": [
        50.42,
        36.77
      ],
      "path": "M 0 29.416000000000004 L 0 0 L 43.066 0 L 50.42 7.354000000000001 L 50.42 36.77 L 7.354000000000001 36.77 Z",
      "fill": "#de1a37",
      "fixedRatio": false,
      "rotate": 0,
      "text": {
        "content": "<p style=\"text-align: center;\"><span style=\"font-size: 18px;\"><span style=\"font-family: 思源黑体 CN;\"><span style=\"color: rgb(255, 255, 255);\">01</span></span></span></p>",
        "defaultFontName": "思源黑体 CN",
        "defaultColor": "#333",
        "align": "middle"
      },
      "flipH": false,
      "flipV": false,
      "pathFormula": "cutRectDiagonal",
      "keypoints": [
        0.2
      ]
    },
    {
      "type": "text",
      "width": 211.88,
      "height": 40,
      "left": 145.68,
      "top": 166.88,
      "rotate": 0,
      "defaultFontName": "思源黑体 CN",
      "defaultColor": "#333",
      "content": "<p style=\"\" class=\"\"><span style=\"font-size: 20px;\"><span style=\"font-family: 思源黑体 CN;\">{{title}}</span></span></p>",
      "lineHeight": 1,
      "outline": {
        "color": "#000",
        "width": 0,
        "style": "solid"
      },
      "fill": "",
      "vertical": false
    },

   
    {
      "type": "shape",
      "width": 50.42,
      "height": 36.77,
      "left": 381.88,
      "top": 172.92,
      "viewBox": [
        50.42,
        36.77
      ],
      "path": "M 0 29.416000000000004 L 0 0 L 43.066 0 L 50.42 7.354000000000001 L 50.42 36.77 L 7.354000000000001 36.77 Z",
      "fill": "#de1a37",
      "fixedRatio": false,
      "rotate": 0,
      "text": {
        "content": "<p style=\"text-align: center;\" class=\"\"><span style=\"font-size: 18px;\"><span style=\"font-family: 思源黑体 CN;\"><span style=\"color: rgb(255, 255, 255);\">02</span></span></span></p>",
        "defaultFontName": "思源黑体 CN",
        "defaultColor": "#333",
        "align": "middle"
      },
      "flipH": false,
      "flipV": false,
      "pathFormula": "cutRectDiagonal",
      "keypoints": [
        0.2
      ]
    },
    {
      "type": "text",
      "width": 211.88,
      "height": 40,
      "left": 442.24,
      "top": 166.88,
      "rotate": 0,
      "defaultFontName": "思源黑体 CN",
      "defaultColor": "#333",
      "content": "<p style=\"\" class=\"\"><span style=\"font-size: 20px;\"><span style=\"font-family: 思源黑体 CN;\">{{title}}</span></span></p>",
      "lineHeight": 1,
      "outline": {
        "color": "#000",
        "width": 0,
        "style": "solid"
      },
      "fill": "",
      "vertical": false
    },
    
    {
      "type": "shape",
      "width": 50.42,
      "height": 36.77,
      "left": 678.44,
      "top": 172.92,
      "viewBox": [
        50.42,
        36.77
      ],
      "path": "M 0 29.416000000000004 L 0 0 L 43.066 0 L 50.42 7.354000000000001 L 50.42 36.77 L 7.354000000000001 36.77 Z",
      "fill": "#de1a37",
      "fixedRatio": false,
      "rotate": 0,
      "text": {
        "content": "<p style=\"text-align: center;\" class=\"\"><span style=\"font-size: 18px;\"><span style=\"font-family: 思源黑体 CN;\"><span style=\"color: rgb(255, 255, 255);\">03</span></span></span></p>",
        "defaultFontName": "思源黑体 CN",
        "defaultColor": "#333",
        "align": "middle"
      },
      "flipH": false,
      "flipV": false,
      "pathFormula": "cutRectDiagonal",
      "keypoints": [
        0.2
      ]
    },
    {
      "type": "text",
      "width": 211.88,
      "height": 40,
      "left": 738.8,
      "top": 166.88,
      "rotate": 0,
      "defaultFontName": "思源黑体 CN",
      "defaultColor": "#333",
      "content": "<p style=\"\"><span style=\"font-size: 20px;\"><span style=\"font-family: 思源黑体 CN;\">{{title}}</span></span></p>",
      "lineHeight": 1,
      "outline": {
        "color": "#000",
        "width": 0,
        "style": "solid"
      },
      "fill": "",
      "vertical": false
    },
   
    {
      "type": "shape",
      "width": 50.42,
      "height": 36.77,
      "left": 85.31,
      "top": 263.7,
      "viewBox": [
        50.42,
        36.77
      ],
      "path": "M 0 29.416000000000004 L 0 0 L 43.066 0 L 50.42 7.354000000000001 L 50.42 36.77 L 7.354000000000001 36.77 Z",
      "fill": "#de1a37",
      "fixedRatio": false,
      "rotate": 0,
      "text": {
        "content": "<p style=\"text-align: center;\" class=\"\"><span style=\"font-size: 18px;\"><span style=\"font-family: 思源黑体 CN;\"><span style=\"color: rgb(255, 255, 255);\">04</span></span></span></p>",
        "defaultFontName": "思源黑体 CN",
        "defaultColor": "#333",
        "align": "middle"
      },
      "flipH": false,
      "flipV": false,
      "pathFormula": "cutRectDiagonal",
      "keypoints": [
        0.2
      ]
    },
    {
      "type": "text",
      "width": 211.88,
      "height": 40,
      "left": 145.68,
      "top": 257.66,
      "rotate": 0,
      "defaultFontName": "思源黑体 CN",
      "defaultColor": "#333",
      "content": "<p style=\"\"><span style=\"font-size: 20px;\"><span style=\"font-family: 思源黑体 CN;\">{{title}}</span></span></p>",
      "lineHeight": 1,
      "outline": {
        "color": "#000",
        "width": 0,
        "style": "solid"
      },
      "fill": "",
      "vertical": false
    },
    
    {
      "type": "shape",
      "width": 50.42,
      "height": 36.77,
      "left": 381.88,
      "top": 263.7,
      "viewBox": [
        50.42,
        36.77
      ],
      "path": "M 0 29.416000000000004 L 0 0 L 43.066 0 L 50.42 7.354000000000001 L 50.42 36.77 L 7.354000000000001 36.77 Z",
      "fill": "#de1a37",
      "fixedRatio": false,
      "rotate": 0,
      "text": {
        "content": "<p style=\"text-align: center;\" class=\"\"><span style=\"font-size: 18px;\"><span style=\"font-family: 思源黑体 CN;\"><span style=\"color: rgb(255, 255, 255);\">05</span></span></span></p>",
        "defaultFontName": "思源黑体 CN",
        "defaultColor": "#333",
        "align": "middle"
      },
      "flipH": false,
      "flipV": false,
      "pathFormula": "cutRectDiagonal",
      "keypoints": [
        0.2
      ]
    },
    {
      "type": "text",
      "width": 211.88,
      "height": 40,
      "left": 442.24,
      "top": 257.66,
      "rotate": 0,
      "defaultFontName": "思源黑体 CN",
      "defaultColor": "#333",
      "content": "<p style=\"\"><span style=\"font-size: 20px;\"><span style=\"font-family: 思源黑体 CN;\">{{title}}</span></span></p>",
      "lineHeight": 1,
      "outline": {
        "color": "#000",
        "width": 0,
        "style": "solid"
      },
      "fill": "",
      "vertical": false
    },
    
    {
      "type": "shape",
      "width": 50.42,
      "height": 36.77,
      "left": 678.44,
      "top": 263.7,
      "viewBox": [
        50.42,
        36.77
      ],
      "path": "M 0 29.416000000000004 L 0 0 L 43.066 0 L 50.42 7.354000000000001 L 50.42 36.77 L 7.354000000000001 36.77 Z",
      "fill": "#de1a37",
      "fixedRatio": false,
      "rotate": 0,
      "text": {
        "content": "<p style=\"text-align: center;\" class=\"ProseMirror-selectednode\" draggable=\"true\"><span style=\"font-size: 18px;\"><span style=\"font-family: 思源黑体 CN;\"><span style=\"color: rgb(255, 255, 255);\">06</span></span></span></p>",
        "defaultFontName": "思源黑体 CN",
        "defaultColor": "#333",
        "align": "middle"
      },
      "flipH": false,
      "flipV": false,
      "pathFormula": "cutRectDiagonal",
      "keypoints": [
        0.2
      ]
    },
    {
      "type": "text",
      "width": 211.88,
      "height": 40,
      "left": 738.8,
      "top": 257.66,
      "rotate": 0,
      "defaultFontName": "思源黑体 CN",
      "defaultColor": "#333",
      "content": "<p style=\"\"><span style=\"font-size: 20px;\"><span style=\"font-family: 思源黑体 CN;\">{{title}}</span></span></p>",
      "lineHeight": 1,
      "outline": {
        "color": "#000",
        "width": 0,
        "style": "solid"
      },
      "fill": "",
      "vertical": false
    },
    
    {
      "type": "shape",
      "width": 50.42,
      "height": 36.77,
      "left": 85.31,
      "top": 352.29,
      "viewBox": [
        50.42,
        36.77
      ],
      "path": "M 0 29.416000000000004 L 0 0 L 43.066 0 L 50.42 7.354000000000001 L 50.42 36.77 L 7.354000000000001 36.77 Z",
      "fill": "#de1a37",
      "fixedRatio": false,
      "rotate": 0,
      "text": {
        "content": "<p style=\"text-align: center;\" class=\"\"><span style=\"font-size: 18px;\"><span style=\"font-family: 思源黑体 CN;\"><span style=\"color: rgb(255, 255, 255);\">07</span></span></span></p>",
        "defaultFontName": "思源黑体 CN",
        "defaultColor": "#333",
        "align": "middle"
      },
      "flipH": false,
      "flipV": false,
      "pathFormula": "cutRectDiagonal",
      "keypoints": [
        0.2
      ]
    },
    {
      "type": "text",
      "width": 211.88,
      "height": 40,
      "left": 145.68,
      "top": 346.25,
      "rotate": 0,
      "defaultFontName": "思源黑体 CN",
      "defaultColor": "#333",
      "content": "<p style=\"\"><span style=\"font-size: 20px;\"><span style=\"font-family: 思源黑体 CN;\">{{title}}</span></span></p>",
      "lineHeight": 1,
      "outline": {
        "color": "#000",
        "width": 0,
        "style": "solid"
      },
      "fill": "",
      "vertical": false
    },
   
    {
      "type": "shape",
      "width": 50.42,
      "height": 36.77,
      "left": 381.88,
      "top": 352.29,
      "viewBox": [
        50.42,
        36.77
      ],
      "path": "M 0 29.416000000000004 L 0 0 L 43.066 0 L 50.42 7.354000000000001 L 50.42 36.77 L 7.354000000000001 36.77 Z",
      "fill": "#de1a37",
      "fixedRatio": false,
      "rotate": 0,
      "text": {
        "content": "<p style=\"text-align: center;\" class=\"\"><span style=\"font-size: 18px;\"><span style=\"font-family: 思源黑体 CN;\"><span style=\"color: rgb(255, 255, 255);\">08</span></span></span></p>",
        "defaultFontName": "思源黑体 CN",
        "defaultColor": "#333",
        "align": "middle"
      },
      "flipH": false,
      "flipV": false,
      "pathFormula": "cutRectDiagonal",
      "keypoints": [
        0.2
      ]
    },
    {
      "type": "text",
      "width": 211.88,
      "height": 40,
      "left": 442.24,
      "top": 346.25,
      "rotate": 0,
      "defaultFontName": "思源黑体 CN",
      "defaultColor": "#333",
      "content": "<p style=\"\"><span style=\"font-size: 20px;\"><span style=\"font-family: 思源黑体 CN;\">{{title}}</span></span></p>",
      "lineHeight": 1,
      "outline": {
        "color": "#000",
        "width": 0,
        "style": "solid"
      },
      "fill": "",
      "vertical": false
    },
   
    {
      "type": "shape",
      "width": 50.42,
      "height": 36.77,
      "left": 678.44,
      "top": 352.29,
      "viewBox": [
        50.42,
        36.77
      ],
      "path": "M 0 29.416000000000004 L 0 0 L 43.066 0 L 50.42 7.354000000000001 L 50.42 36.77 L 7.354000000000001 36.77 Z",
      "fill": "#de1a37",
      "fixedRatio": false,
      "rotate": 0,
      "text": {
        "content": "<p style=\"text-align: center;\"><span style=\"font-size: 18px;\"><span style=\"font-family: 思源黑体 CN;\"><span style=\"color: rgb(255, 255, 255);\">09</span></span></span></p>",
        "defaultFontName": "思源黑体 CN",
        "defaultColor": "#333",
        "align": "middle"
      },
      "flipH": false,
      "flipV": false,
      "pathFormula": "cutRectDiagonal",
      "keypoints": [
        0.2
      ]
    },
    {
      "type": "text",
      "width": 211.88,
      "height": 40,
      "left": 738.8,
      "top": 346.25,
      "rotate": 0,
      "defaultFontName": "思源黑体 CN",
      "defaultColor": "#333",
      "content": "<p style=\"\"><span style=\"font-size: 20px;\"><span style=\"font-family: 思源黑体 CN;\">{{title}}</span></span></p>",
      "lineHeight": 1,
      "outline": {
        "color": "#000",
        "width": 0,
        "style": "solid"
      },
      "fill": "",
      "vertical": false
    },
   
    {
      "type": "shape",
      "width": 50.42,
      "height": 36.77,
      "left": 85.78,
      "top": 435,
      "viewBox": [
        50.42,
        36.77
      ],
      "path": "M 0 29.416000000000004 L 0 0 L 43.066 0 L 50.42 7.354000000000001 L 50.42 36.77 L 7.354000000000001 36.77 Z",
      "fill": "#de1a37",
      "fixedRatio": false,
      "rotate": 0,
      "text": {
        "content": "<p style=\"text-align: center;\" class=\"\"><span style=\"font-size: 18px;\"><span style=\"font-family: 思源黑体 CN;\"><span style=\"color: rgb(255, 255, 255);\">10</span></span></span></p>",
        "defaultFontName": "思源黑体 CN",
        "defaultColor": "#333",
        "align": "middle"
      },
      "flipH": false,
      "flipV": false,
      "pathFormula": "cutRectDiagonal",
      "keypoints": [
        0.2
      ]
    }
    ,
    {
      "type": "text",
      "width": 211.88,
      "height": 40,
      "left": 146.15,
      "top": 428.96,
      "rotate": 0,
      "defaultFontName": "思源黑体 CN",
      "defaultColor": "#333",
      "content": "<p style=\"\"><span style=\"font-size: 20px;\"><span style=\"font-family: 思源黑体 CN;\">{{title}}</span></span></p>",
      "lineHeight": 1,
      "outline": {
        "color": "#000",
        "width": 0,
        "style": "solid"
      },
      "fill": "",
      "vertical": false
    },
   
    {
      "type": "shape",
      "width": 50.42,
      "height": 36.77,
      "left": 382.34,
      "top": 435,
      "viewBox": [
        50.42,
        36.77
      ],
      "path": "M 0 29.416000000000004 L 0 0 L 43.066 0 L 50.42 7.354000000000001 L 50.42 36.77 L 7.354000000000001 36.77 Z",
      "fill": "#de1a37",
      "fixedRatio": false,
      "rotate": 0,
      "text": {
        "content": "<p style=\"text-align: center;\"><span style=\"font-size: 18px;\"><span style=\"font-family: 思源黑体 CN;\"><span style=\"color: rgb(255, 255, 255);\">11</span></span></span></p>",
        "defaultFontName": "思源黑体 CN",
        "defaultColor": "#333",
        "align": "middle"
      },
      "flipH": false,
      "flipV": false,
      "pathFormula": "cutRectDiagonal",
      "keypoints": [
        0.2
      ]
    },
    {
      "type": "text",
      "width": 211.88,
      "height": 40,
      "left": 442.71,
      "top": 428.96,
      "rotate": 0,
      "defaultFontName": "思源黑体 CN",
      "defaultColor": "#333",
      "content": "<p style=\"\"><span style=\"font-size: 20px;\"><span style=\"font-family: 思源黑体 CN;\">{{title}}</span></span></p>",
      "lineHeight": 1,
      "outline": {
        "color": "#000",
        "width": 0,
        "style": "solid"
      },
      "fill": "",
      "vertical": false
    },
    
    {
      "type": "shape",
      "width": 50.42,
      "height": 36.77,
      "left": 678.91,
      "top": 435,
      "viewBox": [
        50.42,
        36.77
      ],
      "path": "M 0 29.416000000000004 L 0 0 L 43.066 0 L 50.42 7.354000000000001 L 50.42 36.77 L 7.354000000000001 36.77 Z",
      "fill": "#de1a37",
      "fixedRatio": false,
      "rotate": 0,
      "text": {
        "content": "<p style=\"text-align: center;\" class=\"ProseMirror-selectednode\" draggable=\"true\"><span style=\"font-size: 18px;\"><span style=\"font-family: 思源黑体 CN;\"><span style=\"color: rgb(255, 255, 255);\">12</span></span></span></p>",
        "defaultFontName": "思源黑体 CN",
        "defaultColor": "#333",
        "align": "middle"
      },
      "flipH": false,
      "flipV": false,
      "pathFormula": "cutRectDiagonal",
      "keypoints": [
        0.2
      ]
    },
    {
      "type": "text",
      "width": 211.88,
      "height": 40,
      "left": 739.27,
      "top": 428.96,
      "rotate": 0,
      "defaultFontName": "思源黑体 CN",
      "defaultColor": "#333",
      "content": "<p style=\"\"><span style=\"font-size: 20px;\"><span style=\"font-family: 思源黑体 CN;\">{{title}}</span></span></p>",
      "lineHeight": 1,
      "outline": {
        "color": "#000",
        "width": 0,
        "style": "solid"
      },
      "fill": "",
      "vertical": false
    },

  ]

 },
 '7':{
  manyLenght:[3,3,3],
  'few':[
    {
    "type": "shape",
    "width": 42.39,
    "height": 42.39,
    "left": 158.49,
    "top": 247.73,
    "viewBox": [
      200,
      200
    ],
    "path": "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
    "fill": "rgb(234, 201, 177)",
    "fixedRatio": false,
    "rotate": 0,
    "flipH": false,
    "flipV": false
  },
  {
    "type": "text",
    "width": 65.9,
    "height": 40,
    "left": 166.69,
    "top": 252.70999999999998,
    "rotate": 0,
    "defaultFontName": "思源黑体 CN",
    "defaultColor": "#333",
    "content": "<p style=\"\"><em>01.</em></p>",
    "lineHeight": 1,
    "outline": {
      "color": "#000",
      "width": 0,
      "style": "solid"
    },
    "fill": "",
    "vertical": false
  },
  {
    "type": "text",
    "width": 300,
    "height": 50,
    "left": 223.31,
    "top": 245.69,
    "rotate": 0,
    "content": "<p style=\"\">{{title}}</p>",
    "defaultFontName": "思源黑体 CN",
    "defaultColor": "#333"
  },
  {
    "type": "shape",
    "width": 42.39,
    "height": 42.39,
    "left": 585.54,
    "top": 246.73,
    "viewBox": [
      200,
      200
    ],
    "path": "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
    "fill": "rgb(234, 201, 177)",
    "fixedRatio": false,
    "rotate": 0,
    "flipH": false,
    "flipV": false
  },
  {
    "type": "text",
    "width": 65.9,
    "height": 40,
    "left": 593.74,
    "top": 251.70999999999998,
    "rotate": 0,
    "defaultFontName": "思源黑体 CN",
    "defaultColor": "#333",
    "content": "<p style=\"\"><em>02.</em></p>",
    "lineHeight": 1,
    "outline": {
      "color": "#000",
      "width": 0,
      "style": "solid"
    },
    "fill": "",
    "vertical": false
  },
  {
    "type": "text",
    "width": 300,
    "height": 50,
    "left": 648.0228538539416,
    "top": 244.69,
    "rotate": 0,
    "content": "<p style=\"\">{{title}}</p>",
    "defaultFontName": "思源黑体 CN",
    "defaultColor": "#333"
  },
  {
    "type": "shape",
    "width": 42.39,
    "height": 42.39,
    "left": 158.49,
    "top": 348.91,
    "viewBox": [
      200,
      200
    ],
    "path": "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
    "fill": "rgb(234, 201, 177)",
    "fixedRatio": false,
    "rotate": 0,
    "flipH": false,
    "flipV": false
  },
  {
    "type": "text",
    "width": 65.9,
    "height": 40,
    "left": 166.69,
    "top": 353.89000000000004,
    "rotate": 0,
    "defaultFontName": "思源黑体 CN",
    "defaultColor": "#333",
    "content": "<p style=\"\"><em>03.</em></p>",
    "lineHeight": 1,
    "fill": "",
    "vertical": false
  },
  {
    "type": "text",
    "width": 300,
    "height": 50,
    "left": 223.31,
    "top": 346.2475973314966,
    "rotate": 0,
    "content": "<p style=\"\">{{title}}</p>",
    "defaultFontName": "思源黑体 CN",
    "defaultColor": "#333"
  },
  {
    "type": "shape",
    "width": 42.39,
    "height": 42.39,
    "left": 585.54,
    "top": 348.91,
    "viewBox": [
      200,
      200
    ],
    "path": "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
    "fill": "rgb(234, 201, 177)",
    "fixedRatio": false,
    "rotate": 0,
    "flipH": false,
    "flipV": false
  },
  {
    "type": "text",
    "width": 65.9,
    "height": 40,
    "left": 593.74,
    "top": 353.89000000000004,
    "rotate": 0,
    "defaultFontName": "思源黑体 CN",
    "defaultColor": "#333",
    "content": "<p style=\"\"><em>04.</em></p>",
    "lineHeight": 1,
    "outline": {
      "color": "#000",
      "width": 0,
      "style": "solid"
    },
    "fill": "",
    "vertical": false
  },
  {
    "type": "text",
    "width": 300,
    "height": 50,
    "left": 648.0228538539416,
    "top": 347.2475973314966,
    "rotate": 0,
    "content": "<p style=\"\">{{title}}</p>",
    "defaultFontName": "思源黑体 CN",
    "defaultColor": "#333"
  }

],
  'many':[
    {
      "type": "shape",
      "width": 42.39,
      "height": 42.39,
      "left": 200.49,
      "top": 222.73,
      "viewBox": [
        200,
        200
      ],
      "path": "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
      "fill": "rgb(234, 201, 177)",
      "fixedRatio": false,
      "rotate": 0,
      "flipH": false,
      "flipV": false
    },
    {
      "type": "text",
      "width": 65.9,
      "height": 40,
      "left": 208.69,
      "top": 227.70999999999998,
      "rotate": 0,
      "defaultFontName": "思源黑体 CN",
      "defaultColor": "#333",
      "content": "<p style=\"\"><em>01.</em></p>",
      "lineHeight": 1,
      "outline": {
        "color": "#000",
        "width": 0,
        "style": "solid"
      },
      "fill": "",
      "vertical": false
    },
    {
      "type": "text",
      "width": 300,
      "height": 50,
      "left": 267.31,
      "top": 220.69,
      "rotate": 0,
      "content": "<p style=\"\">{{title}}</p>",
      "defaultFontName": "思源黑体 CN",
      "defaultColor": "#333"
    },
    {
      "type": "shape",
      "width": 42.39,
      "height": 42.39,
      "left": 576.54,
      "top": 221.73,
      "viewBox": [
        200,
        200
      ],
      "path": "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
      "fill": "rgb(234, 201, 177)",
      "fixedRatio": false,
      "rotate": 0,
      "flipH": false,
      "flipV": false
    },
    {
      "type": "text",
      "width": 65.9,
      "height": 40,
      "left": 584.74,
      "top": 226.70999999999998,
      "rotate": 0,
      "defaultFontName": "思源黑体 CN",
      "defaultColor": "#333",
      "content": "<p style=\"\"><em>02.</em></p>",
      "lineHeight": 1,
      "outline": {
        "color": "#000",
        "width": 0,
        "style": "solid"
      },
      "fill": "",
      "vertical": false
    },
    {
      "type": "text",
      "width": 300,
      "height": 50,
      "left": 641.0228538539416,
      "top": 219.69,
      "rotate": 0,
      "content": "<p style=\"\">{{title}}</p>",
      "defaultFontName": "思源黑体 CN",
      "defaultColor": "#333"
    },
    {
      "type": "shape",
      "width": 42.39,
      "height": 42.39,
      "left": 200.49,
      "top": 296.91,
      "viewBox": [
        200,
        200
      ],
      "path": "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
      "fill": "rgb(234, 201, 177)",
      "fixedRatio": false,
      "rotate": 0,
      "flipH": false,
      "flipV": false
    },
    {
      "type": "text",
      "width": 65.9,
      "height": 40,
      "left": 208.69,
      "top": 301.89000000000004,
      "rotate": 0,
      "defaultFontName": "思源黑体 CN",
      "defaultColor": "#333",
      "content": "<p style=\"\"><em>03.</em></p>",
      "lineHeight": 1,
      "fill": "",
      "vertical": false
    },
    {
      "type": "text",
      "width": 300,
      "height": 50,
      "left": 267.31,
      "top": 294.2475973314966,
      "rotate": 0,
      "content": "<p style=\"\">{{title}}</p>",
      "defaultFontName": "思源黑体 CN",
      "defaultColor": "#333"
    },
    {
      "type": "shape",
      "width": 42.39,
      "height": 42.39,
      "left": 576.54,
      "top": 296.91,
      "viewBox": [
        200,
        200
      ],
      "path": "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
      "fill": "rgb(234, 201, 177)",
      "fixedRatio": false,
      "rotate": 0,
      "flipH": false,
      "flipV": false
    },
    {
      "type": "text",
      "width": 65.9,
      "height": 40,
      "left": 584.74,
      "top": 301.89000000000004,
      "rotate": 0,
      "defaultFontName": "思源黑体 CN",
      "defaultColor": "#333",
      "content": "<p style=\"\"><em>04.</em></p>",
      "lineHeight": 1,
      "outline": {
        "color": "#000",
        "width": 0,
        "style": "solid"
      },
      "fill": "",
      "vertical": false
    },
    {
      "type": "text",
      "width": 300,
      "height": 50,
      "left": 641.0228538539416,
      "top": 295.2475973314966,
      "rotate": 0,
      "content": "<p style=\"\">{{title}}</p>",
      "defaultFontName": "思源黑体 CN",
      "defaultColor": "#333"
    },
    {
      "type": "shape",
      "width": 42.39,
      "height": 42.39,
      "left": 199.49,
      "top": 370.91,
      "viewBox": [
        200,
        200
      ],
      "path": "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
      "fill": "rgb(234, 201, 177)",
      "fixedRatio": false,
      "rotate": 0,
      "flipH": false,
      "flipV": false
    },
    {
      "type": "text",
      "width": 65.9,
      "height": 40,
      "left": 207.69,
      "top": 375.89000000000004,
      "rotate": 0,
      "defaultFontName": "思源黑体 CN",
      "defaultColor": "#333",
      "content": "<p style=\"\"><em>05.</em></p>",
      "lineHeight": 1,
      "fill": "",
      "vertical": false
    },
    {
      "type": "text",
      "width": 300,
      "height": 50,
      "left": 266.31,
      "top": 368.2475973314966,
      "rotate": 0,
      "content": "<p style=\"\">{{title}}</p>",
      "defaultFontName": "思源黑体 CN",
      "defaultColor": "#333"
    },
    {
      "type": "shape",
      "width": 42.39,
      "height": 42.39,
      "left": 575.54,
      "top": 370.91,
      "viewBox": [
        200,
        200
      ],
      "path": "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
      "fill": "rgb(234, 201, 177)",
      "fixedRatio": false,
      "rotate": 0,
      "flipH": false,
      "flipV": false
    },
    {
      "type": "text",
      "width": 65.9,
      "height": 40,
      "left": 583.74,
      "top": 375.89000000000004,
      "rotate": 0,
      "defaultFontName": "思源黑体 CN",
      "defaultColor": "#333",
      "content": "<p style=\"\"><em>06.</em></p>",
      "lineHeight": 1,
      "outline": {
        "color": "#000",
        "width": 0,
        "style": "solid"
      },
      "fill": "",
      "vertical": false
    },
    {
      "type": "text",
      "width": 300,
      "height": 50,
      "left": 640.0228538539416,
      "top": 369.2475973314966,
      "rotate": 0,
      "content": "<p style=\"\">{{title}}</p>",
      "defaultFontName": "思源黑体 CN",
      "defaultColor": "#333"
    },
    {
      "type": "shape",
      "width": 42.39,
      "height": 42.39,
      "left": 200.49,
      "top": 439.91,
      "viewBox": [
        200,
        200
      ],
      "path": "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
      "fill": "rgb(234, 201, 177)",
      "fixedRatio": false,
      "rotate": 0,
      "flipH": false,
      "flipV": false
    },
    {
      "type": "text",
      "width": 65.9,
      "height": 40,
      "left": 208.69,
      "top": 444.89000000000004,
      "rotate": 0,
      "defaultFontName": "思源黑体 CN",
      "defaultColor": "#333",
      "content": "<p style=\"\"><em>07.</em></p>",
      "lineHeight": 1,
      "fill": "",
      "vertical": false
    },
    {
      "type": "text",
      "width": 300,
      "height": 50,
      "left": 267.31,
      "top": 437.2475973314966,
      "rotate": 0,
      "content": "<p style=\"\">{{title}}</p>",
      "defaultFontName": "思源黑体 CN",
      "defaultColor": "#333"
    },
    {
      "type": "shape",
      "width": 42.39,
      "height": 42.39,
      "left": 576.54,
      "top": 439.91,
      "viewBox": [
        200,
        200
      ],
      "path": "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
      "fill": "rgb(234, 201, 177)",
      "fixedRatio": false,
      "rotate": 0,
      "flipH": false,
      "flipV": false
    },
    {
      "type": "text",
      "width": 65.9,
      "height": 40,
      "left": 584.74,
      "top": 444.89000000000004,
      "rotate": 0,
      "defaultFontName": "思源黑体 CN",
      "defaultColor": "#333",
      "content": "<p style=\"\"><em>08.</em></p>",
      "lineHeight": 1,
      "outline": {
        "color": "#000",
        "width": 0,
        "style": "solid"
      },
      "fill": "",
      "vertical": false
    },
    {
      "type": "text",
      "width": 300,
      "height": 50,
      "left": 642.0228538539416,
      "top": 438.2475973314966,
      "rotate": 0,
      "content": "<p style=\"\">{{title}}</p>",
      "defaultFontName": "思源黑体 CN",
      "defaultColor": "#333"
    }
  ],
  'max':[
    {
      "type": "shape",
      "width": 42.39,
      "height": 42.39,
      "left": 79.93,
      "top": 217.3,
      "viewBox": [
        200,
        200
      ],
      "path": "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
      "fill": "rgb(234, 201, 177)",
      "fixedRatio": false,
      "rotate": 0,
      "flipH": false,
      "flipV": false
    },
    {
      "type": "text",
      "width": 65.9,
      "height": 40,
      "left": 88.13000000000001,
      "top": 222.28,
      "rotate": 0,
      "defaultFontName": "思源黑体 CN",
      "defaultColor": "#333",
      "content": "<p style=\"\"><span style=\"font-size: 24px;\"><em>01</em>.</span></p>",
      "lineHeight": 1,
      "fill": "",
      "vertical": false
    },
    {
      "type": "text",
      "width": 216.09,
      "height": 50,
      "left": 137.75,
      "top": 215.26000000000002,
      "rotate": 0,
      "content": "<p style=\"\"><span style=\"font-size: 24px;\">{{title}}</span></p>",
      "defaultFontName": "思源黑体 CN",
      "defaultColor": "#333"
    },
    {
      "type": "shape",
      "width": 42.39,
      "height": 42.39,
      "left": 382.95,
      "top": 216.93,
      "viewBox": [
        200,
        200
      ],
      "path": "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
      "fill": "rgb(234, 201, 177)",
      "fixedRatio": false,
      "rotate": 0,
      "flipH": false,
      "flipV": false
    },
    {
      "type": "text",
      "width": 65.9,
      "height": 40,
      "left": 391.15,
      "top": 221.91,
      "rotate": 0,
      "defaultFontName": "思源黑体 CN",
      "defaultColor": "#333",
      "content": "<p style=\"\"><span style=\"font-size: 24px;\"><em>02.</em></span></p>",
      "lineHeight": 1,
      "outline": {
        "color": "#000",
        "width": 0,
        "style": "solid"
      },
      "fill": "",
      "vertical": false
    },
    {
      "type": "text",
      "width": 216.09,
      "height": 50,
      "left": 440.77,
      "top": 214.89000000000001,
      "rotate": 0,
      "content": "<p style=\"\" ><span style=\"font-size: 24px;\">{{title}}</span></p>",
      "defaultFontName": "思源黑体 CN",
      "defaultColor": "#333"
    },
    {
      "type": "shape",
      "width": 42.39,
      "height": 42.39,
      "left": 672.28,
      "top": 217.3,
      "viewBox": [
        200,
        200
      ],
      "path": "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
      "fill": "rgb(234, 201, 177)",
      "fixedRatio": false,
      "rotate": 0,
      "flipH": false,
      "flipV": false
    },
    {
      "type": "text",
      "width": 65.9,
      "height": 40,
      "left": 680.48,
      "top": 222.28,
      "rotate": 0,
      "defaultFontName": "思源黑体 CN",
      "defaultColor": "#333",
      "content": "<p style=\"\"><span style=\"font-size: 24px;\"><em>03.</em></span></p>",
      "lineHeight": 1,
      "outline": {
        "color": "#000",
        "width": 0,
        "style": "solid"
      },
      "fill": "",
      "vertical": false
    },
    {
      "type": "text",
      "width": 216.09,
      "height": 50,
      "left": 730.0999999999999,
      "top": 215.26000000000002,
      "rotate": 0,
      "content": "<p style=\"\"><span style=\"font-size: 24px;\">{{title}}</span></p>",
      "defaultFontName": "思源黑体 CN",
      "defaultColor": "#333"
    },
    {
      "type": "shape",
      "width": 42.39,
      "height": 42.39,
      "left": 78.93,
      "top": 291.3,
      "viewBox": [
        200,
        200
      ],
      "path": "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
      "fill": "rgb(234, 201, 177)",
      "fixedRatio": false,
      "rotate": 0,
      "flipH": false,
      "flipV": false
    },
    {
      "type": "text",
      "width": 65.9,
      "height": 40,
      "left": 87.13000000000001,
      "top": 296.28,
      "rotate": 0,
      "defaultFontName": "思源黑体 CN",
      "defaultColor": "#333",
      "content": "<p style=\"\"><span style=\"font-size: 24px;\"><em>04</em>.</span></p>",
      "lineHeight": 1,
      "fill": "",
      "vertical": false
    },
    {
      "type": "text",
      "width": 216.09,
      "height": 50,
      "left": 136.75,
      "top": 289.26,
      "rotate": 0,
      "content": "<p style=\"\" ><span style=\"font-size: 24px;\">{{title}}</span></p>",
      "defaultFontName": "思源黑体 CN",
      "defaultColor": "#333"
    },
    {
      "type": "shape",
      "width": 42.39,
      "height": 42.39,
      "left": 381.95,
      "top": 290.93,
      "viewBox": [
        200,
        200
      ],
      "path": "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
      "fill": "rgb(234, 201, 177)",
      "fixedRatio": false,
      "rotate": 0,
      "flipH": false,
      "flipV": false
    },
    {
      "type": "text",
      "width": 65.9,
      "height": 40,
      "left": 390.15,
      "top": 295.90999999999997,
      "rotate": 0,
      "defaultFontName": "思源黑体 CN",
      "defaultColor": "#333",
      "content": "<p style=\"\"><span style=\"font-size: 24px;\"><em>05.</em></span></p>",
      "lineHeight": 1,
      "outline": {
        "color": "#000",
        "width": 0,
        "style": "solid"
      },
      "fill": "",
      "vertical": false
    },
    {
      "type": "text",
      "width": 216.09,
      "height": 50,
      "left": 439.77,
      "top": 288.89,
      "rotate": 0,
      "content": "<p style=\"\" ><span style=\"font-size: 24px;\">{{title}}</span></p>",
      "defaultFontName": "思源黑体 CN",
      "defaultColor": "#333"
    },
    {
      "type": "shape",
      "width": 42.39,
      "height": 42.39,
      "left": 671.28,
      "top": 291.3,
      "viewBox": [
        200,
        200
      ],
      "path": "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
      "fill": "rgb(234, 201, 177)",
      "fixedRatio": false,
      "rotate": 0,
      "flipH": false,
      "flipV": false
    },
    {
      "type": "text",
      "width": 65.9,
      "height": 40,
      "left": 679.48,
      "top": 296.28,
      "rotate": 0,
      "defaultFontName": "思源黑体 CN",
      "defaultColor": "#333",
      "content": "<p style=\"\"><span style=\"font-size: 24px;\"><em>06.</em></span></p>",
      "lineHeight": 1,
      "outline": {
        "color": "#000",
        "width": 0,
        "style": "solid"
      },
      "fill": "",
      "vertical": false
    },
    {
      "type": "text",
      "width": 216.09,
      "height": 50,
      "left": 729.0999999999999,
      "top": 289.26,
      "rotate": 0,
      "content": "<p style=\"\" ><span style=\"font-size: 24px;\">{{title}}</span></p>",
      "defaultFontName": "思源黑体 CN",
      "defaultColor": "#333"
    },
    {
      "type": "shape",
      "width": 42.39,
      "height": 42.39,
      "left": 78.93,
      "top": 364.3,
      "viewBox": [
        200,
        200
      ],
      "path": "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
      "fill": "rgb(234, 201, 177)",
      "fixedRatio": false,
      "rotate": 0,
      "flipH": false,
      "flipV": false
    },
    {
      "type": "text",
      "width": 65.9,
      "height": 40,
      "left": 87.13000000000001,
      "top": 369.28,
      "rotate": 0,
      "defaultFontName": "思源黑体 CN",
      "defaultColor": "#333",
      "content": "<p style=\"\" ><span style=\"font-size: 24px;\"><em>07</em>.</span></p>",
      "lineHeight": 1,
      "fill": "",
      "vertical": false
    },
    {
      "type": "text",
      "width": 216.09,
      "height": 50,
      "left": 136.75,
      "top": 362.26,
      "rotate": 0,
      "content": "<p style=\"\" ><span style=\"font-size: 24px;\">{{title}}</span></p>",
      "defaultFontName": "思源黑体 CN",
      "defaultColor": "#333"
    },
    {
      "type": "shape",
      "width": 42.39,
      "height": 42.39,
      "left": 381.95,
      "top": 363.93,
      "viewBox": [
        200,
        200
      ],
      "path": "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
      "fill": "rgb(234, 201, 177)",
      "fixedRatio": false,
      "rotate": 0,
      "flipH": false,
      "flipV": false
    },
    {
      "type": "text",
      "width": 65.9,
      "height": 40,
      "left": 390.15,
      "top": 368.90999999999997,
      "rotate": 0,
      "defaultFontName": "思源黑体 CN",
      "defaultColor": "#333",
      "content": "<p style=\"\"><span style=\"font-size: 24px;\"><em>08.</em></span></p>",
      "lineHeight": 1,
      "outline": {
        "color": "#000",
        "width": 0,
        "style": "solid"
      },
      "fill": "",
      "vertical": false
    },
    {
      "type": "text",
      "width": 216.09,
      "height": 50,
      "left": 439.77,
      "top": 361.89,
      "rotate": 0,
      "content": "<p style=\"\" ><span style=\"font-size: 24px;\">{{title}}</span></p>",
      "defaultFontName": "思源黑体 CN",
      "defaultColor": "#333"
    },
    {
      "type": "shape",
      "width": 42.39,
      "height": 42.39,
      "left": 671.28,
      "top": 364.3,
      "viewBox": [
        200,
        200
      ],
      "path": "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
      "fill": "rgb(234, 201, 177)",
      "fixedRatio": false,
      "rotate": 0,
      "flipH": false,
      "flipV": false
    },
    {
      "type": "text",
      "width": 65.9,
      "height": 40,
      "left": 679.48,
      "top": 369.28,
      "rotate": 0,
      "defaultFontName": "思源黑体 CN",
      "defaultColor": "#333",
      "content": "<p style=\"\"><span style=\"font-size: 24px;\"><em>09.</em></span></p>",
      "lineHeight": 1,
      "outline": {
        "color": "#000",
        "width": 0,
        "style": "solid"
      },
      "fill": "",
      "vertical": false
    },
    {
      "type": "text",
      "width": 216.09,
      "height": 50,
      "left": 729.0999999999999,
      "top": 362.26,
      "rotate": 0,
      "content": "<p style=\"\" ><span style=\"font-size: 24px;\">{{title}}</span></p>",
      "defaultFontName": "思源黑体 CN",
      "defaultColor": "#333"
    },
    {
      "type": "shape",
      "width": 42.39,
      "height": 42.39,
      "left": 78.93,
      "top": 431.3,
      "viewBox": [
        200,
        200
      ],
      "path": "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
      "fill": "rgb(234, 201, 177)",
      "fixedRatio": false,
      "rotate": 0,
      "flipH": false,
      "flipV": false
    },
    {
      "type": "text",
      "width": 65.9,
      "height": 40,
      "left": 87.13000000000001,
      "top": 436.28,
      "rotate": 0,
      "defaultFontName": "思源黑体 CN",
      "defaultColor": "#333",
      "content": "<p style=\"\"><span style=\"font-size: 24px;\"><em>10</em>.</span></p>",
      "lineHeight": 1,
      "fill": "",
      "vertical": false
    },
    {
      "type": "text",
      "width": 216.09,
      "height": 50,
      "left": 136.75,
      "top": 429.26,
      "rotate": 0,
      "content": "<p style=\"\" ><span style=\"font-size: 24px;\">{{title}}</span></p>",
      "defaultFontName": "思源黑体 CN",
      "defaultColor": "#333"
    },
    {
      "type": "shape",
      "width": 42.39,
      "height": 42.39,
      "left": 381.95,
      "top": 430.93,
      "viewBox": [
        200,
        200
      ],
      "path": "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
      "fill": "rgb(234, 201, 177)",
      "fixedRatio": false,
      "rotate": 0,
      "flipH": false,
      "flipV": false
    },
    {
      "type": "text",
      "width": 65.9,
      "height": 40,
      "left": 390.15,
      "top": 435.90999999999997,
      "rotate": 0,
      "defaultFontName": "思源黑体 CN",
      "defaultColor": "#333",
      "content": "<p style=\"\"><span style=\"font-size: 24px;\"><em>11.</em></span></p>",
      "lineHeight": 1,
      "outline": {
        "color": "#000",
        "width": 0,
        "style": "solid"
      },
      "fill": "",
      "vertical": false
    },
    {
      "type": "text",
      "width": 216.09,
      "height": 50,
      "left": 439.77,
      "top": 428.89,
      "rotate": 0,
      "content": "<p style=\"\" ><span style=\"font-size: 24px;\">{{title}}</span></p>",
      "defaultFontName": "思源黑体 CN",
      "defaultColor": "#333"
    },
    {
      "type": "shape",
      "width": 42.39,
      "height": 42.39,
      "left": 671.28,
      "top": 431.3,
      "viewBox": [
        200,
        200
      ],
      "path": "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
      "fill": "rgb(234, 201, 177)",
      "fixedRatio": false,
      "rotate": 0,
      "flipH": false,
      "flipV": false
    },
    {
      "type": "text",
      "width": 65.9,
      "height": 40,
      "left": 679.48,
      "top": 436.28,
      "rotate": 0,
      "defaultFontName": "思源黑体 CN",
      "defaultColor": "#333",
      "content": "<p style=\"\"><span style=\"font-size: 24px;\"><em>12.</em></span></p>",
      "lineHeight": 1,
      "outline": {
        "color": "#000",
        "width": 0,
        "style": "solid"
      },
      "fill": "",
      "vertical": false
    },
    {
      "type": "text",
      "width": 220.09000000000003,
      "height": 50,
      "left": 726.0999999999999,
      "top": 429.26,
      "rotate": 0,
      "content": "<p style=\"\" ><span style=\"font-size: 24px;\">{{title}}</span></p>",
      "defaultFontName": "思源黑体 CN",
      "defaultColor": "#333"
    }
  ]

 },
 '8':{
  manyLenght:[4,4,4],
  'few':[
  {
    "type": "shape",
    "left": 135.73126040250537,
    "top": 195.50355749695825,
    "width": 336.95080576759966,
    "height": 80.57675996607294,
    "viewBox": [
      336.95080576759966,
      80.57675996607294
    ],
    "path": "M 12.19253604749788 0 L 324.7582697201018 0 Q 336.95080576759966 0 336.95080576759966 12.19253604749788 L 336.95080576759966 68.38422391857506 Q 336.95080576759966 80.57675996607294 324.7582697201018 80.57675996607294 L 12.19253604749788 80.57675996607294 Q 0 80.57675996607294 0 68.38422391857506 L 0 12.19253604749788 Q 0 0 12.19253604749788 0 Z",
    "fill": "rgba(197,227,255,1)",
    "fixedRatio": false,
    "rotate": 0,
    "pathFormula": "roundRect",
    "keypoints": [
      0.1513157894736842
    ]
  },
  {
    "type": "shape",
    "left": 111.25347242192231,
    "top": 210.1235508340718,
    "width": 54,
    "height": 54,
    "viewBox": [
      200,
      200
    ],
    "path": "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
    "fill": "#5b9bd5",
    "fixedRatio": false,
    "rotate": 0,
   
  },
  {
    "type": "text",
    "left": 111.25347242192231,
    "top": 210.1235508340718,
    "width": 56,
    "height": 54,
    "rotate": 0,
    "content": "<p style=\"text-align: center;\"><strong><span style=\"font-size: 28px;\"><span style=\"color: rgb(255, 255, 255);\">01</span></span></strong></p>",
    "defaultFontName": "思源黑体 CN",
    "defaultColor": "#000",
    "vertical": false,
    "lineHeight": 1
  },
  {
    "type": "text",
    "left": 167.5378761785868,
    "top": 209,
    "width": 285,
    "height": 52.5,
    "content": "<p style=\"text-align: center;\"><span style=\"font-size: 32px;\"><span style=\"font-family: Arial;\">{{title}}</span></span></p>",
    "rotate": 0,
    "defaultFontName": "思源黑体 CN",
    "defaultColor": "#333",
    "vertical": false,
    "lineHeight": 1
  },

  {
    "type": "shape",
    "left": 551.7957218104782,
    "top": 195.50355749695825,
    "width": 336.95080576759966,
    "height": 80.57675996607294,
    "viewBox": [
      336.95080576759966,
      80.57675996607294
    ],
    "path": "M 12.19253604749788 0 L 324.7582697201018 0 Q 336.95080576759966 0 336.95080576759966 12.19253604749788 L 336.95080576759966 68.38422391857506 Q 336.95080576759966 80.57675996607294 324.7582697201018 80.57675996607294 L 12.19253604749788 80.57675996607294 Q 0 80.57675996607294 0 68.38422391857506 L 0 12.19253604749788 Q 0 0 12.19253604749788 0 Z",
    "fill": "rgba(197,227,255,1)",
    "fixedRatio": false,
    "rotate": 0,
    "pathFormula": "roundRect",
    "keypoints": [
      0.1513157894736842
    ]
  },
  {
    "type": "shape",
    "left": 527.3179338298951,
    "top": 210.1235508340718,
    "width": 54,
    "height": 54,
    "viewBox": [
      200,
      200
    ],
    "path": "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
    "fill": "#5b9bd5",
    "fixedRatio": false,
    "rotate": 0,
   
  },
  {
    "type": "text",
    "left": 527.3179338298951,
    "top": 210.1235508340718,
    "width": 56,
    "height": 54,
    "rotate": 0,
    "content": "<p style=\"text-align: center;\"><strong><span style=\"font-size: 28px;\"><span style=\"color: rgb(255, 255, 255);\">02</span></span></strong></p>",
    "defaultFontName": "思源黑体 CN",
    "defaultColor": "#333",
    "vertical": false,
    "lineHeight": 1
  },
  {
    "type": "text",
    "left": 583.6023375865592,
    "top": 209,
    "width": 285,
    "height": 52.5,
    "content": "<p style=\"text-align: center;\"><span style=\"font-size: 32px;\"><span style=\"font-family: Arial;\">{{title}}</span></span></p>",
    "rotate": 0,
    "defaultFontName": "思源黑体 CN",
    "defaultColor": "#333",
    "vertical": false,
    "lineHeight": 1
  },
  {
    "type": "shape",
    "left": 135.73126040250537,
    "top": 314.7062716615045,
    "width": 336.95080576759966,
    "height": 80.57675996607294,
    "viewBox": [
      336.95080576759966,
      80.57675996607294
    ],
    "path": "M 12.19253604749788 0 L 324.7582697201018 0 Q 336.95080576759966 0 336.95080576759966 12.19253604749788 L 336.95080576759966 68.38422391857506 Q 336.95080576759966 80.57675996607294 324.7582697201018 80.57675996607294 L 12.19253604749788 80.57675996607294 Q 0 80.57675996607294 0 68.38422391857506 L 0 12.19253604749788 Q 0 0 12.19253604749788 0 Z",
    "fill": "rgba(197,227,255,1)",
    "fixedRatio": false,
    "rotate": 0,
    "pathFormula": "roundRect",
    "keypoints": [
      0.1513157894736842
    ]
  },
  {
    "type": "shape",
    "left": 111.25347242192231,
    "top": 329.32626499861806,
    "width": 54,
    "height": 51.3,
    "viewBox": [
      200,
      200
    ],
    "path": "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
    "fill": "#5b9bd5",
    "fixedRatio": false,
    "rotate": 0,
   
  },
  {
    "type": "text",
    "left": 111.25347242192231,
    "top": 329.32626499861806,
    "width": 56,
    "height": 51.3,
    "rotate": 0,
    "content": "<p style=\"text-align: center;\"><strong><span style=\"font-size: 28px;\"><span style=\"color: rgb(255, 255, 255);\">03</span></span></strong></p>",
    "defaultFontName": "思源黑体 CN",
    "defaultColor": "#333",
    "vertical": false,
    "lineHeight": 1
  },
  {
    "type": "text",
    "left": 167.5378761785868,
    "top": 328,
    "width": 285,
    "height": 52.5,
    "content": "<p style=\"text-align: center;\"><span style=\"font-size: 32px;\"><span style=\"font-family: Arial;\">{{title}}</span></span></p>",
    "rotate": 0,
    "defaultFontName": "思源黑体 CN",
    "defaultColor": "#333",
    "vertical": false,
    "lineHeight": 1
  },
  {
    "type": "shape",
    "left": 551.7957218104782,
    "top": 314.7062716615045,
    "width": 336.95080576759966,
    "height": 80.57675996607294,
    "viewBox": [
      336.95080576759966,
      80.57675996607294
    ],
    "path": "M 12.19253604749788 0 L 324.7582697201018 0 Q 336.95080576759966 0 336.95080576759966 12.19253604749788 L 336.95080576759966 68.38422391857506 Q 336.95080576759966 80.57675996607294 324.7582697201018 80.57675996607294 L 12.19253604749788 80.57675996607294 Q 0 80.57675996607294 0 68.38422391857506 L 0 12.19253604749788 Q 0 0 12.19253604749788 0 Z",
    "fill": "rgba(197,227,255,1)",
    "fixedRatio": false,
    "rotate": 0,
    "pathFormula": "roundRect",
    "keypoints": [
      0.1513157894736842
    ]
  },
  {
    "type": "shape",
    "left": 527.3,
    "top": 329.32626499861806,
    "width": 54,
    "height": 54,
    "viewBox": [
      200,
      200
    ],
    "path": "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
    "fill": "#5b9bd5",
    "fixedRatio": false,
    "rotate": 0,
   
  },
  {
    "type": "text",
    "left": 527.3,
    "top": 329.32626499861806,
    "width": 56,
    "height": 54,
    "rotate": 0,
    "content": "<p style=\"text-align: center;\"><strong><span style=\"font-size: 28px;\"><span style=\"color: rgb(255, 255, 255);\">04</span></span></strong></p>",
    "defaultFontName": "思源黑体 CN",
    "defaultColor": "#333",
    "vertical": false,
    "lineHeight": 1
  },
  {
    "type": "text",
    "left": 583.6023375865592,
    "top": 328,
    "width": 285,
    "height": 52.5,
    "content": "<p style=\"text-align: center;\"><span style=\"font-size: 32px;\"><span style=\"font-family: Arial;\">{{title}}</span></span></p>",
    "rotate": 0,
    "defaultFontName": "思源黑体 CN",
    "defaultColor": "#333",
    "vertical": false,
    "lineHeight": 1
  }
],
'many':[
  {
    "type": "shape",
    "left": 151.23291476920602,
    "top": 160.62489666142793,
    "width": 301.9635284139101,
    "height": 66.53837998303645,
    "viewBox": [
      301.9635284139101,
      66.53837998303645
    ],
    "path": "M 12.72264631043257 0 L 289.24088210347753 0 Q 301.9635284139101 0 301.9635284139101 12.72264631043257 L 301.9635284139101 53.81573367260388 Q 301.9635284139101 66.53837998303645 289.24088210347753 66.53837998303645 L 12.72264631043257 66.53837998303645 Q 0 66.53837998303645 0 53.81573367260388 L 0 12.72264631043257 Q 0 0 12.72264631043257 0 Z",
    "fill": "rgba(197,227,255,1)",
    "fixedRatio": false,
    "rotate": 0,
    "pathFormula": "roundRect",
    "keypoints": [
      0.19120763555824669
    ]
  },
  {
    "type": "shape",
    "left": 130.8340178895957,
    "top": 166.89408665294616,
    "width": 54,
    "height": 54,
    "viewBox": [
      200,
      200
    ],
    "path": "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
    "fill": "#5b9bd5",
    "fixedRatio": false,
    "rotate": 0,
  
  },
  {
    "type": "text",
    "left": 130.8340178895957,
    "top": 166.89408665294616,
    "width": 56,
    "height": 54,
    "rotate": 0,
    "content": "<p style=\"text-align: center;\"><strong><span style=\"font-size: 28px;\"><span style=\"color: rgb(255, 255, 255);\">01</span></span></strong></p>",
    "defaultFontName": "思源黑体 CN",
    "defaultColor": "#333",
    "vertical": false,
    "lineHeight": 1
  },
  {
    "type": "text",
    "left": 180.2771646184209,
    "top": 168,
    "width": 252,
    "height": 48.5,
    "content": "<p style=\"text-align: center;\"><span style=\"font-size: 28px;\"><span style=\"font-family: Arial;\">{{title}}</span></span></p>",
    "rotate": 0,
    "defaultFontName": "思源黑体 CN",
    "defaultColor": "#333",
    "vertical": false,
    "lineHeight": 1
  },
  {
    "type": "shape",
    "left": 151.23291476920602,
    "top": 247.3521912189478,
    "width": 301.9635284139101,
    "height": 66.53837998303645,
    "viewBox": [
      301.9635284139101,
      66.53837998303645
    ],
    "path": "M 12.72264631043257 0 L 289.24088210347753 0 Q 301.9635284139101 0 301.9635284139101 12.72264631043257 L 301.9635284139101 53.81573367260388 Q 301.9635284139101 66.53837998303645 289.24088210347753 66.53837998303645 L 12.72264631043257 66.53837998303645 Q 0 66.53837998303645 0 53.81573367260388 L 0 12.72264631043257 Q 0 0 12.72264631043257 0 Z",
    "fill": "rgba(197,227,255,1)",
    "fixedRatio": false,
    "rotate": 0,
    "pathFormula": "roundRect",
    "keypoints": [
      0.19120763555824669
    ]
  },
  {
    "type": "shape",
    "left": 130.8340178895957,
    "top": 253.62138121046607,
    "width": 54,
    "height": 54,
    "viewBox": [
      200,
      200
    ],
    "path": "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
    "fill": "#5b9bd5",
    "fixedRatio": false,
    "rotate": 0,
   
  },
  {
    "type": "text",
    "left": 130.8340178895957,
    "top": 253.62138121046607,
    "width": 56,
    "height": 54,
    "content": "<p style=\"text-align: center;\"><strong><span style=\"font-size: 28px;\"><span style=\"color: rgb(255, 255, 255);\">02</span></span></strong></p>",
      "defaultFontName": "思源黑体 CN",
      "rotate": 0,
    "defaultColor": "#333",
    "vertical": false,
    "lineHeight": 1
  },
  {
    "type": "text",
    "left": 180.2771646184209,
    "top": 255,
    "width": 252,
    "height": 48.5,
    "content": "<p style=\"text-align: center;\"><span style=\"font-size: 28px;\"><span style=\"font-family: Arial;\">{{title}}</span></span></p>",
    "rotate": 0,
    "defaultFontName": "思源黑体 CN",
    "defaultColor": "#333",
    "vertical": false,
    "lineHeight": 1
  },
  {
    "type": "shape",
    "left": 151.23291476920602,
    "top": 334.07948577646766,
    "width": 301.9635284139101,
    "height": 66.53837998303645,
    "viewBox": [
      301.9635284139101,
      66.53837998303645
    ],
    "path": "M 12.72264631043257 0 L 289.24088210347753 0 Q 301.9635284139101 0 301.9635284139101 12.72264631043257 L 301.9635284139101 53.81573367260388 Q 301.9635284139101 66.53837998303645 289.24088210347753 66.53837998303645 L 12.72264631043257 66.53837998303645 Q 0 66.53837998303645 0 53.81573367260388 L 0 12.72264631043257 Q 0 0 12.72264631043257 0 Z",
    "fill": "rgba(197,227,255,1)",
    "fixedRatio": false,
    "rotate": 0,
    "pathFormula": "roundRect",
    "keypoints": [
      0.19120763555824669
    ]
  },
  {
    "type": "shape",
    "left": 130.8340178895957,
    "top": 340.3486757679859,
    "width": 54,
    "height": 54,
    "viewBox": [
      200,
      200
    ],
    "path": "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
    "fill": "#5b9bd5",
    "fixedRatio": false,
    "rotate": 0,
   
  },
  {
    "type": "text",
    "left": 130.8340178895957,
    "top": 340.3486757679859,
    "width": 56,
    "height": 54,
    "rotate": 0,
    "content": "<p style=\"text-align: center;\"><strong><span style=\"font-size: 28px;\"><span style=\"color: rgb(255, 255, 255);\">03</span></span></strong></p>",
    "defaultFontName": "思源黑体 CN",
    "defaultColor": "#333",
    "vertical": false,
    "lineHeight": 1
  },
  {
    "type": "text",
    "left": 180.2771646184209,
    "top": 340,
    "width": 252,
    "height": 48.5,
    "content": "<p style=\"text-align: center;\"><span style=\"font-size: 28px;\"><span style=\"font-family: Arial;\">{{title}}</span></span></p>",
    "rotate": 0,
    "defaultFontName": "思源黑体 CN",
    "defaultColor": "#333",
    "vertical": false,
    "lineHeight": 1
  },
  {
    "type": "shape",
    "left": 151.23291476920596,
    "top": 420.8067803339876,
    "width": 301.9635284139101,
    "height": 66.53837998303645,
    "viewBox": [
      301.9635284139101,
      66.53837998303645
    ],
    "path": "M 12.72264631043257 0 L 289.24088210347753 0 Q 301.9635284139101 0 301.9635284139101 12.72264631043257 L 301.9635284139101 53.81573367260388 Q 301.9635284139101 66.53837998303645 289.24088210347753 66.53837998303645 L 12.72264631043257 66.53837998303645 Q 0 66.53837998303645 0 53.81573367260388 L 0 12.72264631043257 Q 0 0 12.72264631043257 0 Z",
    "fill": "rgba(197,227,255,1)",
    "fixedRatio": false,
    "rotate": 0,
    "pathFormula": "roundRect",
    "keypoints": [
      0.19120763555824669
    ]
  },
  {
    "type": "shape",
    "left": 130.83401788959566,
    "top": 427.07597032550586,
    "width": 54,
    "height": 54,
    "viewBox": [
      200,
      200
    ],
    "path": "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
    "fill": "#5b9bd5",
    "fixedRatio": false,
    "rotate": 0,
   
  },
  {
    "type": "text",
    "left": 130.83401788959566,
    "top": 427.07597032550586,
    "width": 56,
    "height": 54,
    "rotate": 0,
    "content": "<p style=\"text-align: center;\"><strong><span style=\"font-size: 28px;\"><span style=\"color: rgb(255, 255, 255);\">04</span></span></strong></p>",
      "defaultFontName": "思源黑体 CN",
    "defaultColor": "#333",
    "vertical": false,
    "lineHeight": 1
  },
  {
    "type": "text",
    "left": 180.27716461842095,
    "top": 428,
    "width": 252,
    "height": 48.5,
    "content": "<p style=\"text-align: center;\"><span style=\"font-size: 28px;\"><span style=\"font-family: Arial;\">{{title}}</span></span></p>",
    "rotate": 0,
    "defaultFontName": "思源黑体 CN",
    "defaultColor": "#333",
    "vertical": false,
    "lineHeight": 1
  },
  {
    "type": "shape",
    "left": 538.6714219787056,
    "top": 160.62489666142793,
    "width": 301.9635284139101,
    "height": 66.53837998303645,
    "viewBox": [
      301.9635284139101,
      66.53837998303645
    ],
    "path": "M 12.72264631043257 0 L 289.24088210347753 0 Q 301.9635284139101 0 301.9635284139101 12.72264631043257 L 301.9635284139101 53.81573367260388 Q 301.9635284139101 66.53837998303645 289.24088210347753 66.53837998303645 L 12.72264631043257 66.53837998303645 Q 0 66.53837998303645 0 53.81573367260388 L 0 12.72264631043257 Q 0 0 12.72264631043257 0 Z",
    "fill": "rgba(197,227,255,1)",
    "fixedRatio": false,
    "rotate": 0,
    "pathFormula": "roundRect",
    "keypoints": [
      0.19120763555824669
    ]
  },
  {
    "type": "shape",
    "left": 518.2725250990952,
    "top": 166.89408665294616,
    "width": 54,
    "height": 54,
    "viewBox": [
      200,
      200
    ],
    "path": "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
    "fill": "#5b9bd5",
    "fixedRatio": false,
    "rotate": 0,
   
  },
  {
    "type": "text",
    "left": 518.2725250990952,
    "top": 166.89408665294616,
    "width": 56,
    "height": 54,
    "rotate": 0,
    "content": "<p style=\"text-align: center;\"><strong><span style=\"font-size: 28px;\"><span style=\"color: rgb(255, 255, 255);\">05</span></span></strong></p>",
    "defaultFontName": "思源黑体 CN",
    "defaultColor": "#333",
    "vertical": false,
    "lineHeight": 1
  },
  {
    "type": "text",
    "left": 567.7156718279205,
    "top": 168,
    "width": 252,
    "height": 48.5,
    "content": "<p style=\"text-align: center;\"><span style=\"font-size: 28px;\"><span style=\"font-family: Arial;\">{{title}}</span></span></p>",
    "rotate": 0,
    "defaultFontName": "思源黑体 CN",
    "defaultColor": "#333",
    "vertical": false,
    "lineHeight": 1
  },
  {
    "type": "shape",
    "left": 538.6714219787056,
    "top": 247.35219121894784,
    "width": 301.9635284139101,
    "height": 66.53837998303645,
    "viewBox": [
      301.9635284139101,
      66.53837998303645
    ],
    "path": "M 12.72264631043257 0 L 289.24088210347753 0 Q 301.9635284139101 0 301.9635284139101 12.72264631043257 L 301.9635284139101 53.81573367260388 Q 301.9635284139101 66.53837998303645 289.24088210347753 66.53837998303645 L 12.72264631043257 66.53837998303645 Q 0 66.53837998303645 0 53.81573367260388 L 0 12.72264631043257 Q 0 0 12.72264631043257 0 Z",
    "fill": "rgba(197,227,255,1)",
    "fixedRatio": false,
    "rotate": 0,
    "pathFormula": "roundRect",
    "keypoints": [
      0.19120763555824669
    ]
  },
  {
    "type": "shape",
    "left": 518.2725250990952,
    "top": 253.6213812104661,
    "width": 54,
    "height": 54,
    "viewBox": [
      200,
      200
    ],
    "path": "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
    "fill": "#5b9bd5",
    "fixedRatio": false,
    "rotate": 0,
   
  },
  {
    "type": "text",
    "left": 518.2725250990952,
    "top": 253.6213812104661,
    "width": 56,
    "height": 54,
    "content": "<p style=\"text-align: center;\"><strong><span style=\"font-size: 28px;\"><span style=\"color: rgb(255, 255, 255);\">06</span></span></strong></p>",
    "defaultFontName": "思源黑体 CN",
    "rotate": 0,
    "defaultColor": "#333",
    "vertical": false,
    "lineHeight": 1
  },
  {
    "type": "text",
    "left": 567.7156718279205,
    "top": 255,
    "width": 252,
    "height": 48.5,
    "content": "<p style=\"text-align: center;\"><span style=\"font-size: 28px;\"><span style=\"font-family: Arial;\">{{title}}</span></span></p>",
    "rotate": 0,
    "defaultFontName": "思源黑体 CN",
    "defaultColor": "#333",
    "vertical": false,
    "lineHeight": 1
  },
  {
    "type": "shape",
    "left": 538.6714219787056,
    "top": 334.07948577646766,
    "width": 301.9635284139101,
    "height": 66.53837998303645,
    "viewBox": [
      301.9635284139101,
      66.53837998303645
    ],
    "path": "M 12.72264631043257 0 L 289.24088210347753 0 Q 301.9635284139101 0 301.9635284139101 12.72264631043257 L 301.9635284139101 53.81573367260388 Q 301.9635284139101 66.53837998303645 289.24088210347753 66.53837998303645 L 12.72264631043257 66.53837998303645 Q 0 66.53837998303645 0 53.81573367260388 L 0 12.72264631043257 Q 0 0 12.72264631043257 0 Z",
    "fill": "rgba(197,227,255,1)",
    "fixedRatio": false,
    "rotate": 0,
    "pathFormula": "roundRect",
    "keypoints": [
      0.19120763555824669
    ]
  },
  {
    "type": "shape",
    "left": 518.2725250990952,
    "top": 340.3486757679859,
    "width": 54,
    "height": 54,
    "viewBox": [
      200,
      200
    ],
    "path": "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
    "fill": "#5b9bd5",
    "fixedRatio": false,
    "rotate": 0,
   
  },
  {
    "type": "text",
    "left": 518.2725250990952,
    "top": 340.3486757679859,
    "width": 56,
    "height": 54,
    "rotate": 0,
    "content": "<p style=\"text-align: center;\"><strong><span style=\"font-size: 28px;\"><span style=\"color: rgb(255, 255, 255);\">07</span></span></strong></p>",
    "defaultFontName": "思源黑体 CN",
    "defaultColor": "#333",
    "vertical": false,
    "lineHeight": 1
  },
  {
    "type": "text",
    "left": 567.7156718279205,
    "top": 342,
    "width": 252,
    "height": 48.5,
    "content": "<p style=\"text-align: center;\"><span style=\"font-size: 28px;\"><span style=\"font-family: Arial;\">{{title}}</span></span></p>",
    "rotate": 0,
    "defaultFontName": "思源黑体 CN",
    "defaultColor": "#333",
    "vertical": false,
    "lineHeight": 1
  },
  {
    "type": "shape",
    "left": 538.6714219787056,
    "top": 420.8067803339876,
    "width": 301.9635284139101,
    "height": 66.53837998303645,
    "viewBox": [
      301.9635284139101,
      66.53837998303645
    ],
    "path": "M 12.72264631043257 0 L 289.24088210347753 0 Q 301.9635284139101 0 301.9635284139101 12.72264631043257 L 301.9635284139101 53.81573367260388 Q 301.9635284139101 66.53837998303645 289.24088210347753 66.53837998303645 L 12.72264631043257 66.53837998303645 Q 0 66.53837998303645 0 53.81573367260388 L 0 12.72264631043257 Q 0 0 12.72264631043257 0 Z",
    "fill": "rgba(197,227,255,1)",
    "fixedRatio": false,
    "rotate": 0,
    "pathFormula": "roundRect",
    "keypoints": [
      0.19120763555824669
    ]
  },
  {
    "type": "shape",
    "left": 518.2725250990952,
    "top": 427.07597032550586,
    "width": 54,
    "height": 54,
    "viewBox": [
      200,
      200
    ],
    "path": "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
    "fill": "#5b9bd5",
    "fixedRatio": false,
    "rotate": 0,
   
  },
  {
    "type": "text",
    "left": 518.2725250990952,
    "top": 427.07597032550586,
    "width": 56,
    "height": 54,
    "rotate": 0,
    "content": "<p style=\"text-align: center;\"><strong><span style=\"font-size: 28px;\"><span style=\"color: rgb(255, 255, 255);\">08</span></span></strong></p>",
      "defaultFontName": "思源黑体 CN",
    "defaultColor": "#333",
    "vertical": false,
    "lineHeight": 1
  },
  {
    "type": "text",
    "left": 567.7156718279205,
    "top": 428,
    "width": 252,
    "height": 48.5,
    "content": "<p style=\"text-align: center;\"><span style=\"font-size: 28px;\"><span style=\"font-family: Arial;\">{{title}}</span></span></p>",
    "rotate": 0,
    "defaultFontName": "思源黑体 CN",
    "defaultColor": "#333",
    "vertical": false,
    "lineHeight": 1
  }
],
'max':[
  {
    "type": "shape",
    "left": 59.407933211574964,
    "top": 160.62489666142793,
    "width": 242.60110312038972,
    "height": 55.93617472434264,
    "viewBox": [
      242.60110312038972,
      55.93617472434264
    ],
    "path": "M 10.695423711214518 0 L 231.9056794091752 0 Q 242.60110312038972 0 242.60110312038972 10.695423711214518 L 242.60110312038972 45.240751013128126 Q 242.60110312038972 55.93617472434264 231.9056794091752 55.93617472434264 L 10.695423711214518 55.93617472434264 Q 0 55.93617472434264 0 45.240751013128126 L 0 10.695423711214518 Q 0 0 10.695423711214518 0 Z",
    "fill": "rgba(197,227,255,1)",
    "fixedRatio": false,
    "rotate": 0,
    "pathFormula": "roundRect",
    "keypoints": [
      0.19120763555824669
    ]
  },
  {
    "type": "shape",
    "left": 39.00903633196466,
    "top": 166.89408665294616,
    "width": 44,
    "height": 44,
    "viewBox": [
      200,
      200
    ],
    "path": "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
    "fill": "#5b9bd5",
    "fixedRatio": true,
    "rotate": 0,
   
  },
  {
    "type": "text",
    "left": 38,
    "top": 161,
    "width": 46,
    "height": 44,
    "rotate": 0,
    "content": "<p style=\"text-align: center;\"><strong><span style=\"font-size: 20px;\"><span style=\"color: rgb(255, 255, 255);\">01</span></span></strong></p>",
      "defaultFontName": "思源黑体 CN",
    "defaultColor": "#333",
    "vertical": false,
    "lineHeight": 1
  },
  {
    "type": "text",
    "left": 77.70793370261774,
    "top": 160,
    "width": 219,
    "height": 44.5,
    "content": "<p style=\"text-align: center;\"><span style=\"font-size: 24px;\"><span style=\"font-family: Arial;\">{{title}}</span></span></p>",
    "rotate": 0,
    "defaultFontName": "思源黑体 CN",
    "defaultColor": "#333",
    "vertical": false,
    "lineHeight": 1
  },
  {
    "type": "shape",
    "left": 59.407933211574964,
    "top": 247.3141813659798,
    "width": 242.60110312038972,
    "height": 55.93617472434264,
    "viewBox": [
      242.60110312038972,
      55.93617472434264
    ],
    "path": "M 10.695423711214518 0 L 231.9056794091752 0 Q 242.60110312038972 0 242.60110312038972 10.695423711214518 L 242.60110312038972 45.240751013128126 Q 242.60110312038972 55.93617472434264 231.9056794091752 55.93617472434264 L 10.695423711214518 55.93617472434264 Q 0 55.93617472434264 0 45.240751013128126 L 0 10.695423711214518 Q 0 0 10.695423711214518 0 Z",
    "fill": "rgba(197,227,255,1)",
    "fixedRatio": false,
    "rotate": 0,
    "pathFormula": "roundRect",
    "keypoints": [
      0.19120763555824669
    ]
  },
  {
    "type": "shape",
    "left": 39.00903633196466,
    "top": 253.58337135749804,
    "width": 44,
    "height": 44,
    "viewBox": [
      200,
      200
    ],
    "path": "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
    "fill": "#5b9bd5",
    "fixedRatio": true,
    "rotate": 0,
   
  },
  {
    "type": "text",
    "left": 38,
    "top": 247,
    "width": 46,
    "height": 44,
    "rotate": 0,
    "content": "<p style=\"text-align: center;\"><strong><span style=\"font-size: 20px;\"><span style=\"color: rgb(255, 255, 255);\">02</span></span></strong></p>",
      "defaultFontName": "思源黑体 CN",
    "defaultColor": "#333",
    "vertical": false,
    "lineHeight": 1
  },
  {
    "type": "text",
    "left": 77.70793370261777,
    "top": 247,
    "width": 219,
    "height": 44.5,
    "content": "<p style=\"text-align: center;\"><span style=\"font-size: 24px;\"><span style=\"font-family: Arial;\">{{title}}</span></span></p>",
    "rotate": 0,
    "defaultFontName": "思源黑体 CN",
    "defaultColor": "#333",
    "vertical": false,
    "lineHeight": 1
  },
  {
    "type": "shape",
    "left": 59.40793321157497,
    "top": 334.0034660705317,
    "width": 242.60110312038972,
    "height": 55.93617472434264,
    "viewBox": [
      242.60110312038972,
      55.93617472434264
    ],
    "path": "M 10.695423711214518 0 L 231.9056794091752 0 Q 242.60110312038972 0 242.60110312038972 10.695423711214518 L 242.60110312038972 45.240751013128126 Q 242.60110312038972 55.93617472434264 231.9056794091752 55.93617472434264 L 10.695423711214518 55.93617472434264 Q 0 55.93617472434264 0 45.240751013128126 L 0 10.695423711214518 Q 0 0 10.695423711214518 0 Z",
    "fill": "rgba(197,227,255,1)",
    "fixedRatio": false,
    "rotate": 0,
    "pathFormula": "roundRect",
    "keypoints": [
      0.19120763555824669
    ]
  },
  {
    "type": "shape",
    "left": 39.00903633196466,
    "top": 340.27265606205,
    "width": 44,
    "height": 44,
    "viewBox": [
      200,
      200
    ],
    "path": "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
    "fill": "#5b9bd5",
    "fixedRatio": true,
    "rotate": 0,
   
  },
  {
    "type": "text",
    "left": 38,
    "top": 335,
    "width": 46,
    "height": 44,
    "rotate": 0,
    "content": "<p style=\"text-align: center;\"><strong><span style=\"font-size: 20px;\"><span style=\"color: rgb(255, 255, 255);\">03</span></span></strong></p>",
      "defaultFontName": "思源黑体 CN",
    "defaultColor": "#333",
    "vertical": false,
    "lineHeight": 1
  },
  {
    "type": "text",
    "left": 77.70793370261777,
    "top": 334,
    "width": 219,
    "height": 44.5,
    "content": "<p style=\"text-align: center;\"><span style=\"font-size: 24px;\"><span style=\"font-family: Arial;\">{{title}}</span></span></p>",
    "rotate": 0,
    "defaultFontName": "思源黑体 CN",
    "defaultColor": "#333",
    "vertical": false,
    "lineHeight": 1
  },
  {
    "type": "shape",
    "left": 59.40793321157497,
    "top": 420.69275077508365,
    "width": 242.60110312038972,
    "height": 55.93617472434264,
    "viewBox": [
      242.60110312038972,
      55.93617472434264
    ],
    "path": "M 10.695423711214518 0 L 231.9056794091752 0 Q 242.60110312038972 0 242.60110312038972 10.695423711214518 L 242.60110312038972 45.240751013128126 Q 242.60110312038972 55.93617472434264 231.9056794091752 55.93617472434264 L 10.695423711214518 55.93617472434264 Q 0 55.93617472434264 0 45.240751013128126 L 0 10.695423711214518 Q 0 0 10.695423711214518 0 Z",
    "fill": "rgba(197,227,255,1)",
    "fixedRatio": false,
    "rotate": 0,
    "pathFormula": "roundRect",
    "keypoints": [
      0.19120763555824669
    ]
  },
  {
    "type": "shape",
    "left": 39.00903633196466,
    "top": 426.9619407666019,
    "width": 44,
    "height": 44,
    "viewBox": [
      200,
      200
    ],
    "path": "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
    "fill": "#5b9bd5",
    "fixedRatio": true,
    "rotate": 0,
   
  },
  {
    "type": "text",
    "left": 38,
    "top": 421,
    "width": 46,
    "height": 44,
    "rotate": 0,
    "content": "<p style=\"text-align: center;\"><strong><span style=\"font-size: 20px;\"><span style=\"color: rgb(255, 255, 255);\">04</span></span></strong></p>",
    "defaultFontName": "思源黑体 CN",
    "defaultColor": "#333",
    "vertical": false,
    "lineHeight": 1
  },
  {
    "type": "text",
    "left": 77.70793370261777,
    "top": 420,
    "width": 219,
    "height": 44.5,
    "content": "<p style=\"text-align: center;\"><span style=\"font-size: 24px;\"><span style=\"font-family: Arial;\">{{title}}</span></span></p>",
    "rotate": 0,
    "defaultFontName": "思源黑体 CN",
    "defaultColor": "#333",
    "vertical": false,
    "lineHeight": 1
  },

  {
    "type": "shape",
    "left": 386.98059938055013,
    "top": 160.62489666142793,
    "width": 242.60110312038972,
    "height": 55.93617472434264,
    "viewBox": [
      242.60110312038972,
      55.93617472434264
    ],
    "path": "M 10.695423711214518 0 L 231.9056794091752 0 Q 242.60110312038972 0 242.60110312038972 10.695423711214518 L 242.60110312038972 45.240751013128126 Q 242.60110312038972 55.93617472434264 231.9056794091752 55.93617472434264 L 10.695423711214518 55.93617472434264 Q 0 55.93617472434264 0 45.240751013128126 L 0 10.695423711214518 Q 0 0 10.695423711214518 0 Z",
    "fill": "rgba(197,227,255,1)",
    "fixedRatio": false,
    "rotate": 0,
    "pathFormula": "roundRect",
    "keypoints": [
      0.19120763555824669
    ]
  },
  {
    "type": "shape",
    "left": 366.58170250093985,
    "top": 166.89408665294616,
    "width": 44,
    "height": 44,
    "viewBox": [
      200,
      200
    ],
    "path": "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
    "fill": "#5b9bd5",
    "fixedRatio": true,
    "rotate": 0,
   
  },
  {
    "type": "text",
    "left": 366,
    "top": 161,
    "width": 46,
    "height": 44,
    "rotate": 0,
    "content": "<p style=\"text-align: center;\"><strong><span style=\"font-size: 20px;\"><span style=\"color: rgb(255, 255, 255);\">05</span></span></strong></p>",
    "defaultFontName": "思源黑体 CN",
    "defaultColor": "#333",
    "vertical": false,
    "lineHeight": 1
  },
  {
    "type": "text",
    "left": 405.2805998715929,
    "top": 160,
    "width": 219,
    "height": 44.5,
    "content": "<p style=\"text-align: center;\"><span style=\"font-size: 24px;\"><span style=\"font-family: Arial;\">{{title}}</span></span></p>",
    "rotate": 0,
    "defaultFontName": "思源黑体 CN",
    "defaultColor": "#333",
    "vertical": false,
    "lineHeight": 1
  },
  {
    "type": "shape",
    "left": 388.89889687961033,
    "top": 247.3141813659798,
    "width": 242.60110312038972,
    "height": 55.93617472434264,
    "viewBox": [
      242.60110312038972,
      55.93617472434264
    ],
    "path": "M 10.695423711214518 0 L 231.9056794091752 0 Q 242.60110312038972 0 242.60110312038972 10.695423711214518 L 242.60110312038972 45.240751013128126 Q 242.60110312038972 55.93617472434264 231.9056794091752 55.93617472434264 L 10.695423711214518 55.93617472434264 Q 0 55.93617472434264 0 45.240751013128126 L 0 10.695423711214518 Q 0 0 10.695423711214518 0 Z",
    "fill": "rgba(197,227,255,1)",
    "fixedRatio": false,
    "rotate": 0,
    "pathFormula": "roundRect",
    "keypoints": [
      0.19120763555824669
    ]
  },
  {
    "type": "shape",
    "left": 368.50000000000006,
    "top": 253.583371357498,
    "width": 44,
    "height": 44,
    "viewBox": [
      200,
      200
    ],
    "path": "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
    "fill": "#5b9bd5",
    "fixedRatio": true,
    "rotate": 0,
   
  },
  {
    "type": "text",
    "left": 367,
    "top": 247,
    "width": 46,
    "height": 44,
    "rotate": 0,
    "content": "<p style=\"text-align: center;\"><strong><span style=\"font-size: 20px;\"><span style=\"color: rgb(255, 255, 255);\">06</span></span></strong></p>",
    "defaultFontName": "思源黑体 CN",
    "defaultColor": "#333",
    "vertical": false,
    "lineHeight": 1
  },
  {
    "type": "text",
    "left": 407.1988973706531,
    "top": 247,
    "width": 219,
    "height": 44.5,
    "content": "<p style=\"text-align: center;\"><span style=\"font-size: 24px;\"><span style=\"font-family: Arial;\">{{title}}</span></span></p>",
    "rotate": 0,
    "defaultFontName": "思源黑体 CN",
    "defaultColor": "#333",
    "vertical": false,
    "lineHeight": 1
  },

  {
    "type": "shape",
    "left": 388.89889687961033,
    "top": 334.00346607053166,
    "width": 242.60110312038972,
    "height": 55.93617472434264,
    "viewBox": [
      242.60110312038972,
      55.93617472434264
    ],
    "path": "M 10.695423711214518 0 L 231.9056794091752 0 Q 242.60110312038972 0 242.60110312038972 10.695423711214518 L 242.60110312038972 45.240751013128126 Q 242.60110312038972 55.93617472434264 231.9056794091752 55.93617472434264 L 10.695423711214518 55.93617472434264 Q 0 55.93617472434264 0 45.240751013128126 L 0 10.695423711214518 Q 0 0 10.695423711214518 0 Z",
    "fill": "rgba(197,227,255,1)",
    "fixedRatio": false,
    "rotate": 0,
    "pathFormula": "roundRect",
    "keypoints": [
      0.19120763555824669
    ]
  },
  {
    "type": "shape",
    "left": 368.50000000000006,
    "top": 340.2726560620499,
    "width": 44,
    "height": 44,
    "viewBox": [
      200,
      200
    ],
    "path": "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
    "fill": "#5b9bd5",
    "fixedRatio": true,
    "rotate": 0,
   
  },
  {
    "type": "text",
    "left": 368,
    "top": 335,
    "width": 46,
    "height": 44,
    "rotate": 0,
    "content": "<p style=\"text-align: center;\"><strong><span style=\"font-size: 20px;\"><span style=\"color: rgb(255, 255, 255);\">07</span></span></strong></p>",
    "defaultFontName": "思源黑体 CN",
    "defaultColor": "#333",
    "vertical": false,
    "lineHeight": 1
  },
  {
    "type": "text",
    "left": 407.1988973706531,
    "top": 334,
    "width": 219,
    "height": 44.5,
    "content": "<p style=\"text-align: center;\"><span style=\"font-size: 24px;\"><span style=\"font-family: Arial;\">{{title}}</span></span></p>",
    "rotate": 0,
    "defaultFontName": "思源黑体 CN",
    "defaultColor": "#333",
    "vertical": false,
    "lineHeight": 1
  },
  {
    "type": "shape",
    "left": 388.89889687961033,
    "top": 420.6927507750836,
    "width": 242.60110312038972,
    "height": 55.93617472434264,
    "viewBox": [
      242.60110312038972,
      55.93617472434264
    ],
    "path": "M 10.695423711214518 0 L 231.9056794091752 0 Q 242.60110312038972 0 242.60110312038972 10.695423711214518 L 242.60110312038972 45.240751013128126 Q 242.60110312038972 55.93617472434264 231.9056794091752 55.93617472434264 L 10.695423711214518 55.93617472434264 Q 0 55.93617472434264 0 45.240751013128126 L 0 10.695423711214518 Q 0 0 10.695423711214518 0 Z",
    "fill": "rgba(197,227,255,1)",
    "fixedRatio": false,
    "rotate": 0,
    "pathFormula": "roundRect",
    "keypoints": [
      0.19120763555824669
    ]
  },
  {
    "type": "shape",
    "left": 368.50000000000006,
    "top": 426.96194076660186,
    "width": 44,
    "height": 44,
    "viewBox": [
      200,
      200
    ],
    "path": "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
    "fill": "#5b9bd5",
    "fixedRatio": true,
    "rotate": 0,
   
  },
  {
    "type": "text",
    "left": 368,
    "top": 421,
    "width": 46,
    "height": 44,
    "rotate": 0,
    "content": "<p style=\"text-align: center;\"><strong><span style=\"font-size: 20px;\"><span style=\"color: rgb(255, 255, 255);\">08</span></span></strong></p>",
      "defaultFontName": "思源黑体 CN",
    "defaultColor": "#333",
    "vertical": false,
    "lineHeight": 1
  },
  {
    "type": "text",
    "left": 407.1988973706531,
    "top": 420,
    "width": 219,
    "height": 44.5,
    "content": "<p style=\"text-align: center;\"><span style=\"font-size: 24px;\"><span style=\"font-family: Arial;\">{{title}}</span></span></p>",
    "rotate": 0,
    "defaultFontName": "思源黑体 CN",
    "defaultColor": "#333",
    "vertical": false,
    "lineHeight": 1
  },
  {
    "type": "shape",
    "left": 714.5532655495253,
    "top": 160.62489666142793,
    "width": 242.60110312038972,
    "height": 55.93617472434264,
    "viewBox": [
      242.60110312038972,
      55.93617472434264
    ],
    "path": "M 10.695423711214518 0 L 231.9056794091752 0 Q 242.60110312038972 0 242.60110312038972 10.695423711214518 L 242.60110312038972 45.240751013128126 Q 242.60110312038972 55.93617472434264 231.9056794091752 55.93617472434264 L 10.695423711214518 55.93617472434264 Q 0 55.93617472434264 0 45.240751013128126 L 0 10.695423711214518 Q 0 0 10.695423711214518 0 Z",
    "fill": "rgba(197,227,255,1)",
    "fixedRatio": false,
    "rotate": 0,
    "pathFormula": "roundRect",
    "keypoints": [
      0.19120763555824669
    ]
  },
  {
    "type": "shape",
    "left": 694.154368669915,
    "top": 166.89408665294616,
    "width": 44,
    "height": 44,
    "viewBox": [
      200,
      200
    ],
    "path": "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
    "fill": "#5b9bd5",
    "fixedRatio": true,
    "rotate": 0,

  },
  {
    "type": "text",
    "left": 694,
    "top": 161,
    "width": 46,  
    "height": 44,
    "rotate": 0,
    "content": "<p style=\"text-align: center;\"><strong><span style=\"font-size: 20px;\"><span style=\"color: rgb(255, 255, 255);\">09</span></span></strong></p>",
    "defaultFontName": "思源黑体 CN",
    "defaultColor": "#333",
    "vertical": false,
    "lineHeight": 1
  },
  {
    "type": "text",
    "left": 732.8532660405681,
    "top": 160,
    "width": 219,
    "height": 44.5,
    "content": "<p style=\"text-align: center;\"><span style=\"font-size: 24px;\"><span style=\"font-family: Arial;\">{{title}}</span></span></p>",
    "rotate": 0,
    "defaultFontName": "思源黑体 CN",
    "defaultColor": "#333",
    "vertical": false,
    "lineHeight": 1
  },
  {
    "type": "shape",
    "left": 714.5532655495252,
    "top": 247.3141813659798,
    "width": 242.60110312038972,
    "height": 55.93617472434264,
    "viewBox": [
      242.60110312038972,
      55.93617472434264
    ],
    "path": "M 10.695423711214518 0 L 231.9056794091752 0 Q 242.60110312038972 0 242.60110312038972 10.695423711214518 L 242.60110312038972 45.240751013128126 Q 242.60110312038972 55.93617472434264 231.9056794091752 55.93617472434264 L 10.695423711214518 55.93617472434264 Q 0 55.93617472434264 0 45.240751013128126 L 0 10.695423711214518 Q 0 0 10.695423711214518 0 Z",
    "fill": "rgba(197,227,255,1)",
    "fixedRatio": false,
    "rotate": 0,
    "pathFormula": "roundRect",
    "keypoints": [
      0.19120763555824669
    ]
  },
  {
    "type": "shape",
    "left": 694.154368669915,
    "top": 253.58337135749795,
    "width": 44,
    "height": 44,
    "viewBox": [
      200,
      200
    ],
    "path": "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
    "fill": "#5b9bd5",
    "fixedRatio": true,
    "rotate": 0,
   
  },
  {
    "type": "text",
    "left": 694,
    "top": 247,
    "width": 46,
    "height": 44,
    "rotate": 0,
    "content": "<p style=\"text-align: center;\"><strong><span style=\"font-size: 20px;\"><span style=\"color: rgb(255, 255, 255);\">10</span></span></strong></p>",
    "defaultFontName": "思源黑体 CN",
    "defaultColor": "#333",
    "vertical": false,
    "lineHeight": 1
  },
  {
    "type": "text",
    "left": 732.8532660405681,
    "top": 247,
    "width": 219,
    "height": 44.5,
    "content": "<p style=\"text-align: center;\"><span style=\"font-size: 24px;\"><span style=\"font-family: Arial;\">{{title}}</span></span></p>",
    "rotate": 0,
    "defaultFontName": "思源黑体 CN",
    "defaultColor": "#333",
    "vertical": false,
    "lineHeight": 1
  },
  {
    "type": "shape",
    "left": 714.5532655495252,
    "top": 334.00346607053166,
    "width": 242.60110312038972,
    "height": 55.93617472434264,
    "viewBox": [
      242.60110312038972,
      55.93617472434264
    ],
    "path": "M 10.695423711214518 0 L 231.9056794091752 0 Q 242.60110312038972 0 242.60110312038972 10.695423711214518 L 242.60110312038972 45.240751013128126 Q 242.60110312038972 55.93617472434264 231.9056794091752 55.93617472434264 L 10.695423711214518 55.93617472434264 Q 0 55.93617472434264 0 45.240751013128126 L 0 10.695423711214518 Q 0 0 10.695423711214518 0 Z",
    "fill": "rgba(197,227,255,1)",
    "fixedRatio": false,
    "rotate": 0,
    "pathFormula": "roundRect",
    "keypoints": [
      0.19120763555824669
    ]
  },
  {
    "type": "shape",
    "left": 694.154368669915,
    "top": 340.2726560620499,
    "width": 44,
    "height": 44,
    "viewBox": [
      200,
      200
    ],
    "path": "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
    "fill": "#5b9bd5",
    "fixedRatio": true,
    "rotate": 0,
    
  },
  {
    "type": "text",
    "left": 694,
    "top": 335,
    "width": 46,
    "height": 44,
    "rotate": 0,
    "content": "<p style=\"text-align: center;\"><strong><span style=\"font-size: 20px;\"><span style=\"color: rgb(255, 255, 255);\">11</span></span></strong></p>",
    "defaultFontName": "思源黑体 CN",
    "defaultColor": "#333",
    "vertical": false,
    "lineHeight": 1
  },
  {
    "type": "text",
    "left": 732.8532660405681,
    "top": 334,
    "width": 219,
    "height": 44.5,
    "content": "<p style=\"text-align: center;\"><span style=\"font-size: 24px;\"><span style=\"font-family: Arial;\">{{title}}</span></span></p>",
    "rotate": 0,
    "defaultFontName": "思源黑体 CN",
    "defaultColor": "#333",
    "vertical": false,
    "lineHeight": 1
  },
  {
    "type": "shape",
    "left": 714.5532655495252,
    "top": 420.6927507750836,
    "width": 242.60110312038972,
    "height": 55.93617472434264,
    "viewBox": [
      242.60110312038972,
      55.93617472434264
    ],
    "path": "M 10.695423711214518 0 L 231.9056794091752 0 Q 242.60110312038972 0 242.60110312038972 10.695423711214518 L 242.60110312038972 45.240751013128126 Q 242.60110312038972 55.93617472434264 231.9056794091752 55.93617472434264 L 10.695423711214518 55.93617472434264 Q 0 55.93617472434264 0 45.240751013128126 L 0 10.695423711214518 Q 0 0 10.695423711214518 0 Z",
    "fill": "rgba(197,227,255,1)",
    "fixedRatio": false,
    "rotate": 0,
    "pathFormula": "roundRect",
    "keypoints": [
      0.19120763555824669
    ]
  },
  {
    "type": "shape",
    "left": 694.154368669915,
    "top": 426.96194076660186,
    "width": 44,
    "height": 44,
    "viewBox": [
      200,
      200
    ],
    "path": "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
    "fill": "#5b9bd5",
    "fixedRatio": true,
    "rotate": 0,
   
  },
  {
    "type": "text",
    "left": 694,
    "top": 420,
    "width": 46,
    "height": 44,
    "rotate": 0,
    "content": "<p style=\"text-align: center;\"><strong><span style=\"font-size: 20px;\"><span style=\"color: rgb(255, 255, 255);\">12</span></span></strong></p>",
    "defaultFontName": "思源黑体 CN",
    "defaultColor": "#333",
    "vertical": false,
    "lineHeight": 1
  },
  {
    "type": "text",
    "left": 732.8532660405681,
    "top": 420,
    "width": 219,
    "height": 44.5,
    "content": "<p style=\"text-align: center;\"><span style=\"font-size: 24px;\"><span style=\"font-family: Arial;\">{{title}}</span></span></p>",
    "rotate": 0,
    "defaultFontName": "思源黑体 CN",
    "defaultColor": "#333",
    "vertical": false,
    "lineHeight": 1
  }

]

 },
 '9':{
  manyLenght:[2,2,2],
  'few':[
    {
      "type": "text",
      "width": 284.6319969545792,
      "height": 56,
      "left": 186.26105040305066,
      "top": 217.15706701261576,
      "rotate": 0,
      "defaultFontName": "Microsoft Yahei",
      "defaultColor": "#333",
      "content": "<p style=\"text-align: center;\"><strong><span style=\"font-size: 36px;\"><span style=\"font-family: 思源宋体 CN;\">{{title}}</span></span></strong></p>",
      "lineHeight": 1,
      "outline": {
        "color": "#000",
        "width": 0,
        "style": "solid"
      },
      "fill": "",
      "vertical": false
    },
    {
      "type": "text",
      "width": 141.73490813648291,
      "height": 74,
      "left": 257.7095948120988,
      "top": 143.15706701261576,
      "rotate": 0,
      "defaultFontName": "Microsoft Yahei",
      "defaultColor": "#333",
      "content": "<p style=\"text-align: center;\"><span style=\"font-size: 54px;\">01</span></p>",
      "lineHeight": 1,
      "outline": {
        "color": "#000",
        "width": 0,
        "style": "solid"
      },
      "fill": "",
      "vertical": false
    },
    {
      "type": "text",
      "width": 284.6319969545792,
      "height": 56,
      "left": 529.1069526423702,
      "top": 217.15706701261576,
      "rotate": 0,
      "defaultFontName": "Microsoft Yahei",
      "defaultColor": "#333",
      "content": "<p style=\"text-align: center;\"><strong><span style=\"font-size: 36px;\"><span style=\"font-family: 思源宋体 CN;\">{{title}}</span></span></strong></p>",
      "lineHeight": 1,
      "outline": {
        "color": "#000",
        "width": 0,
        "style": "solid"
      },
      "fill": "",
      "vertical": false
    },
    {
      "type": "text",
      "width": 141.73490813648291,
      "height": 74,
      "left": 600.5554970514183,
      "top": 143.15706701261576,
      "rotate": 0,
      "defaultFontName": "Microsoft Yahei",
      "defaultColor": "#333",
      "content": "<p style=\"text-align: center;\"><span style=\"font-size: 54px;\">02</span></p>",
      "lineHeight": 1,
      "outline": {
        "color": "#000",
        "width": 0,
        "style": "solid"
      },
      "fill": "",
      "vertical": false
    },
    {
      "type": "text",
      "width": 284.6319969545792,
      "height": 56,
      "left": 186.26105040305066,
      "top": 401.03323325519415,
      "rotate": 0,
      "defaultFontName": "Microsoft Yahei",
      "defaultColor": "#333",
      "content": "<p style=\"text-align: center;\"><strong><span style=\"font-size: 36px;\"><span style=\"font-family: 思源宋体 CN;\">{{title}}</span></span></strong></p>",
      "lineHeight": 1,
      "outline": {
        "color": "#000",
        "width": 0,
        "style": "solid"
      },
      "fill": "",
      "vertical": false
    },
    {
      "type": "text",
      "width": 141.73490813648291,
      "height": 74,
      "left": 257.7095948120988,
      "top": 327.03323325519426,
      "rotate": 0,
      "defaultFontName": "Microsoft Yahei",
      "defaultColor": "#333",
      "content": "<p style=\"text-align: center;\"><span style=\"font-size: 54px;\">03</span></p>",
      "lineHeight": 1,
      "outline": {
        "color": "#000",
        "width": 0,
        "style": "solid"
      },
      "fill": "",
      "vertical": false
    },
    {
      "type": "text",
      "width": 284.6319969545792,
      "height": 56,
      "left": 529.1069526423702,
      "top": 401.03323325519415,
      "rotate": 0,
      "defaultFontName": "Microsoft Yahei",
      "defaultColor": "#333",
      "content": "<p style=\"text-align: center;\"><strong><span style=\"font-size: 36px;\"><span style=\"font-family: 思源宋体 CN;\">{{title}}</span></span></strong></p>",
      "lineHeight": 1,
      "outline": {
        "color": "#000",
        "width": 0,
        "style": "solid"
      },
      "fill": "",
      "vertical": false
    },
    {
      "type": "text",
      "width": 141.73490813648291,
      "height": 74,
      "left": 600.5554970514183,
      "top": 327.03323325519426,
      "rotate": 0,
      "defaultFontName": "Microsoft Yahei",
      "defaultColor": "#333",
      "content": "<p style=\"text-align: center;\"><span style=\"font-size: 54px;\">04</span></p>",
      "lineHeight": 1,
      "outline": {
        "color": "#000",
        "width": 0,
        "style": "solid"
      },
      "fill": "",
      "vertical": false
    }
  ],
  'many':[
    {
      "type": "text",
      "width": 230.5607501352408,
      "height": 48,
      "left": 71.75723360915755,
      "top": 209.3377285902239,
      "rotate": 0,
      "defaultFontName": "Microsoft Yahei",
      "defaultColor": "#333",
      "content": "<p style=\"text-align: center;\"><strong><span style=\"font-size: 28px;\"><span style=\"font-family: 思源宋体 CN;\">{{title}}</span></span></strong></p>",
      "lineHeight": 1,
      "outline": {
        "color": "#000",
        "width": 0,
        "style": "solid"
      },
      "fill": "",
      "vertical": false,
      "groupId": "64iKaBxA2U"
    },
    {
      "type": "text",
      "width": 88.72388184301387,
      "height": 60,
      "left": 142.675667755271,
      "top": 149.3377285902239,
      "rotate": 0,
      "defaultFontName": "Microsoft Yahei",
      "defaultColor": "#333",
      "content": "<p style=\"text-align: center;\"><span style=\"font-size: 40px;\">01</span></p>",
      "lineHeight": 1,
      "outline": {
        "color": "#000",
        "width": 0,
        "style": "solid"
      },
      "fill": "",
      "vertical": false,
      "groupId": "64iKaBxA2U"
    },
    {
      "type": "text",
      "width": 230.5607501352408,
      "height": 48,
      "left": 294.51977938508304,
      "top": 209.3377285902239,
      "rotate": 0,
      "defaultFontName": "Microsoft Yahei",
      "defaultColor": "#333",
      "content": "<p style=\"text-align: center;\"><strong><span style=\"font-size: 28px;\"><span style=\"font-family: 思源宋体 CN;\">{{title}}</span></span></strong></p>",
      "lineHeight": 1,
      "outline": {
        "color": "#000",
        "width": 0,
        "style": "solid"
      },
      "fill": "",
      "vertical": false,
      "groupId": "yaVC7pIwHm"
    },
    {
      "type": "text",
      "width": 88.72388184301387,
      "height": 60,
      "left": 365.4382135311965,
      "top": 149.3377285902239,
      "rotate": 0,
      "defaultFontName": "Microsoft Yahei",
      "defaultColor": "#333",
      "content": "<p style=\"text-align: center;\"><span style=\"font-size: 40px;\">02</span></p>",
      "lineHeight": 1,
      "outline": {
        "color": "#000",
        "width": 0,
        "style": "solid"
      },
      "fill": "",
      "vertical": false,
      "groupId": "yaVC7pIwHm"
    },
    {
      "type": "text",
      "width": 230.5607501352408,
      "height": 48,
      "left": 517.2823251610085,
      "top": 209.3377285902239,
      "rotate": 0,
      "defaultFontName": "Microsoft Yahei",
      "defaultColor": "#333",
      "content": "<p style=\"text-align: center;\"><strong><span style=\"font-size: 28px;\"><span style=\"font-family: 思源宋体 CN;\">{{title}}</span></span></strong></p>",
      "lineHeight": 1,
      "outline": {
        "color": "#000",
        "width": 0,
        "style": "solid"
      },
      "fill": "",
      "vertical": false,
      "groupId": "KYNjQGZfR-"
    },
    {
      "type": "text",
      "width": 88.72388184301387,
      "height": 60,
      "left": 588.200759307122,
      "top": 149.3377285902239,
      "rotate": 0,
      "defaultFontName": "Microsoft Yahei",
      "defaultColor": "#333",
      "content": "<p style=\"text-align: center;\"><span style=\"font-size: 40px;\">03</span></p>",
      "lineHeight": 1,
      "outline": {
        "color": "#000",
        "width": 0,
        "style": "solid"
      },
      "fill": "",
      "vertical": false,
      "groupId": "KYNjQGZfR-"
    },
    {
      "type": "text",
      "width": 230.5607501352408,
      "height": 48,
      "left": 740.0448709369341,
      "top": 209.3377285902239,
      "rotate": 0,
      "defaultFontName": "Microsoft Yahei",
      "defaultColor": "#333",
      "content": "<p style=\"text-align: center;\"><strong><span style=\"font-size: 28px;\"><span style=\"font-family: 思源宋体 CN;\">{{title}}</span></span></strong></p>",
      "lineHeight": 1,
      "outline": {
        "color": "#000",
        "width": 0,
        "style": "solid"
      },
      "fill": "",
      "vertical": false,
      "groupId": "jegXkZJj_y"
    },
    {
      "type": "text",
      "width": 88.72388184301387,
      "height": 60,
      "left": 810.9633050830475,
      "top": 149.3377285902239,
      "rotate": 0,
      "defaultFontName": "Microsoft Yahei",
      "defaultColor": "#333",
      "content": "<p style=\"text-align: center;\"><span style=\"font-size: 40px;\">04</span></p>",
      "lineHeight": 1,
      "outline": {
        "color": "#000",
        "width": 0,
        "style": "solid"
      },
      "fill": "",
      "vertical": false,
      "groupId": "jegXkZJj_y"
    },
    {
      "type": "text",
      "width": 230.5607501352408,
      "height": 48,
      "left": 71.7572336091575,
      "top": 367.46749958259034,
      "rotate": 0,
      "defaultFontName": "Microsoft Yahei",
      "defaultColor": "#333",
      "content": "<p style=\"text-align: center;\"><strong><span style=\"font-size: 28px;\"><span style=\"font-family: 思源宋体 CN;\">{{title}}</span></span></strong></p>",
      "lineHeight": 1,
      "outline": {
        "color": "#000",
        "width": 0,
        "style": "solid"
      },
      "fill": "",
      "vertical": false,
      "groupId": "yGb0OzbeyL"
    },
    {
      "type": "text",
      "width": 88.72388184301387,
      "height": 60,
      "left": 142.67566775527095,
      "top": 307.46749958259034,
      "rotate": 0,
      "defaultFontName": "Microsoft Yahei",
      "defaultColor": "#333",
      "content": "<p style=\"text-align: center;\"><span style=\"font-size: 40px;\">05</span></p>",
      "lineHeight": 1,
      "outline": {
        "color": "#000",
        "width": 0,
        "style": "solid"
      },
      "fill": "",
      "vertical": false,
      "groupId": "yGb0OzbeyL"
    },
    {
      "type": "text",
      "width": 230.5607501352408,
      "height": 48,
      "left": 294.519779385083,
      "top": 367.46749958259034,
      "rotate": 0,
      "defaultFontName": "Microsoft Yahei",
      "defaultColor": "#333",
      "content": "<p style=\"text-align: center;\"><strong><span style=\"font-size: 28px;\"><span style=\"font-family: 思源宋体 CN;\">{{title}}</span></span></strong></p>",
      "lineHeight": 1,
      "outline": {
        "color": "#000",
        "width": 0,
        "style": "solid"
      },
      "fill": "",
      "vertical": false,
      "groupId": "mFSMxpox61"
    },
    {
      "type": "text",
      "width": 88.72388184301387,
      "height": 60,
      "left": 365.4382135311964,
      "top": 307.46749958259034,
      "rotate": 0,
      "defaultFontName": "Microsoft Yahei",
      "defaultColor": "#333",
      "content": "<p style=\"text-align: center;\"><span style=\"font-size: 40px;\">06</span></p>",
      "lineHeight": 1,
      "outline": {
        "color": "#000",
        "width": 0,
        "style": "solid"
      },
      "fill": "",
      "vertical": false,
      "groupId": "mFSMxpox61"
    },
    {
      "type": "text",
      "width": 230.5607501352408,
      "height": 48,
      "left": 517.2823251610087,
      "top": 367.46749958259034,
      "rotate": 0,
      "defaultFontName": "Microsoft Yahei",
      "defaultColor": "#333",
      "content": "<p style=\"text-align: center;\"><strong><span style=\"font-size: 28px;\"><span style=\"font-family: 思源宋体 CN;\">{{title}}</span></span></strong></p>",
      "lineHeight": 1,
      "outline": {
        "color": "#000",
        "width": 0,
        "style": "solid"
      },
      "fill": "",
      "vertical": false,
      "groupId": "yTvymfHJCX"
    },
    {
      "type": "text",
      "width": 88.72388184301387,
      "height": 60,
      "left": 588.2007593071221,
      "top": 307.46749958259034,
      "rotate": 0,
      "defaultFontName": "Microsoft Yahei",
      "defaultColor": "#333",
      "content": "<p style=\"text-align: center;\"><span style=\"font-size: 40px;\">07</span></p>",
      "lineHeight": 1,
      "outline": {
        "color": "#000",
        "width": 0,
        "style": "solid"
      },
      "fill": "",
      "vertical": false,
      "groupId": "yTvymfHJCX"
    },
    {
      "type": "text",
      "width": 230.5607501352408,
      "height": 48,
      "left": 740.0448709369341,
      "top": 367.46749958259034,
      "rotate": 0,
      "defaultFontName": "Microsoft Yahei",
      "defaultColor": "#333",
      "content": "<p style=\"text-align: center;\"><strong><span style=\"font-size: 28px;\"><span style=\"font-family: 思源宋体 CN;\">{{title}}</span></span></strong></p>",
      "lineHeight": 1,
      "outline": {
        "color": "#000",
        "width": 0,
        "style": "solid"
      },
      "fill": "",
      "vertical": false,
      "groupId": "chKM9Jh_ts"
    },
    {
      "type": "text",
      "width": 88.72388184301387,
      "height": 60,
      "left": 810.9633050830475,
      "top": 307.46749958259034,
      "rotate": 0,
      "defaultFontName": "Microsoft Yahei",
      "defaultColor": "#333",
      "content": "<p style=\"text-align: center;\"><span style=\"font-size: 40px;\">08</span></p>",
      "lineHeight": 1,
      "outline": {
        "color": "#000",
        "width": 0,
        "style": "solid"
      },
      "fill": "",
      "vertical": false,
      "groupId": "chKM9Jh_ts"
    }
  ],
  'max':[
    {
      "type": "text",
      "width": 230.5607501352408,
      "height": 48,
      "left": 80.23899781611256,
      "top": 183.63600735976695,
      "rotate": 0,
      "defaultFontName": "Microsoft Yahei",
      "defaultColor": "#333",
      "content": "<p style=\"text-align: center;\"><strong><span style=\"font-size: 28px;\"><span style=\"font-family: 思源宋体 CN;\">{{title}}</span></span></strong></p>",
      "lineHeight": 1,
      "outline": {
        "color": "#000",
        "width": 0,
        "style": "solid"
      },
      "fill": "",
      "vertical": false
    },
    {
      "type": "text",
      "width": 88.72388184301387,
      "height": 60,
      "left": 151.157431962226,
      "top": 123.63600735976695,
      "rotate": 0,
      "defaultFontName": "Microsoft Yahei",
      "defaultColor": "#333",
      "content": "<p style=\"text-align: center;\"><span style=\"font-size: 40px;\">01</span></p>",
      "lineHeight": 1,
      "outline": {
        "color": "#000",
        "width": 0,
        "style": "solid"
      },
      "fill": "",
      "vertical": false
    },
    {
      "type": "text",
      "width": 230.5607501352408,
      "height": 48,
      "left": 303.00154359203805,
      "top": 183.63600735976695,
      "rotate": 0,
      "defaultFontName": "Microsoft Yahei",
      "defaultColor": "#333",
      "content": "<p style=\"text-align: center;\"><strong><span style=\"font-size: 28px;\"><span style=\"font-family: 思源宋体 CN;\">{{title}}</span></span></strong></p>",
      "lineHeight": 1,
      "outline": {
        "color": "#000",
        "width": 0,
        "style": "solid"
      },
      "fill": "",
      "vertical": false
    },
    {
      "type": "text",
      "width": 88.72388184301387,
      "height": 60,
      "left": 373.9199777381515,
      "top": 123.63600735976695,
      "rotate": 0,
      "defaultFontName": "Microsoft Yahei",
      "defaultColor": "#333",
      "content": "<p style=\"text-align: center;\"><span style=\"font-size: 40px;\">02</span></p>",
      "lineHeight": 1,
      "outline": {
        "color": "#000",
        "width": 0,
        "style": "solid"
      },
      "fill": "",
      "vertical": false
    },
    {
      "type": "text",
      "width": 230.5607501352408,
      "height": 48,
      "left": 525.7640893679636,
      "top": 183.63600735976695,
      "rotate": 0,
      "defaultFontName": "Microsoft Yahei",
      "defaultColor": "#333",
      "content": "<p style=\"text-align: center;\"><strong><span style=\"font-size: 28px;\"><span style=\"font-family: 思源宋体 CN;\">{{title}}</span></span></strong></p>",
      "lineHeight": 1,
      "outline": {
        "color": "#000",
        "width": 0,
        "style": "solid"
      },
      "fill": "",
      "vertical": false
    },
    {
      "type": "text",
      "width": 88.72388184301387,
      "height": 60,
      "left": 596.682523514077,
      "top": 123.63600735976695,
      "rotate": 0,
      "defaultFontName": "Microsoft Yahei",
      "defaultColor": "#333",
      "content": "<p style=\"text-align: center;\"><span style=\"font-size: 40px;\">03</span></p>",
      "lineHeight": 1,
      "outline": {
        "color": "#000",
        "width": 0,
        "style": "solid"
      },
      "fill": "",
      "vertical": false
    },
    {
      "type": "text",
      "width": 230.5607501352408,
      "height": 48,
      "left": 748.526635143889,
      "top": 183.63600735976695,
      "rotate": 0,
      "defaultFontName": "Microsoft Yahei",
      "defaultColor": "#333",
      "content": "<p style=\"text-align: center;\"><strong><span style=\"font-size: 28px;\"><span style=\"font-family: 思源宋体 CN;\">{{title}}</span></span></strong></p>",
      "lineHeight": 1,
      "outline": {
        "color": "#000",
        "width": 0,
        "style": "solid"
      },
      "fill": "",
      "vertical": false
    },
    {
      "type": "text",
      "width": 88.72388184301387,
      "height": 60,
      "left": 819.4450692900025,
      "top": 123.63600735976695,
      "rotate": 0,
      "defaultFontName": "Microsoft Yahei",
      "defaultColor": "#333",
      "content": "<p style=\"text-align: center;\"><span style=\"font-size: 40px;\">04</span></p>",
      "lineHeight": 1,
      "outline": {
        "color": "#000",
        "width": 0,
        "style": "solid"
      },
      "fill": "",
      "vertical": false
    },
    {
      "type": "text",
      "width": 230.5607501352408,
      "height": 48,
      "left": 80.23899781611256,
      "top": 330.9345654598517,
      "rotate": 0,
      "defaultFontName": "Microsoft Yahei",
      "defaultColor": "#333",
      "content": "<p style=\"text-align: center;\"><strong><span style=\"font-size: 28px;\"><span style=\"font-family: 思源宋体 CN;\">{{title}}</span></span></strong></p>",
      "lineHeight": 1,
      "outline": {
        "color": "#000",
        "width": 0,
        "style": "solid"
      },
      "fill": "",
      "vertical": false
    },
    {
      "type": "text",
      "width": 88.72388184301387,
      "height": 60,
      "left": 151.157431962226,
      "top": 270.9345654598517,
      "rotate": 0,
      "defaultFontName": "Microsoft Yahei",
      "defaultColor": "#333",
      "content": "<p style=\"text-align: center;\"><span style=\"font-size: 40px;\">05</span></p>",
      "lineHeight": 1,
      "outline": {
        "color": "#000",
        "width": 0,
        "style": "solid"
      },
      "fill": "",
      "vertical": false
    },
    {
      "type": "text",
      "width": 230.5607501352408,
      "height": 48,
      "left": 303.00154359203805,
      "top": 330.9345654598517,
      "rotate": 0,
      "defaultFontName": "Microsoft Yahei",
      "defaultColor": "#333",
      "content": "<p style=\"text-align: center;\"><strong><span style=\"font-size: 28px;\"><span style=\"font-family: 思源宋体 CN;\">{{title}}</span></span></strong></p>",
      "lineHeight": 1,
      "outline": {
        "color": "#000",
        "width": 0,
        "style": "solid"
      },
      "fill": "",
      "vertical": false
    },
    {
      "type": "text",
      "width": 88.72388184301387,
      "height": 60,
      "left": 373.9199777381515,
      "top": 270.9345654598517,
      "rotate": 0,
      "defaultFontName": "Microsoft Yahei",
      "defaultColor": "#333",
      "content": "<p style=\"text-align: center;\"><span style=\"font-size: 40px;\">06</span></p>",
      "lineHeight": 1,
      "outline": {
        "color": "#000",
        "width": 0,
        "style": "solid"
      },
      "fill": "",
      "vertical": false
    },
    {
      "type": "text",
      "width": 230.5607501352408,
      "height": 48,
      "left": 525.7640893679636,
      "top": 330.9345654598517,
      "rotate": 0,
      "defaultFontName": "Microsoft Yahei",
      "defaultColor": "#333",
      "content": "<p style=\"text-align: center;\"><strong><span style=\"font-size: 28px;\"><span style=\"font-family: 思源宋体 CN;\">{{title}}</span></span></strong></p>",
      "lineHeight": 1,
      "outline": {
        "color": "#000",
        "width": 0,
        "style": "solid"
      },
      "fill": "",
      "vertical": false
    },
    {
      "type": "text",
      "width": 88.72388184301387,
      "height": 60,
      "left": 596.682523514077,
      "top": 270.9345654598517,
      "rotate": 0,
      "defaultFontName": "Microsoft Yahei",
      "defaultColor": "#333",
      "content": "<p style=\"text-align: center;\"><span style=\"font-size: 40px;\">07</span></p>",
      "lineHeight": 1,
      "outline": {
        "color": "#000",
        "width": 0,
        "style": "solid"
      },
      "fill": "",
      "vertical": false
    },
    {
      "type": "text",
      "width": 230.5607501352408,
      "height": 48,
      "left": 748.526635143889,
      "top": 330.9345654598517,
      "rotate": 0,
      "defaultFontName": "Microsoft Yahei",
      "defaultColor": "#333",
      "content": "<p style=\"text-align: center;\"><strong><span style=\"font-size: 28px;\"><span style=\"font-family: 思源宋体 CN;\">{{title}}</span></span></strong></p>",
      "lineHeight": 1,
      "outline": {
        "color": "#000",
        "width": 0,
        "style": "solid"
      },
      "fill": "",
      "vertical": false
    },
    {
      "type": "text",
      "width": 88.72388184301387,
      "height": 60,
      "left": 819.4450692900025,
      "top": 270.9345654598517,
      "rotate": 0,
      "defaultFontName": "Microsoft Yahei",
      "defaultColor": "#333",
      "content": "<p style=\"text-align: center;\"><span style=\"font-size: 40px;\">08</span></p>",
      "lineHeight": 1,
      "outline": {
        "color": "#000",
        "width": 0,
        "style": "solid"
      },
      "fill": "",
      "vertical": false
    },
    {
      "type": "text",
      "width": 230.5607501352408,
      "height": 48,
      "left": 80.23899781611256,
      "top": 478.23312355993664,
      "rotate": 0,
      "defaultFontName": "Microsoft Yahei",
      "defaultColor": "#333",
      "content": "<p style=\"text-align: center;\"><strong><span style=\"font-size: 28px;\"><span style=\"font-family: 思源宋体 CN;\">{{title}}</span></span></strong></p>",
      "lineHeight": 1,
      "outline": {
        "color": "#000",
        "width": 0,
        "style": "solid"
      },
      "fill": "",
      "vertical": false
    },
    {
      "type": "text",
      "width": 88.72388184301387,
      "height": 60,
      "left": 151.157431962226,
      "top": 418.23312355993664,
      "rotate": 0,
      "defaultFontName": "Microsoft Yahei",
      "defaultColor": "#333",
      "content": "<p style=\"text-align: center;\"><span style=\"font-size: 40px;\">09</span></p>",
      "lineHeight": 1,
      "outline": {
        "color": "#000",
        "width": 0,
        "style": "solid"
      },
      "fill": "",
      "vertical": false
    },
    {
      "type": "text",
      "width": 230.5607501352408,
      "height": 48,
      "left": 303.00154359203805,
      "top": 478.23312355993653,
      "rotate": 0,
      "defaultFontName": "Microsoft Yahei",
      "defaultColor": "#333",
      "content": "<p style=\"text-align: center;\"><strong><span style=\"font-size: 28px;\"><span style=\"font-family: 思源宋体 CN;\">{{title}}</span></span></strong></p>",
      "lineHeight": 1,
      "outline": {
        "color": "#000",
        "width": 0,
        "style": "solid"
      },
      "fill": "",
      "vertical": false
    },
    {
      "type": "text",
      "width": 88.72388184301387,
      "height": 60,
      "left": 373.9199777381515,
      "top": 418.23312355993653,
      "rotate": 0,
      "defaultFontName": "Microsoft Yahei",
      "defaultColor": "#333",
      "content": "<p style=\"text-align: center;\"><span style=\"font-size: 40px;\">10</span></p>",
      "lineHeight": 1,
      "outline": {
        "color": "#000",
        "width": 0,
        "style": "solid"
      },
      "fill": "",
      "vertical": false
    },
    {
      "type": "text",
      "width": 230.5607501352408,
      "height": 48,
      "left": 525.7640893679636,
      "top": 478.23312355993653,
      "rotate": 0,
      "defaultFontName": "Microsoft Yahei",
      "defaultColor": "#333",
      "content": "<p style=\"text-align: center;\"><strong><span style=\"font-size: 28px;\"><span style=\"font-family: 思源宋体 CN;\">{{title}}</span></span></strong></p>",
      "lineHeight": 1,
      "outline": {
        "color": "#000",
        "width": 0,
        "style": "solid"
      },
      "fill": "",
      "vertical": false
    },
    {
      "type": "text",
      "width": 88.72388184301387,
      "height": 60,
      "left": 596.682523514077,
      "top": 418.23312355993653,
      "rotate": 0,
      "defaultFontName": "Microsoft Yahei",
      "defaultColor": "#333",
      "content": "<p style=\"text-align: center;\"><span style=\"font-size: 40px;\">11</span></p>",
      "lineHeight": 1,
      "outline": {
        "color": "#000",
        "width": 0,
        "style": "solid"
      },
      "fill": "",
      "vertical": false
    },
    {
      "type": "text",
      "width": 230.5607501352408,
      "height": 48,
      "left": 748.526635143889,
      "top": 478.23312355993653,
      "rotate": 0,
      "defaultFontName": "Microsoft Yahei",
      "defaultColor": "#333",
      "content": "<p style=\"text-align: center;\"><strong><span style=\"font-size: 28px;\"><span style=\"font-family: 思源宋体 CN;\">{{title}}</span></span></strong></p>",
      "lineHeight": 1,
      "outline": {
        "color": "#000",
        "width": 0,
        "style": "solid"
      },
      "fill": "",
      "vertical": false
    },
    {
      "type": "text",
      "width": 88.72388184301387,
      "height": 60,
      "left": 819.4450692900025,
      "top": 418.23312355993653,
      "rotate": 0,
      "defaultFontName": "Microsoft Yahei",
      "defaultColor": "#333",
      "content": "<p style=\"text-align: center;\"><span style=\"font-size: 40px;\">12</span></p>",
      "lineHeight": 1,
      "outline": {
        "color": "#000",
        "width": 0,
        "style": "solid"
      },
      "fill": "",
      "vertical": false
    }
  ]

 },
 '10':{
  manyLenght:[2,2,2],
  'few':[
    {
      "type": "text",
      "id": "jSNHcS0-yq",
      "width": 342.6837299805419,
      "height": 56,
      "left": 280.7274462111185,
      "top": 220.82460587345486,
      "rotate": 0,
      "defaultFontName": "Microsoft Yahei",
      "defaultColor": "#333",
      "content": "<p style=\"text-align: center;\"><strong><span style=\"font-size: 36px;\"><span style=\"font-family: 思源宋体 CN;\"><span style=\"color: rgb(0, 0, 0);\">{{title}}</span></span></span></strong></p>",
      "lineHeight": 1,
      "outline": {
        "color": "#000",
        "width": 0,
        "style": "solid"
      },
      "fill": "",
      "vertical": false
    },
    {
      "type": "text",
      "id": "tf82Zh8S5t",
      "width": 141.73490813648291,
      "height": 74,
      "left": 376.29989634883424,
      "top": 146.82460587345474,
      "rotate": 0,
      "defaultFontName": "Microsoft Yahei",
      "defaultColor": "#333",
      "content": "<p style=\"text-align: center;\"><span style=\"font-size: 54px;\"><span style=\"color: rgb(212, 115, 116);\">01</span></span></p>",
      "lineHeight": 1,
      "outline": {
        "color": "#000",
        "width": 0,
        "style": "solid"
      },
      "fill": "",
      "vertical": false
    },
    {
      "type": "text",
      "id": "76vo7tRbh_",
      "width": 340.50508074306913,
      "height": 56,
      "left": 643.2184904659707,
      "top": 220.82460587345486,
      "rotate": 0,
      "defaultFontName": "Microsoft Yahei",
      "defaultColor": "#333",
      "content": "<p style=\"text-align: center;\"><strong><span style=\"font-size: 36px;\"><span style=\"font-family: 思源宋体 CN;\"><span style=\"color: rgb(0, 0, 0);\">{{title}}</span></span></span></strong></p>",
      "lineHeight": 1,
      "outline": {
        "color": "#000",
        "width": 0,
        "style": "solid"
      },
      "fill": "",
      "vertical": false
    },
    {
      "type": "text",
      "id": "DRHdvO3DBV",
      "width": 141.73490813648291,
      "height": 74,
      "left": 735.5229667474772,
      "top": 146.82460587345474,
      "rotate": 0,
      "defaultFontName": "Microsoft Yahei",
      "defaultColor": "#333",
      "content": "<p style=\"text-align: center;\"><span style=\"font-size: 54px;\"><span style=\"color: rgba(155,174,152,1);\">02</span></span></p>",
      "lineHeight": 1,
      "outline": {
        "color": "#000",
        "width": 0,
        "style": "solid"
      },
      "fill": "",
      "vertical": false
    },
    {
      "type": "text",
      "id": "Q6jhEPbUIg",
      "width": 342.68372998054184,
      "height": 56,
      "left": 280.7274462111185,
      "top": 415.30297737472733,
      "rotate": 0,
      "defaultFontName": "Microsoft Yahei",
      "defaultColor": "#333",
      "content": "<p style=\"text-align: center;\"><strong><span style=\"font-size: 36px;\"><span style=\"font-family: 思源宋体 CN;\"><span style=\"color: rgb(0, 0, 0);\">{{title}}</span></span></span></strong></p>",
      "lineHeight": 1,
      "outline": {
        "color": "#000",
        "width": 0,
        "style": "solid"
      },
      "fill": "",
      "vertical": false
    },
    {
      "type": "text",
      "id": "YAC4eKZrel",
      "width": 141.73490813648291,
      "height": 74,
      "left": 376.29989634883435,
      "top": 341.3029773747271,
      "rotate": 0,
      "defaultFontName": "Microsoft Yahei",
      "defaultColor": "#333",
      "content": "<p style=\"text-align: center;\"><span style=\"font-size: 54px;\"><span style=\"color: rgba(155,174,152,1);\">03</span></span></p>",
      "lineHeight": 1,
      "outline": {
        "color": "#000",
        "width": 0,
        "style": "solid"
      },
      "fill": "",
      "vertical": false
    },
    {
      "type": "text",
      "id": "PhnyPSdua5",
      "width": 340.5050807430691,
      "height": 56,
      "left": 643.2184904659707,
      "top": 415.30297737472733,
      "rotate": 0,
      "defaultFontName": "Microsoft Yahei",
      "defaultColor": "#333",
      "content": "<p style=\"text-align: center;\"><strong><span style=\"font-size: 36px;\"><span style=\"font-family: 思源宋体 CN;\"><span style=\"color: rgb(0, 0, 0);\">{{title}}</span></span></span></strong></p>",
      "lineHeight": 1,
      "outline": {
        "color": "#000",
        "width": 0,
        "style": "solid"
      },
      "fill": "",
      "vertical": false
    },
    {
      "type": "text",
      "id": "HhfpnKcAVv",
      "width": 141.73490813648291,
      "height": 74,
      "left": 735.5229667474774,
      "top": 341.3029773747271,
      "rotate": 0,
      "defaultFontName": "Microsoft Yahei",
      "defaultColor": "#333",
      "content": "<p style=\"text-align: center;\"><span style=\"font-size: 54px;\"><span style=\"color: rgb(212, 115, 116);\">04</span></span></p>",
      "lineHeight": 1,
      "outline": {
        "color": "#000",
        "width": 0,
        "style": "solid"
      },
      "fill": "",
      "vertical": false
    }
  ],
  'many':[
    {
      "type": "text",
      "id": "LQwTkHci9i",
      "width": 296.4488017429194,
      "height": 48,
      "left": 324.2293338194273,
      "top": 86.17659908804347,
      "rotate": 0,
      "defaultFontName": "Microsoft Yahei",
      "defaultColor": "#333",
      "content": "<p style=\"text-align: center;\"><strong><span style=\"font-size: 28px;\"><span style=\"font-family: 思源宋体 CN;\"><span style=\"color: rgb(0, 0, 0);\">{{title}}</span></span></span></strong></p>",
      "lineHeight": 1,
      "outline": {
        "color": "#000",
        "width": 0,
        "style": "solid"
      },
      "fill": "",
      "vertical": false
    },
    {
      "type": "text",
      "id": "aGLTY4WIc4",
      "width": 95,
      "height": 60,
      "left": 423.1236693314099,
      "top": 26.176599088043496,
      "rotate": 0,
      "defaultFontName": "Microsoft Yahei",
      "defaultColor": "#333",
      "content": "<p style=\"text-align: center;\"><span style=\"font-size: 40px;\"><span style=\"color: rgb(212, 115, 116);\">01</span></span></p>",
      "lineHeight": 1,
      "outline": {
        "color": "#000",
        "width": 0,
        "style": "solid"
      },
      "fill": "",
      "vertical": false
    },
    {
      "type": "text",
      "id": "mp4ayDujVB",
      "width": 292.0915032679739,
      "height": 48,
      "left": 650.3546310969475,
      "top": 86.17659908804347,
      "rotate": 0,
      "defaultFontName": "Microsoft Yahei",
      "defaultColor": "#333",
      "content": "<p style=\"text-align: center;\"><strong><span style=\"font-size: 28px;\"><span style=\"font-family: 思源宋体 CN;\"><span style=\"color: rgb(0, 0, 0);\">{{title}}</span></span></span></strong></p>",
      "lineHeight": 1,
      "outline": {
        "color": "#000",
        "width": 0,
        "style": "solid"
      },
      "fill": "",
      "vertical": false
    },
    {
      "type": "text",
      "id": "BA881groUm",
      "width": 101.5359477124183,
      "height": 60,
      "left": 745.4799034281021,
      "top": 26.176599088043496,
      "rotate": 0,
      "defaultFontName": "Microsoft Yahei",
      "defaultColor": "#333",
      "content": "<p style=\"text-align: center;\"><span style=\"font-size: 40px;\"><span style=\"color: rgb(155, 174, 152);\">02</span></span></p>",
      "lineHeight": 1,
      "outline": {
        "color": "#000",
        "width": 0,
        "style": "solid"
      },
      "fill": "",
      "vertical": false
    },
    {
      "type": "text",
      "id": "yO4NDzs4Dg",
      "width": 296.44880174291944,
      "height": 48,
      "left": 324.2293338194273,
      "top": 218.02181589077944,
      "rotate": 0,
      "defaultFontName": "Microsoft Yahei",
      "defaultColor": "#333",
      "content": "<p style=\"text-align: center;\"><strong><span style=\"font-size: 28px;\"><span style=\"font-family: 思源宋体 CN;\"><span style=\"color: rgb(0, 0, 0);\">{{title}}</span></span></span></strong></p>",
      "lineHeight": 1,
      "outline": {
        "color": "#000",
        "width": 0,
        "style": "solid"
      },
      "fill": "",
      "vertical": false
    },
    {
      "type": "text",
      "id": "NZzJQrpBpi",
      "width": 95,
      "height": 60,
      "left": 423.1236693314099,
      "top": 158.0218158907795,
      "rotate": 0,
      "defaultFontName": "Microsoft Yahei",
      "defaultColor": "#333",
      "content": "<p style=\"text-align: center;\"><span style=\"font-size: 40px;\"><span style=\"color: rgba(155,174,152,1);\">03</span></span></p>",
      "lineHeight": 1,
      "outline": {
        "color": "#000",
        "width": 0,
        "style": "solid"
      },
      "fill": "",
      "vertical": false
    },
    {
      "type": "text",
      "id": "6PZ4un8e2I",
      "width": 284.46623093681916,
      "height": 48,
      "left": 657.9799034281021,
      "top": 218.02181589077944,
      "rotate": 0,
      "defaultFontName": "Microsoft Yahei",
      "defaultColor": "#333",
      "content": "<p style=\"text-align: center;\"><strong><span style=\"font-size: 28px;\"><span style=\"font-family: 思源宋体 CN;\"><span style=\"color: rgb(0, 0, 0);\">{{title}}</span></span></span></strong></p>",
      "lineHeight": 1,
      "outline": {
        "color": "#000",
        "width": 0,
        "style": "solid"
      },
      "fill": "",
      "vertical": false
    },
    {
      "type": "text",
      "id": "ZFPd4WcCMu",
      "width": 95,
      "height": 60,
      "left": 745.4799034281021,
      "top": 158.0218158907795,
      "rotate": 0,
      "defaultFontName": "Microsoft Yahei",
      "defaultColor": "#333",
      "content": "<p style=\"text-align: center;\"><span style=\"font-size: 40px;\"><span style=\"color: rgba(212,115,116,1);\">04</span></span></p>",
      "lineHeight": 1,
      "outline": {
        "color": "#000",
        "width": 0,
        "style": "solid"
      },
      "fill": "",
      "vertical": false
    },
    {
      "type": "text",
      "id": "H74Jm_n6sW",
      "width": 296.44880174291944,
      "height": 48,
      "left": 324.2293338194273,
      "top": 355.9306279260418,
      "rotate": 0,
      "defaultFontName": "Microsoft Yahei",
      "defaultColor": "#333",
      "content": "<p style=\"text-align: center;\"><strong><span style=\"font-size: 28px;\"><span style=\"font-family: 思源宋体 CN;\"><span style=\"color: rgb(0, 0, 0);\">{{title}}</span></span></span></strong></p>",
      "lineHeight": 1,
      "outline": {
        "color": "#000",
        "width": 0,
        "style": "solid"
      },
      "fill": "",
      "vertical": false
    },
    {
      "type": "text",
      "id": "YNPBqCYe54",
      "width": 95,
      "height": 60,
      "left": 423.1236693314099,
      "top": 295.9306279260418,
      "rotate": 0,
      "defaultFontName": "Microsoft Yahei",
      "defaultColor": "#333",
      "content": "<p style=\"text-align: center;\"><span style=\"font-size: 40px;\"><span style=\"color: rgb(212, 115, 116);\">05</span></span></p>",
      "lineHeight": 1,
      "outline": {
        "color": "#000",
        "width": 0,
        "style": "solid"
      },
      "fill": "",
      "vertical": false
    },
    {
      "type": "text",
      "id": "l3Tvmgl4VA",
      "width": 284.46623093681916,
      "height": 48,
      "left": 657.9799034281021,
      "top": 355.9306279260418,
      "rotate": 0,
      "defaultFontName": "Microsoft Yahei",
      "defaultColor": "#333",
      "content": "<p style=\"text-align: center;\"><strong><span style=\"font-size: 28px;\"><span style=\"font-family: 思源宋体 CN;\"><span style=\"color: rgb(0, 0, 0);\">{{title}}</span></span></span></strong></p>",
      "lineHeight": 1,
      "outline": {
        "color": "#000",
        "width": 0,
        "style": "solid"
      },
      "fill": "",
      "vertical": false
    },
    {
      "type": "text",
      "id": "Yk3TtqwXWu",
      "width": 95,
      "height": 60,
      "left": 745.4799034281021,
      "top": 295.9306279260418,
      "rotate": 0,
      "defaultFontName": "Microsoft Yahei",
      "defaultColor": "#333",
      "content": "<p style=\"text-align: center;\"><span style=\"font-size: 40px;\"><span style=\"color: rgb(155, 174, 152);\">06</span></span></p>",
      "lineHeight": 1,
      "outline": {
        "color": "#000",
        "width": 0,
        "style": "solid"
      },
      "fill": "",
      "vertical": false
    },
    {
      "type": "text",
      "id": "XwbMJcYI0y",
      "width": 301.89542483660136,
      "height": 48,
      "left": 324.2293338194273,
      "top": 487.7758447287777,
      "rotate": 0,
      "defaultFontName": "Microsoft Yahei",
      "defaultColor": "#333",
      "content": "<p style=\"text-align: center;\"><strong><span style=\"font-size: 28px;\"><span style=\"font-family: 思源宋体 CN;\"><span style=\"color: rgb(0, 0, 0);\">{{title}}</span></span></span></strong></p>",
      "lineHeight": 1,
      "outline": {
        "color": "#000",
        "width": 0,
        "style": "solid"
      },
      "fill": "",
      "vertical": false
    },
    {
      "type": "text",
      "id": "81l-P-UlqT",
      "width": 100.40849673202624,
      "height": 60,
      "left": 423.1236693314099,
      "top": 427.7758447287779,
      "rotate": 0,
      "defaultFontName": "Microsoft Yahei",
      "defaultColor": "#333",
      "content": "<p style=\"text-align: center;\"><span style=\"font-size: 40px;\"><span style=\"color: rgb(155, 174, 152);\">07</span></span></p>",
      "lineHeight": 1,
      "outline": {
        "color": "#000",
        "width": 0,
        "style": "solid"
      },
      "fill": "",
      "vertical": false
    },
    {
      "type": "text",
      "id": "6S7GIEbIUF",
      "width": 284.4662309368192,
      "height": 48,
      "left": 657.9799034281021,
      "top": 487.7758447287777,
      "rotate": 0,
      "defaultFontName": "Microsoft Yahei",
      "defaultColor": "#333",
      "content": "<p style=\"text-align: center;\"><strong><span style=\"font-size: 28px;\"><span style=\"font-family: 思源宋体 CN;\"><span style=\"color: rgb(0, 0, 0);\">{{title}}</span></span></span></strong></p>",
      "lineHeight": 1,
      "outline": {
        "color": "#000",
        "width": 0,
        "style": "solid"
      },
      "fill": "",
      "vertical": false
    },
    {
      "type": "text",
      "id": "Rekza5YHWO",
      "width": 95,
      "height": 60,
      "left": 745.4799034281021,
      "top": 427.7758447287779,
      "rotate": 0,
      "defaultFontName": "Microsoft Yahei",
      "defaultColor": "#333",
      "content": "<p style=\"text-align: center;\"><span style=\"font-size: 40px;\"><span style=\"color: rgb(212, 115, 116);\">08</span></span></p>",
      "lineHeight": 1,
      "outline": {
        "color": "#000",
        "width": 0,
        "style": "solid"
      },
      "fill": "",
      "vertical": false
    }
  ],
  'max':[
    {
      "type": "text",
      "id": "RHlELE7meg",
      "width": 249.97116200169648,
      "height": 48,
      "left": 253.3972062270842,
      "top": 85.4503771796329,
      "rotate": 0,
      "defaultFontName": "Microsoft Yahei",
      "defaultColor": "#333",
      "content": "<p style=\"text-align: center;\"><strong><span style=\"font-size: 28px;\"><span style=\"font-family: 思源宋体 CN;\">{{title}}</span></span></strong></p>",
      "lineHeight": 1,
      "outline": {
        "color": "#000",
        "width": 0,
        "style": "solid"
      },
      "fill": "",
      "vertical": false
    },
    {
      "type": "text",
      "id": "WG4HiAf9FG",
      "width": 95,
      "height": 60,
      "left": 320.8972062270842,
      "top": 25.45037717963291,
      "rotate": 0,
      "defaultFontName": "Microsoft Yahei",
      "defaultColor": "#333",
      "content": "<p style=\"text-align: center;\"><span style=\"font-size: 40px;\"><span style=\"color: rgb(212, 115, 116);\">01</span></span></p>",
      "lineHeight": 1,
      "outline": {
        "color": "#000",
        "width": 0,
        "style": "solid"
      },
      "fill": "",
      "vertical": false
    },
    {
      "type": "text",
      "id": "t8OTrIrYIY",
      "width": 249.48939779474125,
      "height": 48,
      "left": 503.3683682287807,
      "top": 85.4503771796329,
      "rotate": 0,
      "defaultFontName": "Microsoft Yahei",
      "defaultColor": "#333",
      "content": "<p style=\"text-align: center;\"><strong><span style=\"font-size: 28px;\"><span style=\"font-family: 思源宋体 CN;\"><span style=\"color: rgb(0, 0, 0);\">{{title}}</span></span></span></strong></p>",
      "lineHeight": 1,
      "outline": {
        "color": "#000",
        "width": 0,
        "style": "solid"
      },
      "fill": "",
      "vertical": false
    },
    {
      "type": "text",
      "id": "AP71vbwwtV",
      "width": 95,
      "height": 60,
      "left": 570.8683682287807,
      "top": 25.45037717963291,
      "rotate": 0,
      "defaultFontName": "Microsoft Yahei",
      "defaultColor": "#333",
      "content": "<p style=\"text-align: center;\"><span style=\"font-size: 40px;\"><span style=\"color: rgb(155, 174, 152);\">02</span></span></p>",
      "lineHeight": 1,
      "outline": {
        "color": "#000",
        "width": 0,
        "style": "solid"
      },
      "fill": "",
      "vertical": false
    },
    {
      "type": "text",
      "id": "Tahuyn2Hls",
      "width": 247.14223397647817,
      "height": 48,
      "left": 752.8577660235219,
      "top": 85.45037717963291,
      "rotate": 0,
      "defaultFontName": "Microsoft Yahei",
      "defaultColor": "#333",
      "content": "<p style=\"text-align: center;\"><strong><span style=\"font-size: 28px;\"><span style=\"font-family: 思源宋体 CN;\"><span style=\"color: rgb(0, 0, 0);\">{{title}}</span></span></span></strong></p>",
      "lineHeight": 1,
      "outline": {
        "color": "#000",
        "width": 0,
        "style": "solid"
      },
      "fill": "",
      "vertical": false
    },
    {
      "type": "text",
      "id": "8g7_g02BhA",
      "width": 95,
      "height": 60,
      "left": 820.3577660235219,
      "top": 25.45037717963291,
      "rotate": 0,
      "defaultFontName": "Microsoft Yahei",
      "defaultColor": "#333",
      "content": "<p style=\"text-align: center;\"><span style=\"font-size: 40px;\"><span style=\"color: rgb(212, 115, 116);\">03</span></span></p>",
      "lineHeight": 1,
      "outline": {
        "color": "#000",
        "width": 0,
        "style": "solid"
      },
      "fill": "",
      "vertical": false
    },
    {
      "type": "text",
      "id": "2lBPc9ZS89",
      "width": 249.97116200169648,
      "height": 48,
      "left": 253.3972062270842,
      "top": 217.29559398236884,
      "rotate": 0,
      "defaultFontName": "Microsoft Yahei",
      "defaultColor": "#333",
      "content": "<p style=\"text-align: center;\"><strong><span style=\"font-size: 28px;\"><span style=\"font-family: 思源宋体 CN;\"><span style=\"color: rgb(0, 0, 0);\">{{title}}</span></span></span></strong></p>",
      "lineHeight": 1,
      "outline": {
        "color": "#000",
        "width": 0,
        "style": "solid"
      },
      "fill": "",
      "vertical": false
    },
    {
      "type": "text",
      "id": "Cx-xjYOkiV",
      "width": 95,
      "height": 60,
      "left": 320.8972062270842,
      "top": 157.2955939823689,
      "rotate": 0,
      "defaultFontName": "Microsoft Yahei",
      "defaultColor": "#333",
      "content": "<p style=\"text-align: center;\"><span style=\"font-size: 40px;\"><span style=\"color: rgb(155, 174, 152);\">04</span></span></p>",
      "lineHeight": 1,
      "outline": {
        "color": "#000",
        "width": 0,
        "style": "solid"
      },
      "fill": "",
      "vertical": false
    },
    {
      "type": "text",
      "id": "-ZTuwR9KkO",
      "width": 249.48939779474125,
      "height": 48,
      "left": 503.3683682287807,
      "top": 217.29559398236884,
      "rotate": 0,
      "defaultFontName": "Microsoft Yahei",
      "defaultColor": "#333",
      "content": "<p style=\"text-align: center;\"><strong><span style=\"font-size: 28px;\"><span style=\"font-family: 思源宋体 CN;\"><span style=\"color: rgb(0, 0, 0);\">{{title}}</span></span></span></strong></p>",
      "lineHeight": 1,
      "outline": {
        "color": "#000",
        "width": 0,
        "style": "solid"
      },
      "fill": "",
      "vertical": false
    },
    {
      "type": "text",
      "id": "g7GowCfeng",
      "width": 95,
      "height": 60,
      "left": 570.8683682287807,
      "top": 157.2955939823689,
      "rotate": 0,
      "defaultFontName": "Microsoft Yahei",
      "defaultColor": "#333",
      "content": "<p style=\"text-align: center;\"><span style=\"font-size: 40px;\"><span style=\"color: rgb(212, 115, 116);\">05</span></span></p>",
      "lineHeight": 1,
      "outline": {
        "color": "#000",
        "width": 0,
        "style": "solid"
      },
      "fill": "",
      "vertical": false
    },
    {
      "type": "text",
      "id": "bWojhmNlny",
      "width": 247.14223397647817,
      "height": 48,
      "left": 752.8577660235219,
      "top": 217.29559398236887,
      "rotate": 0,
      "defaultFontName": "Microsoft Yahei",
      "defaultColor": "#333",
      "content": "<p style=\"text-align: center;\"><strong><span style=\"font-size: 28px;\"><span style=\"font-family: 思源宋体 CN;\"><span style=\"color: rgb(0, 0, 0);\">{{title}}</span></span></span></strong></p>",
      "lineHeight": 1,
      "outline": {
        "color": "#000",
        "width": 0,
        "style": "solid"
      },
      "fill": "",
      "vertical": false
    },
    {
      "type": "text",
      "id": "bCcHy-1ReZ",
      "width": 95,
      "height": 60,
      "left": 820.3577660235219,
      "top": 157.29559398236893,
      "rotate": 0,
      "defaultFontName": "Microsoft Yahei",
      "defaultColor": "#333",
      "content": "<p style=\"text-align: center;\"><span style=\"font-size: 40px;\"><span style=\"color: rgb(155, 174, 152);\">06</span></span></p>",
      "lineHeight": 1,
      "outline": {
        "color": "#000",
        "width": 0,
        "style": "solid"
      },
      "fill": "",
      "vertical": false
    },
    {
      "type": "text",
      "id": "-BNrMKcYKt",
      "width": 249.97116200169648,
      "height": 48,
      "left": 253.3972062270842,
      "top": 355.2044060176313,
      "rotate": 0,
      "defaultFontName": "Microsoft Yahei",
      "defaultColor": "#333",
      "content": "<p style=\"text-align: center;\"><strong><span style=\"font-size: 28px;\"><span style=\"font-family: 思源宋体 CN;\"><span style=\"color: rgb(0, 0, 0);\">{{title}}</span></span></span></strong></p>",
      "lineHeight": 1,
      "outline": {
        "color": "#000",
        "width": 0,
        "style": "solid"
      },
      "fill": "",
      "vertical": false
    },
    {
      "type": "text",
      "id": "KJxyQpzk-b",
      "width": 95,
      "height": 60,
      "left": 320.8972062270842,
      "top": 295.2044060176313,
      "rotate": 0,
      "defaultFontName": "Microsoft Yahei",
      "defaultColor": "#333",
      "content": "<p style=\"text-align: center;\"><span style=\"font-size: 40px;\"><span style=\"color: rgb(212, 115, 116);\">07</span></span></p>",
      "lineHeight": 1,
      "outline": {
        "color": "#000",
        "width": 0,
        "style": "solid"
      },
      "fill": "",
      "vertical": false
    },
    {
      "type": "text",
      "id": "A5Q7Qk1lhc",
      "width": 249.48939779474125,
      "height": 48,
      "left": 503.3683682287807,
      "top": 355.2044060176313,
      "rotate": 0,
      "defaultFontName": "Microsoft Yahei",
      "defaultColor": "#333",
      "content": "<p style=\"text-align: center;\"><strong><span style=\"font-size: 28px;\"><span style=\"font-family: 思源宋体 CN;\"><span style=\"color: rgb(0, 0, 0);\">{{title}}</span></span></span></strong></p>",
      "lineHeight": 1,
      "outline": {
        "color": "#000",
        "width": 0,
        "style": "solid"
      },
      "fill": "",
      "vertical": false
    },
    {
      "type": "text",
      "id": "dDpQOn20VA",
      "width": 95,
      "height": 60,
      "left": 570.8683682287807,
      "top": 295.2044060176313,
      "rotate": 0,
      "defaultFontName": "Microsoft Yahei",
      "defaultColor": "#333",
      "content": "<p style=\"text-align: center;\"><span style=\"font-size: 40px;\"><span style=\"color: rgb(155, 174, 152);\">08</span></span></p>",
      "lineHeight": 1,
      "outline": {
        "color": "#000",
        "width": 0,
        "style": "solid"
      },
      "fill": "",
      "vertical": false
    },
    {
      "type": "text",
      "id": "pQNrfaPsQ3",
      "width": 247.14223397647817,
      "height": 48,
      "left": 752.8577660235219,
      "top": 355.2044060176313,
      "rotate": 0,
      "defaultFontName": "Microsoft Yahei",
      "defaultColor": "#333",
      "content": "<p style=\"text-align: center;\"><strong><span style=\"font-size: 28px;\"><span style=\"font-family: 思源宋体 CN;\"><span style=\"color: rgb(0, 0, 0);\">{{title}}</span></span></span></strong></p>",
      "lineHeight": 1,
      "outline": {
        "color": "#000",
        "width": 0,
        "style": "solid"
      },
      "fill": "",
      "vertical": false
    },
    {
      "type": "text",
      "id": "6iB9iWxbLA",
      "width": 95,
      "height": 60,
      "left": 820.3577660235219,
      "top": 295.2044060176313,
      "rotate": 0,
      "defaultFontName": "Microsoft Yahei",
      "defaultColor": "#333",
      "content": "<p style=\"text-align: center;\"><span style=\"font-size: 40px;\"><span style=\"color: rgb(212, 115, 116);\">09</span></span></p>",
      "lineHeight": 1,
      "outline": {
        "color": "#000",
        "width": 0,
        "style": "solid"
      },
      "fill": "",
      "vertical": false
    },
    {
      "type": "text",
      "id": "nuM4ZvgFXS",
      "width": 249.97116200169648,
      "height": 48,
      "left": 253.3972062270842,
      "top": 487.04962282036723,
      "rotate": 0,
      "defaultFontName": "Microsoft Yahei",
      "defaultColor": "#333",
      "content": "<p style=\"text-align: center;\"><strong><span style=\"font-size: 28px;\"><span style=\"font-family: 思源宋体 CN;\"><span style=\"color: rgb(0, 0, 0);\">{{title}}</span></span></span></strong></p>",
      "lineHeight": 1,
      "outline": {
        "color": "#000",
        "width": 0,
        "style": "solid"
      },
      "fill": "",
      "vertical": false
    },
    {
      "type": "text",
      "id": "hPj28h-dkM",
      "width": 95,
      "height": 60,
      "left": 320.8972062270842,
      "top": 427.0496228203674,
      "rotate": 0,
      "defaultFontName": "Microsoft Yahei",
      "defaultColor": "#333",
      "content": "<p style=\"text-align: center;\"><span style=\"font-size: 40px;\"><span style=\"color: rgb(155, 174, 152);\">10</span></span></p>",
      "lineHeight": 1,
      "outline": {
        "color": "#000",
        "width": 0,
        "style": "solid"
      },
      "fill": "",
      "vertical": false
    },
    {
      "type": "text",
      "id": "wU2xZbEpCL",
      "width": 249.48939779474125,
      "height": 48,
      "left": 503.3683682287807,
      "top": 487.04962282036723,
      "rotate": 0,
      "defaultFontName": "Microsoft Yahei",
      "defaultColor": "#333",
      "content": "<p style=\"text-align: center;\"><strong><span style=\"font-size: 28px;\"><span style=\"font-family: 思源宋体 CN;\"><span style=\"color: rgb(0, 0, 0);\">{{title}}</span></span></span></strong></p>",
      "lineHeight": 1,
      "outline": {
        "color": "#000",
        "width": 0,
        "style": "solid"
      },
      "fill": "",
      "vertical": false
    },
    {
      "type": "text",
      "id": "HDW4NzXlsV",
      "width": 95,
      "height": 60,
      "left": 570.8683682287807,
      "top": 427.0496228203674,
      "rotate": 0,
      "defaultFontName": "Microsoft Yahei",
      "defaultColor": "#333",
      "content": "<p style=\"text-align: center;\"><span style=\"font-size: 40px;\"><span style=\"color: rgb(212, 115, 116);\">11</span></span></p>",
      "lineHeight": 1,
      "outline": {
        "color": "#000",
        "width": 0,
        "style": "solid"
      },
      "fill": "",
      "vertical": false
    },
    {
      "type": "text",
      "id": "RMDZFWLOVf",
      "width": 247.14223397647817,
      "height": 48,
      "left": 752.8577660235219,
      "top": 487.0496228203672,
      "rotate": 0,
      "defaultFontName": "Microsoft Yahei",
      "defaultColor": "#333",
      "content": "<p style=\"text-align: center;\"><strong><span style=\"font-size: 28px;\"><span style=\"font-family: 思源宋体 CN;\"><span style=\"color: rgb(0, 0, 0);\">{{title}}</span></span></span></strong></p>",
      "lineHeight": 1,
      "outline": {
        "color": "#000",
        "width": 0,
        "style": "solid"
      },
      "fill": "",
      "vertical": false
    },
    {
      "type": "text",
      "id": "J6vy3uKYp2",
      "width": 95,
      "height": 60,
      "left": 820.3577660235219,
      "top": 427.0496228203674,
      "rotate": 0,
      "defaultFontName": "Microsoft Yahei",
      "defaultColor": "#333",
      "content": "<p style=\"text-align: center;\"><span style=\"font-size: 40px;\"><span style=\"color: rgb(155, 174, 152);\">12</span></span></p>",
      "lineHeight": 1,
      "outline": {
        "color": "#000",
        "width": 0,
        "style": "solid"
      },
      "fill": "",
      "vertical": false
    }
  ],
  
 }
 
 
 
}

export const neirong ={
  textLess:[

   [ {
      type: 'text',
      "left": 70,
        "top": 215,
        "width": 860,
        "height": 110,
      rotate: 0,
      defaultFontName: '思源黑体 CN',
      defaultColor: '#333',
      content:
      '{{item}}',
      lineHeight: 1.5,
      fill: '',
      vertical: false
    }]
  ] ,
  textMiddle :[
    [{
      type: 'text',
      "top": 169,
        "width": 860,
        "height": 200,
      left: 70,
      rotate: 0,
      defaultFontName: '思源黑体 CN',
      defaultColor: '#333',
      content:
      '{{item}}',
      lineHeight: 1.5,
      fill: '',
      vertical: false
    }]
  ],
  textGreater :[
   [ {
      type: 'text',
      width: 860,
      height: 385,
      left: 70,
      top: 106,
      rotate: 0,
      defaultFontName: '思源黑体 CN',
      defaultColor: '#333',
      content:
      '{{item}}',
      lineHeight: 1.5,
      fill: '',
      vertical: false
    }]
  ],
  OnlyImg:[
    [{
      type: 'image',
      "left": 70,
      "top": 110,
      "width": 860,
      "height": 390,
    }]
  ],
  textLessAndImg:[
    [
      {
        type: 'text',
        width: 860,
      height: 110,
      left: 70,
      top: 106,
        rotate: 0,
        defaultFontName: '思源黑体 CN',
        defaultColor: '#333',
        content:
        '{{item}}',
        lineHeight: 1.5,
        fill: '',
        vertical: false
      },
      {
        type: 'image',
        width: 400,
        height: 300,
        left: 70,
        top: 216,
      },
    ],
    [
      {
        type: 'text',
        width: 388,
        height: 110,
        left: 70,
        top: 170,
        rotate: 0,
        defaultFontName: '思源黑体 CN',
        defaultColor: '#333',
        content:
        '{{item}}',
        lineHeight: 1.5,
        fill: '',
        vertical: false
      },
      {
        type: 'image',
        width: 456,
        height: 390,
        left: 470,
        top: 120,
      },
    ]
    
  ],
  textGreaterAndImg:[
    [
      {
        type: 'text',
        width: 860,
        height: 200,
        left: 70,
        top: 100,
        rotate: 0,
        defaultFontName: '思源黑体 CN',
        defaultColor: '#333',
        content:
        '{{item}}',
        lineHeight: 1.5,
        fill: '',
        vertical: false
      },
      {
        type: 'image',
        width: 860,
        height: 216,
        left: 70,
        top: 304,
      },
    ],
    [
      {
        type: 'text',
        width: 388,
        height: 425,
        left: 70,
        top: 106,
        rotate: 0,
        defaultFontName: '思源黑体 CN',
        defaultColor: '#333',
        content:
        '{{item}}',
        lineHeight: 1.5,
        fill: '',
        vertical: false
      },
      {
        type: 'image',
        width: 456,
        height: 390,
        left: 473,
        top: 110,
      },
    ]
    
  ],
  oneImg:[
  
    {
      type: 'text',
      width: 430,
      height: 0,
      left: 500,
      top: 106,
      rotate: 0,
      defaultFontName: '思源黑体 CN',
      defaultColor: '#333',
      content:
      '{{item}}',
      lineHeight: 1.5,
      fill: '',
      vertical: false
    }
    ,{
      type: 'table',
      width: 430,
      height: 400,
      left: 500,
      top: 130,
    },
    {
      type: 'image',
      width: 400,
      height: 400,
      left: 70,
      top: 130,
    },
  ]
}